export default {
    // 中
    zhCN: {
        vin: 'VIN',
        inquiry_no: '案例单号',
        case_theme: '案例主题',
        department_name: '部门名称',
        department_type: '部门类型',
        document_status: '单据状态',
        inquiry_date: '问询日期',
        organization_name: '组织名称',
        name: '提案方名称',
        sap_code: 'SAP编码',
        failed_part: '失效零件',
        case_type: '案例类型',
        vehicle_status: '维修状态',
        case_owner: '责任人',
        country: '国家',
        fault_cause: '故障原因',
        symptoms: '故障现象',
        is_the_document_qualified: '单据是否合格',
        is_the_document_replied_in_a_timely_manner: '单据是否及时答复',
        filter: '筛选器',
        system_classification_I: '系统分类I',
        system_classification_II: '系统分类II',
        full_query: '全量查询',
        fuzzy_query: '模糊查询',
        whether_belongs_new_car_market: '是否新车上市',
        caseStatus: '案例状态',
        correct: '是',
        deny: '否',
        not_closed: '未结案',
        no_reply: '未答复',
        replied: '已答复',
        closed: '已结案',
        drafts: '草稿箱',
        create_time: '创建时间',
        create_user: '创建人',
        parent_of_document: '单据所属上级',
        document_owner: '单据负责人',
        case_subject: '案例主题',
        receipt_info: '单据信息',
        superior_of_case: '案例所属上级',
        inquiry_time: '问询时间',
        status: '状态',
        overseas_company: '海外公司名称',
        general_agent_name: '总代名称',
        dealer_code: '经销商编码',
        dealer_name: '经销商名称',
        name_of_subsidiary: '子公司名称',
        contacts: '联系人',
        contact_information: '联系方式',
        training_certification: '培训认证',
        driving_mileage: '行驶里程',
        plate_number: '车牌号',
        material_no: '物料号',
        material_desc: '物料描述',
        offline_date: '下线日期',
        model_platform: '车型平台',
        engine_number: '发动机号',
        transmission_type: '变速箱型号',
        assembly_no: '总装号',
        fault_info_desc: '故障信息描述',
        fault_handle_process: '故障处理经过',
        solution: '解决方案',
        remark: '备注',
        caseRemark: '案例备注',
        document_information: '单据信息',
        basic_information_of_service_center: '服务中心基本信息',
        basic_vehicle_information: '车辆基本信息',
        problem_description: '问题描述',
        common_links: '常用链接',
        claim_information: '索赔信息',
        diagnostic_report_record: '诊断报告记录',
        vehicle_history: '车辆历史问询单据',
        programming_history: '编程历史',
        vehicle_sales_logistics_information: '车辆销售及物流信息',
        new_vehicle_information: '新增车辆信息',
        attachment_upload: '附件上传',
        diagnostic_report: '诊断报告',
        bulk_download: '批量下载',
        document_View: '文档查看',
        inquiry_content: '问询内容',
        inquiry_entry: '问询回复',
        subordinate_record: '下级问答记录',
        superior_record: '上级问答记录',
        send_content: '发送内容',
        send_time: '发送时间',
        sent_username: '发送人',
        receive_name: '发送至',
        dept_name: '级别',
        enclosure: '附件',
        wind_case: '结案',
        close_order: '关单',
        case_reporting: '案例上报',
        pdf_preview: 'PDF预览',
        SIS_maintenance: '重大事故维护',
        Please_fill_in_the_inquiry_content: '请填写询问内容',
        sending_an_email: '发送邮件',
        copy: '复制',
        repeat: 'Vin 重复',
        inconsistent: '车型平台不一致',
        sendTo: '发送至',
        reply: '输入内容进行问询/回复',
        please_check_the_exported_document: '请勾选导出的单据',
        please_upload_diagnostic_report: '请上传诊断报告',
        please_enter_the_vin: '请输入VIN',
        placeholderDTC: '示例：P080800_P087D00_------',
        placeholderFaultInfoDesc: '1.核实客户关注的问题(只是为了确保出现问题)',
        placeholderFaultHandleProcess:
            '2.确定相关症状(查找并记录可能与问题相关的所有症状)\n' +
            '3.分析症状(仔细观察相关症状，找出常见原因)\n' +
            '4.确认问题(缩小你的结果范围，以确保你解决了正确的问题)',
        placeholderSolution:
            '5.修复问题(进行维修)\n' + '6.验证车辆运行情况(检查以确保您所做的修复已解决问题)',
        placeholderRemark: '例如：转向机-201806，FL减震器-2010101',
        placeholderContact: '请输入操作者姓名',
        close_time: '结案时间',
        one_touch: '单据重建',
        confirm_generating_new_case: '确定生成新的单据？',
        closing_statement: '结案说明',
        number_of_cases: '单据数量',
        number_of_vehicles: '车辆数量',
        pleaseEnterContent: '请输入内容',
        case_age: '案龄',
        last_response_time: '上次响应时间',
        time_since_last_response: '自上次响应以来的时间',
        warranty_start_date: '保修开始日期',
        submit_reason: '提交原因',
        synchronize_PQCP: '同步PQCP',
        FPR_export: 'FPR导出',
        level_selection: '级别选择',
        category_selection: '分类选择',
        brand_selection: '品牌选择',
        code: '代码',
        description: '描述',
        major_complaints: '重大抱怨',
        difficult_miscellaneous_diseases: '疑难杂症',
        emerging_issues: '新发问题',
        breakpoint_failure: '断点失效',
        general_complaints: '一般抱怨',
        other: '其他',
        roewe: '荣威',
        mg: 'MG',
        serious: '严重',
        secondary: '次要',
        generally: '一般',
        complete: '完成',
        please_select_level: '请选择级别',
        please_select_category: '请选择分类',
        please_select_brand: '请选择品牌',
        placeholder_auto: '自动带出',
        translate: '翻译',
        isTranslate: '是否翻译',
        day: '天',
        one_click_order: '一键关单',
        greater_than: '大于',
        less_than: '小于',
        between: '之间',
        document_label: '单据标签',
        receipts_first_modification_time: '单据首次修改时间',
        Selection_of_Document_Owner: '单据责任人选择',
        responsiblePerson: '责任人：',
        functional_Domain: '功能域',
        Category: '类别',
        property: '属性',
        reRepair: '重复维修',
        pullInNum: '进站次数',
        perception: '感知类',
        onSupport: '是否现场支持',
        batteryNo: '电池编号',
        normalStartDate: '保修日期',
        qmotorNo: '前电机编号',
        hmotorNo: '后电机编号',
        fault_cause_type: '故障原因类型',
        measure_name: '措施名称',
        part_name: '零件名称',
        close_order_notification: '关单需要答复提案方',
        TIS_Case_Data: 'TIS案例数据',
        case_File: '案例档案',
        responsibility_Data: '分责数据',
        longterm_Measures: '长期措施',
        tisCaseNo: 'TIS案例编号',
        vehGlobalFwVer: '整车软件版本号',
        vehGlobalFwPn: '整车软件零件号',
        archivesNo: '档案编号',
        archivesTitle: '档案标题',
        archivesSource: '档案来源',
        proposer: '提出人员',
        proposedTime: '提出日期',
        archivesManagementPersonnel: '管理人员',
        functionalMode: '功能模块',
        supplier: '供应商',
        accessoriesInvolved: '是否涉及配件',
        functionalDomain: '功能域',
        invalidPartId: '失效件',
        archivesType: '档案类型',
        archivesGrade: '档案等级',
        problemDescription: '问题描述',
        analysisProgress: '分析进展',
        qaRemark: 'QA备注',
        tacRemark: 'TAC备注',
        responsibleDepartment: '责任部门',
        coordinator: '协调人',
        principal: '责任人',
        containmentAction: '遏制措施',
        issueStatus: '问题状态',
        softwareProblems: '软件问题',
        vehGlobalFwVer_j: '基线版本号',
        vehGlobalFwPn_j: '基线零件号',
        ewo: 'EWO号',
        rootCause: '根本原因',
        marketBehavior: '市场行为',
        shortTermMeasures: '短期措施',
        shortTermBreakpointDescription: '短措断点说明',
        measuresResult: '措施审批结果',
        measuresConfirmation: '措施确认说明',
        longTermMeasures: '长期措施',
        longTermMeasuresBreak: '长措预估断点说明',
        implementation: '是否实施',
        longMeasuresTime: '长措实际断点日期',
        vinBreak: '长措断点VIN',
        breakpointImplementationPhase: '断点实施阶段',
        archive_Information: '档案信息',
        reason_incomplete_closure: '未完工关闭原因',
        entry_Date: '进站日期',
        departure_date: '离站日期',
        work_order_number: '工单号',
        questionnaire_usage: '问询单用途',
        classification_of_technical_enquiries: '技术问询分类',
        change_of_document_owner: '单据owner变更',
        oldowner: 'Old Owner',
        newowner: 'New Owner',
        original: '原稿',
        translation: '译文',
        dealer_address: '经销商地址',
        sel_up_engineers: '最多选择12个工程师！',
        sel_up_weeks: '最多选择12周！',
        veh_infor_inquiry: '车辆信息查询',
        create_organization: '创建组织',
        ref_code: '获取刷新验证码',
        fault_complaint_Desp: '故障信息描述/客户抱怨描述',
        broken_down_vehicle: '是否抛锚车辆',
        reporting_organization: '上报组织',
        reporter: '上报人',
        oneclick_convert: '一键转换',
        assembly: '总成',
        show_original: '展示原文',
        sync_datong: '同步大通',
        system_category_iii: '系统分类III',
        maxus_Records: 'MAXUS对话记录',
    },
    // 英
    enUS: {
        vin: 'VIN',
        inquiry_no: 'Case no.',
        case_theme: 'Case subject',
        department_name: 'Department name',
        department_type: 'Department type',
        document_status: 'Document status',
        inquiry_date: 'Inquiry date',
        organization_name: 'Organization name',
        name: 'Name of proposer',
        sap_code: 'SAP code',
        failed_part: 'System-part',
        case_type: 'Case type',
        vehicle_status: 'Repair status',
        case_owner: 'Person responsible',
        country: 'Country',
        fault_cause: 'Fault cause',
        symptoms: 'Fault phenomenon',
        is_the_document_qualified: 'Is the case qualified',
        is_the_document_replied_in_a_timely_manner: 'Is the case replied in a timely manner',
        filter: 'Filter',
        system_classification_I: 'System-group',
        system_classification_II: 'System-assembly',
        full_query: 'Full query',
        fuzzy_query: 'Fuzzy query',
        whether_belongs_new_car_market: 'New car launched',
        caseStatus: 'Case status',
        correct: 'Correct',
        deny: 'Deny',
        not_closed: 'Open',
        no_reply: 'Wait for tac reply',
        replied: 'TAC Replied',
        closed: 'Closed',
        drafts: 'Draft box',
        create_time: 'Create time',
        create_user: 'Created by',
        parent_of_document: 'Parent of the document',
        document_owner: 'Case owner',
        case_subject: 'Subject',
        receipt_info: 'Case information',
        superior_of_case: 'Case superior',
        inquiry_time: 'Inquiry time',
        status: 'Status',
        overseas_company: 'Sales company name',
        general_agent_name: 'Distributor name',
        dealer_code: 'Dealer code',
        dealer_name: 'Dealer name',
        name_of_subsidiary: 'Name of subsidiary',
        contacts: 'Contact person',
        contact_information: 'Contact information',
        training_certification: 'Training certification',
        driving_mileage: 'Mileage',
        plate_number: 'License plate #',
        material_no: 'Vehicle Material code',
        material_desc: 'Material description',
        offline_date: 'Off-line date',
        model_platform: 'Platform',
        engine_number: 'Engine number',
        transmission_type: 'Transmission',
        assembly_no: 'CSN no',
        fault_info_desc: 'Customer reported concern',
        fault_handle_process: 'Diagnosis/Work carried out',
        solution: 'Solution',
        remark: 'Remark',
        caseRemark: 'Case remark',
        document_information: 'Case information',
        basic_information_of_service_center: 'Service center information',
        basic_vehicle_information: 'Vehicle basic information',
        problem_description: 'Problem description',
        common_links: 'Useful link',
        claim_information: 'Claim information',
        diagnostic_report_record: 'Diagnostic report',
        vehicle_history: 'Technical inquiry history',
        programming_history: 'Programming history',
        vehicle_sales_logistics_information: 'Vehicle sales and logistics information',
        new_vehicle_information: 'New vehicle information',
        attachment_upload: 'Attachment upload',
        diagnostic_report: 'Diagnostic report',
        bulk_download: 'Bulk download',
        document_View: 'Document view',
        inquiry_content: 'Case response detail',
        inquiry_entry: 'Case response entry',
        subordinate_record: 'Subordinate record',
        superior_record: 'Superior record',
        send_content: 'Send content',
        send_time: 'Send time',
        sent_username: 'Sender',
        receive_name: 'Send to',
        dept_name: 'Level',
        enclosure: 'Attachment',
        wind_case: 'Closed',
        close_order: 'Close case',
        case_reporting: 'Case submit',
        pdf_preview: 'PDF preview',
        SIS_maintenance: 'Major accident maintenance',
        Please_fill_in_the_inquiry_content: 'Please fill in the inquiry content',
        sending_an_email: 'Sending an email',
        copy: 'Copy',
        repeat: 'Vin repeat',
        inconsistent: 'Inconsistent vehicle platform',
        sendTo: 'Send to',
        reply: 'Input for inquiry/reply',
        please_check_the_exported_document: 'Please check the exported document',
        please_upload_diagnostic_report: 'Please upload diagnostic report',
        please_enter_the_vin: 'Please enter the VIN',
        placeholderDTC: 'Example：P080800_P087D00_------',
        placeholderFaultInfoDesc: '1.Verify customer concerns (just to ensure issues arise)',
        placeholderFaultHandleProcess:
            '2.Identify relevant symptoms (identify and record all symptoms that may be related to the problem)\n' +
            '3.Analyze symptoms (carefully observe relevant symptoms to identify common causes)\n' +
            '4.Confirm the problem (narrow down the scope of your results to ensure you have solved the correct problem)',
        placeholderSolution:
            '5.Fix the problem (carry out repairs)\n' +
            '6.Verify vehicle operation (check to ensure that your repairs have resolved the issue)',
        placeholderRemark: 'Example: Steering gear-201806, FL Shock absorber-2010101',
        placeholderContact: 'Please enter operator name',
        close_time: 'Close time',
        one_touch: 'Case rebuild',
        confirm_generating_new_case: 'Confirm generating new case？',
        closing_statement: 'Closing statement',
        number_of_cases: 'Number of cases',
        number_of_vehicles: 'Number of vehicles',
        pleaseEnterContent: 'Please enter content',
        case_age: 'Case age',
        last_response_time: 'Last response time',
        time_since_last_response: 'Time since last response',
        warranty_start_date: 'Warranty start date',
        submit_reason: 'Reason for submission',
        synchronize_PQCP: 'Synchronize PQCP',
        FPR_export: 'FPR export',
        level_selection: 'Level selection',
        category_selection: 'Category selection',
        brand_selection: 'Brand selection',
        code: 'Code',
        description: 'Description',
        major_complaints: 'Major complaints',
        difficult_miscellaneous_diseases: 'Difficult miscellaneous diseases',
        emerging_issues: 'Emerging issues',
        breakpoint_failure: 'Breakpoint failure',
        general_complaints: 'General complaints',
        other: 'Other',
        roewe: 'Roewe',
        mg: 'MG',
        serious: 'Serious',
        secondary: 'Secondary',
        generally: 'Generally',
        complete: 'complete',
        please_select_level: 'Please select level',
        please_select_category: 'Please select category',
        please_select_brand: 'Please select brand',
        placeholder_auto: 'Auto Populated',
        translate: 'Translate',
        isTranslate: 'Is translate',
        day: 'day',
        one_click_order: 'One-click case',
        greater_than: 'Greater than',
        less_than: 'Less than',
        between: 'Between',
        document_label: 'Document label',
        receipts_first_modification_time: 'Receipts first modification time',
        Selection_of_Document_Owner: 'Document Responsible Person Selection',
        responsiblePerson: 'responsible Person：',
        functional_Domain: 'Functional Domain',
        Category: 'Category',
        property: 'Causality',
        reRepair: 'Repeat Repairs',
        pullInNum: 'Number of Entries',
        perception: 'Perception Class',
        onSupport: 'On-Site Support',
        batteryNo: 'Battery Number',
        normalStartDate: 'Warranty Date',
        qmotorNo: 'Front Motor Number',
        hmotorNo: 'Rear Motor Number',
        fault_cause_type: 'Fault Cause Type',
        measure_name: 'Measure Name',
        part_name: 'Part Name',
        close_order_notification: 'Closing the order requires a response from the proposer.',
        TIS_Case_Data: 'TIS Case Data',
        case_File: 'Case File',
        responsibility_Data: 'Responsibility Data',
        longterm_Measures: 'Long-term Measures',
        tisCaseNo: 'TIS Case Number',
        vehGlobalFwVer: 'Vehicle Software Version Number',
        vehGlobalFwPn: 'Vehicle Software Part Number',
        archivesNo: 'File Number',
        archivesTitle: 'File Title',
        archivesSource: 'File Source',
        proposer: 'Proposer',
        proposedTime: 'Proposed Date',
        archivesManagementPersonnel: 'Management Personnel',
        functionalMode: 'Functional Module',
        supplier: 'Supplier',
        accessoriesInvolved: 'Involves Accessories',
        functionalDomain: 'Functional Domain',
        invalidPartId: 'Invalid Part ID',
        archivesType: 'File Type',
        archivesGrade: 'File Grade',
        problemDescription: 'Problem Description',
        analysisProgress: 'Analysis Progress',
        qaRemark: 'QA Remark',
        tacRemark: 'TAC Remark',
        responsibleDepartment: 'Responsible Department',
        coordinator: 'Coordinator',
        principal: 'Principal',
        containmentAction: 'Containment Action',
        issueStatus: 'Issue Status',
        softwareProblems: 'Software Problems',
        vehGlobalFwVer_j: 'Baseline Version Number',
        vehGlobalFwPn_j: 'Baseline Part Number',
        ewo: 'EWO Number',
        rootCause: 'Root Cause',
        marketBehavior: 'Market Behavior',
        shortTermMeasures: 'Short-term Measures',
        shortTermBreakpointDescription: 'Short-term Breakpoint Description',
        measuresResult: 'Measures Approval Result',
        measuresConfirmation: 'Measures Confirmation',
        longTermMeasures: 'Long-term Measures',
        longTermMeasuresBreak: 'Long-term Measures Estimated Breakpoint Description',
        implementation: 'Implementation',
        longMeasuresTime: 'Long-term Measures Actual Breakpoint Date',
        vinBreak: 'Long-term Measures Breakpoint VIN',
        breakpointImplementationPhase: 'Breakpoint Implementation Phase',
        archive_Information: 'Archive Information',
        reason_incomplete_closure: 'Reason for Incomplete Closure',
        entry_Date: 'Date of arrival to dealership',
        departure_date: 'Leave Time',
        work_order_number: 'Work Order Number',
        questionnaire_usage: 'Questionnaire Usage',
        classification_of_technical_enquiries: 'Classification Of Technical Enquiries',
        change_of_document_owner: 'Change Of Document Owner',
        oldowner: 'Old Owner',
        newowner: 'New Owner',
        original: 'Original',
        translation: 'Translation',
        dealer_address: 'Dealer address',
        sel_up_engineers: 'Select up to 12 engineers!',
        sel_up_weeks: 'Choose up to 12 weeks!',
        veh_infor_inquiry: 'Vehicle information inquiry',
        create_organization: 'Create Organization',
        ref_code: 'Refresh Captcha',
        fault_complaint_Desp: 'Description of Fault/Customer Complaint Description',
        broken_down_vehicle: 'Broken Down Vehicle',
        reporting_organization: 'Reporting organization',
        reporter: 'Reporter',
        oneclick_convert: 'One-Click Convert',
        assembly: 'Assembly',
        show_original: 'Show Original',
        sync_datong: 'Sync Datong',
        system_category_iii: 'System Category III',
        maxus_Records: 'MAXUS Conversation Records',
    },
    // 德
    deDE: {
        vin: 'VIN',
        inquiry_no: 'Anfragenummer',
        case_theme: 'Ein fall für sich.',
        department_name: 'Abteilungsname',
        department_type: 'Abteilungstyp',
        document_status: 'Dokumentenstatus',
        inquiry_date: 'Datum der Anfrage',
        organization_name: 'Organisationsname',
        name: 'Name des Antragstellers',
        sap_code: 'SAP-Code',
        failed_part: 'Defekte Teile',
        case_type: 'Falltyp',
        vehicle_status: 'Wartungsstatus',
        case_owner: 'Haftpflichtige Person',
        country: 'Land',
        fault_cause: 'Fehlerursache',
        symptoms: 'Fehlerphänomen',
        is_the_document_qualified: 'Ist das Dokument qualifiziert',
        is_the_document_replied_in_a_timely_manner: 'Wird das Dokument rechtzeitig beantwortet',
        filter: 'Filter',
        system_classification_I: 'Systematik I',
        system_classification_II: 'Systematik II',
        full_query: 'vollständige Abfrage',
        fuzzy_query: 'fuzzy-Abfrage',
        whether_belongs_new_car_market: 'Neues Auto gestartet',
        caseStatus: 'Fallstatus',
        correct: 'Richtig',
        deny: 'Ablehnen',
        not_closed: 'Offen',
        no_reply: 'Auf Antwort warten',
        replied: 'Antwort',
        closed: 'Geschlossen',
        drafts: 'Entwurfskasten',
        create_time: 'Erstellungszeit',
        create_user: 'Erstellt von',
        parent_of_document: 'Übergeordneter Dokumententyp',
        document_owner: 'Dokumenteneigentümer',
        case_subject: 'Ein fall für sich',
        receipt_info: 'Empfangsinformationen',
        superior_of_case: 'Er hat den fall aufgeklärt',
        inquiry_time: 'Anfragezeit',
        status: 'Status',
        overseas_company: 'Verkaufsfirmenname',
        general_agent_name: 'Distributeur-Name',
        dealer_code: 'Händlercode',
        dealer_name: 'Händlername',
        name_of_subsidiary: 'Name der Tochtergesellschaft',
        contacts: 'Kontaktperson',
        contact_information: 'Kontaktinformationen',
        training_certification: 'Schulungszertifizierung',
        driving_mileage: 'Fahrleistung',
        plate_number: 'Kennzeichen',
        material_no: 'Fahrzeugmaterialcode',
        material_desc: 'Materialbeschreibung',
        offline_date: 'Off-line Datum',
        model_platform: 'Plattform',
        engine_number: 'Motornummer',
        transmission_type: 'Getriebe',
        assembly_no: 'CSN-Nr.',
        fault_info_desc: 'Fehlerinfo-Beschreibung',
        fault_handle_process: 'Fehlerbehandlungsprozess',
        solution: 'Lösung',
        remark: 'Bemerkung',
        caseRemark: 'Fall Bemerkungen',
        document_information: 'Fallinformationen',
        basic_information_of_service_center: 'Servicecenter-Informationen',
        basic_vehicle_information: 'Fahrzeuggrundinformationen',
        problem_description: 'Problem Beschreibung',
        common_links: 'Allgemeine Links',
        claim_information: 'Reklamationsinformationen',
        diagnostic_report_record: 'Diagnosebericht',
        vehicle_history: 'Technische Anfragengeschichte',
        programming_history: 'Programmierungsverlauf',
        vehicle_sales_logistics_information: 'Fahrzeugverkaufs- und Logistikinformationen',
        new_vehicle_information: 'Informationen für neue Fahrzeuge',
        attachment_upload: 'Anhang hochladen',
        diagnostic_report: 'Diagnosebericht',
        bulk_download: 'Massendownload',
        document_View: 'Dokument anzeigen',
        inquiry_content: 'Anfrageinhalt',
        inquiry_entry: 'Beantwortung der Anfrage',
        subordinate_record: 'Untergeordneter Eintrag',
        superior_record: 'Übergeordneter Eintrag',
        send_content: 'Senden Inhalt',
        send_time: 'Sendezeit',
        sent_username: 'Absender',
        receive_name: 'Empfänger',
        dept_name: 'Ebene',
        enclosure: 'Anlage',
        wind_case: 'Windkoffer',
        close_order: 'Liste schließen',
        case_reporting: 'Fallberichterstattung',
        pdf_preview: 'PDF-Vorschau',
        SIS_maintenance: 'Hauptunfallinstandhaltung',
        Please_fill_in_the_inquiry_content: 'Bitte füllen Sie den Inhalt der Anfrage aus',
        sending_an_email: 'Senden einer E-Mail',
        copy: 'Kopie',
        repeat: 'Vin Wiederholen',
        inconsistent: 'Inkonsistente Fahrzeugplattform',
        sendTo: 'Senden an',
        reply: 'Inhalt für Anfrage/Antwort eingeben',
        please_check_the_exported_document: 'Bitte überprüfen Sie das exportierte Dokument',
        please_upload_diagnostic_report: 'Bitte laden Sie einen Diagnosebericht hoch',
        please_enter_the_vin: 'Bitte geben Sie die VIN ein',
        placeholderDTC: 'Beispiel：P080800_P087D00_------',
        placeholderFaultInfoDesc:
            '1.Überprüfen Sie Kundenanliegen (nur um sicherzustellen, dass Probleme auftreten)',
        placeholderFaultHandleProcess:
            '2.Relevante Symptome identifizieren (alle Symptome identifizieren und aufzeichnen, die mit dem Problem zusammenhängen können)\n' +
            '3.Symptome analysieren (relevante Symptome sorgfältig beobachten, um häufige Ursachen zu identifizieren)\n' +
            '4.Bestätigen Sie das Problem (schränken Sie den Umfang Ihrer Ergebnisse ein, um sicherzustellen, dass Sie das richtige Problem gelöst haben)',
        placeholderSolution:
            '5.Beheben Sie das Problem (führen Sie Reparaturen durch)\n' +
            '6.Überprüfen Sie den Fahrzeugbetrieb (überprüfen Sie, ob Ihre Reparaturen das Problem behoben haben)',
        placeholderRemark: 'Zum Beispiel：Lenkgetriebe-201806，FL Stoßdämpfer-2010101',
        placeholderContact: 'Alle fünf minuten',
        close_time: 'Schließzeit',
        one_touch: 'Fall Rekonstruktion',
        confirm_generating_new_case: 'Generierung neuer Dokumente bestätigen？',
        closing_statement: 'Akte geschlossen',
        number_of_cases: 'Anzahl der Fälle',
        number_of_vehicles: 'Anzahl der Fahrzeuge',
        pleaseEnterContent: 'Bitte Inhalt eingeben',
        case_age: 'Fallalter',
        last_response_time: 'Letzte Antwortzeit',
        time_since_last_response: 'Zeit seit der letzten Antwort',
        warranty_start_date: 'Beginn der Garantie',
        submit_reason: 'Grund für die Einreichung',
        synchronize_PQCP: 'PQCP synchronisieren',
        FPR_export: 'FPR export',
        level_selection: 'Ebenenauswahl',
        category_selection: 'Klassifikationsauswahl',
        brand_selection: 'Markenauswahl',
        code: 'Code',
        description: 'Beschreibung',
        major_complaints: 'Wichtige Beschwerden',
        difficult_miscellaneous_diseases: 'Ein Knotenproblem',
        emerging_issues: 'Neue Probleme',
        breakpoint_failure: 'Bruchpunktfehler',
        general_complaints: 'Allgemeine Beschwerden',
        other: 'Andere',
        roewe: 'Roewe',
        mg: 'MG',
        serious: 'Schwerwiegend',
        secondary: 'Sekundär',
        generally: 'Häufig',
        complete: 'Komplett',
        please_select_level: 'Bitte wählen Sie eine Ebene',
        please_select_category: 'Bitte wählen Sie eine Klassifizierung',
        please_select_brand: 'Bitte wählen Sie eine Marke',
        placeholder_auto: 'Automatisch hervorbringen',
        translate: 'übersetzen',
        isTranslate: 'Übersetzen oder nicht',
        day: 'tag',
        one_click_order: 'Drück den knopf',
        greater_than: 'Größer als',
        less_than: 'Weniger als',
        between: 'Zwischen',
        document_label: 'Dokumentenbezeichnung',
        receipts_first_modification_time: 'Quittungen erste Änderungszeit',
        Selection_of_Document_Owner: 'Auswahl des Dokumentverantwortlichen',
        responsiblePerson: 'Verantwortliche Person：',
        functional_Domain: 'Funktionale Domäne',
        Category: 'Kategorie',
        property: 'Kausalität',
        reRepair: 'Wiederholte Reparaturen',
        pullInNum: 'Anzahl der Einträge',
        perception: 'Wahrnehmungsklasse',
        onSupport: 'Vor-Ort-Unterstützung',
        batteryNo: 'Hintere Motornummer',
        normalStartDate: 'Vordere Motornummer',
        qmotorNo: 'Front Motor Number',
        hmotorNo: 'Rear Motor Number',
        fault_cause_type: 'Fehlerursachentyp',
        measure_name: 'Maßnahmenname',
        part_name: 'Teilname',
        close_order_notification:
            'Das Schließen der Bestellung erfordert eine Antwort vom Antragsteller.',
        TIS_Case_Data: 'TIS Falldaten',
        case_File: 'Falldatei',
        responsibility_Data: 'Verantwortungsdaten',
        longterm_Measures: 'Langfristige Maßnahmen',
        tisCaseNo: 'TIS Fallnummer',
        vehGlobalFwVer: 'Fahrzeugsoftware-Versionsnummer',
        vehGlobalFwPn: 'Fahrzeugsoftware-Teilenummer',
        archivesNo: 'Archivnummer',
        archivesTitle: 'Archivtitel',
        archivesSource: 'Archivquelle',
        proposer: 'Antragsteller',
        proposedTime: 'Antragsdatum',
        archivesManagementPersonnel: 'Verwaltungspersonal',
        functionalMode: 'Funktionsmodul',
        supplier: 'Lieferant',
        accessoriesInvolved: 'Zubehör involviert',
        functionalDomain: 'Funktionsdomäne',
        invalidPartId: 'Ungültige Teil-ID',
        archivesType: 'Archivtyp',
        archivesGrade: 'Archivbewertung',
        problemDescription: 'Problembeschreibung',
        analysisProgress: 'Analysefortschritt',
        qaRemark: 'QA-Bemerkung',
        tacRemark: 'TAC-Bemerkung',
        responsibleDepartment: 'Verantwortliche Abteilung',
        coordinator: 'Koordinator',
        principal: 'Verantwortlicher',
        containmentAction: 'Eindämmungsmaßnahme',
        issueStatus: 'Problemstatus',
        softwareProblems: 'Softwareprobleme',
        vehGlobalFwVer_j: 'Basisversionsnummer',
        vehGlobalFwPn_j: 'Basisteilenummer',
        ewo: 'EWO-Nummer',
        rootCause: 'Grundursache',
        marketBehavior: 'Marktverhalten',
        shortTermMeasures: 'Kurzfristige Maßnahmen',
        shortTermBreakpointDescription: 'Kurzfristige Breakpoint-Beschreibung',
        measuresResult: 'Maßnahmen Genehmigungsergebnis',
        measuresConfirmation: 'Maßnahmen Bestätigung',
        longTermMeasures: 'Langfristige Maßnahmen',
        longTermMeasuresBreak: 'Langfristige Maßnahmen geschätzte Breakpoint-Beschreibung',
        implementation: 'Implementierung',
        longMeasuresTime: 'Langfristige Maßnahmen tatsächliches Breakpoint-Datum',
        vinBreak: 'Langfristige Maßnahmen Breakpoint VIN',
        breakpointImplementationPhase: 'Breakpoint Implementierungsphase',
        archive_Information: 'Archivinformationen',
        reason_incomplete_closure: 'Grund für unvollständige Schließung',
        entry_Date: 'Eingangsdatum',
        departure_date: 'Abfahrtsdatum',
        work_order_number: 'Auftragsnummer',
        questionnaire_usage: 'Verwendungszweck des Fragebogens',
        classification_of_technical_enquiries: 'Klassifikation technischer Anfragen',
        change_of_document_owner: 'Change Of Document Owner',
        oldowner: 'Old Owner',
        newowner: 'New Owner',
        original: 'Original',
        translation: 'Übersetzung',
        dealer_address: 'Händleradresse',
        sel_up_engineers: 'Wählen Sie bis zu 12 Ingenieure aus!',
        sel_up_weeks: 'Wähle bis zu 12 Wochen aus!',
        veh_infor_inquiry: 'Fahrzeuginformationsabfrage',
        create_organization: 'Organisation erstellen',
        ref_code: 'CAPTCHA aktualisieren',
        fault_complaint_Desp: 'Fehlerbeschreibung / Kundenreklamationsbeschreibung',
        broken_down_vehicle: 'Liegen gebliebenes Fahrzeug',
        reporting_organization: 'meldenden Organisation',
        reporter: 'Melder',
        oneclick_convert: 'Ein-Klick-Konvertierung',
        assembly: 'Montage',
        show_original: 'Original anzeigen',
        sync_datong: 'Datong synchronisieren',
        system_category_iii: 'Systemkategorie III',
        maxus_Records: 'MAXUS Gesprächsprotokolle',
    },
    // 法
    frFR: {
        vin: 'VIN',
        inquiry_no: 'Numéro du cas',
        case_theme: 'Sujet du cas',
        department_name: 'Nom du service',
        department_type: 'Type de service',
        document_status: 'Statut du document',
        inquiry_date: 'Date de l\'enquête',
        organization_name: 'Nom de l\'organisation',
        name: 'Nom du promoteur',
        sap_code: 'Code SAP',
        failed_part: 'Pièces affectées',
        case_type: 'Type de cas',
        vehicle_status: 'État des réparations',
        case_owner: 'Personnes responsables',
        country: 'Pays',
        fault_cause: 'Cause du défaut',
        symptoms: 'Défaut constaté',
        is_the_document_qualified: 'Le document est - il conforme',
        is_the_document_replied_in_a_timely_manner:
            'Les documents répondent - ils en temps opportun',
        filter: 'Filtre',
        system_classification_I: 'Système 1',
        system_classification_II: 'Système 2',
        full_query: 'Recherche complète',
        fuzzy_query: 'Recherche floue',
        whether_belongs_new_car_market: 'Lancement d\'un nouveau modèle',
        caseStatus: 'État du cas',
        correct: 'Correct',
        deny: 'Refuser',
        not_closed: 'Ouvert',
        no_reply: 'En attente de réponse',
        replied: 'Répondu',
        closed: 'Fermé',
        drafts: 'Brouillons',
        create_time: 'Heure de création ',
        create_user: 'Créé par',
        parent_of_document: 'Cas supérieur',
        document_owner: 'Responsable du cas',
        case_subject: 'Sujet du cas',
        receipt_info: 'Information sur le cas ',
        superior_of_case: 'Appartenance du cas supérieur',
        inquiry_time: 'Temps d\'enquête',
        status: 'Statut',
        overseas_company: 'Nom de la société',
        general_agent_name: 'Nom du distributeur',
        dealer_code: 'Code réparateur',
        dealer_name: 'Nom du distributeur',
        name_of_subsidiary: 'Nom de la filiale',
        contacts: 'Personne à contacter',
        contact_information: 'Information de contact',
        training_certification: 'Niveau de formation',
        driving_mileage: 'Kilométrage',
        plate_number: 'Plaque d\'immatriculation',
        material_no: 'Code modèle',
        material_desc: 'Description',
        offline_date: 'Date de fabrication',
        model_platform: 'Platforme',
        engine_number: 'Numéro moteur',
        transmission_type: 'Transmission',
        assembly_no: 'Numéro CSN',
        fault_info_desc: 'Description du problème',
        fault_handle_process: 'Action corrective',
        solution: 'Solution',
        remark: 'Remarque',
        caseRemark: 'CAS Remarques',
        document_information: 'Information sur le cas ',
        basic_information_of_service_center: 'Information sur le Réparateur ',
        basic_vehicle_information: 'Informations de base sur le véhicule',
        problem_description: 'Déscription du problème',
        common_links: 'Lien utile',
        claim_information: 'Informations sur la réclamation',
        diagnostic_report_record: 'Rapport de diagnostic',
        vehicle_history: 'Historique technique',
        programming_history: 'Historique de programmation',
        vehicle_sales_logistics_information: 'Informations sur la logistique et sur la vente',
        new_vehicle_information: 'Informations sur les nouveaux véhicules',
        attachment_upload: 'Téléchargement de pièces jointes',
        diagnostic_report: 'Rapport de diagnostic',
        bulk_download: 'Téléchargement en masse',
        document_View: 'Affichage du document',
        inquiry_content: 'Détails de la recherche',
        inquiry_entry: 'Demande de réponse',
        subordinate_record: 'Enregistrement subordonné',
        superior_record: 'Enregistrement supérieur',
        send_content: 'Envoyer du contenue',
        send_time: 'Envoyer le',
        sent_username: 'Expéditeur',
        receive_name: 'Envoyer à',
        dept_name: 'Niveau',
        enclosure: 'Pièces jointes',
        wind_case: 'Cas de vent',
        close_order: 'Fermer la monade',
        case_reporting: 'Cas soumis',
        pdf_preview: 'Aperçu PDF',
        SIS_maintenance: 'Entretien des accidents majeurs',
        sending_an_email: 'Envoyer un email',
        copy: 'Copier',
        repeat: 'Répéter le VIN',
        inconsistent: 'Plate-forme de modèle incohérente',
        sendTo: 'Envoyer à',
        reply: 'Contribution à la recherche',
        please_check_the_exported_document: 'Veuillez cocher le document exporté',
        please_upload_diagnostic_report: 'Veuillez télécharger le rapport de diagnostic',
        please_enter_the_vin: 'Veuillez entrer le VIN',
        placeholderDTC: 'Exemples：P080800_P087D00_------',
        placeholderFaultInfoDesc:
            '1.Vérifiez les préoccupations des clients (juste pour vous assurer que quelque chose ne va pas)',
        placeholderFaultHandleProcess:
            '2.Identifier les symptômes associés (trouver et documenter tous les symptômes qui peuvent être associés au problème)\n' +
            '3.Analyser les symptômes (Regardez attentivement les symptômes pertinents pour trouver les causes communes)\n' +
            '4.Confirmer le problème (rétrécissez vos résultats pour vous assurer que vous avez résolu le bon problème)',
        placeholderSolution:
            '5.Résoudre les problèmes (effectuer des réparations)\n' +
            '6.Vérifiez le fonctionnement du véhicule (Vérifiez que les correctifs que vous avez effectués ont résolu le problème)',
        placeholderRemark:
            'Par exemple：Machine de direction-201806，FL Amortisseur de chocs-2010101',
        placeholderContact: 'Veuillez entrer le nom de l’opérateur',
        close_time: 'Temps de fermeture',
        one_touch: 'CAS Reconstruction',
        confirm_generating_new_case: 'Déterminer la génération d\'un nouveau document？',
        closing_statement: 'Note de clôture',
        number_of_cases: 'Nombre de cas',
        number_of_vehicles: 'Nombre de véhicules',
        pleaseEnterContent: 'Veuillez entrer le contenu',
        case_age: 'Âge du cas',
        last_response_time: 'Dernier temps de réponse',
        time_since_last_response: 'Temps écoulé depuis la dernière réponse',
        warranty_start_date: 'Date de début de la garantie',
        submit_reason: 'Raison de la soumission',
        synchronize_PQCP: 'Synchronisation PQCP',
        FPR_export: 'FPR exportation',
        level_selection: 'Sélection des niveaux',
        category_selection: 'Sélection de catégories',
        brand_selection: 'Sélection de marques',
        code: 'Code',
        description: 'Description',
        major_complaints: 'Plaintes majeures',
        difficult_miscellaneous_diseases: 'Trouble suspect',
        emerging_issues: 'Nouveaux problèmes',
        breakpoint_failure: 'Défaillance du point d\'arrêt',
        general_complaints: 'Plaintes générales',
        other: 'Autres',
        roewe: 'Ronway',
        mg: 'MG',
        serious: 'Sérieux',
        secondary: 'Secondaire',
        generally: 'Général',
        complete: 'Terminé',
        please_select_level: 'Veuillez sélectionner un niveau',
        please_select_category: 'Veuillez sélectionner une classification',
        please_select_brand: 'Veuillez sélectionner une marque',
        placeholder_auto: 'Sortir automatiquement',
        translate: 'Traduction',
        isTranslate: 'Traduire ou non',
        day: 'jours',
        one_click_order: 'Une clé pour fermer la commande',
        greater_than: 'Supérieure à',
        less_than: 'Moins que',
        between: 'Entre',
        document_label: 'Étiquettes des documents',
        receipts_first_modification_time: 'Reçus première heure de modification',
        Selection_of_Document_Owner: 'Sélection du Responsable du Document',
        responsiblePerson: 'Personne Responsable：',
        functional_Domain: 'Domaine Fonctionnel',
        Category: 'Catégorie',
        property: 'Causalité',
        reRepair: 'Réparations répétées',
        pullInNum: 'Nombre d\'entrées',
        perception: 'Classe de perception',
        onSupport: 'Support sur site',
        batteryNo: 'Numéro de batterie',
        normalStartDate: 'Date de garantie',
        qmotorNo: 'Numéro de moteur avant',
        hmotorNo: 'Numéro de moteur arrière',
        fault_cause_type: 'Type de cause de panne',
        measure_name: 'Nom de la mesure',
        part_name: 'Nom de la pièce',
        close_order_notification:
            'La fermeture de la commande nécessite une réponse de la partie proposante.',
        TIS_Case_Data: 'Données de cas TIS',
        case_File: 'Fichier de cas',
        responsibility_Data: 'Données de responsabilité',
        longterm_Measures: 'Mesures à long terme',

        tisCaseNo: 'Numéro de cas TIS',
        vehGlobalFwVer: 'Numéro de version du logiciel du véhicule',
        vehGlobalFwPn: 'Numéro de pièce du logiciel du véhicule',
        archivesNo: 'Numéro de dossier',
        archivesTitle: 'Titre du dossier',
        archivesSource: 'Source du dossier',
        proposer: 'Proposant',
        proposedTime: 'Date de proposition',
        archivesManagementPersonnel: 'Personnel de gestion',
        functionalMode: 'Module fonctionnel',
        supplier: 'Fournisseur',
        accessoriesInvolved: 'Accessoires impliqués',
        functionalDomain: 'Domaine fonctionnel',
        invalidPartId: 'ID de pièce invalide',
        archivesType: 'Type de dossier',
        archivesGrade: 'Évaluation du dossier',
        problemDescription: 'Description du problème',
        analysisProgress: 'Progrès de l\'analyse',
        qaRemark: 'Remarque QA',
        tacRemark: 'Remarque TAC',
        responsibleDepartment: 'Département responsable',
        coordinator: 'Coordinateur',
        principal: 'Responsable',
        containmentAction: 'Action de confinement',
        issueStatus: 'Statut du problème',
        softwareProblems: 'Problèmes logiciels',
        vehGlobalFwVer_j: 'Numéro de version de base',
        vehGlobalFwPn_j: 'Numéro de pièce de base',
        ewo: 'Numéro EWO',
        rootCause: 'Cause principale',
        marketBehavior: 'Comportement du marché',
        shortTermMeasures: 'Mesures à court terme',
        shortTermBreakpointDescription: 'Description du Breakpoint à court terme',
        measuresResult: 'Résultat de l\'approbation des mesures',
        measuresConfirmation: 'Confirmation des mesures',
        longTermMeasures: 'Mesures à long terme',
        longTermMeasuresBreak: 'Description estimée du Breakpoint des mesures à long terme',
        implementation: 'Implémentation',
        longMeasuresTime: 'Date réelle du Breakpoint des mesures à long terme',
        vinBreak: 'VIN du Breakpoint des mesures à long terme',
        breakpointImplementationPhase: 'Phase d\'implémentation du Breakpoint',
        archive_Information: 'Informations d\'archive',
        reason_incomplete_closure: 'Raison de la fermeture incomplète',
        entry_Date: 'Date d\'entrée',
        departure_date: 'Date de départ',
        work_order_number: 'Numéro de commande',
        questionnaire_usage: 'Utilisation du questionnaire',
        classification_of_technical_enquiries: 'Classification des demandes techniques',
        change_of_document_owner: 'Change Of Document Owner',
        oldowner: 'Old Owner',
        newowner: 'New Owner',
        original: 'Original',
        translation: 'Traduction',
        dealer_address: 'Adresse du concessionnaire',
        sel_up_engineers: 'Sélectionnez jusqu\'à 12 ingénieurs !',
        sel_up_weeks: 'Choisissez jusqu\'à 12 semaines !',
        veh_infor_inquiry: 'Recherche d\'informations sur le véhicule',
        create_organization: 'Créer une organisation',
        ref_code: 'Actualiser le captcha',
        fault_complaint_Desp: 'Description de la panne / Description de la réclamation client',
        broken_down_vehicle: 'Véhicule en panne',
        reporting_organization: 'l\'organisation de rapport',
        reporter: 'Déclarant',
        oneclick_convert: 'Conversion en un clic',
        assembly: 'Assemblage',
        show_original: 'Afficher l’original',
        sync_datong: 'Synchroniser Datong',
        system_category_iii: 'Catégorie système III',
        maxus_Records: 'Enregistrements de conversations MAXUS',
    },
    // 意大利
    itIT: {
        vin: 'Vin',
        inquiry_no: 'Numero di richiesta',
        case_theme: 'Tema case',
        department_name: 'Nome del dipartimento',
        department_type: 'Tipo di dipartimento',
        document_status: 'Stato del documento',
        inquiry_date: 'Data della richiesta',
        organization_name: 'Nome dell\'organizzazione',
        name: 'Nome del proponente',
        sap_code: 'Codice SAP',
        failed_part: 'Parte difettosa',
        case_type: 'Tipo di caso',
        vehicle_status: 'Stato di manutenzione',
        case_owner: 'Persona responsabile',
        country: 'Paese',
        fault_cause: 'Causa del malfunzionamento',
        symptoms: 'Sintomi del malfunzionamento',
        is_the_document_qualified: 'Il documento è qualificato',
        is_the_document_replied_in_a_timely_manner: 'Il documento risponde tempestivamente',
        filter: 'Filtro',
        system_classification_I: 'Classificazione del sistema I',
        system_classification_II: 'Classificazione del sistema II',
        full_query: 'Query completa',
        fuzzy_query: 'Query sfuocata',
        whether_belongs_new_car_market: 'Appartiene al nuovo mercato dell\'auto',
        caseStatus: 'Stato del caso',
        correct: 'Si',
        deny: 'No',
        not_closed: 'Non chiuso',
        no_reply: 'Attendere la risposta',
        replied: 'Risposta',
        closed: 'Chiuso',
        drafts: 'Bozze',
        create_time: 'Data di creazione',
        create_user: 'Creatore',
        parent_of_document: 'Documento genitore',
        document_owner: 'Proprietario del documento',
        case_subject: 'Oggetto della causa',
        receipt_info: 'Informazioni di ricevimento',
        superior_of_case: 'Superiore gerarchico',
        inquiry_time: 'Orario della richiesta',
        status: 'Stato',
        overseas_company: 'Nome dell\'azienda estera',
        general_agent_name: 'Nome dell\'agente generale',
        dealer_code: 'Codice del concessionario',
        dealer_name: 'Nome del concessionario',
        name_of_subsidiary: 'Nome della sussidiaria',
        contacts: 'Contatti',
        contact_information: 'Informazioni di contatto',
        training_certification: 'Certificazione di formazione',
        driving_mileage: 'Chilometraggio di guida',
        plate_number: 'Numero di targa',
        material_no: 'Numero di materiale',
        material_desc: 'Descrizione del materiale',
        offline_date: 'Data offline',
        model_platform: 'Piattaforma del modello',
        engine_number: 'Numero del motore',
        transmission_type: 'Tipo di trasmissione',
        assembly_no: 'Numero di assemblaggio',
        fault_info_desc: 'Descrizione informazioni malfunzionamento',
        fault_handle_process: 'Processo di gestione di malfunzionamento',
        solution: 'Soluzione',
        remark: 'Nota',
        caseRemark: 'caso Nota',
        document_information: 'Informazioni del documento',
        basic_information_of_service_center: 'Informazioni di base del centro assistenza',
        basic_vehicle_information: 'Informazioni di base del veicolo',
        problem_description: 'Descrizione del problema',
        common_links: 'Link comuni',
        claim_information: 'Informazioni sulla richiesta',
        diagnostic_report_record: 'Record di rapporto diagnostico',
        vehicle_history: 'Documento di richiesta storica del veicolo',
        programming_history: 'Storia della programmazione',
        vehicle_sales_logistics_information:
            'Informazioni sulle vendite e sulla logistica del veicolo',
        new_vehicle_information: 'Informazioni sui veicoli nuovi',
        attachment_upload: 'Upload degli allegati',
        diagnostic_report: 'Rapporto diagnostico',
        bulk_download: 'Download in blocco',
        document_View: 'Visualizza documento',
        inquiry_content: 'Contenuto della richiesta',
        inquiry_entry: 'Risposta all\'inchiesta',
        subordinate_record: 'Record delle risposte subordinate',
        superior_record: 'Record delle risposte superiori',
        send_content: 'Invia contenuto',
        send_time: 'Orario di invio',
        sent_username: 'Mittente',
        receive_name: 'Destinatario',
        dept_name: 'Livello',
        enclosure: 'Allegato',
        wind_case: 'Chiudere il caso',
        close_order: 'Lista chiusa',
        case_reporting: 'Segnalazione dei casi',
        pdf_preview: 'Anteprima PDF',
        SIS_maintenance: 'Manutenzione di incidenti significativi',
        Please_fill_in_the_inquiry_content: 'Si prega di compilare il contenuto della richiesta',
        sending_an_email: 'Invio di una email',
        copy: 'Copia',
        repeat: 'Vin ripeti',
        inconsistent: 'Piattaforma del veicolo incoerente',
        sendTo: 'Invia a',
        reply: 'Inserisci il contenuto per la richiesta/risposta',
        please_check_the_exported_document: 'Controlla il documento esportato',
        please_upload_diagnostic_report: 'Carica un rapporto diagnostico',
        please_enter_the_vin: 'Inserire il VIN',
        placeholderDTC: 'Esempio：P080800_P087D00_------',
        placeholderFaultInfoDesc:
            '1.Verificare le preoccupazioni dei clienti (solo per assicurarsi che sorgano problemi)',
        placeholderFaultHandleProcess:
            '2.Identificare i sintomi rilevanti (identificare e registrare tutti i sintomi che possono essere correlati al problema)\n' +
            '3.Analizzare i sintomi (osservare attentamente i sintomi rilevanti per identificare le cause comuni)\n' +
            '4.Confermare il problema (restringere la portata dei risultati per assicurarsi di aver risolto il problema corretto)',
        placeholderSolution:
            '5.Risolvere il problema (effettuare riparazioni)\n' +
            '6.Verificare il funzionamento del veicolo (verificare che le riparazioni abbiano risolto il problema)',
        placeholderRemark: 'Per esempio：Servosterzo-201806，FL Ammortizzatore-2010101',
        placeholderContact: 'Digitare il nome dell’operatore',
        close_time: 'Orario di chiusura',
        one_touch: 'caso ricostruzione',
        confirm_generating_new_case: 'Conferma la generazione di nuovi documenti？',
        closing_statement: 'Dichiarazione di chiusura',
        number_of_cases: 'Numero di casi',
        number_of_vehicles: 'Numero di veicoli',
        pleaseEnterContent: 'Inserisci il contenuto',
        case_age: 'Età del caso',
        last_response_time: 'Tempo di risposta ultima',
        time_since_last_response: 'Tempo dall\'ultima risposta',
        warranty_start_date: 'Data di inizio della garanzia',
        submit_reason: 'Motivo della presentazione',
        synchronize_PQCP: 'Sincronizza PQCP',
        FPR_export: 'FPR Esportazione',
        level_selection: 'Selezione del livello',
        category_selection: 'Selezione della classificazione',
        brand_selection: 'Selezione del marchio',
        code: 'Codice',
        description: 'Descrivere',
        major_complaints: 'Principali reclami',
        difficult_miscellaneous_diseases: 'Un problema nodoso',
        emerging_issues: 'Questioni emergenti',
        breakpoint_failure: 'Guasto al punto di rottura',
        general_complaints: 'Reclami generali',
        other: 'Altro',
        roewe: 'Roewe',
        mg: 'MG',
        serious: 'Sérieux',
        secondary: 'Secondaire',
        generally: 'Général',
        complete: 'completo',
        please_select_level: 'Seleziona un livello',
        please_select_category: 'Seleziona una classificazione',
        please_select_brand: 'Seleziona una marca',
        placeholder_auto: 'Estrarre automaticamente',
        translate: 'Traduci',
        isTranslate: 'Traduci o no',
        day: 'giorno',
        one_click_order: 'Una barra di sicurezza',
        greater_than: 'Maggiore di',
        less_than: 'Inferiore a',
        between: 'Tra',
        document_label: 'Etichetta del documento',
        receipts_first_modification_time: 'Ricevute tempo di prima modifica',
        Selection_of_Document_Owner: 'Selezione del Responsabile del Documento',
        responsiblePerson: 'Persona Responsabile：',
        functional_Domain: 'Dominio Funzionale',
        Category: 'Categoria',
        property: 'causalità',
        reRepair: 'Riparazioni ripetute',
        pullInNum: 'Numero di ingressi',
        perception: 'Classe di percezione',
        onSupport: 'Supporto in loco',
        batteryNo: 'Numero della batteria',
        normalStartDate: 'Data di garanzia',
        qmotorNo: 'Numero motore anteriore',
        hmotorNo: 'Numero motore posteriore',
        fault_cause_type: 'Tipo di causa del guasto',
        measure_name: 'Nome della misura',
        part_name: 'Nome del pezzo',
        close_order_notification: 'La chiusura dell\'ordine richiede una risposta dal proponente.',
        TIS_Case_Data: 'Dati del caso TIS',
        case_File: 'File del caso',
        responsibility_Data: 'Dati di responsabilità',
        longterm_Measures: 'Misure a lungo termine',
        tisCaseNo: 'Numero del caso TIS',
        vehGlobalFwVer: 'Numero di versione del software del veicolo',
        vehGlobalFwPn: 'Numero di parte del software del veicolo',
        archivesNo: 'Numero di archivio',
        archivesTitle: 'Titolo dell\'archivio',
        archivesSource: 'Fonte dell\'archivio',
        proposer: 'Proponente',
        proposedTime: 'Data di proposta',
        archivesManagementPersonnel: 'Personale di gestione',
        functionalMode: 'Modulo funzionale',
        supplier: 'Fornitore',
        accessoriesInvolved: 'Accessori coinvolti',
        functionalDomain: 'Dominio funzionale',
        invalidPartId: 'ID parte non valida',
        archivesType: 'Tipo di archivio',
        archivesGrade: 'Valutazione dell\'archivio',
        problemDescription: 'Descrizione del problema',
        analysisProgress: 'Progresso dell\'analisi',
        qaRemark: 'Osservazione QA',
        tacRemark: 'Osservazione TAC',
        responsibleDepartment: 'Dipartimento responsabile',
        coordinator: 'Coordinatore',
        principal: 'Responsabile',
        containmentAction: 'Azione di contenimento',
        issueStatus: 'Stato del problema',
        softwareProblems: 'Problemi software',
        vehGlobalFwVer_j: 'Numero di versione di base',
        vehGlobalFwPn_j: 'Numero di parte di base',
        ewo: 'Numero EWO',
        rootCause: 'Causa principale',
        marketBehavior: 'Comportamento di mercato',
        shortTermMeasures: 'Misure a breve termine',
        shortTermBreakpointDescription: 'Descrizione del Breakpoint a breve termine',
        measuresResult: 'Risultato dell\'approvazione delle misure',
        measuresConfirmation: 'Conferma delle misure',
        longTermMeasures: 'Misure a lungo termine',
        longTermMeasuresBreak: 'Descrizione stimata del Breakpoint delle misure a lungo termine',
        implementation: 'Implementazione',
        longMeasuresTime: 'Data effettiva del Breakpoint delle misure a lungo termine',
        vinBreak: 'VIN del Breakpoint delle misure a lungo termine',
        breakpointImplementationPhase: 'Fase di implementazione del Breakpoint',
        archive_Information: 'Informazioni sull\'archivio',
        reason_incomplete_closure: 'Motivo della chiusura incompleta',
        entry_Date: 'Data di ingresso',
        departure_date: 'Data di partenza',
        work_order_number: 'Numero dell\'ordine di lavoro',
        questionnaire_usage: 'Uso del questionario',
        classification_of_technical_enquiries: 'Classificazione delle richieste tecniche',
        change_of_document_owner: 'Change Of Document Owner',
        oldowner: 'Old Owner',
        newowner: 'New Owner',
        original: 'Originale',
        translation: 'Traduzione',
        dealer_address: 'Indirizzo del rivenditore',
        sel_up_engineers: 'Seleziona fino a 12 ingegneri!',
        sel_up_weeks: 'Scegli fino a 12 settimane!',
        veh_infor_inquiry: 'Ricerca delle informazioni del veicolo',
        create_organization: 'Crea organizzazione',
        ref_code: 'Aggiorna il captcha',
        fault_complaint_Desp: 'Descrizione del guasto / Descrizione del reclamo del cliente',
        broken_down_vehicle: 'Veicolo in panne',
        reporting_organization: 'Organizzazione Segnalante',
        reporter: 'Segnalante',
        oneclick_convert: 'Conversione in un clic',
        assembly: 'Assemblaggio',
        show_original: 'Mostra originale',
        sync_datong: 'Sincronizza Datong',
        system_category_iii: 'Categoria sistema III',
        maxus_Records: 'Registri delle conversazioni MAXUS',
    },
    // 荷兰
    nlNL: {
        vin: 'VIN',
        inquiry_no: 'Geval Nr',
        case_theme: 'Hoofdthema',
        department_name: 'Afdelingsnaam',
        department_type: 'Afdelingstype',
        document_status: 'Documentstatus',
        inquiry_date: 'Datum van onderzoek',
        organization_name: 'Organisatienaam',
        name: 'Naam van de indiener',
        sap_code: 'SAP-code',
        failed_part: 'Getroffen onderdeel',
        case_type: 'Gevaltype',
        vehicle_status: 'Staat van onderhoud',
        case_owner: 'Aansprakelijk persoon',
        country: 'Land',
        fault_cause: 'Foutoorzaak',
        symptoms: 'Foutverschijnselen',
        is_the_document_qualified: 'Is het document gekwalificeerd',
        is_the_document_replied_in_a_timely_manner: 'Is het document tijdig beantwoord?',
        filter: 'Filter',
        system_classification_I: 'Systeemclassificatie I',
        system_classification_II: 'Systeemclassificatie II',
        full_query: 'Volledige zoekopdracht',
        fuzzy_query: 'Zoeken op overeenkomsten',
        whether_belongs_new_car_market: 'Nieuw voertuig geïntroduceerd',
        caseStatus: 'Case status',
        correct: 'Correct',
        deny: 'Ontkennen',
        not_closed: 'Open',
        no_reply: 'Wachten op antwoord',
        replied: 'Beantwoord',
        closed: 'Gesloten',
        drafts: 'Concepten',
        create_time: 'Aanmaaktijd',
        create_user: 'Gemaakt door',
        parent_of_document: 'Ouder van het document',
        document_owner: 'Documenteigenaar',
        case_subject: 'Hoofdthema',
        receipt_info: 'Ontvangstinfo',
        superior_of_case: 'De hierarchieke meerdere van de zaak',
        inquiry_time: 'Onderzoekstijd',
        status: 'Status',
        overseas_company: 'Verkoopmaatschappij naam',
        general_agent_name: 'Distributeur naam',
        dealer_code: 'Dealer code',
        dealer_name: 'Dealer naam',
        name_of_subsidiary: 'Naam van dochteronderneming',
        contacts: 'Contactpersoon',
        contact_information: 'Contactgegevens',
        training_certification: 'Training certificering',
        driving_mileage: 'Kilometerstand',
        plate_number: 'Kenteken',
        material_no: 'Voertuigmateriaalcode',
        material_desc: 'Materiaalomschrijving',
        offline_date: 'Offline datum',
        model_platform: 'Modelplatform',
        engine_number: 'Motornummer',
        transmission_type: 'Transmissie',
        assembly_no: 'CSN nr.',
        fault_info_desc: 'Foutinformatie beschrijving',
        fault_handle_process: 'Foutafhandelingsproces',
        solution: 'Oplossing',
        remark: 'Opmerking',
        caseRemark: 'geval Opmerkingen',
        document_information: 'Dossier informatie',
        basic_information_of_service_center: 'Basisinformatie van servicecentrum',
        basic_vehicle_information: 'Basisvoertuiginformatie',
        problem_description: 'Probleemomschrijving',
        common_links: 'Veelvoorkomende links',
        claim_information: 'Claim informatie',
        diagnostic_report_record: 'Diagnostisch rapport',
        vehicle_history: 'Technische onderzoekshistorie',
        programming_history: 'Programmeerhistorie',
        vehicle_sales_logistics_information: 'Voertuig verkoop- en logistieke informatie',
        new_vehicle_information: 'Nieuwe voertuiginformatie',
        attachment_upload: 'Bijlage uploaden',
        diagnostic_report: 'Diagnostisch rapport',
        bulk_download: 'Bulk download',
        document_View: 'Documentweergave',
        inquiry_content: 'Onderzoeksdetails',
        inquiry_entry: 'Antwoord op het onderzoek',
        subordinate_record: 'Ondergeschikte records',
        superior_record: 'Superieure records',
        send_content: 'Verstuur inhoud',
        send_time: 'Verstuurtijd',
        sent_username: 'Verzender',
        receive_name: 'Ontvanger',
        dept_name: 'Niveau',
        enclosure: 'Bijlage',
        wind_case: 'Wind case',
        close_order: 'Gesloten lijst',
        case_reporting: 'Rapportage van zaken',
        pdf_preview: 'PDF Voorbeeld',
        SIS_maintenance: 'Belangrijk onderhoud na een ongeval',
        Please_fill_in_the_inquiry_content: 'Vul de onderzoeksinhoud in',
        sending_an_email: 'Een e-mail versturen',
        copy: 'Kopie',
        repeat: 'Vin herhalen',
        inconsistent: 'Onconsistent voertuigplatform',
        sendTo: 'Verzenden naar',
        reply: 'Inhoud invoeren voor onderzoek/antwoord',
        please_check_the_exported_document: 'Controleer het geëxporteerde document',
        please_upload_diagnostic_report: 'Upload een diagnoserapport',
        please_enter_the_vin: 'Voer het VIN in',
        placeholderDTC: 'Voorbeeld：P080800_P087D00_------',
        placeholderFaultInfoDesc:
            '1.Controleer de zorgen van klanten (alleen om ervoor te zorgen dat er problemen ontstaan)',
        placeholderFaultHandleProcess:
            '2.Identificeer relevante symptomen (identificeer en registreer alle symptomen die gerelateerd kunnen zijn aan het probleem)\n' +
            '3.Symptomen analyseren (relevante symptomen zorgvuldig observeren om veelvoorkomende oorzaken te identificeren)\n' +
            '4.Bevestig het probleem (beperk de reikwijdte van uw resultaten om ervoor te zorgen dat u het juiste probleem hebt opgelost)',
        placeholderSolution:
            '5.Het probleem oplossen (reparaties uitvoeren)\n' +
            '6.Controleer de werking van het voertuig (controleer of uw reparaties het probleem hebben opgelost)',
        placeholderRemark: 'Bijvoorbeeld：Stuurwerk-201806，FL Schokdemper-2010101',
        placeholderContact: 'Voer de naam van de operator in',
        close_time: 'Sluitijd',
        one_touch: 'geval reconstructie',
        confirm_generating_new_case: 'Bevestig het genereren van nieuwe documenten？',
        closing_statement: 'Omschrijving van de zaak',
        number_of_cases: 'Aantal gevallen',
        number_of_vehicles: 'Aantal voertuigen',
        pleaseEnterContent: 'Voer inhoud in',
        case_age: 'Leeftijd van het geval',
        last_response_time: 'Laatste responstijd',
        time_since_last_response: 'Tijd sinds laatste reactie',
        warranty_start_date: 'Beginddatum van de garantie',
        submit_reason: 'Reden voor indiening',
        synchronize_PQCP: 'PQCP synchroniseren',
        FPR_export: 'FPR export',
        level_selection: 'Niveauselectie',
        category_selection: 'Classificatie selectie',
        brand_selection: 'Merkselectie',
        code: 'Code',
        description: 'Beschrijven',
        major_complaints: 'Belangrijke klachten',
        difficult_miscellaneous_diseases: 'Een knoopprobleem',
        emerging_issues: 'Opkomende kwesties',
        breakpoint_failure: 'Breekpunt mislukt',
        general_complaints: 'Algemene klachten',
        other: 'Andere',
        roewe: 'Roewe',
        mg: 'MG',
        serious: 'Ernstig',
        secondary: 'Secundair',
        generally: 'Vaak',
        complete: 'Compleet',
        please_select_level: 'Selecteer een niveau',
        please_select_category: 'Selecteer een classificatie',
        please_select_brand: 'Selecteer een merk',
        placeholder_auto: 'Automatisch naar buiten brengen',
        translate: 'Vertalen',
        isTranslate: 'Vertalen of niet',
        day: 'dag',
        one_click_order: 'Eén sleutel',
        greater_than: 'Groter dan',
        less_than: 'Minder dan',
        between: 'Tussen',
        document_label: 'Documentlabel',
        receipts_first_modification_time: 'Ontvangsten eerste wijzigingstijd',
        Selection_of_Document_Owner: 'Selectie van de Documentverantwoordelijke',
        responsiblePerson: 'Verantwoordelijke Persoon：',
        functional_Domain: 'Functioneel Domein',
        Category: 'Categorie',
        property: 'causaliteit',
        reRepair: 'Herhaalde reparaties',
        pullInNum: 'Aantal entries',
        perception: 'Waarnemingsklasse',
        onSupport: 'On-site ondersteuning',
        batteryNo: 'Batterijnummer',
        normalStartDate: 'Garantiedatum',
        qmotorNo: 'Voorste motornummer',
        hmotorNo: 'Achterste motornummer',
        fault_cause_type: 'Foutoorzaaktype',
        measure_name: 'Maatregelnaam',
        part_name: 'Onderdeelsnaam',
        close_order_notification:
            'Het sluiten van de bestelling vereist een reactie van de voorsteller.',
        TIS_Case_Data: 'TIS Zaakgegevens',
        case_File: 'Zaakbestand',
        responsibility_Data: 'Verantwoordelijkheidsgegevens',
        longterm_Measures: 'Langetermijnmaatregelen',
        tisCaseNo: 'TIS Zaaknummer',
        vehGlobalFwVer: 'Voertuigsoftware Versienummer',
        vehGlobalFwPn: 'Voertuigsoftware Onderdeelnummer',
        archivesNo: 'Dossiernummer',
        archivesTitle: 'Dossiertitel',
        archivesSource: 'Dossierbron',
        proposer: 'Voorsteller',
        proposedTime: 'Voorgestelde Datum',
        archivesManagementPersonnel: 'Beheerders',
        functionalMode: 'Functioneel Module',
        supplier: 'Leverancier',
        accessoriesInvolved: 'Betrokken Accessoires',
        functionalDomain: 'Functioneel Domein',
        invalidPartId: 'Ongeldig Onderdeel ID',
        archivesType: 'Dossiertype',
        archivesGrade: 'Dossierbeoordeling',
        problemDescription: 'Probleembeschrijving',
        analysisProgress: 'Analysevoortgang',
        qaRemark: 'QA Opmerking',
        tacRemark: 'TAC Opmerking',
        responsibleDepartment: 'Verantwoordelijke Afdeling',
        coordinator: 'Coördinator',
        principal: 'Verantwoordelijke',
        containmentAction: 'Beheersmaatregel',
        issueStatus: 'Probleemstatus',
        softwareProblems: 'Softwareproblemen',
        vehGlobalFwVer_j: 'Baseline Versienummer',
        vehGlobalFwPn_j: 'Baseline Onderdeelnummer',
        ewo: 'EWO Nummer',
        rootCause: 'Hoofdoorzaak',
        marketBehavior: 'Marktgedrag',
        shortTermMeasures: 'Korte Termijn Maatregelen',
        shortTermBreakpointDescription: 'Korte Termijn Breakpoint Beschrijving',
        measuresResult: 'Maatregelen Goedkeuringsresultaat',
        measuresConfirmation: 'Maatregelen Bevestiging',
        longTermMeasures: 'Lange Termijn Maatregelen',
        longTermMeasuresBreak: 'Geschatte Breakpoint Beschrijving van Lange Termijn Maatregelen',
        implementation: 'Implementatie',
        longMeasuresTime: 'Werkelijke Breakpoint Datum van Lange Termijn Maatregelen',
        vinBreak: 'Break VIN van Lange Termijn Maatregelen',
        breakpointImplementationPhase: 'Implementatiefase van Breakpoint',
        archive_Information: 'Archiefinformatie',
        reason_incomplete_closure: 'Reden voor onvolledige sluiting',
        entry_Date: 'Ingangsdatum',
        departure_date: 'Vertrekdatum',
        work_order_number: 'Werkordernummer',
        questionnaire_usage: 'Gebruik van de vragenlijst',
        classification_of_technical_enquiries: 'Classificatie van technische vragen',
        change_of_document_owner: 'Change Of Document Owner',
        oldowner: 'Old Owner',
        newowner: 'New Owner',
        original: 'Origineel',
        translation: 'Vertaling',
        dealer_address: 'Adres van de dealer',
        sel_up_engineers: 'Selecteer maximaal 12 ingenieurs!',
        sel_up_weeks: 'Kies tot 12 weken!',
        veh_infor_inquiry: 'Voertuiginformatie opvragen',
        create_organization: 'Organisatie aanmaken',
        ref_code: 'Verifieercode vernieuwen',
        fault_complaint_Desp: 'Beschrijving van de storing / Klantklachtomschrijving',
        broken_down_vehicle: 'Gestrand voertuig',
        reporting_organization: 'apporterende organisatie',
        reporter: 'Melder',
        oneclick_convert: 'Éénclicconversie',
        assembly: 'Montage',
        show_original: 'Toon origineel',
        sync_datong: 'Datong synchroniseren',
        system_category_iii: 'Systeemcategorie III',
        maxus_Records: 'MAXUS gespreksverslagen',
    },
    // 越南
    viVN: {
        vin: 'Số khung',
        inquiry_no: 'Mã số vụ việc',
        case_theme: 'Chủ đề vụ việc',
        department_name: 'Tên phòng ban',
        department_type: 'Loại phòng ban',
        document_status: 'Trạng thái tài liệu',
        inquiry_date: 'Ngày hỏi',
        organization_name: 'Tên tổ chức',
        name: 'Tên đề xuất',
        sap_code: 'Mã SAP',
        failed_part: 'Ảnh hưởng',
        case_type: 'Loại trường hợp',
        vehicle_status: 'Bảo trì tình trạng',
        case_owner: 'Người chịu trách nhiệm',
        country: 'Quốc gia',
        fault_cause: 'Nguyên nhân lỗi',
        symptoms: 'Hiện tượng lỗi',
        is_the_document_qualified: 'Tài liệu có đủ điều kiện',
        is_the_document_replied_in_a_timely_manner: 'Tài liệu đã được trả lời kịp thời',
        filter: 'Bộ lọc',
        system_classification_I: 'Hệ thống I',
        system_classification_II: 'Hệ thống II',
        full_query: 'Truy vấn đầy đủ',
        fuzzy_query: 'Truy vấn mờ',
        whether_belongs_new_car_market: 'Xe đã được giới thiệu ra thị trường',
        caseStatus: 'Trạng thái vụ án',
        correct: 'Đúng',
        deny: 'Không',
        not_closed: 'Trạng thái mở',
        no_reply: 'Chờ trả lời',
        replied: 'Trả lời',
        closed: 'Đóng',
        drafts: 'Thư mục tạm',
        create_time: 'Thời gian tạo',
        create_user: 'Tạo bởi',
        parent_of_document: 'Tài liệu cấp trên',
        document_owner: 'Người sở hữu vụ việc',
        case_subject: 'Chủ đề vụ án',
        receipt_info: 'Thông tin vụ việc',
        superior_of_case: 'Người quản lý vụ việc',
        inquiry_time: 'Thời gian truy vấn',
        status: 'Trạng thái',
        overseas_company: 'Tên công ty bán hàng',
        general_agent_name: 'Tên nhà phân phối',
        dealer_code: 'Mã đại ký',
        dealer_name: 'Tên đại lý',
        name_of_subsidiary: 'Tên công ty con',
        contacts: 'Người liên hệ',
        contact_information: 'Thông tin liên hệ',
        training_certification: 'Chứng chỉ đào tạo',
        driving_mileage: 'Số km đã đi được',
        plate_number: 'Biển số #',
        material_no: 'Mã vật liệu xe',
        material_desc: 'Mô tả vật liệu',
        offline_date: 'Ngày off-line',
        model_platform: 'Nền tảng',
        engine_number: 'Số động cơ',
        transmission_type: 'Hộp số',
        assembly_no: 'Số CSN',
        fault_info_desc: 'Mô tả lỗi',
        fault_handle_process: 'Thực hiện khắc phục',
        solution: 'Giải pháp',
        remark: 'Ghi chú',
        caseRemark: 'Ghi chú vụ án',
        document_information: 'Thông tin tài liệu',
        basic_information_of_service_center: 'Thông tin trung tâm dịch vụ',
        basic_vehicle_information: 'Thông tin cơ bản về xe',
        problem_description: 'Mô tả sự cố',
        common_links: 'Đường dẫn hữu ích',
        claim_information: 'Thông tin phản ánh',
        diagnostic_report_record: 'Bảng lỗi',
        vehicle_history: 'Lịch sử truy vấn kỹ thuật',
        programming_history: 'Lịch sử cài đặt chương trình',
        vehicle_sales_logistics_information: 'Thông tin bán hàng và vận chuyển',
        new_vehicle_information: 'Thông tin xe mới',
        attachment_upload: 'Tải tệp đính kèm',
        diagnostic_report: 'Bảng lỗi',
        bulk_download: 'Tải xuống hàng loạt',
        document_View: 'Xem tài liệu',
        inquiry_content: 'Truy vấn chi tiết',
        inquiry_entry: 'Hỏi đáp',
        subordinate_record: 'Ghi chép câu hỏi dưới',
        superior_record: 'Ghi chú câu trả lời trên',
        send_content: 'Nội dung gửi',
        send_time: 'Thời gian gửi',
        sent_username: 'Nguời gửi',
        receive_name: 'Gửi tới',
        dept_name: 'Cấp độ',
        enclosure: 'Tệp đính kèm',
        wind_case: 'Đóng',
        close_order: 'Đóng danh sách',
        case_reporting: 'Nộp hồ sơ',
        pdf_preview: 'Xem trước PDF',
        SIS_maintenance: 'Bảo trì sự cố nghiêm trọng',
        Please_fill_in_the_inquiry_content: 'Vui lòng điền nội dung yêu cầu',
        sending_an_email: 'Gửi email',
        copy: 'Sao chép',
        repeat: 'VIN đã bị trùng',
        inconsistent: 'Không nhất quán về nền tảng xe',
        sendTo: 'Gửi đến',
        reply: 'Nhập cho truy vấn/phản hồi',
        please_check_the_exported_document: 'Vui lòng chọn tài liệu đã xuất',
        please_upload_diagnostic_report: 'Vui lòng tải lên báo cáo chẩn đoán',
        please_enter_the_vin: 'Vui lòng nhập VIN',
        placeholderDTC: 'Ví dụ: P080800_P087D00_------',
        placeholderFaultInfoDesc:
            '1. Xác minh vấn đề khách hàng quan tâm (chỉ để đảm bảo có vấn đề xảy ra)',
        placeholderFaultHandleProcess:
            '2. Xác định các triệu chứng liên quan (tìm kiếm và ghi lại tất cả các triệu chứng có thể liên quan đến vấn đề)\n' +
            '3. Phân tích các triệu chứng (xem xét cẩn thận các triệu chứng liên quan để tìm ra nguyên nhân phổ biến)\n' +
            '4. Xác nhận vấn đề (thu hẹp kết quả của bạn để đảm bảo bạn đã giải quyết đúng vấn đề)',
        placeholderSolution:
            '5. Sửa chữa (sửa chữa)\n' +
            '6. Xác minh hoạt động của xe (kiểm tra để đảm bảo rằng các bản sửa lỗi bạn đã thực hiện đã được giải quyết)',
        placeholderRemark: 'Ví dụ: Hộp lái-201806, Giảm chấn trước-2010101',
        placeholderContact: 'Vui lòng nhập tên người thực hiện',
        close_time: 'Thời gian kết thúc',
        one_touch: 'Trường hợp Xây dựng lại',
        confirm_generating_new_case: 'Xác nhận tạo vụ án mới?',
        closing_statement: 'Lời giải thích kết thúc',
        number_of_cases: 'Số trường hợp',
        number_of_vehicles: 'Số lượng xe',
        pleaseEnterContent: 'Vui lòng nhập nội dung',
        case_age: 'Tuổi vụ án',
        last_response_time: 'Thời gian đáp ứng cuối cùng',
        time_since_last_response: 'Thời gian kể từ lần trả lời cuối cùng',
        warranty_start_date: 'Ngày bắt đầu bảo hành',
        submit_reason: 'Lý do đệ trình',
        synchronize_PQCP: 'Đồng bộ PQCP',
        FPR_export: 'FPR Xuất khẩu',
        level_selection: 'Chọn cấp độ',
        category_selection: 'Lựa chọn phân loại',
        brand_selection: 'Lựa chọn thương hiệu',
        code: 'Mã số',
        description: 'Mô tả',
        major_complaints: 'Khiếu nại lớn',
        difficult_miscellaneous_diseases: 'Bệnh nan y',
        emerging_issues: 'Câu hỏi mới',
        breakpoint_failure: 'Lỗi breakpoint',
        general_complaints: 'Phàn nàn chung',
        other: 'Khác',
        roewe: 'Vinh Uy.',
        mg: 'MG',
        serious: 'Nghiêm trọng',
        secondary: 'Nhỏ',
        generally: 'Tổng quan',
        complete: 'Hoàn thành',
        please_select_level: 'Vui lòng chọn cấp độ',
        please_select_category: 'Vui lòng chọn',
        please_select_brand: 'Vui lòng chọn thương hiệu',
        placeholder_auto: 'Tự động mang ra',
        translate: 'Dịch',
        isTranslate: 'Dịch hay không',
        day: 'ngày',
        one_click_order: 'Một đĩa đơn quan trọng',
        greater_than: 'Lớn hơn',
        less_than: 'Nhỏ hơn',
        between: 'Giữa',
        document_label: 'Nhãn tài liệu',
        receipts_first_modification_time: 'Thời gian thay đổi biên lai đầu tiên',
        Selection_of_Document_Owner: 'Lựa chọn Người Chịu trách nhiệm về Tài liệu',
        responsiblePerson: 'Người chịu trách nhiệm：',
        functional_Domain: 'Lĩnh Vực Chức Năng',
        Category: 'Danh Mục',
        property: 'thuộc tính',
        reRepair: 'Sửa chữa lặp lại',
        pullInNum: 'Số lần nhập',
        perception: 'Lớp nhận thức',
        onSupport: 'Hỗ trợ tại chỗ',
        batteryNo: 'Số pin',
        normalStartDate: 'Ngày bảo hành',
        qmotorNo: 'Số máy trước',
        hmotorNo: 'Số máy sau',
        fault_cause_type: 'Loại Nguyên Nhân Sự Cố',
        measure_name: 'Tên bộ phận',
        part_name: 'Tên biện pháp',
        close_order_notification: 'Đóng đơn đặt hàng đòi hỏi phải có phản hồi từ người đề xuất.',
        TIS_Case_Data: 'Dữ liệu trường hợp TIS',
        case_File: 'Hồ sơ trường hợp',
        responsibility_Data: 'Dữ liệu trách nhiệm',
        longterm_Measures: 'Các biện pháp dài hạn',
        tisCaseNo: 'Số vụ TIS',
        vehGlobalFwVer: 'Số phiên bản phần mềm xe',
        vehGlobalFwPn: 'Số phần mềm phụ tùng xe',
        archivesNo: 'Số hồ sơ',
        archivesTitle: 'Tiêu đề hồ sơ',
        archivesSource: 'Nguồn hồ sơ',
        proposer: 'Người đề xuất',
        proposedTime: 'Ngày đề xuất',
        archivesManagementPersonnel: 'Nhân viên quản lý',
        functionalMode: 'Mô-đun chức năng',
        supplier: 'Nhà cung cấp',
        accessoriesInvolved: 'Phụ kiện liên quan',
        functionalDomain: 'Miền chức năng',
        invalidPartId: 'ID phần không hợp lệ',
        archivesType: 'Loại hồ sơ',
        archivesGrade: 'Đánh giá hồ sơ',
        problemDescription: 'Mô tả vấn đề',
        analysisProgress: 'Tiến độ phân tích',
        qaRemark: 'Nhận xét QA',
        tacRemark: 'Nhận xét TAC',
        responsibleDepartment: 'Bộ phận chịu trách nhiệm',
        coordinator: 'Điều phối viên',
        principal: 'Chủ nhiệm',
        containmentAction: 'Hành động kiểm soát',
        issueStatus: 'Trạng thái vấn đề',
        softwareProblems: 'Vấn đề phần mềm',
        vehGlobalFwVer_j: 'Số phiên bản cơ sở',
        vehGlobalFwPn_j: 'Số phần cơ sở',
        ewo: 'Số EWO',
        rootCause: 'Nguyên nhân gốc rễ',
        marketBehavior: 'Hành vi thị trường',
        shortTermMeasures: 'Biện pháp ngắn hạn',
        shortTermBreakpointDescription: 'Mô tả Breakpoint ngắn hạn',
        measuresResult: 'Kết quả phê duyệt biện pháp',
        measuresConfirmation: 'Xác nhận biện pháp',
        longTermMeasures: 'Biện pháp dài hạn',
        longTermMeasuresBreak: 'Mô tả dự đoán Breakpoint của biện pháp dài hạn',
        implementation: 'Thực hiện',
        longMeasuresTime: 'Ngày Breakpoint thực tế của biện pháp dài hạn',
        vinBreak: 'VIN của Breakpoint biện pháp dài hạn',
        breakpointImplementationPhase: 'Giai đoạn thực hiện Breakpoint',
        archive_Information: 'Thông tin lưu trữ',
        reason_incomplete_closure: 'Lý do đóng cửa không hoàn tất',
        entry_Date: 'Ngày vào',
        departure_date: 'Ngày rời',
        work_order_number: 'Số lệnh công việc',
        questionnaire_usage: 'Mục đích sử dụng bảng hỏi',
        classification_of_technical_enquiries: 'Phân loại các yêu cầu kỹ thuật',
        change_of_document_owner: 'Change Of Document Owner',
        oldowner: 'Old Owner',
        newowner: 'New Owner',
        original: 'Bản gốc',
        translation: 'Bản dịch',
        dealer_address: 'Địa chỉ đại lý',
        sel_up_engineers: 'Chọn tối đa 12 kỹ sư!',
        sel_up_weeks: 'Chọn tối đa 12 tuần!',
        veh_infor_inquiry: 'Tra cứu thông tin phương tiện',
        create_organization: 'Tạo tổ chức',
        ref_code: 'Tải lại mã xác thực',
        fault_complaint_Desp: 'Mô tả lỗi / Mô tả khiếu nại của khách hàng',
        broken_down_vehicle: 'Xe bị hỏng',
        reporting_organization: 'Tên tổ chức báo cáo',
        reporter: 'Người báo cáo',
        oneclick_convert: 'Chuyển đổi một cú nhấp',
        assembly: 'Lắp ráp',
        show_original: 'Hiển thị bản gốc',
        sync_datong: 'Đồng bộ Datong',
        system_category_iii: 'Phân loại hệ thống III',
        maxus_Records: 'Bản ghi cuộc trò chuyện MAXUS',
    },
    // 西班牙
    esES: {
        vin: 'VIN',
        inquiry_no: 'Número de consulta',
        case_theme: 'Tema del caso',
        department_name: 'Nombre del departamento',
        department_type: 'Tipo de departamento',
        document_status: 'Estado del documento',
        inquiry_date: 'Fecha de consulta',
        organization_name: 'Nombre de la organización',
        name: 'Nombre del proponente',
        sap_code: 'Código SAP',
        failed_part: 'Piezas defectuosas',
        case_type: 'Tipo de caso',
        vehicle_status: 'Estado de mantenimiento',
        case_owner: 'Responsable',
        country: 'País',
        fault_cause: 'Causa de falla',
        symptoms: 'Síntoma de falla',
        is_the_document_qualified: '¿Documento calificado?',
        is_the_document_replied_in_a_timely_manner: '¿Respuesta oportuna al documento?',
        filter: 'Filtro',
        system_classification_I: 'Clasificación del sistema I',
        system_classification_II: 'Clasificación del sistema II',
        full_query: 'Consulta completa',
        fuzzy_query: 'Consulta difusa',
        whether_belongs_new_car_market: '¿Es un nuevo lanzamiento de vehículo?',
        caseStatus: 'Estado del caso',
        correct: 'Sí',
        deny: 'No',
        not_closed: 'No resuelto',
        no_reply: 'Esperando una respuesta',
        replied: 'Ha respondido',
        closed: 'Resuelto',
        drafts: 'Borrador',
        create_time: 'Fecha de creación',
        create_user: 'Creador',
        parent_of_document: 'Superior del documento',
        document_owner: 'Responsable del documento',
        case_subject: 'Tema del caso',
        receipt_info: 'Información del documento',
        superior_of_case: 'Superior del caso',
        inquiry_time: 'Hora de consulta',
        status: 'Estado',
        overseas_company: 'Nombre de la empresa en el extranjero',
        general_agent_name: 'Nombre del distribuidor principal',
        dealer_code: 'Código del distribuidor',
        dealer_name: 'Nombre del distribuidor',
        name_of_subsidiary: 'Nombre de la subsidiaria',
        contacts: 'Persona de contacto',
        contact_information: 'Información de contacto',
        training_certification: 'Certificación de capacitación',
        driving_mileage: 'Kilometraje',
        plate_number: 'Número de placa',
        material_no: 'Número de material',
        material_desc: 'Descripción del material',
        offline_date: 'Fecha de desactivación',
        model_platform: 'Plataforma del modelo de vehículo',
        engine_number: 'Número de motor',
        transmission_type: 'Número de transmisión',
        assembly_no: 'Número de ensamblaje',
        fault_info_desc: 'Descripción de la falla',
        fault_handle_process: 'Proceso de reparación de falla',
        solution: 'Solución',
        remark: 'Observaciones',
        caseRemark: 'Observaciones del caso',
        document_information: 'Información del documento',
        basic_information_of_service_center: 'Información básica del centro de servicio',
        basic_vehicle_information: 'Información básica del vehículo',
        problem_description: 'Descripción del problema',
        common_links: 'Enlaces frecuentes',
        claim_information: 'Información de reclamos',
        diagnostic_report_record: 'Registro de informes de diagnóstico',
        vehicle_history: 'Documentos históricos de consultas de vehículos',
        programming_history: 'Historial de programación',
        vehicle_sales_logistics_information: 'Información de ventas y logística del vehículo',
        new_vehicle_information: 'Información de vehículos nuevos agregados',
        attachment_upload: 'Carga de archivos adjuntos',
        diagnostic_report: 'Informe de diagnóstico',
        bulk_download: 'Descarga masiva',
        document_View: 'Vista de documentos',
        inquiry_content: 'Contenido de consulta',
        inquiry_entry: 'Respuesta a la consulta',
        subordinate_record: 'Registro de preguntas y respuestas de nivel inferior',
        superior_record: 'Registro de preguntas y respuestas de nivel superior',
        send_content: 'Contenido enviado',
        send_time: 'Fecha de envío',
        sent_username: 'Remitente',
        receive_name: 'Enviar a',
        dept_name: 'Nivel',
        enclosure: 'Adjunto',
        wind_case: 'Cerrar caso',
        close_order: 'Cerrar la mónada',
        case_reporting: 'Reportar caso',
        pdf_preview: 'Vista previa del archivo PDF',
        SIS_maintenance: 'Mantenimiento de accidentes graves',
        Please_fill_in_the_inquiry_content: 'Por favor ingrese el contenido de consulta',
        sending_an_email: 'Enviar correo electrónico',
        copy: 'Copiar',
        repeat: 'VIN duplicado',
        inconsistent: 'Plataforma del modelo de vehículo no coincidente',
        sendTo: 'Enviar a',
        reply: 'Ingrese el contenido de la consulta o respuesta',
        please_check_the_exported_document: 'Por favor seleccione los documentos para exportar',
        please_upload_diagnostic_report: 'Por favor cargue el informe de diagnóstico',
        please_enter_the_vin: 'Por favor ingrese el VIN',
        placeholderDTC: 'Ejemplo: P080800_P087D00_------',
        placeholderFaultInfoDesc:
            '1. Verificar el problema que le preocupa al cliente (solo para asegurarse de que haya un problema).',
        placeholderFaultHandleProcess:
            '2. Identificar los síntomas relacionados (buscar y registrar todos los síntomas que puedan estar relacionados con el problema).\n' +
            '3. Analizar los síntomas (observar detenidamente los síntomas relacionados y encontrar las posibles causas comunes).\n' +
            '4. Confirmar el problema (reducir el alcance de los resultados para asegurarse de que se está solucionando el problema correcto).',
        placeholderSolution:
            '5. Reparar el problema (realizar reparaciones).\n' +
            '6. Verificar el funcionamiento del vehículo (realizar una revisión para asegurarse de que las reparaciones realizadas hayan solucionado el problema).',
        placeholderRemark:
            'Por ejemplo: Dirección asistida -201806, Amortiguador frontal izquierdo -2010101',
        placeholderContact: 'Por favor ingrese el nombre del operador',
        close_time: 'Tiempo de cierre',
        one_touch: 'Reconstruir el documento',
        confirm_generating_new_case: '¿Desea generar un nuevo documento?',
        closing_statement: 'Explicación de cierre',
        number_of_cases: 'Cantidad de documentos',
        number_of_vehicles: 'Cantidad de vehículos',
        pleaseEnterContent: 'Por favor, introduzca el contenido',
        case_age: 'Edad del caso',
        last_response_time: 'Último tiempo de respuesta',
        time_since_last_response: 'Tiempo desde la última respuesta',
        warranty_start_date: 'Fecha de inicio de la garantía',
        submit_reason: 'Razones para presentar',
        synchronize_PQCP: 'PQCP simultáneo',
        FPR_export: 'FPR exportación',
        level_selection: 'Selección de niveles',
        category_selection: 'Selección de clasificación',
        brand_selection: 'Selección de marca',
        code: 'Código',
        description: 'Descripción',
        major_complaints: 'Quejas importantes',
        difficult_miscellaneous_diseases: 'Enfermedades difíciles y complicadas',
        emerging_issues: 'Nuevos problemas',
        breakpoint_failure: 'Falla del punto de interrupción',
        general_complaints: 'Quejas generales',
        other: 'Otros',
        roewe: 'Roewe',
        mg: 'MG',
        serious: 'Grave',
        secondary: 'Secundario',
        generally: 'General',
        complete: 'Completado',
        please_select_level: 'Por favor, elija el nivel',
        please_select_category: 'Por favor, elija la clasificación',
        please_select_brand: 'Por favor, elija la marca',
        placeholder_auto: 'Sacar automáticamente',
        translate: 'Traducción',
        isTranslate: 'Si traducir',
        day: 'días',
        one_click_order: 'Un botón para cerrar la orden',
        greater_than: 'Mayor que',
        less_than: 'Menos',
        between: 'Entre',
        document_label: 'Etiqueta del documento',
        receipts_first_modification_time: 'Recibos primera modificación tiempo',
        Selection_of_Document_Owner: 'Selección de la Persona Responsable del Documento',
        responsiblePerson: 'Persona Responsable：',
        functional_Domain: 'Dominio Funcional',
        Category: 'Categoría',
        property: 'atributo',
        reRepair: 'Reparaciones repetidas',
        pullInNum: 'Número de entradas',
        perception: 'Clase de percepción',
        onSupport: 'Soporte en el lugar',
        batteryNo: 'Número de batería',
        normalStartDate: 'Fecha de garantía',
        qmotorNo: 'Número de motor delantero',
        hmotorNo: 'Número de motor trasero',
        fault_cause_type: 'Tipo de causa del fallo',
        measure_name: 'Nombre de la medida',
        part_name: 'Nombre de la pieza',
        close_order_notification: 'Cerrar el pedido requiere una respuesta del proponente.',
        TIS_Case_Data: 'Datos del caso TIS',
        case_File: 'Archivo del caso',
        responsibility_Data: 'Datos de responsabilidad',
        longterm_Measures: 'Medidas a largo plazo',
        tisCaseNo: 'Número de Caso TIS',
        vehGlobalFwVer: 'Número de Versión del Software del Vehículo',
        vehGlobalFwPn: 'Número de Parte del Software del Vehículo',
        archivesNo: 'Número de Archivo',
        archivesTitle: 'Título del Archivo',
        archivesSource: 'Fuente del Archivo',
        proposer: 'Proponente',
        proposedTime: 'Fecha Propuesta',
        archivesManagementPersonnel: 'Personal de Gestión',
        functionalMode: 'Módulo Funcional',
        supplier: 'Proveedor',
        accessoriesInvolved: 'Accesorios Involucrados',
        functionalDomain: 'Dominio Funcional',
        invalidPartId: 'ID de Parte Inválida',
        archivesType: 'Tipo de Archivo',
        archivesGrade: 'Grado de Archivo',
        problemDescription: 'Descripción del Problema',
        analysisProgress: 'Progreso del Análisis',
        qaRemark: 'Observación QA',
        tacRemark: 'Observación TAC',
        responsibleDepartment: 'Departamento Responsable',
        coordinator: 'Coordinador',
        principal: 'Principal',
        containmentAction: 'Acción de Contención',
        issueStatus: 'Estado del Problema',
        softwareProblems: 'Problemas de Software',
        vehGlobalFwVer_j: 'Número de Versión Base',
        vehGlobalFwPn_j: 'Número de Parte Base',
        ewo: 'Número EWO',
        rootCause: 'Causa Raíz',
        marketBehavior: 'Comportamiento del Mercado',
        shortTermMeasures: 'Medidas a Corto Plazo',
        shortTermBreakpointDescription: 'Descripción del Breakpoint a Corto Plazo',
        measuresResult: 'Resultado de Aprobación de Medidas',
        measuresConfirmation: 'Confirmación de Medidas',
        longTermMeasures: 'Medidas a Largo Plazo',
        longTermMeasuresBreak: 'Descripción Estimada del Breakpoint de Medidas a Largo Plazo',
        implementation: 'Implementación',
        longMeasuresTime: 'Fecha Real del Breakpoint de Medidas a Largo Plazo',
        vinBreak: 'VIN del Breakpoint de Medidas a Largo Plazo',
        breakpointImplementationPhase: 'Fase de Implementación del Breakpoint',
        archive_Information: 'Información del archivo',
        reason_incomplete_closure: 'Razón de cierre incompleto',
        entry_Date: 'Fecha de entrada',
        departure_date: 'Fecha de salida',
        work_order_number: 'Número de orden de trabajo',
        questionnaire_usage: 'Uso del cuestionario',
        classification_of_technical_enquiries: 'Clasificación de consultas técnicas',
        change_of_document_owner: 'Change Of Document Owner',
        oldowner: 'Old Owner',
        newowner: 'New Owner',
        original: 'Original',
        translation: 'Traducción',
        dealer_address: 'Dirección del concesionario',
        sel_up_engineers: 'Seleccione hasta 12 ingenieros!',
        sel_up_weeks: '¡Elige hasta 12 semanas!',
        veh_infor_inquiry: 'Consulta de información del vehículo',
        create_organization: 'Crear organización',
        ref_code: 'Refrescar Captcha',
        fault_complaint_Desp: 'Descripción del fallo / Descripción de la queja del cliente',
        broken_down_vehicle: '¿Vehículo averiado',
        reporting_organization: 'la organización informante',
        reporter: 'Reportero',
        oneclick_convert: 'Conversión en un clic',
        assembly: 'Ensamblaje',
        show_original: 'Mostrar original',
        sync_datong: 'Sincronizar Datong',
        system_category_iii: 'Categoría de sistema III',
        maxus_Records: 'Registros de conversaciones MAXUS',
    },
    // 葡萄牙
    ptBR: {
        vin: 'VIN',
        inquiry_no: 'Número da consulta',
        case_theme: 'Tema do caso',
        department_name: 'Nome do departamento',
        department_type: 'Tipo de departamento',
        document_status: 'Status do documento',
        inquiry_date: 'Data da consulta',
        organization_name: 'Nome da organização',
        name: 'Nome do proponente',
        sap_code: 'Código SAP',
        failed_part: 'Peça com falha',
        case_type: 'Tipo de caso',
        vehicle_status: 'Status da manutenção',
        case_owner: 'Responsável pelo caso',
        country: 'País',
        fault_cause: 'Causa da falha',
        symptoms: 'Sintomas',
        is_the_document_qualified: 'O documento está qualificado',
        is_the_document_replied_in_a_timely_manner: 'O documento foi respondido em tempo hábil',
        filter: 'Filtro',
        system_classification_I: 'Classificação do sistema I',
        system_classification_II: 'Classificação do sistema II',
        full_query: 'Consulta completa',
        fuzzy_query: 'Consulta fuzzy',
        whether_belongs_new_car_market: 'Pertence ao mercado de carros novos',
        caseStatus: 'Status do caso',
        correct: 'Sim',
        deny: 'Não',
        not_closed: 'Não fechado',
        no_reply: 'Sem resposta',
        replied: 'Respondido',
        closed: 'Fechado',
        drafts: 'Rascunhos',
        create_time: 'Tempo de criação',
        create_user: 'Criado por',
        parent_of_document: 'Documento superior',
        document_owner: 'Responsável pelo documento',
        case_subject: 'Assunto do caso',
        receipt_info: 'Informação do documento',
        superior_of_case: 'Superior do caso',
        inquiry_time: 'Tempo da consulta',
        status: 'Status',
        overseas_company: 'Nome da empresa no exterior',
        general_agent_name: 'Nome do agente geral',
        dealer_code: 'Código do revendedor',
        dealer_name: 'Nome do revendedor',
        name_of_subsidiary: 'Nome da subsidiária',
        contacts: 'Contatos',
        contact_information: 'Informação de contato',
        training_certification: 'Certificação de treinamento',
        driving_mileage: 'Quilometragem',
        plate_number: 'Placa',
        material_no: 'Número do material',
        material_desc: 'Descrição do material',
        offline_date: 'Data de offline',
        model_platform: 'Plataforma do veículo',
        engine_number: 'Número do motor',
        transmission_type: 'Tipo de transmissão',
        assembly_no: 'Número de montagem',
        fault_info_desc: 'Descrição da informação de falha',
        fault_handle_process: 'Processo de tratamento de falha',
        solution: 'Solução',
        remark: 'Observação',
        caseRemark: 'Observação do caso',
        document_information: 'Informação do documento',
        basic_information_of_service_center: 'Informação básica do centro de serviços',
        basic_vehicle_information: 'Informação básica do veículo',
        problem_description: 'Descrição do problema',
        common_links: 'Links comuns',
        claim_information: 'Informação de reivindicação',
        diagnostic_report_record: 'Registro do relatório de diagnóstico',
        vehicle_history: 'Histórico de consultas de veículos',
        programming_history: 'Histórico de programação',
        vehicle_sales_logistics_information: 'Informação de vendas e logística do veículo',
        new_vehicle_information: 'Informação do veículo novo',
        attachment_upload: 'Upload de anexo',
        diagnostic_report: 'Relatório de diagnóstico',
        bulk_download: 'Download em massa',
        document_View: 'Visualização de documentos',
        inquiry_content: 'Conteúdo da consulta',
        inquiry_entry: 'Resposta à consulta',
        subordinate_record: 'Registro de perguntas e respostas subordinado',
        superior_record: 'Registro de perguntas e respostas superior',
        send_content: 'Conteúdo enviado',
        send_time: 'Tempo de envio',
        sent_username: 'Remetente',
        receive_name: 'Destinatário',
        dept_name: 'Nível',
        enclosure: 'Anexo',
        wind_case: 'Encerrar caso',
        close_order: 'Fechar a mônada',
        case_reporting: 'Relatório de caso',
        pdf_preview: 'Visualização PDF',
        SIS_maintenance: 'Manutenção de acidentes graves',
        Please_fill_in_the_inquiry_content: 'Por favor, preencha o conteúdo da consulta',
        sending_an_email: 'Enviando um email',
        copy: 'Copiar',
        repeat: 'Vin repetido',
        inconsistent: 'Plataforma do veículo inconsistente',
        sendTo: 'Enviar para',
        reply: 'Digite o conteúdo para consulta/resposta',
        please_check_the_exported_document: 'Por favor, verifique o documento exportado',
        please_upload_diagnostic_report: 'Por favor, faça upload do relatório de diagnóstico',
        please_enter_the_vin: 'Por favor, insira o VIN',
        placeholderDTC: 'Exemplo: P080800_P087D00_------',
        placeholderFaultInfoDesc:
            '1. Verifique o problema do cliente (apenas para garantir que haja um problema)',
        placeholderFaultHandleProcess:
            '2. Determine os sintomas relacionados (encontre e registre todos os sintomas relacionados ao problema)\n' +
            '3. Analise os sintomas (observe cuidadosamente os sintomas relacionados para encontrar as causas comuns)\n' +
            '4. Confirme o problema (estreite o escopo de suas conclusões para garantir que você esteja resolvendo o problema correto)',
        placeholderSolution:
            '5. Reparar o problema (realizar manutenção)\n' +
            '6. Verificar o desempenho do veículo (verificar se a solução que você fez resolveu o problema)',
        placeholderRemark: 'Exemplo: Direção - 201806, amortecedor dianteiro esquerdo - 2010101',
        placeholderContact: 'Por favor, insira o nome do operador',
        close_time: 'Tempo de encerramento',
        one_touch: 'Reconstrução do caso',
        confirm_generating_new_case: 'Confirmar a criação de um novo caso?',
        closing_statement: 'Declaração de encerramento',
        number_of_cases: 'Número de casos',
        number_of_vehicles: 'Número de veículos',
        pleaseEnterContent: 'Por favor, insira o conteúdo',
        case_age: 'Idade do caso',
        last_response_time: 'Último tempo de resposta',
        time_since_last_response: 'Tempo desde a última resposta',
        warranty_start_date: 'Data de início da garantia',
        submit_reason: 'Motivo do envio',
        synchronize_PQCP: 'Sincronizar PQCP',
        FPR_export: 'Exportar FPR',
        level_selection: 'Seleção de nível',
        category_selection: 'Seleção de categoria',
        brand_selection: 'Seleção de marca',
        code: 'Código',
        description: 'Descrição',
        major_complaints: 'Principais reclamações',
        difficult_miscellaneous_diseases: 'Doenças miscelâneas difíceis',
        emerging_issues: 'Questões emergentes',
        breakpoint_failure: 'Falha em ponto de interrupção',
        general_complaints: 'Reclamações gerais',
        other: 'Outro',
        roewe: 'Roewe',
        mg: 'MG',
        serious: 'Grave',
        secondary: 'Secundário',
        generally: 'Geralmente',
        complete: 'Completo',
        please_select_level: 'Por favor, selecione o nível',
        please_select_category: 'Por favor, selecione a categoria',
        please_select_brand: 'Por favor, selecione a marca',
        placeholder_auto: 'Preenchimento automático',
        translate: 'Traduzir',
        isTranslate: 'Traduzir',
        day: 'dia',
        one_click_order: 'Uma chave para fechar a ordem',
        greater_than: 'Maior que',
        less_than: 'Menos de',
        between: 'Entre',
        document_label: 'Rótulo do documento',
        receipts_first_modification_time: 'Recibos primeira hora de modificação',
        Selection_of_Document_Owner: 'Seleção da Pessoa Responsável pelo Documento',
        responsiblePerson: 'Pessoa Responsável：',
        functional_Domain: 'Domínio Funcional',
        Category: 'Categoria',
        property: 'atributo',
        reRepair: 'Reparações repetidas',
        pullInNum: 'Número de entradas',
        perception: 'Classe de percepção',
        onSupport: 'Suporte no local',
        batteryNo: 'Número da bateria',
        normalStartDate: 'Data de garantia',
        qmotorNo: 'Número do motor dianteiro',
        hmotorNo: 'Número do motor traseiro',
        fault_cause_type: 'Tipo de causa da falha',
        measure_name: 'Nome da medida',
        part_name: 'Nome da peça',
        close_order_notification: 'Fechar o pedido requer uma resposta do proponente.',
        TIS_Case_Data: 'Dados do caso TIS',
        case_File: 'Arquivo do caso',
        responsibility_Data: 'Dados de responsabilidade',
        longterm_Measures: 'Medidas a longo prazo',
        tisCaseNo: 'Número do Caso TIS',
        vehGlobalFwVer: 'Número da Versão do Software do Veículo',
        vehGlobalFwPn: 'Número da Peça do Software do Veículo',
        archivesNo: 'Número do Arquivo',
        archivesTitle: 'Título do Arquivo',
        archivesSource: 'Fonte do Arquivo',
        proposer: 'Proponente',
        proposedTime: 'Data Proposta',
        archivesManagementPersonnel: 'Pessoal de Gestão',
        functionalMode: 'Módulo Funcional',
        supplier: 'Fornecedor',
        accessoriesInvolved: 'Acessórios Envolvidos',
        functionalDomain: 'Domínio Funcional',
        invalidPartId: 'ID da Peça Inválida',
        archivesType: 'Tipo de Arquivo',
        archivesGrade: 'Grau do Arquivo',
        problemDescription: 'Descrição do Problema',
        analysisProgress: 'Progresso da Análise',
        qaRemark: 'Observação QA',
        tacRemark: 'Observação TAC',
        responsibleDepartment: 'Departamento Responsável',
        coordinator: 'Coordenador',
        principal: 'Principal',
        containmentAction: 'Ação de Contenção',
        issueStatus: 'Status do Problema',
        softwareProblems: 'Problemas de Software',
        vehGlobalFwVer_j: 'Número da Versão Base',
        vehGlobalFwPn_j: 'Número da Peça Base',
        ewo: 'Número EWO',
        rootCause: 'Causa Raiz',
        marketBehavior: 'Comportamento do Mercado',
        shortTermMeasures: 'Medidas de Curto Prazo',
        shortTermBreakpointDescription: 'Descrição do Breakpoint de Curto Prazo',
        measuresResult: 'Resultado da Aprovação das Medidas',
        measuresConfirmation: 'Confirmação das Medidas',
        longTermMeasures: 'Medidas de Longo Prazo',
        longTermMeasuresBreak: 'Descrição Estimada do Breakpoint das Medidas de Longo Prazo',
        implementation: 'Implementação',
        longMeasuresTime: 'Data Real do Breakpoint das Medidas de Longo Prazo',
        vinBreak: 'VIN do Breakpoint das Medidas de Longo Prazo',
        breakpointImplementationPhase: 'Fase de Implementação do Breakpoint',
        archive_Information: 'Informações do arquivo',
        reason_incomplete_closure: 'Razão para fechamento incompleto',
        entry_Date: 'Data de entrada',
        departure_date: 'Data de saída',
        work_order_number: 'Número da ordem de serviço',
        questionnaire_usage: 'Uso do questionário',
        classification_of_technical_enquiries: 'Classificação de consultas técnicas',
        change_of_document_owner: 'Change Of Document Owner',
        oldowner: 'Old Owner',
        newowner: 'New Owner',
        original: 'Original',
        translation: 'Tradução',
        dealer_address: 'Endereço do revendedor',
        sel_up_engineers: 'Selecione até 12 engenheiros!',
        sel_up_weeks: 'Escolha até 12 semanas!',
        veh_infor_inquiry: 'Consulta de informações do veículo',
        create_organization: 'Criar organização',
        ref_code: 'Atualizar Captcha',
        fault_complaint_Desp: 'Descrição da falha / Descrição da reclamação do cliente',
        broken_down_vehicle: 'Veículo com defeito',
        reporting_organization: 'organização de reportagem',
        reporter: 'Repórter',
        oneclick_convert: 'Conversão em um clique',
        assembly: 'Montagem',
        show_original: 'Mostrar original',
        sync_datong: 'Sincronizar Datong',
        system_category_iii: 'Categoria do sistema III',
        maxus_Records: 'Registos de conversas MAXUS',
    },
    // 波兰
    plPL: {
        vin: 'VIN',
        inquiry_no: 'Numer zapytania',
        case_theme: 'Temat zapytania',
        department_name: 'Nazwa oddziału',
        department_type: 'Typ odziału',
        document_status: 'Stan dokumentów',
        inquiry_date: 'Data zapytania',
        organization_name: 'Nazwa organizacji',
        name: 'Nazwa wnioskodawcy',
        sap_code: 'Kod SAP',
        failed_part: 'Uszkodzona część',
        case_type: 'Typ sprawy',
        vehicle_status: 'Status pojazdu',
        case_owner: 'Osoba odpowiedzialna',
        country: 'Kraj',
        fault_cause: 'Przyczyna błędu',
        symptoms: 'zjawisko usterki',
        is_the_document_qualified: 'Czy sprawa się kwalifikuje',
        is_the_document_replied_in_a_timely_manner:
            'Czy odpowiedź została udzielona w odpowiednim czasie?',
        filter: 'Filtr',
        system_classification_I: 'System 1',
        system_classification_II: 'System 2',
        full_query: 'Pełne zapytanie',
        fuzzy_query: 'Rozmyte zapytanie',
        whether_belongs_new_car_market: 'Czy nowo wprowadzony pojazd?',
        caseStatus: 'Status sprawy',
        correct: 'Poprawny',
        deny: 'Odmowa',
        not_closed: 'Otwarta',
        no_reply: 'Brak odpowiedzi',
        replied: 'Udzielono odpowiedzi',
        closed: 'Zamknięta',
        drafts: 'Robocze',
        create_time: 'Czas założenia',
        create_user: 'Założona przez',
        parent_of_document: 'Właściciel dokumentów',
        document_owner: 'Właściciel sprawy',
        case_subject: 'Temat',
        receipt_info: 'Informacje o sprawie',
        superior_of_case: 'Przełożony',
        inquiry_time: 'Czas zapytania',
        status: 'Status',
        overseas_company: 'Nazwa firmy sprzedającej',
        general_agent_name: 'Nazwa dystrybutora',
        dealer_code: 'Kod dealera',
        dealer_name: 'Nazwa dealera',
        name_of_subsidiary: 'Nazwa spółki zależnej',
        contacts: 'Osoba kontaktowa',
        contact_information: 'Kontakt',
        training_certification: 'Certyfikat szkolenia',
        driving_mileage: 'Przebieg',
        plate_number: 'Numer rejestracyjny',
        material_no: 'Kod materiałowy pojazdu',
        material_desc: 'Opis materiału',
        offline_date: 'Data zejścia z linii',
        model_platform: 'Platforma',
        engine_number: 'Numer silnika',
        transmission_type: 'Skrzynia biegów',
        assembly_no: 'Numer CSN',
        fault_info_desc: 'Opis błędu',
        fault_handle_process: 'Podjęte działania ',
        solution: 'Rozwiązanie',
        remark: 'Uwagi',
        caseRemark: 'Uwagi do sprawy',
        document_information: 'Informacje o sprawie',
        basic_information_of_service_center: 'Informacje centrum serwisowego',
        basic_vehicle_information: 'Podstawowe informaje o pojeździe',
        problem_description: 'Opis problemu',
        common_links: 'Przydatne linki',
        claim_information: 'Informacje o reklamacji',
        diagnostic_report_record: 'Raport diagnostyczny',
        vehicle_history: 'Historia zapytań technicznych',
        programming_history: 'Historia programowania',
        vehicle_sales_logistics_information: 'Inpofmacje sprzedażowe i logistyczne',
        new_vehicle_information: 'Informacje o nowym pojeździe',
        attachment_upload: 'Prześlij załącznik',
        diagnostic_report: 'Raport diagnostyczny',
        bulk_download: 'Pobieranie zbiorcze',
        document_View: 'Przeglądanie dokumentów',
        inquiry_content: 'Szczegóły zapytania',
        inquiry_entry: 'Odpowiedź na zapytanie',
        subordinate_record: 'record',
        superior_record: 'Zapis podwładnego',
        send_content: 'Zapis przełożonegsuperior',
        send_time: 'Czas wysłania',
        sent_username: 'Nadawca',
        receive_name: 'Wysłać do',
        dept_name: 'Poziom',
        enclosure: 'Załącznik',
        wind_case: 'Zamknięta',
        close_order: 'Zamknij zamówienie',
        case_reporting: 'Raport sprawy',
        pdf_preview: 'Podgląd PDF',
        SIS_maintenance: 'Serwis po poważnym wypadku',
        Please_fill_in_the_inquiry_content: 'Proszę o uzupełnienie treści zapytania',
        sending_an_email: 'Wysyłanie wiadomości e-mail',
        copy: 'Skopiuj',
        repeat: 'Powtórzenie numeru VIN',
        inconsistent: 'Niespójna platforma pojazdu',
        sendTo: 'Wyślij do',
        reply: 'Wprowadź treść zapytania/odpowiedzi',
        please_check_the_exported_document: 'Proszę zaznaczyć eksportowany dokument',
        please_upload_diagnostic_report: 'Proszę przesłać raport diagnostyczny',
        please_enter_the_vin: 'Proszę wprowadzić nr VIN',
        placeholderDTC: 'Przykład: P080800_P087D00_------',
        placeholderFaultInfoDesc:
            '1. Zweryfikuj obawy klienta (aby upewnić się, że problemy się pojawiają)',
        placeholderFaultHandleProcess:
            '2. Zidentyfikuj symptomy (zidentyfikuj i zapisz wszystkie symptomy, które mogą być związane z problemem.\n' +
            '3. Zanalizuj symptomy (uważnie obserwuj symptomy, aby zidentykować typowe przyczyny)\n' +
            '4. Potwierdź problem (zawęż zakres wyników, aby mieć pewność, że rozwiązałeś właściwy problem.)',
        placeholderSolution:
            '5. Napraw problem (przeprowadź naprawę)\n' +
            '6. Sprawdź działanie pojazdu (sprawdź, czy naprawa rozwiązała problem)',
        placeholderRemark: 'Przykład: Przekładnia kierownicza-201806, Amortyzator FL-2010101',
        placeholderContact: 'Wpisz imię i nazwisko oepratora',
        close_time: 'Czas zakończenia',
        one_touch: 'Rekonstrukcja sprawy',
        confirm_generating_new_case: 'Potwierdź utworzenie nowej sprawy?',
        closing_statement: 'Wyajśnienie końcowe',
        number_of_cases: 'Liczba spraw',
        number_of_vehicles: 'Liczba pojazdów',
        pleaseEnterContent: 'Proszę wprowadzić treść',
        case_age: 'Wiek sprawy',
        last_response_time: 'Ostatni czas odpowiedzi',
        time_since_last_response: 'Czas od ostatniej odpowiedzi',
        warranty_start_date: 'Data rozpoczęcia gwarancji',
        submit_reason: 'Prześlij powód',
        synchronize_PQCP: 'Synchronizuj PQCP',
        FPR_export: 'Eksport FPR',
        level_selection: 'Wybór poziomu',
        category_selection: 'Wybór kategorii',
        brand_selection: 'Wybór marki',
        code: 'Kod',
        description: 'Opis',
        major_complaints: 'Główne skargi',
        difficult_miscellaneous_diseases: 'Trudne, różnorodne choroby',
        emerging_issues: 'Nowo pojawiające się problemy',
        breakpoint_failure: 'Awaria w punkcie zerowym',
        general_complaints: 'Ogólne skargi',
        other: 'Inne',
        roewe: 'Roewe',
        mg: 'MG',
        serious: 'Poważny',
        secondary: 'Drugorzędny',
        generally: 'Zazwyczaj',
        complete: 'Zakończone',
        please_select_level: 'Proszę wybrać poziom',
        please_select_category: 'Proszę wybrać kategorię',
        please_select_brand: 'Proszę wybrać markę',
        placeholder_auto: 'Automatyczne wypełnienie',
        translate: 'Przetłumacz',
        isTranslate: 'Czy przetłumaczyć?',
        day: 'dzień',
        one_click_order: 'Odprawa celna jednym kliknięciem',
        greater_than: 'Większa niż',
        less_than: 'Mniej niż',
        between: 'Między',
        document_label: 'Etykieta dokumentu',
        receipts_first_modification_time: 'Czas pierwszej modyfikacji paragonów',
        Selection_of_Document_Owner: 'Wybór Osoby Odpowiedzialnej za Dokument',
        responsiblePerson: 'Osoba Odpowiedzialna：',
        functional_Domain: 'Obszar Funkcjonalny',
        Category: 'Kategoria',
        property: 'przyczynowość',
        reRepair: 'Powtarzające się naprawy',
        pullInNum: 'Liczba wpisów',
        perception: 'Klasa percepcji',
        onSupport: 'Wsparcie na miejscu',
        batteryNo: 'Numer baterii',
        normalStartDate: 'Data gwarancji',
        qmotorNo: 'Numer silnika przedniego',
        hmotorNo: 'Numer silnika tylnego',
        fault_cause_type: 'Typ przyczyny awarii',
        measure_name: 'Nazwa środka',
        part_name: 'Nazwa części',
        close_order_notification: 'Zamknięcie zamówienia wymaga odpowiedzi od wnioskodawcy.',
        TIS_Case_Data: 'Dane sprawy TIS',
        case_File: 'Plik sprawy',
        responsibility_Data: 'Dane dotyczące odpowiedzialności',
        longterm_Measures: 'Środki długoterminowe',
        tisCaseNo: 'Numer Przypadku TIS',
        vehGlobalFwVer: 'Numer Wersji Oprogramowania Pojazdu',
        vehGlobalFwPn: 'Numer Części Oprogramowania Pojazdu',
        archivesNo: 'Numer Archiwum',
        archivesTitle: 'Tytuł Archiwum',
        archivesSource: 'Źródło Archiwum',
        proposer: 'Wnioskodawca',
        proposedTime: 'Data Wniosku',
        archivesManagementPersonnel: 'Personel Zarządzający',
        functionalMode: 'Moduł Funkcjonalny',
        supplier: 'Dostawca',
        accessoriesInvolved: 'Zaangażowane Akcesoria',
        functionalDomain: 'Domena Funkcjonalna',
        invalidPartId: 'Nieprawidłowy ID Części',
        archivesType: 'Typ Archiwum',
        archivesGrade: 'Ocena Archiwum',
        problemDescription: 'Opis Problemu',
        analysisProgress: 'Postęp Analizy',
        qaRemark: 'Uwagi QA',
        tacRemark: 'Uwagi TAC',
        responsibleDepartment: 'Odpowiedzialny Dział',
        coordinator: 'Koordynator',
        principal: 'Główny',
        containmentAction: 'Działania Zabezpieczające',
        issueStatus: 'Status Problemu',
        softwareProblems: 'Problemy Oprogramowania',
        vehGlobalFwVer_j: 'Numer Wersji Bazowej',
        vehGlobalFwPn_j: 'Numer Części Bazowej',
        ewo: 'Numer EWO',
        rootCause: 'Przyczyna Główna',
        marketBehavior: 'Zachowanie Rynkowe',
        shortTermMeasures: 'Krótkoterminowe Środki',
        shortTermBreakpointDescription: 'Opis Krótkoterminowego Breakpointu',
        measuresResult: 'Wynik Zatwierdzenia Środków',
        measuresConfirmation: 'Potwierdzenie Środków',
        longTermMeasures: 'Długoterminowe Środki',
        longTermMeasuresBreak: 'Szacowany Opis Breakpointu Długoterminowych Środków',
        implementation: 'Wdrożenie',
        longMeasuresTime: 'Rzeczywista Data Breakpointu Długoterminowych Środków',
        vinBreak: 'VIN Breakpointu Długoterminowych Środków',
        breakpointImplementationPhase: 'Faza Wdrożenia Breakpointu',
        archive_Information: 'Informacje archiwalne',
        reason_incomplete_closure: 'Powód niekompletnego zamknięcia',
        entry_Date: 'Data przybycia',
        departure_date: 'Data wyjazdu',
        work_order_number: 'Numer zlecenia',
        questionnaire_usage: 'Zastosowanie ankiety',
        classification_of_technical_enquiries: 'Klasyfikacja zapytań technicznych',
        change_of_document_owner: 'Change Of Document Owner',
        oldowner: 'Old Owner',
        newowner: 'New Owner',
        original: 'Oryginał',
        translation: 'Tłumaczenie',
        dealer_address: 'Adres dealera',
        sel_up_engineers: 'Wybierz maksymalnie 12 inżynierów!',
        sel_up_weeks: 'Wybierz do 12 tygodni!',
        veh_infor_inquiry: 'Zapytanie o informacje dotyczące pojazdu',
        create_organization: 'Utwórz organizację',
        ref_code: 'Odśwież captcha',
        fault_complaint_Desp: 'Opis usterki / Opis skargi klienta',
        broken_down_vehicle: 'Pochodzący pojazd',
        reporting_organization: 'organizacji raportującej',
        reporter: 'Zgłaszający',
        oneclick_convert: 'Konwersja jednym kliknięciem',
        assembly: 'Montaż',
        show_original: 'Pokaż oryginał',
        sync_datong: 'Synchronizuj Datong',
        system_category_iii: 'Kategoria systemu III',
        maxus_Records: 'Zapisy rozmów MAXUS',
    },
    // 土耳其
    trTR: {
        vin: 'VIN',
        inquiry_no: 'Dosya No.',
        case_theme: 'Dosya konusu',
        department_name: 'Departman adı',
        department_type: 'Departman türü',
        document_status: 'Belge durumu',
        inquiry_date: 'Sorgulama tarihi',
        organization_name: 'Organizasyon adı',
        name: 'Teklif adı',
        sap_code: 'SAP kodu',
        failed_part: 'Etkilendi',
        case_type: 'Bölge türü',
        vehicle_status: 'Araç durumu',
        case_owner: 'Sorumlu kişi',
        country: 'Ülke',
        fault_cause: 'Hata sebebi',
        symptoms: 'Hata semptomu',
        is_the_document_qualified: 'Belgeler nitelikli mi?',
        is_the_document_replied_in_a_timely_manner: 'Dosyaya zamanında geri dönüş yapıldı mı?',
        filter: 'Filtreleme',
        system_classification_I: 'Sistem 1',
        system_classification_II: 'Sistem 2',
        full_query: 'Tam soru',
        fuzzy_query: 'Bulanık soru',
        whether_belongs_new_car_market: 'Yeni araç tanıtımı',
        caseStatus: 'Dosya durumu',
        correct: 'Doğru',
        deny: 'Red et',
        not_closed: 'Aç',
        no_reply: 'Cevap yok',
        replied: 'Cevap verildi',
        closed: 'Kapatıldı',
        drafts: 'Taslak kutusu',
        create_time: 'Oluşturma zamanı',
        create_user: 'Oluşturan kişi',
        parent_of_document: 'Belgenin ait olduğu yönetici',
        document_owner: 'Dosyanın Sahibi',
        case_subject: 'Konu',
        receipt_info: 'Dosya bilgisi',
        superior_of_case: 'Dosya yöneticisi',
        inquiry_time: 'Sorgulama zamanı',
        status: 'Durum',
        overseas_company: 'Satış şirketi ismi',
        general_agent_name: 'Dağıtıcı adı',
        dealer_code: 'Bayi kodu',
        dealer_name: 'Bayi adı',
        name_of_subsidiary: 'Bağlı kuruluş adı',
        contacts: 'Kontakt kişi',
        contact_information: 'Kontakt bilgisi',
        training_certification: 'Eğitim sertifikası',
        driving_mileage: 'Km si',
        plate_number: 'Plaka no',
        material_no: 'Araç malzeme kodu',
        material_desc: 'Malzeme tanımı',
        offline_date: 'Devre-tışı tarih',
        model_platform: 'Platform',
        engine_number: 'Motor Numarası',
        transmission_type: 'Şanzıman',
        assembly_no: 'CSN Hayır',
        fault_info_desc: 'Arıza tanımı',
        fault_handle_process: 'Düzeltici Faaliyet',
        solution: 'Çözüm',
        remark: 'Yorum',
        caseRemark: 'Dosya Yorumu',
        document_information: 'Dosya bilgisi',
        basic_information_of_service_center: 'Servis merkezi bilgileri',
        basic_vehicle_information: 'Araç temel bilgi',
        problem_description: 'Sorun tarifi',
        common_links: 'Faydalı ağlar',
        claim_information: 'Kleym bilgisi',
        diagnostic_report_record: 'Diagnostik rapor',
        vehicle_history: 'Teknik sorgulama tarihi',
        programming_history: 'Programlama geçmişi',
        vehicle_sales_logistics_information: 'Araç satış ve lojik bilgileri',
        new_vehicle_information: 'Yeni araç bilgisi',
        attachment_upload: 'Ekleri  yükleme',
        diagnostic_report: 'Diagnostik rapor',
        bulk_download: 'Toplu indirme',
        document_View: 'Belge Görüntüsü',
        inquiry_content: 'Sorgulama detayları',
        inquiry_entry: 'Sorulara yanıtlar',
        subordinate_record: 'Kayıt',
        superior_record: 'Üst seviye kayıt',
        send_content: 'İçeri gönder',
        send_time: 'Gönderim zamanı',
        sent_username: 'Gönderici',
        receive_name: 'Gönderin',
        dept_name: 'Seviye',
        enclosure: 'Ekli dosya',
        wind_case: 'Kapalı',
        close_order: 'yakın sipariş',
        case_reporting: 'Dosya gönderimi',
        pdf_preview: 'PDF Önizlemesi',
        SIS_maintenance: 'Büyük kaza bakımı',
        Please_fill_in_the_inquiry_content: 'Lütfen istenen bilgileri doldurun',
        sending_an_email: 'E-posta gönderiyor',
        copy: 'Kopya',
        repeat: 'Vin tekrar',
        inconsistent: 'Tutarsız araç platformu',
        sendTo: 'Gönderin',
        reply: 'Sorgulama/cevap için girdi',
        please_check_the_exported_document: 'Lütfen dışarı aktarılmış belgeleri kontrol edin',
        please_upload_diagnostic_report: 'Lütfen arızacılık raporunu yükleyin',
        please_enter_the_vin: 'Lütfen VIN girin',
        placeholderDTC: 'Misal：P080800_P087D00_------',
        placeholderFaultInfoDesc:
            '1.Müşterilerin endişelerini kontrol edin (sadece sorun çıkmasını önlemek için)',
        placeholderFaultHandleProcess:
            '2.İlgili simptomları belirleyin (sorunla bağlı olabilecek bütün simptomları belirleyuin ve kaydedin)\n' +
            '3.Simptomları analiz edin (ortak sebepleri tanımlamak için ilgili simptomları dikkatli gözlemleyin)\n' +
            '4.Sorunu  teyit edin (sonuçlarınızın boyutunu azaltmak için doğru sorunu çözmenizi sağlayın)',
        placeholderSolution:
            '5.Problemi çözün (tamir edin)\n' +
            '6.Aracın çalışmasını kontrol edin (yapılan onarımın sorunu çözdüğünü kontrol edin)',
        placeholderRemark: 'Misal: Direksiyon kutusu-201806, FL Amortisör-2010101',
        placeholderContact: 'Lütfen operatör adını girin',
        close_time: 'Kapanış zamanı',
        one_touch: 'Dosyanın yeniden açılması',
        confirm_generating_new_case: 'Yeni  bir  dosyanın açıldığını onaylayın ?',
        closing_statement: 'Kapanış bildirimi',
        number_of_cases: 'Dosya sayısı',
        number_of_vehicles: 'Araç sayısı',
        pleaseEnterContent: 'Lütfen içerik girin',
        case_age: 'vaka yaşı',
        last_response_time: 'son yanıt süresi',
        time_since_last_response: 'Son yanıttan bu yana geçen süre',
        warranty_start_date: 'Garanti Başlangıç Tarihi',
        submit_reason: 'Başvuru nedeni',
        synchronize_PQCP: 'Senkronize PQCP',
        FPR_export: 'FPR İhracat',
        level_selection: 'Seviye Seçimi',
        category_selection: 'Kategori Seçimi',
        brand_selection: 'Marka Seçimi',
        code: 'kodu',
        description: 'tarif et',
        major_complaints: 'önemli̇ şi̇kayet',
        difficult_miscellaneous_diseases: 'şüpheli veya tedavisi zor vakalar',
        emerging_issues: 'ortaya çıkan sorunlar',
        breakpoint_failure: 'kesme noktası hatası',
        general_complaints: 'Genel şikayetler',
        other: 'diğer',
        roewe: 'Roewe',
        mg: 'MG',
        serious: 'Ciddiyet',
        secondary: 'küçük',
        generally: 'olağan',
        complete: 'yerine getirmek',
        please_select_level: 'Lütfen bir seviye seçin',
        please_select_category: 'Lütfen bir kategori seçin',
        please_select_brand: 'Lütfen bir marka seçin',
        placeholder_auto: 'yer tutucu otomatik',
        translate: 'tercüme etmek',
        isTranslate: 'Çeviri ya da değil',
        day: 'gün',
        one_click_order: 'Seçili olanı kapatmak için tıklayın',
        greater_than: 'ağır basar',
        less_than: 'daha az',
        between: 'arasında',
        document_label: 'belge etiketi',
        receipts_first_modification_time: 'belge İlk değişiklik zamanı',
        Selection_of_Document_Owner: 'Belge Sorumlusu Seçimi',
        responsiblePerson: 'Sorumlu Kişi：',
        functional_Domain: 'Fonksiyonel Alan',
        Category: 'Kategori',
        property: 'nedensellik',
        reRepair: 'Tekrarlanan Onarımlar',
        pullInNum: 'Giriş Sayısı',
        perception: 'Algı Sınıfı',
        onSupport: 'Yerinde Destek',
        batteryNo: 'Batarya Numarası',
        normalStartDate: 'Garanti Tarihi',
        qmotorNo: 'Ön Motor Numarası',
        hmotorNo: 'Arka Motor Numarası',
        fault_cause_type: 'Arıza Neden Türü',
        measure_name: 'Tedbir Adı',
        part_name: 'Parça Adı',
        close_order_notification: 'Siparişi kapatmak, teklif sahibinden bir yanıt gerektirir.',
        TIS_Case_Data: 'TIS Vaka Verileri',
        case_File: 'Vaka Dosyası',
        responsibility_Data: 'Sorumluluk Verileri',
        longterm_Measures: 'Uzun Vadeli Önlemler',
        tisCaseNo: 'TIS Vaka Numarası',
        vehGlobalFwVer: 'Araç Yazılımı Sürüm Numarası',
        vehGlobalFwPn: 'Araç Yazılımı Parça Numarası',
        archivesNo: 'Dosya Numarası',
        archivesTitle: 'Dosya Başlığı',
        archivesSource: 'Dosya Kaynağı',
        proposer: 'Teklif Eden',
        proposedTime: 'Teklif Tarihi',
        archivesManagementPersonnel: 'Yönetim Personeli',
        functionalMode: 'Fonksiyonel Modül',
        supplier: 'Tedarikçi',
        accessoriesInvolved: 'Aksesuarlar Dahil',
        functionalDomain: 'Fonksiyonel Alan',
        invalidPartId: 'Geçersiz Parça Kimliği',
        archivesType: 'Dosya Türü',
        archivesGrade: 'Dosya Derecesi',
        problemDescription: 'Problem Açıklaması',
        analysisProgress: 'Analiz İlerlemesi',
        qaRemark: 'QA Açıklaması',
        tacRemark: 'TAC Açıklaması',
        responsibleDepartment: 'Sorumlu Departman',
        coordinator: 'Koordinatör',
        principal: 'Yetkili',
        containmentAction: 'Sınırlandırma Eylemi',
        issueStatus: 'Sorun Durumu',
        softwareProblems: 'Yazılım Problemleri',
        vehGlobalFwVer_j: 'Temel Sürüm Numarası',
        vehGlobalFwPn_j: 'Temel Parça Numarası',
        ewo: 'EWO Numarası',
        rootCause: 'Temel Sebep',
        marketBehavior: 'Pazar Davranışı',
        shortTermMeasures: 'Kısa Vadeli Önlemler',
        shortTermBreakpointDescription: 'Kısa Vadeli Kesilme Noktası Açıklaması',
        measuresResult: 'Önlemler Onay Sonucu',
        measuresConfirmation: 'Önlemler Onayı',
        longTermMeasures: 'Uzun Vadeli Önlemler',
        longTermMeasuresBreak: 'Uzun Vadeli Önlemler Tahmini Kesilme Noktası Açıklaması',
        implementation: 'Uygulama',
        longMeasuresTime: 'Uzun Vadeli Önlemler Gerçek Kesilme Tarihi',
        vinBreak: 'Uzun Vadeli Önlemler Kesilme Noktası VIN',
        breakpointImplementationPhase: 'Kesilme Noktası Uygulama Aşaması',
        archive_Information: 'Arşiv Bilgisi',
        reason_incomplete_closure: 'Tamamlanmamış kapanma nedeni',
        entry_Date: 'Giriş tarihi',
        departure_date: 'Çıkış tarihi',
        work_order_number: 'İş emri numarası',
        questionnaire_usage: 'Anket kullanımı',
        classification_of_technical_enquiries: 'Teknik soruların sınıflandırılması',
        change_of_document_owner: 'Change Of Document Owner',
        oldowner: 'Old Owner',
        newowner: 'New Owner',
        original: 'Özgün',
        translation: 'Çeviri',
        dealer_address: 'Bayi adresi',
        sel_up_engineers: 'En fazla 12 mühendis seçin!',
        sel_up_weeks: 'En fazla 12 hafta seçin!',
        veh_infor_inquiry: 'Araç bilgisi sorgulama',
        create_organization: 'Kuruluş oluştur',
        ref_code: 'Captcha\'yı yenile',
        fault_complaint_Desp: 'Arıza açıklaması / Müşteri şikâyeti açıklaması',
        broken_down_vehicle: 'Arıza Yapan Araç',
        reporting_organization: 'organizasyonu adı',
        reporter: 'Bildiren',
        oneclick_convert: 'Bir Tıkla Dönüştürme',
        assembly: 'Montaj',
        show_original: 'Orijinali göster',
        sync_datong: 'Datong’u senkronize et',
        system_category_iii: 'Sistem kategorisi III',
        maxus_Records: 'MAXUS Sohbet Kayıtları',
    },
    // 捷克语
    csCZ: {
        vin: 'VIN',
        inquiry_no: 'Případ č.',
        case_theme: 'Předmět případu',
        department_name: 'Název oddělení',
        department_type: 'Typ oddělení',
        document_status: 'Stav dokumentu',
        inquiry_date: 'Datum dotazu',
        organization_name: 'Název organizace',
        name: 'Jméno navrhovatele',
        sap_code: 'SAP kód',
        failed_part: 'Systémová část',
        case_type: 'Typ případu:',
        vehicle_status: 'Stav opravy',
        case_owner: 'Zodpovědná osoba',
        country: 'Země',
        fault_cause: 'Příčina závady',
        symptoms: 'Fenomén závady',
        is_the_document_qualified: 'Je případ kvalifikovaný',
        is_the_document_replied_in_a_timely_manner: 'Je případ zodpovězen včas',
        filter: 'Filtr',
        system_classification_I: 'Systémová skupina',
        system_classification_II: 'Sestava systému',
        full_query: 'Úplný dotaz',
        fuzzy_query: 'Nejasný dotaz',
        whether_belongs_new_car_market: 'Nový model na trhu',
        caseStatus: 'Stav případu',
        correct: 'Upravit',
        deny: 'Odmítnout',
        not_closed: 'OTEVŘENO',
        no_reply: 'Čeká na odpověď',
        replied: 'Odpovězeno',
        closed: 'ZAVŘENO',
        drafts: 'Návrh/Koncept',
        create_time: 'Čas vytvoření',
        create_user: 'Vytvořil',
        parent_of_document: 'Vlastník dokumentu',
        document_owner: 'Vlastník případu',
        case_subject: 'Předmět',
        receipt_info: 'Informace o případu',
        superior_of_case: 'Dohled případu',
        inquiry_time: 'Čas dotazu',
        status: 'Status',
        overseas_company: 'Název společnosti prodejce',
        general_agent_name: 'Jméno distributora',
        dealer_code: 'Kód dealera',
        dealer_name: 'Jméno dealera',
        name_of_subsidiary: 'Název pobočky',
        contacts: 'Kontaktní osoba',
        contact_information: 'Kontaktní informace',
        training_certification: 'Certifikace školení',
        driving_mileage: 'Počet najetých kilometrů',
        plate_number: 'Poznávací značka #',
        material_no: 'Kód materiálu vozidla',
        material_desc: 'Popis materiálu',
        offline_date: 'Datum off-line',
        model_platform: 'Platforma',
        engine_number: 'Číslo motoru',
        transmission_type: 'Převodovka',
        assembly_no: 'ČSN č',
        fault_info_desc: 'Stížnost zákazníka',
        fault_handle_process: 'Diagnostika/Provedené práce',
        solution: 'Řešení',
        remark: 'Poznámka',
        caseRemark: 'Poznámka k případu',
        document_information: 'Informace o případu',
        basic_information_of_service_center: 'Informace o servisním středisku',
        basic_vehicle_information: 'Základní informace o vozidle',
        problem_description: 'Popis problému',
        common_links: 'Užitečný odkaz',
        claim_information: 'Informace o nároku',
        diagnostic_report_record: 'Diagnostický report',
        vehicle_history: 'Historie technických dotazů',
        programming_history: 'Historie programování',
        vehicle_sales_logistics_information: 'Informace o prodeji vozidel a logistice',
        new_vehicle_information: 'Nové informace o vozidle',
        attachment_upload: 'Nahrání přílohy',
        diagnostic_report: 'Diagnostický report',
        bulk_download: 'Hromadné stahování',
        document_View: 'Zobrazení dokumentu',
        inquiry_content: 'Detail odpovědi případu',
        inquiry_entry: 'Zadání odpovědi případu',
        subordinate_record: 'Podřízený záznam',
        superior_record: 'Hlavní záznam',
        send_content: 'Odeslat obsah',
        send_time: 'Čas odeslání',
        sent_username: 'Odesílatel',
        receive_name: 'Poslat komu',
        dept_name: 'Úroveň',
        enclosure: 'Příloha',
        wind_case: 'ZAVŘENO',
        close_order: 'Uzavřít případ',
        case_reporting: 'Odeslat případ',
        pdf_preview: 'Náhled PDF',
        SIS_maintenance: 'Údržba při závažných haváriích',
        Please_fill_in_the_inquiry_content: 'Vyplňte prosím obsah dotazu',
        sending_an_email: 'Odeslání emailu',
        copy: 'kopírovat',
        repeat: 'Opakovat VIN',
        inconsistent: 'Nekonzistentní platforma vozidla',
        sendTo: 'Odeslat na',
        reply: 'Vstup pro dotaz/odpověď',
        please_check_the_exported_document: 'Zkontrolujte exportovaný dokument',
        please_upload_diagnostic_report: 'Nahrajte prosím diagnostický report',
        please_enter_the_vin: 'Zadejte VIN',
        placeholderDTC: 'Příklad：P080800_P087D00_------',
        placeholderFaultInfoDesc: '1. Stížnost zákazníka (zjištění / potvrzení projevu stížnosti)',
        placeholderFaultHandleProcess:
            '2. Identifikace relevantních příznaků (identifikujte a zaznamenejte všechny příznaky, které mohou souviset s problémem).\n' +
            '3. Analyzujte symptomy (pečlivě sledujte příslušné symptomy, abyste identifikovali společné příčiny)\n' +
            '4. Potvrzení problému (zúžení rozsahu výsledků, abyste se ujistili, že jste vyřešili správný problém)',
        placeholderSolution:
            '5.Odstranění problému (provedení opravy)\n' +
            '6. Ověřte provoz vozidla (zkontrolujte, zda vaše opravy problém vyřešily)',
        placeholderRemark: 'Příklad: Převodka řízení-201806, Tlumič FL-2010101',
        placeholderContact: 'Zadejte jméno operátora',
        close_time: 'Čas uzavření',
        one_touch: 'Obnovení případu',
        confirm_generating_new_case: 'Potvrdit generování nového případu?',
        closing_statement: 'Závěrečná zpráva',
        number_of_cases: 'Počet případů',
        number_of_vehicles: 'Počet vozidel',
        pleaseEnterContent: 'Prosím zadejte obsah',
        case_age: 'Stáří případu',
        last_response_time: 'Čas poslední reakce',
        time_since_last_response: 'Čas od poslední odpovědi',
        warranty_start_date: 'Datum začátku záruky',
        submit_reason: 'Důvod podání žádosti',
        synchronize_PQCP: 'Synchronizujte PQCP',
        FPR_export: 'FPR export',
        level_selection: 'Volba úrovně',
        category_selection: 'Volba kategorie',
        brand_selection: 'Výběr značky',
        code: 'Kód',
        description: 'Popis',
        major_complaints: 'Hlavní stížnost',
        difficult_miscellaneous_diseases: 'Obtížné případy',
        emerging_issues: 'Nové případy',
        breakpoint_failure: 'Breakpoint závady',
        general_complaints: 'Obecné stížnosti',
        other: 'jiný',
        roewe: 'Roewe',
        mg: 'MG',
        serious: 'Vážně',
        secondary: 'Vedlejší',
        generally: 'Obecně',
        complete: 'dokončeno',
        please_select_level: 'Vyberte úroveň',
        please_select_category: 'Vyberte kategorii',
        please_select_brand: 'Vyberte značku',
        placeholder_auto: 'Automaticky vyplněné',
        translate: 'Přeložit',
        isTranslate: 'Překládá se',
        day: 'den',
        one_click_order: 'Objednávka jedním kliknutím',
        greater_than: 'Větší než',
        less_than: 'Méně než',
        between: 'Mezi',
        document_label: 'Označení dokumentu',
        receipts_first_modification_time: 'Čas první úpravy',
        Selection_of_Document_Owner: 'Výběr odpovědné osoby za dokument',
        responsiblePerson: 'odpovědná osoba',
        functional_Domain: 'Funkční doména',
        Category: 'Kategorie',
        property: 'vlastnictví',
        reRepair: 'Opakovaná oprava',
        pullInNum: 'Počet vstupů',
        perception: 'Třída vnímání',
        onSupport: 'Podpora na místě',
        batteryNo: 'Číslo baterie',
        normalStartDate: 'Datum záruky',
        qmotorNo: 'Číslo předního motoru',
        hmotorNo: 'Číslo zadního motoru',
        fault_cause_type: 'typ příčiny závady',
        measure_name: 'Měření',
        part_name: 'Název dílu',
        close_order_notification: 'Uzavření objednávky vyžaduje odpověď navrhovatele.',
        TIS_Case_Data: 'Údaje o případu TIS',
        case_File: 'Soubor případu',
        responsibility_Data: 'Údaje o odpovědnosti',
        longterm_Measures: 'Dlouhodobá opatření',
        tisCaseNo: 'Číslo případu TIS',
        vehGlobalFwVer: 'Číslo verze softwaru vozidla',
        vehGlobalFwPn: 'Číslo dílu softwaru vozidla',
        archivesNo: 'Číslo souboru',
        archivesTitle: 'Název souboru',
        archivesSource: 'Zdroj souboru',
        proposer: 'Navrhovatel',
        proposedTime: 'Navrhované datum',
        archivesManagementPersonnel: 'Personál správy',
        functionalMode: 'Funkční modul',
        supplier: 'Dodavatel',
        accessoriesInvolved: 'Zahrnuté příslušenství',
        functionalDomain: 'Funkční doména',
        invalidPartId: 'Neplatné ID dílu',
        archivesType: 'Typ souboru',
        archivesGrade: 'Hodnocení souboru',
        problemDescription: 'Popis problému',
        analysisProgress: 'Pokrok analýzy',
        qaRemark: 'Poznámka QA',
        tacRemark: 'Poznámka TAC',
        responsibleDepartment: 'Odpovědné oddělení',
        coordinator: 'Koordinátor',
        principal: 'Vedoucí',
        containmentAction: 'Zajišťovací opatření',
        issueStatus: 'Stav problému',
        softwareProblems: 'Problémy softwaru',
        vehGlobalFwVer_j: 'Číslo základní verze',
        vehGlobalFwPn_j: 'Číslo základního dílu',
        ewo: 'Číslo EWO',
        rootCause: 'Kořenová příčina',
        marketBehavior: 'Tržní chování',
        shortTermMeasures: 'Krátkodobá opatření',
        shortTermBreakpointDescription: 'Popis krátkodobého bodu zlomu',
        measuresResult: 'Výsledek schválení opatření',
        measuresConfirmation: 'Potvrzení opatření',
        longTermMeasures: 'Dlouhodobá opatření',
        longTermMeasuresBreak: 'Odhadovaný popis bodu zlomu dlouhodobých opatření',
        implementation: 'Implementace',
        longMeasuresTime: 'Skutečné datum bodu zlomu dlouhodobých opatření',
        vinBreak: 'VIN bodu zlomu dlouhodobých opatření',
        breakpointImplementationPhase: 'Fáze implementace bodu zlomu',
        archive_Information: 'Informace o archivu',
        reason_incomplete_closure: 'Důvod neúplného uzavření',
        entry_Date: 'Datum vstupu',
        departure_date: 'Datum odjezdu',
        work_order_number: 'Číslo pracovního příkazu',
        questionnaire_usage: 'Použití dotazníku',
        classification_of_technical_enquiries: 'Klasifikace technických dotazů',
        change_of_document_owner: 'Change Of Document Owner',
        oldowner: 'Old Owner',
        newowner: 'New Owner',
        original: 'Originál',
        translation: 'Překlad',
        dealer_address: 'Adresa prodejce',
        sel_up_engineers: 'Vyberte až 12 inženýrů!',
        sel_up_weeks: 'Vyberte až 12 týdnů!',
        veh_infor_inquiry: 'Dotaz na informace o vozidle',
        create_organization: 'Vytvořit organizaci',
        ref_code: 'Obnovit CAPTCHA',
        fault_complaint_Desp: 'Popis závady / Popis stížnosti zákazníka',
        broken_down_vehicle: 'Bildirim organizasyonu adı',
        reporting_organization: 'ohlašující společnosti',
        reporter: 'Nahlášení',
        oneclick_convert: 'Převod jedním kliknutím',
        assembly: 'Montáž',
        show_original: 'Zobrazit originál',
        sync_datong: 'Synchronizovat Datong',
        system_category_iii: 'Kategorie systému III',
        maxus_Records: 'Záznamy konverzací MAXUS',
    },
    // 匈牙利语翻译
    huHU: {
        vin: 'Alvázszám',
        inquiry_no: 'Eset sz.',
        case_theme: 'Eset tárgya',
        department_name: 'Részleg neve',
        department_type: 'Részleg típusa',
        document_status: 'Dokumentum állapota',
        inquiry_date: 'Érdeklődés dátuma',
        organization_name: 'Szervezet neve',
        name: 'Ajánlattevő neve',
        sap_code: 'SAP-kód',
        failed_part: 'Rendszer része',
        case_type: 'Eset típusa',
        vehicle_status: 'Javítás állapota',
        case_owner: 'Felelős személy',
        country: 'Ország',
        fault_cause: 'Hiba oka',
        symptoms: 'Hibajelenség',
        is_the_document_qualified: 'Minősített eset-e',
        is_the_document_replied_in_a_timely_manner: 'Időben reagáltak-e az esetre',
        filter: 'Szűrő',
        system_classification_I: 'Rendszercsoport',
        system_classification_II: 'Rendszeregység',
        full_query: 'Teljes lekérdezés',
        fuzzy_query: 'Részleges lekérdezés',
        whether_belongs_new_car_market: 'Új jármű bevezetése',
        caseStatus: 'Eset állapota',
        correct: 'Helyes',
        deny: 'Elutasítás',
        not_closed: 'Megnyitás',
        no_reply: 'Válaszra vár',
        replied: 'Megválaszolva',
        closed: 'Lezárva',
        drafts: 'Vázlatmező',
        create_time: 'Létrehozás ideje',
        create_user: 'Létrehozta',
        parent_of_document: 'Dokumentum szülője',
        document_owner: 'Eset tulajdonosa',
        case_subject: 'Tárgy',
        receipt_info: 'Esetinformáció',
        superior_of_case: 'Eset felettes',
        inquiry_time: 'Érdeklődés ideje',
        status: 'Állapot',
        overseas_company: 'Értékesítő vállalat neve',
        general_agent_name: 'Forgalmazó neve',
        dealer_code: 'Kereskedői kód',
        dealer_name: 'Kereskedő neve',
        name_of_subsidiary: 'Alvállalkozó neve',
        contacts: 'Kapcsolattartó',
        contact_information: 'Elérhetőségek',
        training_certification: 'Képzési bizonyítvány',
        driving_mileage: 'Futásteljesítmény',
        plate_number: 'Rendszám',
        material_no: 'Jármű anyagkód',
        material_desc: 'Anyagleírás',
        offline_date: 'Offline dátum',
        model_platform: 'Platform',
        engine_number: 'Motorszám',
        transmission_type: 'Váltómű',
        assembly_no: 'CSN sz.',
        fault_info_desc: 'Ügyfél által jelentett panasz',
        fault_handle_process: 'Elvégzett diagnosztika/munka',
        solution: 'Megoldás',
        remark: 'Megjegyzés',
        caseRemark: 'Eset megjegyzés',
        document_information: 'Esetinformáció',
        basic_information_of_service_center: 'Szervizközpont információ',
        basic_vehicle_information: 'Jármű alapvető információi',
        problem_description: 'Probléma leírása',
        common_links: 'Hasznos hivatkozás',
        claim_information: 'Igényinformáció',
        diagnostic_report_record: 'Diagnosztikai jelentés',
        vehicle_history: 'Műszaki érdeklődés előzménye',
        programming_history: 'Programozási előzmények',
        vehicle_sales_logistics_information: 'Járműértékesítési és -logisztikai információ',
        new_vehicle_information: 'Újjármű-információ',
        attachment_upload: 'Csatolmány feltöltése',
        diagnostic_report: 'Diagnosztikai jelentés',
        bulk_download: 'Kötegelt letöltés',
        document_View: 'Dokumentumnézet',
        inquiry_content: 'Esetreakció-részlet',
        inquiry_entry: 'Esetreakció-bejegyzés',
        subordinate_record: 'Beosztotti rekord',
        superior_record: 'Felettesi rekord',
        send_content: 'Tartalom küldése',
        send_time: 'Küldési idő',
        sent_username: 'Küldő',
        receive_name: 'Címzett',
        dept_name: 'Szint',
        enclosure: 'Csatolmány',
        wind_case: 'Lezárva',
        close_order: 'Rendelés lezárása',
        case_reporting: 'Eset beküldése',
        pdf_preview: 'PDF előnézet',
        SIS_maintenance: 'Nagy baleseti karbantartás',
        Please_fill_in_the_inquiry_content: 'Töltse ki az érdeklődés tartalmát',
        sending_an_email: 'E-mail küldése',
        copy: 'Másolás',
        repeat: 'Alvázszám újra',
        inconsistent: 'Nem következetes járműplatform',
        sendTo: 'Címzett',
        reply: 'Érdeklődés/válasz bevitele',
        please_check_the_exported_document: 'Ellenőrizze az exportált dokumentumot',
        please_upload_diagnostic_report: 'Töltse fel a diagnosztikai jelentést',
        please_enter_the_vin: 'Adja meg az alvázszámot',
        placeholderDTC: 'Példa：P080800_P087D00_------',
        placeholderFaultInfoDesc:
            '1. Ellenőrizze az ügyfélpanaszt (hogy meggyőződjön a fellépő problémáról)',
        placeholderFaultHandleProcess:
            '2. Azonosítsa a vonatkozó tüneteket (azonosítsa és rögzítse az összes tünetet, ami a problémához kapcsolódhat)\n' +
            '3. Elemezze a tüneteket (gondosan figyelje meg a vonatkozó tüneteket, hogy azonosítsa a gyakori okokat)\n' +
            '4. Erősítse meg a problémát (szűkítse le az eredmények körét, hogy biztosan a megfelelő problémát oldotta-e meg)',
        placeholderSolution:
            '5. Javítsa meg a problémát (végezze el a javításokat)\n' +
            '6. Ellenőrizze a jármű működését (ellenőrizze, hogy a javítások biztosan megoldották-e a problémát)',
        placeholderRemark: 'Példa: Kormánymű–201806, BE lengéscsillapító–2010101',
        placeholderContact: 'Adja meg az operátor nevét',
        close_time: 'Lezárás ideje',
        one_touch: 'Eset újraépítése',
        confirm_generating_new_case: 'Biztosan új esetet hoz létre?',
        closing_statement: 'Lezárási nyilatkozat',
        number_of_cases: 'Esetek száma',
        number_of_vehicles: 'Járművek száma',
        pleaseEnterContent: 'Adja meg a tartalmat',
        case_age: 'Eset kora',
        last_response_time: 'Utolsó reakció ideje',
        time_since_last_response: 'Utolsó reakció óta eltelt idő',
        warranty_start_date: 'Garancia érvényességének kezdete',
        submit_reason: 'Beküldés oka',
        synchronize_PQCP: 'PQCP szinkronizálása',
        FPR_export: 'FPR exportálása',
        level_selection: 'Szintválasztás',
        category_selection: 'Kategóriaválasztás',
        brand_selection: 'Márkaválasztás',
        code: 'Kód',
        description: 'Leírás',
        major_complaints: 'Komoly panaszok',
        difficult_miscellaneous_diseases: 'Bonyolult egyéb tünetek',
        emerging_issues: 'Felmerülő problémák',
        breakpoint_failure: 'Lerobbanás',
        general_complaints: 'Általános panaszok',
        other: 'Egyéb',
        roewe: 'Roewe',
        mg: 'MG',
        serious: 'Súlyos',
        secondary: 'Másodlagos',
        generally: 'Általános',
        complete: 'Kész',
        please_select_level: 'Válasszon szintet',
        please_select_category: 'Válasszon kategóriát',
        please_select_brand: 'Válasszon márkát',
        placeholder_auto: 'Automatikusan kitöltve',
        translate: 'Fordítás',
        isTranslate: 'Fordítsa-e',
        day: 'Nap',
        one_click_order: 'Egykattintásos rendelés',
        greater_than: 'Nagyobb, mint',
        less_than: 'Kisebb, mint',
        between: 'Között',
        document_label: 'Dokumentumcímke',
        receipts_first_modification_time: 'Számla első módosításának ideje',
        Selection_of_Document_Owner: 'Dokumentumért felelős személy kiválasztása',
        responsiblePerson: 'Felelős személy',
        functional_Domain: 'Funkcionális terület',
        Category: 'Kategória',
        property: 'Tulajdonság',
        reRepair: 'Javítások ismétlése',
        pullInNum: 'Bejegyzések száma',
        perception: 'Észlelési osztály',
        onSupport: 'Helyszíni támogatás',
        batteryNo: 'Akkumulátor száma',
        normalStartDate: 'Garancia dátuma',
        qmotorNo: 'Elülsőmotor száma',
        hmotorNo: 'Hátsómotor száma',
        fault_cause_type: 'Hiba okának típusa',
        measure_name: 'Intézkedés neve',
        part_name: 'Alkatrész neve',
        close_order_notification: 'A rendelés lezárásához az ajánló reakciójára van szükség.',
        TIS_Case_Data: 'TIS esetadatok',
        case_File: 'Eset fájl',
        responsibility_Data: 'Felelős adatok',
        longterm_Measures: 'Hosszú távú intézkedések',
        tisCaseNo: 'TIS eset száma',
        vehGlobalFwVer: 'Teljes jármű szoftververzió',
        vehGlobalFwPn: 'Teljes jármű szoftver alkatrész szám',
        archivesNo: 'Archívum szám',
        archivesTitle: 'Archívum címe',
        archivesSource: 'Archívum forrása',
        proposer: 'Javasló személy',
        proposedTime: 'Javaslat dátuma',
        archivesManagementPersonnel: 'Kezelő személy',
        functionalMode: 'Funkcionális mód',
        supplier: 'Szállító',
        accessoriesInvolved: 'Résztvevő alkatrészek',
        functionalDomain: 'Funkcionális terület',
        invalidPartId: 'Elégtelen alkatrész',
        archivesType: 'Archívum típusa',
        archivesGrade: 'Archívum szintje',
        problemDescription: 'Probléma leírása',
        analysisProgress: 'Elemzési előrehaladás',
        qaRemark: 'QA megjegyzés',
        tacRemark: 'TAC megjegyzés',
        responsibleDepartment: 'Felelős osztály',
        coordinator: 'Koordinátor',
        principal: 'Felelős személy',
        containmentAction: 'Felfogó intézkedés',
        issueStatus: 'Probléma állapota',
        softwareProblems: 'Szoftverproblémák',
        vehGlobalFwVer_j: 'Alapvonal verziószám',
        vehGlobalFwPn_j: 'Alapvonal alkatrész szám',
        ewo: 'EWO szám',
        rootCause: 'Gyökérok',
        marketBehavior: 'Piaci magatartás',
        shortTermMeasures: 'Rövid távú intézkedések',
        shortTermBreakpointDescription: 'Rövid távú törési leírás',
        measuresResult: 'Intézkedések jóváhagyási eredménye',
        measuresConfirmation: 'Intézkedések megerősítési nyilatkozat',
        longTermMeasures: 'Hosszú távú intézkedések',
        longTermMeasuresBreak: 'Hosszú távú várható törési leírás',
        implementation: 'Megvalósítás',
        longMeasuresTime: 'Hosszú távú tényleges törési dátum',
        vinBreak: 'Hosszú távú törési VIN',
        breakpointImplementationPhase: 'Törés végrehajtási szakasz',
        archive_Information: 'Archívum információ',
        reason_incomplete_closure: 'Hiányzó zárás oka',
        entry_Date: 'Belépési dátum',
        departure_date: 'Távozási dátum',
        work_order_number: 'Munkarend szám',
        questionnaire_usage: 'Kérdőív használata',
        classification_of_technical_enquiries: 'Technikai kérdések osztályozása',
        change_of_document_owner: 'Change Of Document Owner',
        oldowner: 'Old Owner',
        newowner: 'New Owner',
        original: 'Eredeti',
        translation: 'Fordítás',
        dealer_address: 'Kereskedő címe',
        sel_up_engineers: 'Válasszon legfeljebb 12 mérnököt!',
        sel_up_weeks: 'Válasszon legfeljebb 12 hetet!',
        veh_infor_inquiry: 'Jármű információk lekérdezése',
        create_organization: 'Szervezet létrehozása',
        ref_code: 'Frissítse a Captcha-t',
        fault_complaint_Desp: 'Hibaleírás / Ügyfélelpanasz leírása',
        broken_down_vehicle: 'Meghibásodott jármű',
        reporting_organization: 'Jelentő szervezet',
        reporter: 'Bejelentő',
        oneclick_convert: 'Átalakítás egy kattintással',
        assembly: 'Összeszerelés',
        show_original: 'Eredeti megjelenítése',
        sync_datong: 'Datong szinkronizálása',
        system_category_iii: 'Rendszerkategória III',
        maxus_Records: 'MAXUS beszélgetési naplók',
    },
    // 俄罗斯语
    ruRU: {
        vin: 'VIN',
        inquiry_no: 'Номер случая',
        case_theme: 'Тема случая',
        department_name: 'Название отдела',
        department_type: 'Тип отдела',
        document_status: 'Статус документа',
        inquiry_date: 'Дата запроса',
        organization_name: 'Название организации',
        name: 'Имя предложителя',
        sap_code: 'Код SAP',
        failed_part: 'Неисправная деталь',
        case_type: 'Тип случая',
        vehicle_status: 'Статус ремонта',
        case_owner: 'Ответственный',
        country: 'Страна',
        fault_cause: 'Причина неисправности',
        symptoms: 'Симптом неисправности',
        is_the_document_qualified: 'Соответствие документа требованиям',
        is_the_document_replied_in_a_timely_manner: 'Своевременность ответа по документу',
        filter: 'Фильтр',
        system_classification_I: 'Системная группа',
        system_classification_II: 'Системная сборка',
        full_query: 'Полный запрос',
        fuzzy_query: 'Неопределенный запрос',
        whether_belongs_new_car_market: 'Новый автомобиль на рынке',
        caseStatus: 'Статус случая',
        correct: 'Да',
        deny: 'Нет',
        not_closed: 'Открыт',
        no_reply: 'Ожидание ответа',
        replied: 'Ответили',
        closed: 'Закрыто',
        drafts: 'Черновик',
        create_time: 'Время создания',
        create_user: 'Создатель',
        parent_of_document: 'Руководитель документа',
        document_owner: 'Ответственный за случай',
        case_subject: 'Тема',
        receipt_info: 'Информация о случае',
        superior_of_case: 'Руководитель случая',
        inquiry_time: 'Время запроса',
        status: 'Статус',
        overseas_company: 'Название компании-продавца',
        general_agent_name: 'Название дистрибьютора',
        dealer_code: 'Код дилера',
        dealer_name: 'Название дилера',
        name_of_subsidiary: 'Название дочернего предприятия',
        contacts: 'Контактное лицо',
        contact_information: 'Контактная информация',
        training_certification: 'Обучение и сертификация',
        driving_mileage: 'Пробег',
        plate_number: 'Регистрационный номер',
        material_no: 'Код материала',
        material_desc: 'Описание материала',
        offline_date: 'Дата выпуска',
        model_platform: 'Платформа',
        engine_number: 'Номер двигателя',
        transmission_type: 'Трансмиссия',
        assembly_no: 'Номер сборки',
        fault_info_desc: 'Сообщенные проблемы клиента',
        fault_handle_process: 'Диагностика/Проведенные работы',
        solution: 'Решение',
        remark: 'Примечание',
        caseRemark: 'Примечание к случаю',
        document_information: 'Информация о случае',
        basic_information_of_service_center: 'Информация о сервисном центре',
        basic_vehicle_information: 'Основная информация о транспортном средстве',
        problem_description: 'Описание проблемы',
        common_links: 'Полезные ссылки',
        claim_information: 'Информация о претензии',
        diagnostic_report_record: 'Диагностический отчет',
        vehicle_history: 'История технических запросов',
        programming_history: 'История программирования',
        vehicle_sales_logistics_information:
            'Информация о продаже и логистике транспортного средства',
        new_vehicle_information: 'Новая информация о транспортном средстве',
        attachment_upload: 'Загрузка вложений',
        diagnostic_report: 'Диагностический отчет',
        bulk_download: 'Пакетная загрузка',
        document_View: 'Просмотр документа',
        inquiry_content: 'Подробности ответа по случаю',
        inquiry_entry: 'Запись ответа по случаю',
        subordinate_record: 'Запись нижестоящих ответов',
        superior_record: 'Запись вышестоящих ответов',
        send_content: 'Содержание сообщения',
        send_time: 'Время отправки',
        sent_username: 'Отправитель',
        receive_name: 'Получатель',
        dept_name: 'Уровень',
        enclosure: 'Вложение',
        wind_case: 'Закрытие дела',
        close_order: 'Закрытие заявки',
        case_reporting: 'Подать случай',
        pdf_preview: 'Предварительный просмотр PDF',
        SIS_maintenance: 'Обслуживание крупных происшествий',
        Please_fill_in_the_inquiry_content: 'Пожалуйста, заполните содержание запроса',
        sending_an_email: 'Отправить по электронной почте',
        copy: 'Копировать',
        repeat: 'Повторный VIN',
        inconsistent: 'Несоответствие платформы автомобиля',
        sendTo: 'Получатель',
        reply: 'Введите содержимое для запроса/ответа',
        please_check_the_exported_document: 'Пожалуйста, выберите документы для экспорта',
        please_upload_diagnostic_report: 'Пожалуйста, загрузите диагностический отчет',
        please_enter_the_vin: 'Пожалуйста, введите VIN',
        placeholderDTC: 'Пример: P080800_P087D00_------',
        placeholderFaultInfoDesc:
            '1. Проверьте проблемы клиента (чтобы убедиться, что проблемы действительно возникают)',
        placeholderFaultHandleProcess:
            '2. Определите соответствующие симптомы (найдите и зафиксируйте все симптомы, которые могут быть связаны с проблемой)\n' +
            '3. Проанализируйте симптомы  (тщательно исследуйте соответствующие симптомы, чтобы выявить общие причины)\n' +
            '4. Подтвердите проблему  (сузьте область результатов, чтобы убедиться, что вы решаете правильную проблему)',
        placeholderSolution:
            '5. Исправьте проблему (проведите ремонт)\n' +
            '6. Проверьте работу автомобиля (убедитесь, что ваш ремонт решает проблему)',
        placeholderRemark: 'Пример: Рулевое управление-201806, Фронтальный амортизатор-2010101',
        placeholderContact: 'Пожалуйста, введите имя оператора',
        close_time: 'Время закрытия',
        one_touch: 'Перестройка дела',
        confirm_generating_new_case: 'Подтвердите создание нового дела?',
        closing_statement: 'Заключение по делу',
        number_of_cases: 'Количество дел',
        number_of_vehicles: 'Количество автомобилей',
        pleaseEnterContent: 'Пожалуйста, введите содержание',
        case_age: 'Возраст дела',
        last_response_time: 'Время последнего ответа',
        time_since_last_response: 'Время с последнего ответа',
        warranty_start_date: 'Дата начала гарантии',
        submit_reason: 'Причина подачи',
        synchronize_PQCP: 'Синхронизировать PQCP',
        FPR_export: 'Экспорт FPR',
        level_selection: 'Выбор уровня',
        category_selection: 'Выбор категории',
        brand_selection: 'Выбор бренда',
        code: 'Код',
        description: 'Описание',
        major_complaints: 'Основные жалобы',
        difficult_miscellaneous_diseases: 'Сложные редкие неисправности',
        emerging_issues: 'Новые проблемы',
        breakpoint_failure: 'Неисправность по прерыванию',
        general_complaints: 'Общие жалобы',
        other: 'Прочее',
        roewe: 'Roewe',
        mg: 'MG',
        serious: 'Серьезная',
        secondary: 'Второстепенная',
        generally: 'Обычная',
        complete: 'Завершено',
        please_select_level: 'Пожалуйста, выберите уровень',
        please_select_category: 'Пожалуйста, выберите категорию',
        please_select_brand: 'Пожалуйста, выберите бренд',
        placeholder_auto: 'Автоматически заполняется',
        translate: 'Перевод',
        isTranslate: 'Требуется перевод',
        day: 'День',
        one_click_order: 'Однократное закрытие заказа',
        greater_than: 'Больше чем',
        less_than: 'Меньше чем',
        between: 'Между',
        document_label: 'Метка документа',
        receipts_first_modification_time: 'Время первой модификации документа',
        Selection_of_Document_Owner: 'Выбор ответственного за документ',
        responsiblePerson: 'Ответственный',
        functional_Domain: 'Функциональная область',
        Category: 'Категория',
        property: 'Свойство',
        reRepair: 'Повторные ремонты',
        pullInNum: 'Количество записей',
        perception: 'Класс восприятия',
        onSupport: 'Поддержка на месте',
        batteryNo: 'Номер батареи',
        normalStartDate: 'Дата гарантии',
        qmotorNo: 'Номер переднего мотора',
        hmotorNo: 'Номер заднего мотора',
        fault_cause_type: 'Тип причины неисправности',
        measure_name: 'Название меры',
        part_name: 'Название детали',
        close_order_notification: 'Закрытие заказа требует ответа от предложителя',
        TIS_Case_Data: 'Данные TIS по делу',
        case_File: 'Файл дела',
        responsibility_Data: 'Данные по ответственности',
        longterm_Measures: 'Долгосрочные меры',
        tisCaseNo: 'Номер дела TIS',
        vehGlobalFwVer: 'Версия программного обеспечения автомобиля',
        vehGlobalFwPn: 'Номер детали программного обеспечения автомобиля',
        archivesNo: 'Номер файла',
        archivesTitle: 'Название файла',
        archivesSource: 'Источник файла',
        proposer: 'Предложитель',
        proposedTime: 'Дата предложения',
        archivesManagementPersonnel: 'Управляющий персонал',
        functionalMode: 'Функциональный модуль',
        supplier: 'Поставщик',
        accessoriesInvolved: 'Включает аксессуары',
        functionalDomain: 'Функциональная область',
        invalidPartId: 'Неверный идентификатор детали',
        archivesType: 'Тип файла',
        archivesGrade: 'Оценка файла',
        problemDescription: 'Описание проблемы',
        analysisProgress: 'Прогресс анализа',
        qaRemark: 'Примечание QA',
        tacRemark: 'Примечание TAC',
        responsibleDepartment: 'Ответственный отдел',
        coordinator: 'Координатор',
        principal: 'Ответственный',
        containmentAction: 'Меры по предотвращению',
        issueStatus: 'Статус проблемы',
        softwareProblems: 'Программные проблемы',
        vehGlobalFwVer_j: 'Базовая версия',
        vehGlobalFwPn_j: 'Базовая часть',
        ewo: 'Номер EWO',
        rootCause: 'Коренная причина',
        marketBehavior: 'Рыночное поведение',
        shortTermMeasures: 'Краткосрочные меры',
        shortTermBreakpointDescription: 'Описание краткосрочного прерывания',
        measuresResult: 'Результат утверждения мер',
        measuresConfirmation: 'Подтверждение мер',
        longTermMeasures: 'Долгосрочные меры',
        longTermMeasuresBreak: 'Описание долгосрочного прерывания',
        implementation: 'Реализация',
        longMeasuresTime: 'Фактическая дата прерывания долгосрочных мер',
        vinBreak: 'VIN прерывания',
        breakpointImplementationPhase: 'Фаза реализации прерывания',
        archive_Information: 'Архивная информация',
        reason_incomplete_closure: 'Причина незавершённого закрытия',
        entry_Date: 'Дата въезда',
        departure_date: 'Дата выезда',
        work_order_number: 'Номер наряда-заказа',
        questionnaire_usage: 'Использование опросника',
        classification_of_technical_enquiries: 'Классификация технических запросов',
        change_of_document_owner: 'Изменение владельца документа',
        oldowner: 'Старый владелец',
        newowner: 'Новый владелец',
        original: 'Оригинал',
        translation: 'Перевод',
        dealer_address: 'Адрес дилера',
        sel_up_engineers: 'Выберите не более 12 инженеров!',
        sel_up_weeks: 'Выберите до 12 недель!',
        veh_infor_inquiry: 'Запрос информации о транспортном средстве',
        create_organization: 'Создать организацию',
        ref_code: 'Обновить капчу',
        fault_complaint_Desp: 'Описание неисправности / Описание жалобы клиента',
        broken_down_vehicle: 'Неисправный транспорт',
        reporting_organization: 'Название отчетной организации',
        reporter: 'Заявитель',
        oneclick_convert: 'Преобразование одним щелчком мыши',
        assembly: 'Сборка',
        show_original: 'Показать оригинал',
        sync_datong: 'Синхронизировать Datong',
        system_category_iii: 'Категория системы III',
        maxus_Records: 'Записи переговоров MAXUS',
    },
    // 沙特阿拉伯
    arSA: {
        vin: 'VIN',
        inquiry_no: 'رقم حالة الاستفسار',
        case_theme: 'موضوع الحالة',
        department_name: 'اسم القسم',
        department_type: 'نوع القسم',
        document_status: 'حالة المستند',
        inquiry_date: 'تاريخ الاستفسار',
        organization_name: 'اسم المنظمة',
        name: 'اسم الجهة المقترحة',
        sap_code: 'رمز SAP',
        failed_part: 'القطعة المعطلة',
        case_type: 'نوع الحالة',
        vehicle_status: 'حالة الصيانة',
        case_owner: 'المسؤول',
        country: 'الدولة',
        fault_cause: 'سبب العطل',
        symptoms: 'أعراض العطل',
        is_the_document_qualified: 'هل المستند مؤهل؟',
        is_the_document_replied_in_a_timely_manner: 'هل تم الرد على المستند في الوقت المناسب؟',
        filter: 'المرشح',
        system_classification_I: 'التصنيف النظامي I',
        system_classification_II: 'التصنيف النظامي II',
        full_query: 'استعلام كامل',
        fuzzy_query: 'استعلام غامض',
        whether_belongs_new_car_market: 'هل ينتمي إلى إطلاق سيارة جديدة؟',
        caseStatus: 'حالة الحالة',
        correct: 'نعم',
        deny: 'لا',
        not_closed: 'لم يتم الإغلاق',
        no_reply: 'لم يتم الرد',
        replied: 'تم الرد',
        closed: 'تم الإغلاق',
        drafts: 'صندوق المسودات',
        create_time: 'وقت الإنشاء',
        create_user: 'المنشئ',
        parent_of_document: 'المستند الأعلى',
        document_owner: 'مسؤول المستند',
        case_subject: 'موضوع الحالة',
        receipt_info: 'معلومات المستند',
        superior_of_case: 'الحالة الأعلى',
        inquiry_time: 'وقت الاستفسار',
        status: 'الحالة',
        overseas_company: 'اسم الشركة الخارجية',
        general_agent_name: 'اسم الوكيل العام',
        dealer_code: 'رمز التاجر',
        dealer_name: 'اسم التاجر',
        name_of_subsidiary: 'اسم الفرع',
        contacts: 'جهة الاتصال',
        contact_information: 'معلومات الاتصال',
        training_certification: 'شهادة التدريب',
        driving_mileage: 'عدد الكيلومترات المقطوعة',
        plate_number: 'رقم اللوحة',
        material_no: 'رقم المادة',
        material_desc: 'وصف المادة',
        offline_date: 'تاريخ الخروج من خط الإنتاج',
        model_platform: 'منصة الطراز',
        engine_number: 'رقم المحرك',
        transmission_type: 'نوع ناقل الحركة',
        assembly_no: 'رقم التجميع',
        fault_info_desc: 'وصف معلومات العطل',
        fault_handle_process: 'سير معالجة العطل',
        solution: 'الحل',
        remark: 'ملاحظة',
        caseRemark: 'ملاحظة الحالة',
        document_information: 'معلومات المستند',
        basic_information_of_service_center: 'المعلومات الأساسية لمركز الخدمة',
        basic_vehicle_information: 'المعلومات الأساسية للمركبة',
        problem_description: 'وصف المشكلة',
        common_links: 'روابط شائعة',
        claim_information: 'معلومات المطالبة',
        diagnostic_report_record: 'سجل تقرير التشخيص',
        vehicle_history: 'مستندات استعلام تاريخ المركبة',
        programming_history: 'سجل البرمجة',
        vehicle_sales_logistics_information: 'معلومات بيع المركبة والخدمات اللوجستية',
        new_vehicle_information: 'إضافة معلومات مركبة جديدة',
        attachment_upload: 'تحميل المرفقات',
        diagnostic_report: 'تقرير التشخيص',
        bulk_download: 'تنزيل دفعة',
        document_View: 'عرض المستند',
        inquiry_content: 'محتوى الاستفسار',
        inquiry_entry: 'إدخال الاستفسار',
        subordinate_record: 'سجل الأسئلة والأجوبة من المستوى الأدنى',
        superior_record: 'سجل الأسئلة والأجوبة من المستوى الأعلى',
        send_content: 'محتوى الإرسال',
        send_time: 'وقت الإرسال',
        sent_username: 'المرسل',
        receive_name: 'إرسال إلى',
        dept_name: 'المستوى',
        enclosure: 'المرفق',
        wind_case: 'إغلاق الحالة',
        close_order: 'إغلاق الطلب',
        case_reporting: 'تقديم الحالة',
        pdf_preview: 'معاينة PDF',
        SIS_maintenance: 'صيانة الحوادث الكبرى',
        Please_fill_in_the_inquiry_content: 'يرجى ملء محتوى الاستفسار',
        sending_an_email: 'إرسال بريد إلكتروني',
        copy: 'نسخ',
        repeat: 'تكرار VIN',
        inconsistent: 'عدم اتساق منصة طراز المركبة',
        sendTo: 'إرسال إلى',
        reply: 'أدخل المحتوى للاستفسار/الرد',
        please_check_the_exported_document: 'يرجى تحديد المستند المصدر',
        please_upload_diagnostic_report: 'يرجى تحميل تقرير التشخيص',
        please_enter_the_vin: 'يرجى إدخال رقم VIN',
        placeholderDTC: 'مثال: P080800_P087D00_------',
        placeholderFaultInfoDesc:
            '1. تحقق من المشكلة التي يهتم بها العميل (فقط للتأكد من حدوث المشكلة)',
        placeholderFaultHandleProcess:
            '2. حدد الأعراض ذات الصلة (ابحث وسجّل جميع الأعراض التي قد تكون مرتبطة بالمشكلة)\n3. حلّل الأعراض (راقب الأعراض ذات الصلة بعناية، وابحث عن الأسباب الشائعة)\n4. أكد المشكلة (قلّص نطاق نتائجك للتأكد من أنك تعالج المشكلة الصحيحة)',
        placeholderSolution:
            '5. أصلح المشكلة (قم بالصيانة)\n6. تحقق من تشغيل المركبة (تأكد من أن الإصلاح الذي قمت به قد حل المشكلة)',
        placeholderRemark: 'مثال: علبة التوجيه - 201806، مخمد الصدمة الأمامي الأيسر - 2010101',
        placeholderContact: 'يرجى إدخال اسم المشغّل',
        close_time: 'وقت الإغلاق',
        one_touch: 'إعادة إنشاء المستند',
        confirm_generating_new_case: 'هل أنت متأكد من إنشاء مستند جديد؟',
        closing_statement: 'شرح الإغلاق',
        number_of_cases: 'عدد المستندات',
        number_of_vehicles: 'عدد المركبات',
        pleaseEnterContent: 'يرجى إدخال المحتوى',
        case_age: 'عمر الحالة',
        last_response_time: 'وقت آخر رد',
        time_since_last_response: 'الوقت منذ آخر رد',
        warranty_start_date: 'تاريخ بدء الضمان',
        submit_reason: 'سبب التقديم',
        synchronize_PQCP: 'مزامنة PQCP',
        FPR_export: 'تصدير FPR',
        level_selection: 'اختيار المستوى',
        category_selection: 'اختيار الفئة',
        brand_selection: 'اختيار العلامة التجارية',
        code: 'الرمز',
        description: 'الوصف',
        major_complaints: 'شكاوى جوهرية',
        difficult_miscellaneous_diseases: 'مشاكل معقدة ونادرة',
        emerging_issues: 'مشكلات جديدة',
        breakpoint_failure: 'فشل نقطة التوقف',
        general_complaints: 'شكوى عامة',
        other: 'أخرى',
        roewe: 'رووي',
        mg: 'MG',
        serious: 'خطير',
        secondary: 'ثانوي',
        generally: 'عام',
        complete: 'مكتمل',
        please_select_level: 'يرجى اختيار المستوى',
        please_select_category: 'يرجى اختيار الفئة',
        please_select_brand: 'يرجى اختيار العلامة التجارية',
        placeholder_auto: 'يتم ملؤه تلقائيًا',
        translate: 'ترجمة',
        isTranslate: 'هل يتم الترجمة؟',
        day: 'يوم',
        one_click_order: 'إغلاق الطلب بنقرة واحدة',
        greater_than: 'أكبر من',
        less_than: 'أقل من',
        between: 'بين',
        document_label: 'تسمية المستند',
        receipts_first_modification_time: 'وقت أول تعديل للمستند',
        Selection_of_Document_Owner: 'اختيار مسؤول المستند',
        responsiblePerson: 'الشخص المسؤول:',
        functional_Domain: 'المجال الوظيفي',
        Category: 'الفئة',
        property: 'الخصائص',
        reRepair: 'إصلاح متكرر',
        pullInNum: 'عدد مرات الدخول إلى المحطة',
        perception: 'مرتبط بالإدراك الحسي',
        onSupport: 'هل هناك دعم ميداني؟',
        batteryNo: 'رقم البطارية',
        normalStartDate: 'تاريخ الضمان',
        qmotorNo: 'رقم المحرك الأمامي',
        hmotorNo: 'رقم المحرك الخلفي',
        fault_cause_type: 'نوع سبب العطل',
        measure_name: 'اسم الإجراء',
        part_name: 'اسم القطعة',
        close_order_notification: 'يتطلب إغلاق الطلب الرد على الجهة المقترحة',
        TIS_Case_Data: 'بيانات حالة TIS',
        case_File: 'ملف الحالة',
        responsibility_Data: 'بيانات توزيع المسؤولية',
        longterm_Measures: 'الإجراءات طويلة الأجل',
        tisCaseNo: 'رقم حالة TIS',
        vehGlobalFwVer: 'إصدار برنامج السيارة بالكامل',
        vehGlobalFwPn: 'رقم قطعة برنامج السيارة بالكامل',
        archivesNo: 'رقم الأرشيف',
        archivesTitle: 'عنوان الأرشيف',
        archivesSource: 'مصدر الأرشيف',
        proposer: 'الشخص المقترح',
        proposedTime: 'تاريخ الاقتراح',
        archivesManagementPersonnel: 'الموظف المُشرف على الأرشيف',
        functionalMode: 'وحدة وظيفية',
        supplier: 'المورّد',
        accessoriesInvolved: 'هل يشمل ملحقات؟',
        functionalDomain: 'المجال الوظيفي',
        invalidPartId: 'القطعة المعطوبة',
        archivesType: 'نوع الأرشيف',
        archivesGrade: 'درجة الأرشيف',
        problemDescription: 'وصف المشكلة',
        analysisProgress: 'تقدم التحليل',
        qaRemark: 'ملاحظة ضمان الجودة (QA)',
        tacRemark: 'ملاحظة مركز الدعم الفني (TAC)',
        responsibleDepartment: 'القسم المسؤول',
        coordinator: 'المنسق',
        principal: 'المسؤول الرئيسي',
        containmentAction: 'إجراءات الاحتواء',
        issueStatus: 'حالة المشكلة',
        softwareProblems: 'مشاكل البرمجيات',
        vehGlobalFwVer_j: 'رقم إصدار الخط الأساسي',
        vehGlobalFwPn_j: 'رقم قطعة الخط الأساسي',
        ewo: 'رقم أمر العمل الهندسي (EWO)',
        rootCause: 'السبب الجذري',
        marketBehavior: 'سلوك السوق',
        shortTermMeasures: 'الإجراءات قصيرة الأجل',
        shortTermBreakpointDescription: 'شرح نقطة التوقف للإجراء القصير',
        measuresResult: 'نتيجة اعتماد الإجراءات',
        measuresConfirmation: 'شرح تأكيد الإجراءات',
        longTermMeasures: 'الإجراءات طويلة الأجل',
        longTermMeasuresBreak: 'شرح تقدير نقطة التوقف للإجراء الطويل',
        implementation: 'هل تم التنفيذ؟',
        longMeasuresTime: 'تاريخ نقطة التوقف الفعلية للإجراء الطويل',
        vinBreak: 'VIN لنقطة التوقف للإجراء الطويل',
        breakpointImplementationPhase: 'مرحلة تنفيذ نقطة التوقف',
        archive_Information: 'معلومات الأرشيف',
        reason_incomplete_closure: 'سبب الإغلاق دون إنجاز',
        entry_Date: 'تاريخ الدخول',
        departure_date: 'تاريخ المغادرة',
        work_order_number: 'رقم أمر العمل',
        questionnaire_usage: 'غرض استبيان الاستفسار',
        classification_of_technical_enquiries: 'تصنيف الاستعلامات الفنية',
        change_of_document_owner: 'تغيير مالك المستند',
        oldowner: 'المالك القديم',
        newowner: 'المالك الجديد',
        original: 'النص الأصلي',
        translation: 'الترجمة',
        dealer_address: 'عنوان الوكيل',
        sel_up_engineers: 'يمكنك اختيار ما يصل إلى 12 مهندسًا!',
        sel_up_weeks: 'يمكنك اختيار ما يصل إلى 12 أسبوعًا!',
        veh_infor_inquiry: 'استعلام معلومات المركبة',
        create_organization: 'إنشاء منظمة',
        ref_code: 'الحصول على رمز التحقق المُحدَّث',
        fault_complaint_Desp: 'وصف العطل / وصف شكوى العميل',
        broken_down_vehicle: 'هل المركبة معطلة؟',
        reporting_organization: 'المنظمة المبلغة',
        reporter: 'المُبلِغ',
        oneclick_convert: 'تحويل بنقرة واحدة',
        assembly: 'التجميع',
        show_original: 'عرض النص الأصلي',
        sync_datong: 'مزامنة مع داتونغ',
        system_category_iii: 'تصنيف النظام III',
        maxus_Records: 'سجلات محادثات ماكسيس',
    },
    // 保加利亚
    bgBG: {
        vin: 'VIN',
        inquiry_no: 'Номер на заявката',
        case_theme: 'Тема на случая',
        department_name: 'Име на отдела',
        department_type: 'Тип на отдела',
        document_status: 'Статус на документа',
        inquiry_date: 'Дата на запитване',
        organization_name: 'Име на организацията',
        name: 'Име на подателя',
        sap_code: 'SAP код',
        failed_part: 'Неизправна част',
        case_type: 'Тип на случая',
        vehicle_status: 'Статус на ремонта',
        case_owner: 'Отговорник',
        country: 'Държава',
        fault_cause: 'Причина за неизправността',
        symptoms: 'Симптоми на неизправността',
        is_the_document_qualified: 'Дали документът е квалифициран?',
        is_the_document_replied_in_a_timely_manner: 'Дали документът е отговорен навреме?',
        filter: 'Филтър',
        system_classification_I: 'Системна класификация I',
        system_classification_II: 'Системна класификация II',
        full_query: 'Пълен заявкa',
        fuzzy_query: 'Неточен заявкa',
        whether_belongs_new_car_market: 'Отнася ли се за нов модел?',
        caseStatus: 'Статус на случая',
        correct: 'Да',
        deny: 'Не',
        not_closed: 'Не е приключен',
        no_reply: 'Без отговор',
        replied: 'Отговорено',
        closed: 'Приключен',
        drafts: 'Чернови',
        create_time: 'Време на създаване',
        create_user: 'Създател',
        parent_of_document: 'Родителски документ',
        document_owner: 'Собственик на документа',
        case_subject: 'Тема на случая',
        receipt_info: 'Информация за получението',
        superior_of_case: 'Надреден случай',
        inquiry_time: 'Време на запитване',
        status: 'Статус',
        overseas_company: 'Име на чуждестранна компания',
        general_agent_name: 'Име на генерален агент',
        dealer_code: 'Код на дилър',
        dealer_name: 'Име на дилър',
        name_of_subsidiary: 'Име на дъщерно дружество',
        contacts: 'Контакти',
        contact_information: 'Контактна информация',
        training_certification: 'Сертификат за обучение',
        driving_mileage: 'Пробег',
        plate_number: 'Регистрационен номер',
        material_no: 'Номер на материал',
        material_desc: 'Описание на материал',
        offline_date: 'Дата на излизане от линията',
        model_platform: 'Платформа на модела',
        engine_number: 'Номер на двигател',
        transmission_type: 'Тип на скоростната кутия',
        assembly_no: 'Номер на сборка',
        fault_info_desc: 'Описание на информацията за неизправността',
        fault_handle_process: 'Процес на обработка на неизправност',
        solution: 'Решение',
        remark: 'Бележка',
        caseRemark: 'Бележка по случая',
        document_information: 'Информация за документа',
        basic_information_of_service_center: 'Основна информация за сервизния център',
        basic_vehicle_information: 'Основна информация за превозното средство',
        problem_description: 'Описание на проблема',
        common_links: 'Чести връзки',
        claim_information: 'Информация за искане',
        diagnostic_report_record: 'Запис на диагностичен отчет',
        vehicle_history: 'Документи за историята на превозното средство',
        programming_history: 'История на програмирането',
        vehicle_sales_logistics_information:
            'Информация за продажба и логистика на превозното средство',
        new_vehicle_information: 'Нова информация за превозно средство',
        attachment_upload: 'Качване на прикачени файлове',
        diagnostic_report: 'Диагностичен отчет',
        bulk_download: 'Масово изтегляне',
        document_View: 'Преглед на документ',
        inquiry_content: 'Съдържание на заявката',
        inquiry_entry: 'Въвеждане на запитване',
        subordinate_record: 'Запис на въпроси и отговори от подчинените',
        superior_record: 'Запис на въпроси и отговори от ръководството',
        send_content: 'Изпратено съдържание',
        send_time: 'Време на изпращане',
        sent_username: 'Изпратил',
        receive_name: 'Изпратено до',
        dept_name: 'Ниво',
        enclosure: 'Прикачен файл',
        wind_case: 'Приключване на случая',
        close_order: 'Затваряне на заявката',
        case_reporting: 'Докладване на случая',
        pdf_preview: 'Преглед на PDF',
        SIS_maintenance: 'Поддръжка при сериозни инциденти',
        Please_fill_in_the_inquiry_content: 'Моля, попълнете съдържанието на заявката',
        sending_an_email: 'Изпращане на имейл',
        copy: 'Копиране',
        repeat: 'Повторение на VIN',
        inconsistent: 'Несъответствие в платформата на модела',
        sendTo: 'Изпратено до',
        reply: 'Въведете съдържание за запитване/отговор',
        please_check_the_exported_document: 'Моля, маркирайте експортирания документ',
        please_upload_diagnostic_report: 'Моля, качете диагностичния доклад',
        please_enter_the_vin: 'Моля, въведете VIN',
        placeholderDTC: 'Пример: P080800_P087D00_------',
        placeholderFaultInfoDesc:
            '1. Потвърдете проблема, посочен от клиента (само за да се гарантира, че проблемът съществува)',
        placeholderFaultHandleProcess:
            '2. Определете свързаните симптоми (намерете и запишете всички симптоми, които може да са свързани с проблема)\n3. Анализирайте симптомите (внимателно наблюдавайте свързаните симптоми, за да намерите честите причини)\n4. Потвърдете проблема (стеснете обхвата на заключенията си, за да сте сигурни, че решавате правилния проблем)',
        placeholderSolution:
            '5. Поправете проблема (извършете ремонт)\n6. Проверете работата на превозното средство (удостоверете се, че ремонта е решил проблема)',
        placeholderRemark: 'Напр.: Управление - 201806, Преден ляв амортизатор - 2010101',
        placeholderContact: 'Моля, въведете име на оператора',
        close_time: 'Време на приключване',
        one_touch: 'Пресъздаване на документ',
        confirm_generating_new_case: 'Сигурни ли сте, че искате да създадете нов документ?',
        closing_statement: 'Обяснение при приключване',
        number_of_cases: 'Брой документи',
        number_of_vehicles: 'Брой превозни средства',
        pleaseEnterContent: 'Моля, въведете съдържание',
        case_age: 'Възраст на случая',
        last_response_time: 'Време на последния отговор',
        time_since_last_response: 'Време от последния отговор',
        warranty_start_date: 'Начална дата на гаранцията',
        submit_reason: 'Причина за подаване',
        synchronize_PQCP: 'Синхронизиране на PQCP',
        FPR_export: 'Експорт на FPR',
        level_selection: 'Избор на ниво',
        category_selection: 'Избор на категория',
        brand_selection: 'Избор на марка',
        code: 'Код',
        description: 'Описание',
        major_complaints: 'Сериозни оплаквания',
        difficult_miscellaneous_diseases: 'Сложни и редки неизправности',
        emerging_issues: 'Нововъзникнали проблеми',
        breakpoint_failure: 'Неуспех на точка на прекъсване',
        general_complaints: 'Обща оплакване',
        other: 'Друго',
        roewe: 'Roewe',
        mg: 'MG',
        serious: 'Сериозно',
        secondary: 'Второстепенно',
        generally: 'Общо',
        complete: 'Завършено',
        please_select_level: 'Моля, изберете ниво',
        please_select_category: 'Моля, изберете категория',
        please_select_brand: 'Моля, изберете марка',
        placeholder_auto: 'Автоматично попълване',
        translate: 'Превод',
        isTranslate: 'Да се превежда ли?',
        day: 'ден',
        one_click_order: 'Затваряне на заявката с един клик',
        greater_than: 'Повече от',
        less_than: 'По-малко от',
        between: 'Между',
        document_label: 'Етикет на документа',
        receipts_first_modification_time: 'Време на първо модифициране на документа',
        Selection_of_Document_Owner: 'Избор на отговорник за документа',
        responsiblePerson: 'Отговорно лице:',
        functional_Domain: 'Функционален домейн',
        Category: 'Категория',
        property: 'Свойство',
        reRepair: 'Повторен ремонт',
        pullInNum: 'Брой посещения в сервиза',
        perception: 'Перцептивно',
        onSupport: 'Изисква ли се поддръжка на място?',
        batteryNo: 'Номер на батерията',
        normalStartDate: 'Дата на гаранцията',
        qmotorNo: 'Номер на предния мотор',
        hmotorNo: 'Номер на задния мотор',
        fault_cause_type: 'Тип причина за неизправност',
        measure_name: 'Име на мерките',
        part_name: 'Име на детайла',
        close_order_notification:
            'Затварянето на заявката изисква отговор до подателя на предложението',
        TIS_Case_Data: 'Данни за случая в TIS',
        case_File: 'Архив на случая',
        responsibility_Data: 'Данни за разпределение на отговорността',
        longterm_Measures: 'Дългосрочни мерки',
        tisCaseNo: 'Номер на случая в TIS',
        vehGlobalFwVer: 'Версия на софтуера на цялото превозно средство',
        vehGlobalFwPn: 'Номер на софтуерната част за цялото превозно средство',
        archivesNo: 'Номер на архива',
        archivesTitle: 'Заглавие на архива',
        archivesSource: 'Източник на архива',
        proposer: 'Подател',
        proposedTime: 'Дата на подаване',
        archivesManagementPersonnel: 'Персонал по управление на архивите',
        functionalMode: 'Функционален модул',
        supplier: 'Доставчик',
        accessoriesInvolved: 'Свързано ли е с аксесоари?',
        functionalDomain: 'Функционален домейн',
        invalidPartId: 'Неизправна част',
        archivesType: 'Тип архив',
        archivesGrade: 'Клас на архива',
        problemDescription: 'Описание на проблема',
        analysisProgress: 'Напредък на анализа',
        qaRemark: 'Бележка от QA',
        tacRemark: 'Бележка от TAC',
        responsibleDepartment: 'Отговорен отдел',
        coordinator: 'Координатор',
        principal: 'Основен отговорник',
        containmentAction: 'Мерки за ограничаване',
        issueStatus: 'Статус на проблема',
        softwareProblems: 'Проблеми със софтуера',
        vehGlobalFwVer_j: 'Базова версия',
        vehGlobalFwPn_j: 'Базов номер на част',
        ewo: 'Номер на EWO',
        rootCause: 'Основна причина',
        marketBehavior: 'Поведение на пазара',
        shortTermMeasures: 'Краткосрочни мерки',
        shortTermBreakpointDescription: 'Описание на точката на прекъсване за краткосрочните мерки',
        measuresResult: 'Резултат от одобрението на мерките',
        measuresConfirmation: 'Потвърждение на мерките',
        longTermMeasures: 'Дългосрочни мерки',
        longTermMeasuresBreak: 'Очаквано описание на точката на прекъсване за дългосрочните мерки',
        implementation: 'Приложено ли е?',
        longMeasuresTime: 'Фактическа дата на точката на прекъсване за дългосрочните мерки',
        vinBreak: 'VIN на точката на прекъсване за дългосрочните мерки',
        breakpointImplementationPhase: 'Етап на прилагане на точката на прекъсване',
        archive_Information: 'Информация за архива',
        reason_incomplete_closure: 'Причина за затваряне без завършване',
        entry_Date: 'Дата на влизане',
        departure_date: 'Дата на напускане',
        work_order_number: 'Номер на работната заповед',
        questionnaire_usage: 'Цел на въпросника',
        classification_of_technical_enquiries: 'Класификация на техническите запитвания',
        change_of_document_owner: 'Промяна на собственика на документа',
        oldowner: 'Стар собственик',
        newowner: 'Нов собственик',
        original: 'Оригинал',
        translation: 'Превод',
        dealer_address: 'Адрес на дилъра',
        sel_up_engineers: 'Можете да изберете до 12 инженери!',
        sel_up_weeks: 'Можете да изберете до 12 седмици!',
        veh_infor_inquiry: 'Запитване за информация за превозното средство',
        create_organization: 'Създаване на организация',
        ref_code: 'Получаване на нов код за потвърждение',
        fault_complaint_Desp: 'Описание на неизправността / Описание на оплакването на клиента',
        broken_down_vehicle: 'Автомобил ли е спрял поради повреда?',
        reporting_organization: 'Докладваща организация',
        reporter: 'Докладчик',
        oneclick_convert: 'Преобразуване с един клик',
        assembly: 'Сборна единица',
        show_original: 'Показване на оригиналния текст',
        sync_datong: 'Синхронизация с Datong',
        system_category_iii: 'Системна категория III',
        maxus_Records: 'Записи от разговори на MAXUS',
    },
    // 丹麦语
    daDK: {
        vin: 'VIN',
        inquiry_no: 'Sagsnummer',
        case_theme: 'Sagstema',
        department_name: 'Afdelingsnavn',
        department_type: 'Afdelingstype',
        document_status: 'Dokumentstatus',
        inquiry_date: 'Forespørgselsdato',
        organization_name: 'Organisationsnavn',
        name: 'Navn på foreslående part',
        sap_code: 'SAP-kode',
        failed_part: 'Defekt komponent',
        case_type: 'Sagstype',
        vehicle_status: 'Reparationsstatus',
        case_owner: 'Ansvarlig',
        country: 'Land',
        fault_cause: 'Fejlårsag',
        symptoms: 'Fejlsymptomer',
        is_the_document_qualified: 'Er dokumentet kvalificeret?',
        is_the_document_replied_in_a_timely_manner: 'Er dokumentet besvaret rettidigt?',
        filter: 'Filter',
        system_classification_I: 'Systemklassifikation I',
        system_classification_II: 'Systemklassifikation II',
        full_query: 'Fuld forespørgsel',
        fuzzy_query: 'Upræcis forespørgsel',
        whether_belongs_new_car_market: 'Hører til lancering af ny bil?',
        caseStatus: 'Sagsstatus',
        correct: 'Ja',
        deny: 'Nej',
        not_closed: 'Ikke afsluttet',
        no_reply: 'Ingen svar',
        replied: 'Besvaret',
        closed: 'Lukket',
        drafts: 'Kladder',
        create_time: 'Oprettelsestidspunkt',
        create_user: 'Opretter',
        parent_of_document: 'Overordnet dokument',
        document_owner: 'Dokumentansvarlig',
        case_subject: 'Sagsemne',
        receipt_info: 'Modtagelsesoplysninger',
        superior_of_case: 'Overordnet sag',
        inquiry_time: 'Forespørgselstidspunkt',
        status: 'Status',
        overseas_company: 'Udlandsk virksomhedsnavn',
        general_agent_name: 'Generel agentnavn',
        dealer_code: 'Forhandlerkode',
        dealer_name: 'Forhandlernavn',
        name_of_subsidiary: 'Datterselskabsnavn',
        contacts: 'Kontaktpersoner',
        contact_information: 'Kontaktinformation',
        training_certification: 'Uddannelsescertifikat',
        driving_mileage: 'Kilometerstand',
        plate_number: 'Nummerplade',
        material_no: 'Materiale-nummer',
        material_desc: 'Materialebeskrivelse',
        offline_date: 'Offline dato',
        model_platform: 'Modelplatform',
        engine_number: 'Motornummer',
        transmission_type: 'Gearkassetype',
        assembly_no: 'Samlenummer',
        fault_info_desc: 'Fejlinformationsbeskrivelse',
        fault_handle_process: 'Fejlhåndteringsforløb',
        solution: 'Løsning',
        remark: 'Bemærkning',
        caseRemark: 'Sagsbemærkning',
        document_information: 'Dokumentinformation',
        basic_information_of_service_center: 'Grundlæggende oplysninger om servicecenter',
        basic_vehicle_information: 'Grundlæggende køretøjsoplysninger',
        problem_description: 'Problembeskrivelse',
        common_links: 'Almindelige links',
        claim_information: 'Garantikravoplysninger',
        diagnostic_report_record: 'Diagnoserapportoptegnelse',
        vehicle_history: 'Køretøjshistorik forespørgselsdokumenter',
        programming_history: 'Programmeringshistorik',
        vehicle_sales_logistics_information: 'Salgs- og logistikoplysninger for køretøj',
        new_vehicle_information: 'Ny køretøjsinformation',
        attachment_upload: 'Upload af vedhæftede filer',
        diagnostic_report: 'Diagnoserapport',
        bulk_download: 'Masse-download',
        document_View: 'Dokumentvisning',
        inquiry_content: 'Forespørgselsindhold',
        inquiry_entry: 'Indtastning af forespørgsel',
        subordinate_record: 'Underordnet spørgsmål-og-svar-log',
        superior_record: 'Overordnet spørgsmål-og-svar-log',
        send_content: 'Sendt indhold',
        send_time: 'Afsendelsestidspunkt',
        sent_username: 'Afsender',
        receive_name: 'Sendt til',
        dept_name: 'Niveau',
        enclosure: 'Vedhæftet fil',
        wind_case: 'Afslut sag',
        close_order: 'Luk ordre',
        case_reporting: 'Sagsrapportering',
        pdf_preview: 'PDF-forhåndsvisning',
        SIS_maintenance: 'Vedligeholdelse ved alvorlige ulykker',
        Please_fill_in_the_inquiry_content: 'Udfyld venligst forespørgselsindholdet',
        sending_an_email: 'Sender e-mail',
        copy: 'Kopiér',
        repeat: 'VIN-dublet',
        inconsistent: 'Modellens platform er inkonsistent',
        sendTo: 'Send til',
        reply: 'Indtast indhold for forespørgsel/svar',
        please_check_the_exported_document: 'Marker venligst det eksporterede dokument',
        please_upload_diagnostic_report: 'Upload venligst diagnosticeringsrapporten',
        please_enter_the_vin: 'Indtast venligst VIN-nummeret',
        placeholderDTC: 'Eksempel: P080800_P087D00_------',
        placeholderFaultInfoDesc:
            '1. Bekræft kundens rapporterede problem (kun for at sikre, at problemet opstod)',
        placeholderFaultHandleProcess:
            '2. Identificer relaterede symptomer (find og notér alle symptomer, der muligvis er forbundet med problemet)\n3. Analyser symptomerne (iagttag nøje de relaterede symptomer for at finde almindelige årsager)\n4. Bekræft problemet (indsnævr dine resultater for at sikre, at du løser det rigtige problem)',
        placeholderSolution:
            '5. Ret problemet (foretag reparation)\n6. Verificer køretøjets funktion (kontrollér, at din reparation har løst problemet)',
        placeholderRemark: 'F.eks.: Styrekasse - 201806, FL-støddæmper - 2010101',
        placeholderContact: 'Indtast operatørnavn',
        close_time: 'Afslutningstidspunkt',
        one_touch: 'Genopret dokument',
        confirm_generating_new_case: 'Er du sikker på, at du vil oprette et nyt dokument?',
        closing_statement: 'Afsluttende bemærkning',
        number_of_cases: 'Antal dokumenter',
        number_of_vehicles: 'Antal køretøjer',
        pleaseEnterContent: 'Indtast venligst indhold',
        case_age: 'Sagsalder',
        last_response_time: 'Tidspunkt for seneste svar',
        time_since_last_response: 'Tid siden sidste svar',
        warranty_start_date: 'Garantistartdato',
        submit_reason: 'Årsag til indsendelse',
        synchronize_PQCP: 'Synkronisér PQCP',
        FPR_export: 'FPR-eksport',
        level_selection: 'Niveauvalg',
        category_selection: 'Kategorivalg',
        brand_selection: 'Mærkevalg',
        code: 'Kode',
        description: 'Beskrivelse',
        major_complaints: 'Alvorlige klager',
        difficult_miscellaneous_diseases: 'Komplekse og sjældne fejl',
        emerging_issues: 'Nye problemer',
        breakpoint_failure: 'Breakpoint-fejl',
        general_complaints: 'Generel klage',
        other: 'Andet',
        roewe: 'Roewe',
        mg: 'MG',
        serious: 'Alvorlig',
        secondary: 'Sekundær',
        generally: 'Generelt',
        complete: 'Færdig',
        please_select_level: 'Vælg venligst niveau',
        please_select_category: 'Vælg venligst kategori',
        please_select_brand: 'Vælg venligst mærke',
        placeholder_auto: 'Udfyldes automatisk',
        translate: 'Oversæt',
        isTranslate: 'Skal der oversættes?',
        day: 'dag',
        one_click_order: 'Luk sag med ét klik',
        greater_than: 'Større end',
        less_than: 'Mindre end',
        between: 'Mellem',
        document_label: 'Dokumentmærkat',
        receipts_first_modification_time: 'Dokumentets første ændringstidspunkt',
        Selection_of_Document_Owner: 'Valg af dokumentansvarlig',
        responsiblePerson: 'Ansvarlig person:',
        functional_Domain: 'Funktionelt domæne',
        Category: 'Kategori',
        property: 'Egenskab',
        reRepair: 'Gentagen reparation',
        pullInNum: 'Antal værkstedsbesøg',
        perception: 'Perception-relateret',
        onSupport: 'Kræver stedfortrædende support?',
        batteryNo: 'Batterinummer',
        normalStartDate: 'Garantiperiode startdato',
        qmotorNo: 'Forhjulsmotornummer',
        hmotorNo: 'Baghjulsmotornummer',
        fault_cause_type: 'Fejlårsagstype',
        measure_name: 'Foranstaltningens navn',
        part_name: 'Reservedelsnavn',
        close_order_notification: 'Lukning af sag kræver svar til indsenderen',
        TIS_Case_Data: 'TIS-sagsdata',
        case_File: 'Sagsmappe',
        responsibility_Data: 'Ansvarsdata',
        longterm_Measures: 'Langsigtede foranstaltninger',
        tisCaseNo: 'TIS-sagsnummer',
        vehGlobalFwVer: 'Softwareversion for hele køretøjet',
        vehGlobalFwPn: 'Softwaredelnummer for hele køretøjet',
        archivesNo: 'Arkivnummer',
        archivesTitle: 'Arkivtitel',
        archivesSource: 'Arkivkilde',
        proposer: 'Indsender',
        proposedTime: 'Indsendelsesdato',
        archivesManagementPersonnel: 'Arkivansvarlig personale',
        functionalMode: 'Funktionelt modul',
        supplier: 'Leverandør',
        accessoriesInvolved: 'Involverer tilbehør?',
        functionalDomain: 'Funktionelt domæne',
        invalidPartId: 'Defekt komponent',
        archivesType: 'Arkivtype',
        archivesGrade: 'Arkivgrad',
        problemDescription: 'Problembeskrivelse',
        analysisProgress: 'Analysefremskridt',
        qaRemark: 'QA-bemærkning',
        tacRemark: 'TAC-bemærkning',
        responsibleDepartment: 'Ansvarlig afdeling',
        coordinator: 'Koordinator',
        principal: 'Hovedansvarlig',
        containmentAction: 'Indholdshandlinger',
        issueStatus: 'Problestatus',
        softwareProblems: 'Softwareproblemer',
        vehGlobalFwVer_j: 'Baseline version',
        vehGlobalFwPn_j: 'Baseline delnummer',
        ewo: 'EWO-nummer',
        rootCause: 'Rodårsag',
        marketBehavior: 'Markedsadfærd',
        shortTermMeasures: 'Kortsigtede foranstaltninger',
        shortTermBreakpointDescription: 'Beskrivelse af kortsigtede breakpoint-foranstaltninger',
        measuresResult: 'Resultat af godkendelse af foranstaltninger',
        measuresConfirmation: 'Bekræftelse af foranstaltninger',
        longTermMeasures: 'Langsigtede foranstaltninger',
        longTermMeasuresBreak: 'Forventet breakpoint-beskrivelse for langsigtede foranstaltninger',
        implementation: 'Er det implementeret?',
        longMeasuresTime: 'Faktisk breakpoint-dato for langsigtede foranstaltninger',
        vinBreak: 'VIN for langsigtede breakpoint',
        breakpointImplementationPhase: 'Fase for implementering af breakpoint',
        archive_Information: 'Arkivoplysninger',
        reason_incomplete_closure: 'Årsag til lukning uden færdiggørelse',
        entry_Date: 'Indgangsdato',
        departure_date: 'Afgangsdato',
        work_order_number: 'Arbejdsordrenummer',
        questionnaire_usage: 'Formål med spørgeskema',
        classification_of_technical_enquiries: 'Klassifikation af tekniske forespørgsler',
        change_of_document_owner: 'Ændring af dokumentejer',
        oldowner: 'Tidligere ejer',
        newowner: 'Ny ejer',
        original: 'Original',
        translation: 'Oversættelse',
        dealer_address: 'Forhandleradresse',
        sel_up_engineers: 'Vælg op til 12 ingeniører!',
        sel_up_weeks: 'Vælg op til 12 uger!',
        veh_infor_inquiry: 'Forespørgsel om køretøjsinformation',
        create_organization: 'Opret organisation',
        ref_code: 'Hent ny bekræftelseskode',
        fault_complaint_Desp: 'Beskrivelse af fejl/kundeklage',
        broken_down_vehicle: 'Er køretøjet gået i stykker?',
        reporting_organization: 'Rapporterende organisation',
        reporter: 'Rapportør',
        oneclick_convert: 'Konverter med ét klik',
        assembly: 'Samling',
        show_original: 'Vis original',
        sync_datong: 'Synkroniser med Datong',
        system_category_iii: 'Systemkategori III',
        maxus_Records: 'MAXUS samtaleoptegnelser',
    },
    // 芬兰语
    fiFI: {
        vin: 'VIN',
        inquiry_no: 'Tapausnumero',
        case_theme: 'Tapauksen aihe',
        department_name: 'Osaston nimi',
        department_type: 'Osaston tyyppi',
        document_status: 'Asiakirjan tila',
        inquiry_date: 'Kyselypäivämäärä',
        organization_name: 'Organisaation nimi',
        name: 'Ehdottajan nimi',
        sap_code: 'SAP-koodi',
        failed_part: 'Viallinen osa',
        case_type: 'Tapauksen tyyppi',
        vehicle_status: 'Korjaustila',
        case_owner: 'Vastuuhenkilö',
        country: 'Maa',
        fault_cause: 'Vian syy',
        symptoms: 'Vian oireet',
        is_the_document_qualified: 'Onko asiakirja pätevä?',
        is_the_document_replied_in_a_timely_manner: 'Onko asiakirjaan vastattu ajoissa?',
        filter: 'Suodatin',
        system_classification_I: 'Järjestelmäluokitus I',
        system_classification_II: 'Järjestelmäluokitus II',
        full_query: 'Täysi haku',
        fuzzy_query: 'Epämääräinen haku',
        whether_belongs_new_car_market: 'Liittyykö uuden auton markkinoille tuontiin?',
        caseStatus: 'Tapauksen tila',
        correct: 'Kyllä',
        deny: 'Ei',
        not_closed: 'Ei suljettu',
        no_reply: 'Ei vastausta',
        replied: 'Vastattu',
        closed: 'Suljettu',
        drafts: 'Luonnokset',
        create_time: 'Luontiaika',
        create_user: 'Luoja',
        parent_of_document: 'Yläasiakirja',
        document_owner: 'Asiakirjan omistaja',
        case_subject: 'Tapauksen aihe',
        receipt_info: 'Vastaanottotiedot',
        superior_of_case: 'Ylempi tapaus',
        inquiry_time: 'Kyselyn aika',
        status: 'Tila',
        overseas_company: 'Ulkomainen yritys',
        general_agent_name: 'Pääedustajan nimi',
        dealer_code: 'Jälleenmyyjän koodi',
        dealer_name: 'Jälleenmyyjän nimi',
        name_of_subsidiary: 'Tytäryhtiön nimi',
        contacts: 'Yhteyshenkilöt',
        contact_information: 'Yhteystiedot',
        training_certification: 'Koulutustodistus',
        driving_mileage: 'Ajokilometrit',
        plate_number: 'Rekisterinumero',
        material_no: 'Materiaalinumero',
        material_desc: 'Materiaalin kuvaus',
        offline_date: 'Poistopäivämäärä',
        model_platform: 'Mallialusta',
        engine_number: 'Moottorin numero',
        transmission_type: 'Vaihteiston tyyppi',
        assembly_no: 'Kokoonpanon numero',
        fault_info_desc: 'Vikatietojen kuvaus',
        fault_handle_process: 'Vian käsittelyprosessi',
        solution: 'Ratkaisu',
        remark: 'Huomautus',
        caseRemark: 'Tapauskommentti',
        document_information: 'Asiakirjan tiedot',
        basic_information_of_service_center: 'Huoltokeskuksen perustiedot',
        basic_vehicle_information: 'Ajoneuvon perustiedot',
        problem_description: 'Ongelman kuvaus',
        common_links: 'Yleiset linkit',
        claim_information: 'Takuivaatimustiedot',
        diagnostic_report_record: 'Diagnostiikkakertomuksen tallenne',
        vehicle_history: 'Ajoneuvon historian kyselyasiakirjat',
        programming_history: 'Ohjelmointihistoria',
        vehicle_sales_logistics_information: 'Ajoneuvon myynti- ja logistiikkatiedot',
        new_vehicle_information: 'Uudet ajoneuvotiedot',
        attachment_upload: 'Liitteiden lataus',
        diagnostic_report: 'Diagnostiikkakertomus',
        bulk_download: 'Eräpohjainen lataus',
        document_View: 'Asiakirjan tarkastelu',
        inquiry_content: 'Kyselyn sisältö',
        inquiry_entry: 'Kyselyn vastaus',
        subordinate_record: 'Alaisten kysymys-vastausloki',
        superior_record: 'Ylemmän tason kysymys-vastausloki',
        send_content: 'Lähetetty sisältö',
        send_time: 'Lähetyshetki',
        sent_username: 'Lähettäjä',
        receive_name: 'Lähetetty kohteeseen',
        dept_name: 'Taso',
        enclosure: 'Liite',
        wind_case: 'Sulje tapaus',
        close_order: 'Sulje tilaus',
        case_reporting: 'Tapauksen raportointi',
        pdf_preview: 'PDF-esikatselu',
        SIS_maintenance: 'Vakavien onnettomuuksien ylläpito',
        Please_fill_in_the_inquiry_content: 'Täytä kyselyn sisältö',
        sending_an_email: 'Sähköpostin lähetys',
        copy: 'Kopioi',
        repeat: 'VIN toistuu',
        inconsistent: 'Ajoneuvomallin alusta ei täsmää',
        sendTo: 'Lähetä kohteeseen',
        reply: 'Syötä sisältö kyselyä/vastausta varten',
        please_check_the_exported_document: 'Valitse viety asiakirja',
        please_upload_diagnostic_report: 'Lataa vianmääritysraportti',
        please_enter_the_vin: 'Anna VIN-tunnus',
        placeholderDTC: 'Esimerkki: P080800_P087D00_------',
        placeholderFaultInfoDesc:
            '1. Vahvista asiakkaan huomioimaa ongelmaa (vain varmistaaksesi, että ongelma ilmeni)',
        placeholderFaultHandleProcess:
            '2. Määritä liittyvät oireet (etsi ja kirjaa kaikki mahdollisesti ongelmaan liittyvät oireet)\n3. Analysoi oireita (tarkkaile huolellisesti liittyviä oireita ja tunnista yleiset syyt)\n4. Vahvista ongelma (rajoita tuloksiasi varmistaaksesi, että ratkaiset oikean ongelman)',
        placeholderSolution:
            '5. Korjaa ongelma (suorita korjaus)\n6. Varmista ajoneuvon toiminta (tarkista, että tekemäsi korjaus ratkaisi ongelman)',
        placeholderRemark:
            'Esimerkiksi: Ohjauslaitteisto - 201806, Etuvasen tärinänvaimennin - 2010101',
        placeholderContact: 'Anna käyttäjän nimi',
        close_time: 'Sulkemisaika',
        one_touch: 'Uudelleenluo asiakirja',
        confirm_generating_new_case: 'Haluatko varmasti luoda uuden asiakirjan?',
        closing_statement: 'Sulkemiselite',
        number_of_cases: 'Asiakirjojen määrä',
        number_of_vehicles: 'Ajoneuvojen määrä',
        pleaseEnterContent: 'Anna sisältö',
        case_age: 'Tapauksen ikä',
        last_response_time: 'Viimeisin vastausaika',
        time_since_last_response: 'Aika viimeisestä vastauksesta',
        warranty_start_date: 'Takuun alkamispäivämäärä',
        submit_reason: 'Lähetyksen syy',
        synchronize_PQCP: 'Synkronoi PQCP',
        FPR_export: 'FPR-vienti',
        level_selection: 'Tason valinta',
        category_selection: 'Luokan valinta',
        brand_selection: 'Merkkivalinta',
        code: 'Koodi',
        description: 'Kuvaus',
        major_complaints: 'Merkitsevät valitukset',
        difficult_miscellaneous_diseases: 'Monimutkaiset ja harvinaiset vikatilanteet',
        emerging_issues: 'Uudet ongelmat',
        breakpoint_failure: 'Katkaisupisteen epäonnistuminen',
        general_complaints: 'Yleinen valitus',
        other: 'Muu',
        roewe: 'Roewe',
        mg: 'MG',
        serious: 'Vakava',
        secondary: 'Toissijainen',
        generally: 'Yleisesti',
        complete: 'Valmis',
        please_select_level: 'Valitse taso',
        please_select_category: 'Valitse luokka',
        please_select_brand: 'Valitse merkki',
        placeholder_auto: 'Täytetään automaattisesti',
        translate: 'Käännä',
        isTranslate: 'Käännetäänkö?',
        day: 'päivä',
        one_click_order: 'Sulje työ käden käänteessä',
        greater_than: 'Suurempi kuin',
        less_than: 'Pienempi kuin',
        between: 'Välillä',
        document_label: 'Asiakirjan tunniste',
        receipts_first_modification_time: 'Asiakirjan ensimmäinen muokkausaika',
        Selection_of_Document_Owner: 'Asiakirjan vastuullisen henkilön valinta',
        responsiblePerson: 'Vastuuhenkilö:',
        functional_Domain: 'Toiminnallinen alue',
        Category: 'Luokka',
        property: 'Ominaisuus',
        reRepair: 'Toistuva korjaus',
        pullInNum: 'Työpajakäynnit',
        perception: 'Havaittavissa oleva',
        onSupport: 'Vaatiiko paikan päällä tukea?',
        batteryNo: 'Akun numero',
        normalStartDate: 'Takuun alkupäivämäärä',
        qmotorNo: 'Etummoottorin numero',
        hmotorNo: 'Takamoottorin numero',
        fault_cause_type: 'Vikasyyntyyppi',
        measure_name: 'Toimenpiteen nimi',
        part_name: 'Osan nimi',
        close_order_notification: 'Työn sulkeminen vaatii vastauksen ehdotuksen tekijälle',
        TIS_Case_Data: 'TIS-tapaustiedot',
        case_File: 'Tapausarkisto',
        responsibility_Data: 'Vastuutieto',
        longterm_Measures: 'Pitkän aikavälin toimenpiteet',
        tisCaseNo: 'TIS-tapausnumero',
        vehGlobalFwVer: 'Ajoneuvon ohjelmistoversio',
        vehGlobalFwPn: 'Ajoneuvon ohjelmistokomponentin numero',
        archivesNo: 'Arkistonumero',
        archivesTitle: 'Arkiston otsikko',
        archivesSource: 'Arkiston lähde',
        proposer: 'Ehdottaja',
        proposedTime: 'Ehdotuksen päivämäärä',
        archivesManagementPersonnel: 'Arkiston ylläpitäjä',
        functionalMode: 'Toiminnallinen moduuli',
        supplier: 'Toimittaja',
        accessoriesInvolved: 'Liittyykö varusteisiin?',
        functionalDomain: 'Toiminnallinen alue',
        invalidPartId: 'Virheellinen osa',
        archivesType: 'Arkistotyyppi',
        archivesGrade: 'Arkiston taso',
        problemDescription: 'Ongelman kuvaus',
        analysisProgress: 'Analyysin eteneminen',
        qaRemark: 'Laadunvarmistuksen huomautus',
        tacRemark: 'TAC-huomautus',
        responsibleDepartment: 'Vastuuosasto',
        coordinator: 'Koordinaattori',
        principal: 'Päävastuullinen henkilö',
        containmentAction: 'Rajoittavat toimenpiteet',
        issueStatus: 'Ongelman tila',
        softwareProblems: 'Ohjelmistovirheet',
        vehGlobalFwVer_j: 'Perusviiteversio',
        vehGlobalFwPn_j: 'Perusviiteosanumero',
        ewo: 'EWO-numero',
        rootCause: 'Juurisyy',
        marketBehavior: 'Markkinakäyttäytyminen',
        shortTermMeasures: 'Lyhyen aikavälin toimenpiteet',
        shortTermBreakpointDescription: 'Lyhyen aikavälin toimenpiteiden katkaiskuvaus',
        measuresResult: 'Toimenpiteiden hyväksyntätulos',
        measuresConfirmation: 'Toimenpiteiden vahvistus',
        longTermMeasures: 'Pitkän aikavälin toimenpiteet',
        longTermMeasuresBreak: 'Arvioitu katkaiskuvaus pitkille toimenpiteille',
        implementation: 'Onko toteutettu?',
        longMeasuresTime: 'Todellinen katkaispäivämäärä pitkille toimenpiteille',
        vinBreak: 'Pitkien toimenpiteiden katkais-VIN',
        breakpointImplementationPhase: 'Katkaisvaiheen toteutusvaihe',
        archive_Information: 'Arkistotiedot',
        reason_incomplete_closure: 'Suljetun tapauksen peruste (ei valmis)',
        entry_Date: 'Työpajaan saapumispäivä',
        departure_date: 'Työpajasta lähtöpäivä',
        work_order_number: 'Työtilausnumero',
        questionnaire_usage: 'Kyselylomakkeen käyttötarkoitus',
        classification_of_technical_enquiries: 'Teknisten kyselyiden luokittelu',
        change_of_document_owner: 'Asiakirjan omistajan vaihto',
        oldowner: 'Vanha omistaja',
        newowner: 'Uusi omistaja',
        original: 'Alkuperäinen',
        translation: 'Käännös',
        dealer_address: 'Jälleenmyyjän osoite',
        sel_up_engineers: 'Voit valita enintään 12 insinööriä!',
        sel_up_weeks: 'Voit valita enintään 12 viikkoa!',
        veh_infor_inquiry: 'Ajoneuvotietojen haku',
        create_organization: 'Luo organisaatio',
        ref_code: 'Hanki uusi vahvistuskoodi',
        fault_complaint_Desp: 'Vian kuvaus / Asiakkaan valituskuvaus',
        broken_down_vehicle: 'Onko ajoneuvo hajonnut?',
        reporting_organization: 'Ilmoittava organisaatio',
        reporter: 'Ilmoittaja',
        oneclick_convert: 'Muunna yhdellä napsautuksella',
        assembly: 'Kokoonpano',
        show_original: 'Näytä alkuperäinen teksti',
        sync_datong: 'Synkronoi Datongin kanssa',
        system_category_iii: 'Järjestelmäluokka III',
        maxus_Records: 'MAXUS keskustelutallenteet',
    },
    // 繁体中文台湾
    zhTW: {
        vin: 'VIN',
        inquiry_no: '案例單號',
        case_theme: '案例主題',
        department_name: '部門名稱',
        department_type: '部門類型',
        document_status: '單據狀態',
        inquiry_date: '詢問日期',
        organization_name: '組織名稱',
        name: '提案方名稱',
        sap_code: 'SAP編碼',
        failed_part: '失效零件',
        case_type: '案例類型',
        vehicle_status: '維修狀態',
        case_owner: '責任人',
        country: '國家',
        fault_cause: '故障原因',
        symptoms: '故障現象',
        is_the_document_qualified: '單據是否合格',
        is_the_document_replied_in_a_timely_manner: '單據是否及時答覆',
        filter: '篩選器',
        system_classification_I: '系統分類I',
        system_classification_II: '系統分類II',
        full_query: '全量查詢',
        fuzzy_query: '模糊查詢',
        whether_belongs_new_car_market: '是否新車上市',
        caseStatus: '案例狀態',
        correct: '是',
        deny: '否',
        not_closed: '未結案',
        no_reply: '未答覆',
        replied: '已答覆',
        closed: '已結案',
        drafts: '草稿箱',
        create_time: '建立時間',
        create_user: '建立人',
        parent_of_document: '單據所屬上級',
        document_owner: '單據負責人',
        case_subject: '案例主題',
        receipt_info: '單據資訊',
        superior_of_case: '案例所屬上級',
        inquiry_time: '詢問時間',
        status: '狀態',
        overseas_company: '海外公司名稱',
        general_agent_name: '總代名稱',
        dealer_code: '經銷商編碼',
        dealer_name: '經銷商名稱',
        name_of_subsidiary: '子公司名稱',
        contacts: '聯絡人',
        contact_information: '聯絡方式',
        training_certification: '培訓認證',
        driving_mileage: '行駛里程',
        plate_number: '車牌號',
        material_no: '物料號',
        material_desc: '物料描述',
        offline_date: '下線日期',
        model_platform: '車型平台',
        engine_number: '發動機號',
        transmission_type: '變速箱型號',
        assembly_no: '總裝號',
        fault_info_desc: '故障資訊描述',
        fault_handle_process: '故障處理經過',
        solution: '解決方案',
        remark: '備註',
        caseRemark: '案例備註',
        document_information: '單據資訊',
        basic_information_of_service_center: '服務中心基本資訊',
        basic_vehicle_information: '車輛基本資訊',
        problem_description: '問題描述',
        common_links: '常用連結',
        claim_information: '索賠資訊',
        diagnostic_report_record: '診斷報告記錄',
        vehicle_history: '車輛歷史問詢單據',
        programming_history: '編程歷史',
        vehicle_sales_logistics_information: '車輛銷售及物流資訊',
        new_vehicle_information: '新增車輛資訊',
        attachment_upload: '附件上傳',
        diagnostic_report: '診斷報告',
        bulk_download: '批次下載',
        document_View: '文件檢視',
        inquiry_content: '詢問內容',
        inquiry_entry: '詢問回覆',
        subordinate_record: '下級問答記錄',
        superior_record: '上級問答記錄',
        send_content: '發送內容',
        send_time: '發送時間',
        sent_username: '發送人',
        receive_name: '發送至',
        dept_name: '級別',
        enclosure: '附件',
        wind_case: '結案',
        close_order: '關單',
        case_reporting: '案例上報',
        pdf_preview: 'PDF預覽',
        SIS_maintenance: '重大事故維護',
        Please_fill_in_the_inquiry_content: '請填寫詢問內容',
        sending_an_email: '發送郵件',
        copy: '複製',
        repeat: 'VIN 重複',
        inconsistent: '車型平台不一致',
        sendTo: '發送至',
        reply: '輸入內容進行詢問/回覆',
        please_check_the_exported_document: '請勾選匯出的單據',
        please_upload_diagnostic_report: '請上傳診斷報告',
        please_enter_the_vin: '請輸入VIN',
        placeholderDTC: '範例：P080800_P087D00_------',
        placeholderFaultInfoDesc: '1. 核實客戶關注的問題（僅為確保問題確實發生）',
        placeholderFaultHandleProcess:
            '2. 確定相關症狀（查找並記錄所有可能與問題相關的症狀）\n3. 分析症狀（仔細觀察相關症狀，找出常見原因）\n4. 確認問題（縮小結果範圍，以確保解決的是正確問題）',
        placeholderSolution:
            '5. 修復問題（進行維修）\n6. 驗證車輛運行情況（檢查以確保所做修復已解決問題）',
        placeholderRemark: '例如：轉向機-201806，FL減震器-2010101',
        placeholderContact: '請輸入操作者姓名',
        close_time: '結案時間',
        one_touch: '單據重建',
        confirm_generating_new_case: '確定產生新的單據？',
        closing_statement: '結案說明',
        number_of_cases: '單據數量',
        number_of_vehicles: '車輛數量',
        pleaseEnterContent: '請輸入內容',
        case_age: '案齡',
        last_response_time: '上次回應時間',
        time_since_last_response: '自上次回應以來的時間',
        warranty_start_date: '保固開始日期',
        submit_reason: '提交原因',
        synchronize_PQCP: '同步PQCP',
        FPR_export: 'FPR匯出',
        level_selection: '級別選擇',
        category_selection: '分類選擇',
        brand_selection: '品牌選擇',
        code: '代碼',
        description: '描述',
        major_complaints: '重大抱怨',
        difficult_miscellaneous_diseases: '疑難雜症',
        emerging_issues: '新發問題',
        breakpoint_failure: '斷點失效',
        general_complaints: '一般抱怨',
        other: '其他',
        roewe: '榮威',
        mg: 'MG',
        serious: '嚴重',
        secondary: '次要',
        generally: '一般',
        complete: '完成',
        please_select_level: '請選擇級別',
        please_select_category: '請選擇分類',
        please_select_brand: '請選擇品牌',
        placeholder_auto: '自動帶出',
        translate: '翻譯',
        isTranslate: '是否翻譯',
        day: '天',
        one_click_order: '一鍵關單',
        greater_than: '大於',
        less_than: '小於',
        between: '之間',
        document_label: '單據標籤',
        receipts_first_modification_time: '單據首次修改時間',
        Selection_of_Document_Owner: '單據責任人選擇',
        responsiblePerson: '責任人：',
        functional_Domain: '功能域',
        Category: '類別',
        property: '屬性',
        reRepair: '重複維修',
        pullInNum: '進站次數',
        perception: '感知類',
        onSupport: '是否現場支援',
        batteryNo: '電池編號',
        normalStartDate: '保固日期',
        qmotorNo: '前馬達編號',
        hmotorNo: '後馬達編號',
        fault_cause_type: '故障原因類型',
        measure_name: '措施名稱',
        part_name: '零件名稱',
        close_order_notification: '關單需要答覆提案方',
        TIS_Case_Data: 'TIS案例資料',
        case_File: '案例檔案',
        responsibility_Data: '分責數據',
        longterm_Measures: '長期措施',
        tisCaseNo: 'TIS案例編號',
        vehGlobalFwVer: '整車軟體版本號',
        vehGlobalFwPn: '整車軟體零件號',
        archivesNo: '檔案編號',
        archivesTitle: '檔案標題',
        archivesSource: '檔案來源',
        proposer: '提出人員',
        proposedTime: '提出日期',
        archivesManagementPersonnel: '管理人員',
        functionalMode: '功能模組',
        supplier: '供應商',
        accessoriesInvolved: '是否涉及配件',
        functionalDomain: '功能域',
        invalidPartId: '失效件',
        archivesType: '檔案類型',
        archivesGrade: '檔案等級',
        problemDescription: '問題描述',
        analysisProgress: '分析進展',
        qaRemark: 'QA備註',
        tacRemark: 'TAC備註',
        responsibleDepartment: '責任部門',
        coordinator: '協調人',
        principal: '責任人',
        containmentAction: '遏制措施',
        issueStatus: '問題狀態',
        softwareProblems: '軟體問題',
        vehGlobalFwVer_j: '基線版本號',
        vehGlobalFwPn_j: '基線零件號',
        ewo: 'EWO號',
        rootCause: '根本原因',
        marketBehavior: '市場行為',
        shortTermMeasures: '短期措施',
        shortTermBreakpointDescription: '短措斷點說明',
        measuresResult: '措施審批結果',
        measuresConfirmation: '措施確認說明',
        longTermMeasures: '長期措施',
        longTermMeasuresBreak: '長措預估斷點說明',
        implementation: '是否實施',
        longMeasuresTime: '長措實際斷點日期',
        vinBreak: '長措斷點VIN',
        breakpointImplementationPhase: '斷點實施階段',
        archive_Information: '檔案資訊',
        reason_incomplete_closure: '未完工關閉原因',
        entry_Date: '進站日期',
        departure_date: '離站日期',
        work_order_number: '工單號',
        questionnaire_usage: '問詢單用途',
        classification_of_technical_enquiries: '技術問詢分類',
        change_of_document_owner: '單據擁有者變更',
        oldowner: '舊擁有者',
        newowner: '新擁有者',
        original: '原稿',
        translation: '譯文',
        dealer_address: '經銷商地址',
        sel_up_engineers: '最多選擇12位工程師！',
        sel_up_weeks: '最多選擇12週！',
        veh_infor_inquiry: '車輛資訊查詢',
        create_organization: '建立組織',
        ref_code: '取得重新整理驗證碼',
        fault_complaint_Desp: '故障資訊描述／客戶抱怨描述',
        broken_down_vehicle: '是否為拋錨車輛',
        reporting_organization: '上報組織',
        reporter: '上報人',
        oneclick_convert: '一鍵轉換',
        assembly: '總成',
        show_original: '顯示原文',
        sync_datong: '同步大通',
        system_category_iii: '系統分類III',
        maxus_Records: 'MAXUS 對話記錄',
    },
    // 克罗地亚
    hrHR: {
        vin: 'VIN',
        inquiry_no: 'Broj slučaja',
        case_theme: 'Tema slučaja',
        department_name: 'Naziv odjela',
        department_type: 'Tip odjela',
        document_status: 'Status dokumenta',
        inquiry_date: 'Datum upita',
        organization_name: 'Naziv organizacije',
        name: 'Naziv predlagatelja',
        sap_code: 'SAP kod',
        failed_part: 'Neispravan dio',
        case_type: 'Vrsta slučaja',
        vehicle_status: 'Status popravka',
        case_owner: 'Odgovorna osoba',
        country: 'Država',
        fault_cause: 'Uzrok kvara',
        symptoms: 'Simptomi kvara',
        is_the_document_qualified: 'Je li dokument kvalificiran?',
        is_the_document_replied_in_a_timely_manner: 'Je li dokument pravovremeno odgovoren?',
        filter: 'Filter',
        system_classification_I: 'Sistemska klasifikacija I',
        system_classification_II: 'Sistemska klasifikacija II',
        full_query: 'Potpuno pretraživanje',
        fuzzy_query: 'Nejasno pretraživanje',
        whether_belongs_new_car_market: 'Pripada li lansiranju novog automobila?',
        caseStatus: 'Status slučaja',
        correct: 'Da',
        deny: 'Ne',
        not_closed: 'Nije zatvoreno',
        no_reply: 'Bez odgovora',
        replied: 'Odgovoreno',
        closed: 'Zatvoreno',
        drafts: 'Skice',
        create_time: 'Vrijeme stvaranja',
        create_user: 'Kreator',
        parent_of_document: 'Nadređeni dokument',
        document_owner: 'Vlasnik dokumenta',
        case_subject: 'Predmet slučaja',
        receipt_info: 'Informacije o primitku',
        superior_of_case: 'Nadređeni slučaj',
        inquiry_time: 'Vrijeme upita',
        status: 'Status',
        overseas_company: 'Naziv inozemne tvrtke',
        general_agent_name: 'Ime glavnog agenta',
        dealer_code: 'Kod dilera',
        dealer_name: 'Ime dilera',
        name_of_subsidiary: 'Ime podružnice',
        contacts: 'Kontakti',
        contact_information: 'Kontakt informacije',
        training_certification: 'Certifikat o obuci',
        driving_mileage: 'Prijeđeni kilometri',
        plate_number: 'Registarska oznaka',
        material_no: 'Broj materijala',
        material_desc: 'Opis materijala',
        offline_date: 'Datum isključenja s proizvodnje',
        model_platform: 'Platforma modela',
        engine_number: 'Broj motora',
        transmission_type: 'Tip mjenjača',
        assembly_no: 'Broj sklopa',
        fault_info_desc: 'Opis informacija o kvaru',
        fault_handle_process: 'Postupak rješavanja kvara',
        solution: 'Rješenje',
        remark: 'Napomena',
        caseRemark: 'Napomena slučaja',
        document_information: 'Informacije o dokumentu',
        basic_information_of_service_center: 'Osnovne informacije o servisnom centru',
        basic_vehicle_information: 'Osnovne informacije o vozilu',
        problem_description: 'Opis problema',
        common_links: 'Uobičajene poveznice',
        claim_information: 'Informacije o zahtjevu',
        diagnostic_report_record: 'Zapis dijagnostičkog izvješća',
        vehicle_history: 'Dokumenti upita povijesti vozila',
        programming_history: 'Povijest programiranja',
        vehicle_sales_logistics_information: 'Informacije o prodaji i logistici vozila',
        new_vehicle_information: 'Nova informacija o vozilu',
        attachment_upload: 'Prijenos priloga',
        diagnostic_report: 'Dijagnostičko izvješće',
        bulk_download: 'Skupno preuzimanje',
        document_View: 'Pregled dokumenta',
        inquiry_content: 'Sadržaj upita',
        inquiry_entry: 'Unos upita',
        subordinate_record: 'Zapis pitanja i odgovora nižih razina',
        superior_record: 'Zapis pitanja i odgovora viših razina',
        send_content: 'Poslani sadržaj',
        send_time: 'Vrijeme slanja',
        sent_username: 'Pošiljatelj',
        receive_name: 'Poslano za',
        dept_name: 'Razina',
        enclosure: 'Prilog',
        wind_case: 'Zatvaranje slučaja',
        close_order: 'Zatvori narudžbu',
        case_reporting: 'Prijavljivanje slučaja',
        pdf_preview: 'PDF pregled',
        SIS_maintenance: 'Održavanje ozbiljnih nesreća',
        Please_fill_in_the_inquiry_content: 'Molimo unesite sadržaj upita',
        sending_an_email: 'Slanje e-pošte',
        copy: 'Kopiraj',
        repeat: 'Ponavljanje VIN-a',
        inconsistent: 'Nedosljednost platforme modela vozila',
        sendTo: 'Pošalji za',
        reply: 'Unesite sadržaj za upit/odgovor',
        please_check_the_exported_document: 'Molimo označite izvezeni dokument',
        please_upload_diagnostic_report: 'Molimo prenesite dijagnostičko izvješće',
        please_enter_the_vin: 'Molimo unesite VIN',
        placeholderDTC: 'Primjer: P080800_P087D00_------',
        placeholderFaultInfoDesc:
            '1. Provjerite problem koji je klijent prijavio (samo kako biste osigurali da se problem pojavio)',
        placeholderFaultHandleProcess:
            '2. Utvrdite povezane simptome (pronađite i zapišite sve simptome koji bi mogli biti povezani s problemom)\n3. Analizirajte simptome (pažljivo promatrajte povezane simptome kako biste pronašli uobičajene uzroke)\n4. Potvrdite problem (sužavanjem rezultata osigurajte da rješavate ispravan problem)',
        placeholderSolution:
            '5. Popravite problem (izvršite popravak)\n6. Provjerite rad vozila (provjerite je li vaš popravak riješio problem)',
        placeholderRemark:
            'Npr.: Upravljački mehanizam - 201806, Prednji lijevi amortizer - 2010101',
        placeholderContact: 'Unesite ime operatera',
        close_time: 'Vrijeme zatvaranja',
        one_touch: 'Ponovno stvaranje dokumenta',
        confirm_generating_new_case: 'Jeste li sigurni da želite stvoriti novi dokument?',
        closing_statement: 'Objašnjenje zatvaranja',
        number_of_cases: 'Broj dokumenata',
        number_of_vehicles: 'Broj vozila',
        pleaseEnterContent: 'Molimo unesite sadržaj',
        case_age: 'Starost slučaja',
        last_response_time: 'Vrijeme posljednjeg odgovora',
        time_since_last_response: 'Vrijeme od posljednjeg odgovora',
        warranty_start_date: 'Datum početka jamstva',
        submit_reason: 'Razlog za slanje',
        synchronize_PQCP: 'Sinkronizacija PQCP-a',
        FPR_export: 'Izvoz FPR-a',
        level_selection: 'Odabir razine',
        category_selection: 'Odabir kategorije',
        brand_selection: 'Odabir marke',
        code: 'Kôd',
        description: 'Opis',
        major_complaints: 'Ozbiljne pritužbe',
        difficult_miscellaneous_diseases: 'Složeni i rijetki kvarovi',
        emerging_issues: 'Novonastali problemi',
        breakpoint_failure: 'Neuspjeh točke prekida',
        general_complaints: 'Opšta pritužba',
        other: 'Ostalo',
        roewe: 'Roewe',
        mg: 'MG',
        serious: 'Ozbiljno',
        secondary: 'Sekundarno',
        generally: 'Općenito',
        complete: 'Završeno',
        please_select_level: 'Odaberite razinu',
        please_select_category: 'Odaberite kategoriju',
        please_select_brand: 'Odaberite marku',
        placeholder_auto: 'Automatski popunjeno',
        translate: 'Prevedi',
        isTranslate: 'Prevesti li?',
        day: 'dan',
        one_click_order: 'Zatvori narudžbu jednim klikom',
        greater_than: 'Veće od',
        less_than: 'Manje od',
        between: 'Između',
        document_label: 'Oznaka dokumenta',
        receipts_first_modification_time: 'Prvo vrijeme izmjene dokumenta',
        Selection_of_Document_Owner: 'Odabir vlasnika dokumenta',
        responsiblePerson: 'Odgovorna osoba:',
        functional_Domain: 'Funkcionalna domena',
        Category: 'Kategorija',
        property: 'Svojstvo',
        reRepair: 'Ponovni popravak',
        pullInNum: 'Broj dolazaka u servis',
        perception: 'Percepcijski',
        onSupport: 'Potrebna li je podrška na licu mjesta?',
        batteryNo: 'Broj baterije',
        normalStartDate: 'Datum jamstva',
        qmotorNo: 'Broj prednjeg motora',
        hmotorNo: 'Broj stražnjeg motora',
        fault_cause_type: 'Vrsta uzroka kvara',
        measure_name: 'Naziv mjere',
        part_name: 'Naziv dijela',
        close_order_notification: 'Zatvaranje naloga zahtijeva odgovor podnositelju prijedloga',
        TIS_Case_Data: 'Podaci o TIS slučaju',
        case_File: 'Arhiva slučaja',
        responsibility_Data: 'Podaci o raspodjeli odgovornosti',
        longterm_Measures: 'Dugoročne mjere',
        tisCaseNo: 'Broj TIS slučaja',
        vehGlobalFwVer: 'Verzija softvera cijelog vozila',
        vehGlobalFwPn: 'Broj dijela softvera cijelog vozila',
        archivesNo: 'Broj arhive',
        archivesTitle: 'Naslov arhive',
        archivesSource: 'Izvor arhive',
        proposer: 'Predlagatelj',
        proposedTime: 'Datum prijedloga',
        archivesManagementPersonnel: 'Osoblje za upravljanje arhivom',
        functionalMode: 'Funkcionalni modul',
        supplier: 'Dobavljač',
        accessoriesInvolved: 'Uključuje li pribor?',
        functionalDomain: 'Funkcionalna domena',
        invalidPartId: 'Neispravan dio',
        archivesType: 'Vrsta arhive',
        archivesGrade: 'Razina arhive',
        problemDescription: 'Opis problema',
        analysisProgress: 'Napredak analize',
        qaRemark: 'QA bilješka',
        tacRemark: 'TAC bilješka',
        responsibleDepartment: 'Odgovorni odjel',
        coordinator: 'Koordinator',
        principal: 'Glavni odgovorni',
        containmentAction: 'Mjere suzbijanja',
        issueStatus: 'Status problema',
        softwareProblems: 'Problemi s softverom',
        vehGlobalFwVer_j: 'Referentna verzija',
        vehGlobalFwPn_j: 'Referentni broj dijela',
        ewo: 'EWO broj',
        rootCause: 'Temeljni uzrok',
        marketBehavior: 'Ponašanje na tržištu',
        shortTermMeasures: 'Kratkoročne mjere',
        shortTermBreakpointDescription: 'Opis prekida kratakoročnih mjera',
        measuresResult: 'Rezultat odobrenja mjera',
        measuresConfirmation: 'Potvrda mjera',
        longTermMeasures: 'Dugoročne mjere',
        longTermMeasuresBreak: 'Procijenjeni opis prekida dugoročnih mjera',
        implementation: 'Je li provedeno?',
        longMeasuresTime: 'Stvarni datum prekida dugoročnih mjera',
        vinBreak: 'VIN prekida dugoročnih mjera',
        breakpointImplementationPhase: 'Faza provedbe prekida',
        archive_Information: 'Informacije o arhivi',
        reason_incomplete_closure: 'Razlog zatvaranja bez dovršetka',
        entry_Date: 'Datum dolaska u servis',
        departure_date: 'Datum napuštanja servisa',
        work_order_number: 'Broj radnog naloga',
        questionnaire_usage: 'Namjena upitnika',
        classification_of_technical_enquiries: 'Klasifikacija tehničkih upita',
        change_of_document_owner: 'Promjena vlasnika dokumenta',
        oldowner: 'Stari vlasnik',
        newowner: 'Novi vlasnik',
        original: 'Izvornik',
        translation: 'Prijevod',
        dealer_address: 'Adresa dilera',
        sel_up_engineers: 'Možete odabrati najviše 12 inženjera!',
        sel_up_weeks: 'Možete odabrati najviše 12 tjedana!',
        veh_infor_inquiry: 'Upit informacija o vozilu',
        create_organization: 'Stvori organizaciju',
        ref_code: 'Dobavi novi verifikacijski kod',
        fault_complaint_Desp: 'Opis kvara / Opis pritužbe kupca',
        broken_down_vehicle: 'Je li vozilo pokvareno?',
        reporting_organization: 'Prijavljivačka organizacija',
        reporter: 'Prijavitelj',
        oneclick_convert: 'Pretvori jednim klikom',
        assembly: 'Sklop',
        show_original: 'Prikaži izvornik',
        sync_datong: 'Sinkroniziraj s Datongom',
        system_category_iii: 'Sustavna kategorija III',
        maxus_Records: 'Zapisi razgovora MAXUS',
    },
    // 拉脱维亚
    lvLV: {
        vin: 'VIN',
        inquiry_no: 'Gadījuma numurs',
        case_theme: 'Gadījuma tēma',
        department_name: 'Departamenta nosaukums',
        department_type: 'Departamenta veids',
        document_status: 'Dokumenta statuss',
        inquiry_date: 'Vaicājuma datums',
        organization_name: 'Organizācijas nosaukums',
        name: 'Ierosinātāja nosaukums',
        sap_code: 'SAP kods',
        failed_part: 'Bojāta detaļa',
        case_type: 'Gadījuma veids',
        vehicle_status: 'Remonta statuss',
        case_owner: 'Atbildīgā persona',
        country: 'Valsts',
        fault_cause: 'Kļūmes iemesls',
        symptoms: 'Kļūmes simptomi',
        is_the_document_qualified: 'Vai dokuments ir kvalificēts?',
        is_the_document_replied_in_a_timely_manner: 'Vai uz dokumentu atbildēts savlaicīgi?',
        filter: 'Filtrs',
        system_classification_I: 'Sistēmas klasifikācija I',
        system_classification_II: 'Sistēmas klasifikācija II',
        full_query: 'Pilna vaicāšana',
        fuzzy_query: 'Neprecīza vaicāšana',
        whether_belongs_new_car_market: 'Vai attiecas uz jauna auto ieviešanu tirgū?',
        caseStatus: 'Gadījuma statuss',
        correct: 'Jā',
        deny: 'Nē',
        not_closed: 'Nav slēgts',
        no_reply: 'Nav atbildes',
        replied: 'Atbildēts',
        closed: 'Slēgts',
        drafts: 'Melnraksti',
        create_time: 'Izveidošanas laiks',
        create_user: 'Izveidotājs',
        parent_of_document: 'Augstāka līmeņa dokuments',
        document_owner: 'Dokumenta īpašnieks',
        case_subject: 'Gadījuma tēma',
        receipt_info: 'Saņemšanas informācija',
        superior_of_case: 'Augstāka līmeņa gadījums',
        inquiry_time: 'Vaicājuma laiks',
        status: 'Statuss',
        overseas_company: 'Ārzemju uzņēmuma nosaukums',
        general_agent_name: 'Galvenā aģenta nosaukums',
        dealer_code: 'Izplatītāja kods',
        dealer_name: 'Izplatītāja nosaukums',
        name_of_subsidiary: 'Meitasuzņēmuma nosaukums',
        contacts: 'Kontakti',
        contact_information: 'Kontaktinformācija',
        training_certification: 'Apmācības sertifikāts',
        driving_mileage: 'Nobraukums',
        plate_number: 'Numura zīme',
        material_no: 'Materiāla numurs',
        material_desc: 'Materiāla apraksts',
        offline_date: 'Noņemšanas no ražošanas datums',
        model_platform: 'Modeļa platforma',
        engine_number: 'Dzinēja numurs',
        transmission_type: 'Ātrumkārbas tips',
        assembly_no: 'Montāžas numurs',
        fault_info_desc: 'Kļūmes informācijas apraksts',
        fault_handle_process: 'Kļūdas apstrādes process',
        solution: 'Risinājums',
        remark: 'Piezīme',
        caseRemark: 'Lietas piezīme',
        document_information: 'Dokumenta informācija',
        basic_information_of_service_center: 'Servisa centra pamatinformācija',
        basic_vehicle_information: 'Transportlīdzekļa pamatinformācija',
        problem_description: 'Problēmas apraksts',
        common_links: 'Bieži lietotas saites',
        claim_information: 'Prasījuma informācija',
        diagnostic_report_record: 'Diagnostikas ziņojuma ieraksts',
        vehicle_history: 'Transportlīdzekļa vēstures vaicājumu dokumenti',
        programming_history: 'Programmēšanas vēsture',
        vehicle_sales_logistics_information:
            'Transportlīdzekļa pārdošanas un loģistikas informācija',
        new_vehicle_information: 'Jauna transportlīdzekļa informācija',
        attachment_upload: 'Pielikumu augšupielāde',
        diagnostic_report: 'Diagnostikas ziņojums',
        bulk_download: 'Masveida lejupielāde',
        document_View: 'Dokumenta skats',
        inquiry_content: 'Vaicājuma saturs',
        inquiry_entry: 'Vaicājuma ievade',
        subordinate_record: 'Apakšā esošo līmeņu jautājumu un atbilžu ieraksts',
        superior_record: 'Augstāku līmeņu jautājumu un atbilžu ieraksts',
        send_content: 'Nosūtītais saturs',
        send_time: 'Nosūtīšanas laiks',
        sent_username: 'Nosūtītājs',
        receive_name: 'Nosūtīts uz',
        dept_name: 'Līmenis',
        enclosure: 'Pielikums',
        wind_case: 'Slēgt lietu',
        close_order: 'Slēgt pasūtījumu',
        case_reporting: 'Lietas ziņošana',
        pdf_preview: 'PDF priekšskatījums',
        SIS_maintenance: 'Smagu negadījumu uzturēšana',
        Please_fill_in_the_inquiry_content: 'Lūdzu, aizpildiet vaicājuma saturu',
        sending_an_email: 'E-pasta sūtīšana',
        copy: 'Kopēt',
        repeat: 'VIN atkārtojas',
        inconsistent: 'Transportlīdzekļa modeļa platforma nav saskaņota',
        sendTo: 'Nosūtīt uz',
        reply: 'Ievadiet saturu, lai veiktu vaicājumu/atbildi',
        please_check_the_exported_document: 'Lūdzu, atzīmējiet eksportēto dokumentu',
        please_upload_diagnostic_report: 'Lūdzu, augšupielādējiet diagnostikas ziņojumu',
        please_enter_the_vin: 'Lūdzu, ievadiet VIN numuru',
        placeholderDTC: 'Piemērs: P080800_P087D00_------',
        placeholderFaultInfoDesc:
            '1. Pārbaudiet klienta norādīto problēmu (tikai, lai pārliecinātos, ka problēma pastāv)',
        placeholderFaultHandleProcess:
            '2. Noteikt saistītos simptomus (atrodiet un ierakstiet visus simptomus, kas varētu būt saistīti ar problēmu)\n3. Analizēt simptomus (uzmanīgi novērojiet saistītos simptomus, lai atrastu biežākos iemeslus)\n4. Apstiprināt problēmu (sašauriniet savus secinājumus, lai pārliecinātos, ka risināt pareizo problēmu)',
        placeholderSolution:
            '5. Novērst problēmu (veiciet remontu)\n6. Pārbaudiet transportlīdzekļa darbību (pārliecinieties, ka veiktais remonts ir novērsis problēmu)',
        placeholderRemark:
            'Piemēram: Vadības mehānisms - 201806, Priekšējais kreisais amortizators - 2010101',
        placeholderContact: 'Lūdzu, ievadiet operatora vārdu',
        close_time: 'Slēgšanas laiks',
        one_touch: 'Dokumenta atkārtota izveide',
        confirm_generating_new_case: 'Vai tiešām vēlaties izveidot jaunu dokumentu?',
        closing_statement: 'Slēgšanas paskaidrojums',
        number_of_cases: 'Dokumentu skaits',
        number_of_vehicles: 'Transportlīdzekļu skaits',
        pleaseEnterContent: 'Lūdzu, ievadiet saturu',
        case_age: 'Lieta vecums',
        last_response_time: 'Pēdējās atbildes laiks',
        time_since_last_response: 'Laiks kopš pēdējās atbildes',
        warranty_start_date: 'Garantijas sākuma datums',
        submit_reason: 'Iesniegšanas iemesls',
        synchronize_PQCP: 'Sinhronizēt PQCP',
        FPR_export: 'FPR eksports',
        level_selection: 'Līmeņa izvēle',
        category_selection: 'Kategorijas izvēle',
        brand_selection: 'Zīmola izvēle',
        code: 'Kods',
        description: 'Apraksts',
        major_complaints: 'Būtiskas sūdzības',
        difficult_miscellaneous_diseases: 'Grūti diagnosticējamas un retas kļūmes',
        emerging_issues: 'Jauni jautājumi',
        breakpoint_failure: 'Pārtraukuma punkta atteice',
        general_complaints: 'Vispārēja sūdzība',
        other: 'Cits',
        roewe: 'Roewe',
        mg: 'MG',
        serious: 'Smags',
        secondary: 'Sekundārs',
        generally: 'Vispārīgi',
        complete: 'Pabeigts',
        please_select_level: 'Lūdzu, atlasiet līmeni',
        please_select_category: 'Lūdzu, atlasiet kategoriju',
        please_select_brand: 'Lūdzu, atlasiet zīmolu',
        placeholder_auto: 'Automātiski aizpildīts',
        translate: 'Tulkot',
        isTranslate: 'Vai tulkot?',
        day: 'diena',
        one_click_order: 'Aizvērt pasūtījumu ar vienu klikšķi',
        greater_than: 'Lielāks par',
        less_than: 'Mazāks par',
        between: 'Starp',
        document_label: 'Dokumenta birka',
        receipts_first_modification_time: 'Dokumenta pirmās izmaiņas laiks',
        Selection_of_Document_Owner: 'Dokumenta atbildīgās personas atlase',
        responsiblePerson: 'Atbildīgā persona:',
        functional_Domain: 'Funkcionālais domēns',
        Category: 'Kategorija',
        property: 'Īpašība',
        reRepair: 'Atkārtots remonts',
        pullInNum: 'Apkalpošanas reižu skaits',
        perception: 'Uztveres kategorija',
        onSupport: 'Vai nepieciešama vietējā atbalsta klātbūtne?',
        batteryNo: 'Akumulatora numurs',
        normalStartDate: 'Garantijas sākuma datums',
        qmotorNo: 'Priekšējā motora numurs',
        hmotorNo: 'Aizmugurējā motora numurs',
        fault_cause_type: 'Kļūmes iemesla veids',
        measure_name: 'Pasākuma nosaukums',
        part_name: 'Detaļas nosaukums',
        close_order_notification: 'Pasūtījuma slēgšanai ir jāatbild piedāvātājai pusei',
        TIS_Case_Data: 'TIS lietas dati',
        case_File: 'Lietas dokuments',
        responsibility_Data: 'Atbildības dati',
        longterm_Measures: 'Ilgtermiņa pasākumi',
        tisCaseNo: 'TIS lietas numurs',
        vehGlobalFwVer: 'Visa transportlīdzekļa programmatūras versija',
        vehGlobalFwPn: 'Visa transportlīdzekļa programmatūras detaļas numurs',
        archivesNo: 'Arhīva numurs',
        archivesTitle: 'Arhīva nosaukums',
        archivesSource: 'Arhīva avots',
        proposer: 'Ierosinātājs',
        proposedTime: 'Ierosināšanas datums',
        archivesManagementPersonnel: 'Arhīva vadītājs',
        functionalMode: 'Funkcionālais modulis',
        supplier: 'Piegādātājs',
        accessoriesInvolved: 'Vai ietekmē aksesuārus?',
        functionalDomain: 'Funkcionālais domēns',
        invalidPartId: 'Neizmantojama detaļa',
        archivesType: 'Arhīva veids',
        archivesGrade: 'Arhīva līmenis',
        problemDescription: 'Problēmas apraksts',
        analysisProgress: 'Analīzes progress',
        qaRemark: 'QA piezīme',
        tacRemark: 'TAC piezīme',
        responsibleDepartment: 'Atbildīgais departaments',
        coordinator: 'Koordinators',
        principal: 'Galvenais atbildīgais',
        containmentAction: 'Ierobežojošie pasākumi',
        issueStatus: 'Problēmas statuss',
        softwareProblems: 'Programmatūras problēmas',
        vehGlobalFwVer_j: 'Bāzes līnijas versija',
        vehGlobalFwPn_j: 'Bāzes līnijas detaļas numurs',
        ewo: 'EWO numurs',
        rootCause: 'Pamatcēlonis',
        marketBehavior: 'Tirgus rīcība',
        shortTermMeasures: 'Īstermiņa pasākumi',
        shortTermBreakpointDescription: 'Īstermiņa pasākumu pārtraukuma apraksts',
        measuresResult: 'Pasākumu apstiprinājuma rezultāts',
        measuresConfirmation: 'Pasākumu apstiprinājuma apraksts',
        longTermMeasures: 'Ilgtermiņa pasākumi',
        longTermMeasuresBreak: 'Ilgtermiņa pasākumu paredzamā pārtraukuma apraksts',
        implementation: 'Vai īstenots?',
        longMeasuresTime: 'Faktiskais ilgtermiņa pasākumu pārtraukuma datums',
        vinBreak: 'Ilgtermiņa pasākumu pārtraukuma VIN',
        breakpointImplementationPhase: 'Pārtraukuma īstenošanas posms',
        archive_Information: 'Arhīva informācija',
        reason_incomplete_closure: 'Iemesls slēgšanai bez pabeigšanas',
        entry_Date: 'Iebraukšanas datums',
        departure_date: 'Izbraukšanas datums',
        work_order_number: 'Darba kārtas numurs',
        questionnaire_usage: 'Ankētas mērķis',
        classification_of_technical_enquiries: 'Tehnisko vaicājumu klasifikācija',
        change_of_document_owner: 'Dokumenta īpašnieka maiņa',
        oldowner: 'Iepriekšējais īpašnieks',
        newowner: 'Jaunais īpašnieks',
        original: 'Oriģināls',
        translation: 'Tulkojums',
        dealer_address: 'Izplatītāja adrese',
        sel_up_engineers: 'Varat izvēlēties līdz 12 inženieriem!',
        sel_up_weeks: 'Varat izvēlēties līdz 12 nedēļām!',
        veh_infor_inquiry: 'Transportlīdzekļa informācijas vaicājums',
        create_organization: 'Izveidot organizāciju',
        ref_code: 'Saņemt jaunu verifikācijas kodu',
        fault_complaint_Desp: 'Kļūmes apraksts / Klienta sūdzības apraksts',
        broken_down_vehicle: 'Vai transportlīdzeklis ir sabojājies?',
        reporting_organization: 'Ziņojošā organizācija',
        reporter: 'Ziņotājs',
        oneclick_convert: 'Pārvērst ar vienu klikšķi',
        assembly: 'Agregāts',
        show_original: 'Rādīt oriģinālu',
        sync_datong: 'Sinhronizēt ar Datong',
        system_category_iii: 'Sistēmas kategorija III',
        maxus_Records: 'MAXUS sarunu ieraksti',
    },
    // 立陶宛
    ltLT: {
        vin: 'VIN',
        inquiry_no: 'Bylos numeris',
        case_theme: 'Bylos tema',
        department_name: 'Skyriaus pavadinimas',
        department_type: 'Skyriaus tipas',
        document_status: 'Dokumento būsena',
        inquiry_date: 'Užklausos data',
        organization_name: 'Organizacijos pavadinimas',
        name: 'Pasiūlymo pateikėjo pavadinimas',
        sap_code: 'SAP kodas',
        failed_part: 'Sugedęs komponentas',
        case_type: 'Bylos tipas',
        vehicle_status: 'Remonto būklė',
        case_owner: 'Atsakingas asmuo',
        country: 'Šalis',
        fault_cause: 'Gedimo priežastis',
        symptoms: 'Gedimo simptomai',
        is_the_document_qualified: 'Ar dokumentas yra tinkamas?',
        is_the_document_replied_in_a_timely_manner: 'Ar į dokumentą atsakyta laiku?',
        filter: 'Filtras',
        system_classification_I: 'Sistemos klasifikacija I',
        system_classification_II: 'Sistemos klasifikacija II',
        full_query: 'Visapusiška užklausa',
        fuzzy_query: 'Netiksliai paieška',
        whether_belongs_new_car_market: 'Ar tai naujo automobilio rinkos paleidimas?',
        caseStatus: 'Bylos būsena',
        correct: 'Taip',
        deny: 'Ne',
        not_closed: 'Neužbaigta',
        no_reply: 'Nėra atsakymo',
        replied: 'Atsakyta',
        closed: 'Uždaryta',
        drafts: 'Juodraščiai',
        create_time: 'Sukūrimo laikas',
        create_user: 'Kūrėjas',
        parent_of_document: 'Aukštesnio lygio dokumentas',
        document_owner: 'Dokumento savininkas',
        case_subject: 'Bylos tema',
        receipt_info: 'Gavimo informacija',
        superior_of_case: 'Aukštesnio lygio byla',
        inquiry_time: 'Užklausos laikas',
        status: 'Būsena',
        overseas_company: 'Užsienio įmonės pavadinimas',
        general_agent_name: 'Bendrojo agento pavadinimas',
        dealer_code: 'Prekybos atstovo kodas',
        dealer_name: 'Prekybos atstovo pavadinimas',
        name_of_subsidiary: 'Dukterinės įmonės pavadinimas',
        contacts: 'Kontaktai',
        contact_information: 'Kontaktinė informacija',
        training_certification: 'Mokymo sertifikatas',
        driving_mileage: 'Nuvažiuotas kelias',
        plate_number: 'Valstybinis numeris',
        material_no: 'Medžiagos numeris',
        material_desc: 'Medžiagos aprašymas',
        offline_date: 'Išėjimo iš gamybos data',
        model_platform: 'Modelio platforma',
        engine_number: 'Variklio numeris',
        transmission_type: 'Pavarų dėžės tipas',
        assembly_no: 'Surinkimo numeris',
        fault_info_desc: 'Gedimo informacijos aprašymas',
        fault_handle_process: 'Gedimo tvarkymo procesas',
        solution: 'Sprendimas',
        remark: 'Pastaba',
        caseRemark: 'Bylos pastaba',
        document_information: 'Dokumento informacija',
        basic_information_of_service_center: 'Aptarnavimo centro pagrindinė informacija',
        basic_vehicle_information: 'Transporto priemonės pagrindinė informacija',
        problem_description: 'Problemos aprašymas',
        common_links: 'Dažnai naudojamos nuorodos',
        claim_information: 'Pretenzijos informacija',
        diagnostic_report_record: 'Diagnostikos ataskaitos įrašas',
        vehicle_history: 'Transporto priemonės istorijos užklausų dokumentai',
        programming_history: 'Programavimo istorija',
        vehicle_sales_logistics_information:
            'Transporto priemonės pardavimo ir logistikos informacija',
        new_vehicle_information: 'Nauja transporto priemonės informacija',
        attachment_upload: 'Priedų įkėlimas',
        diagnostic_report: 'Diagnostikos ataskaita',
        bulk_download: 'Masinis atsisiuntimas',
        document_View: 'Dokumento peržiūra',
        inquiry_content: 'Užklausos turinys',
        inquiry_entry: 'Užklausos įrašas',
        subordinate_record: 'Žemesnio lygio klausimų ir atsakymų įrašai',
        superior_record: 'Aukštesnio lygio klausimų ir atsakymų įrašai',
        send_content: 'Siunčiamas turinys',
        send_time: 'Siuntimo laikas',
        sent_username: 'Siuntėjas',
        receive_name: 'Siųsta į',
        dept_name: 'Lygis',
        enclosure: 'Priedas',
        wind_case: 'Uždaryti bylą',
        close_order: 'Uždaryti užsakymą',
        case_reporting: 'Bylos pranešimas',
        pdf_preview: 'PDF peržiūra',
        SIS_maintenance: 'Didelių avarijų priežiūra',
        Please_fill_in_the_inquiry_content: 'Prašome užpildyti užklausos turinį',
        sending_an_email: 'Siųsti el. laišką',
        copy: 'Kopijuoti',
        repeat: 'VIN kartojasi',
        inconsistent: 'Transporto priemonės modelio platforma nesuderinta',
        sendTo: 'Siųsti į',
        reply: 'Įveskite turinį užklausai/atsakymui',
        please_check_the_exported_document: 'Pažymėkite eksportuotą dokumentą',
        please_upload_diagnostic_report: 'Įkelkite diagnostikos ataskaitą',
        please_enter_the_vin: 'Įveskite VIN kodą',
        placeholderDTC: 'Pavyzdys: P080800_P087D00_------',
        placeholderFaultInfoDesc:
            '1. Patvirtinkite kliento praneštą problemą (tik tam, kad įsitikintumėte, jog problema iš tikrųjų egzistuoja)',
        placeholderFaultHandleProcess:
            '2. Nustatykite susijusius simptomus (suraskite ir užrašykite visus simptomus, kurie gali būti susiję su problema)\n3. Analizuokite simptomus (atsargiai stebėkite susijusius simptomus, kad rastumėte dažniausias priežastis)\n4. Patvirtinkite problemą (susiaurinkite savo išvadas, kad įsitikintumėte, jog sprendžiate teisingą problemą)',
        placeholderSolution:
            '5. Išspręskite problemą (atlikite remontą)\n6. Patikrinkite transporto priemonės veikimą (įsitikinkite, kad atliktas remontas išsprendė problemą)',
        placeholderRemark:
            'Pvz.: Vairo mechanizmas - 201806, Priekinis kairysis amortizatorius - 2010101',
        placeholderContact: 'Įveskite operatoriaus vardą',
        close_time: 'Užbaigimo laikas',
        one_touch: 'Dokumento atkūrimas',
        confirm_generating_new_case: 'Ar tikrai norite sukurti naują dokumentą?',
        closing_statement: 'Užbaigimo paaiškinimas',
        number_of_cases: 'Dokumentų skaičius',
        number_of_vehicles: 'Transporto priemonių skaičius',
        pleaseEnterContent: 'Įveskite turinį',
        case_age: 'Bylos amžius',
        last_response_time: 'Paskutinio atsako laikas',
        time_since_last_response: 'Laikas nuo paskutinio atsako',
        warranty_start_date: 'Garantijos pradžios data',
        submit_reason: 'Pateikimo priežastis',
        synchronize_PQCP: 'Sinchronizuoti PQCP',
        FPR_export: 'FPR eksportas',
        level_selection: 'Lygio pasirinkimas',
        category_selection: 'Kategorijos pasirinkimas',
        brand_selection: 'Prekės ženklo pasirinkimas',
        code: 'Kodas',
        description: 'Aprašymas',
        major_complaints: 'Dideli skundai',
        difficult_miscellaneous_diseases: 'Sudėtingos ir retos gedimų rūšys',
        emerging_issues: 'Naujai atsiradusios problemos',
        breakpoint_failure: 'Pertraukimo taško gedimas',
        general_complaints: 'Bendra skundas',
        other: 'Kita',
        roewe: 'Roewe',
        mg: 'MG',
        serious: 'Rimtas',
        secondary: 'Antrinis',
        generally: 'Bendrai',
        complete: 'Užbaigta',
        please_select_level: 'Pasirinkite lygį',
        please_select_category: 'Pasirinkite kategoriją',
        please_select_brand: 'Pasirinkite prekės ženklą',
        placeholder_auto: 'Automatiškai užpildoma',
        translate: 'Versti',
        isTranslate: 'Ar versti?',
        day: 'diena',
        one_click_order: 'Uždaryti užsakymą vienu paspaudimu',
        greater_than: 'Daugiau nei',
        less_than: 'Mažiau nei',
        between: 'Tarp',
        document_label: 'Dokumento etiketė',
        receipts_first_modification_time: 'Dokumento pirmo pakeitimo laikas',
        Selection_of_Document_Owner: 'Dokumento atsakingo asmens pasirinkimas',
        responsiblePerson: 'Atsakingas asmuo:',
        functional_Domain: 'Funkcinė sritis',
        Category: 'Kategorija',
        property: 'Savybė',
        reRepair: 'Pakartotinis remontas',
        pullInNum: 'Apsilankymų skaičius',
        perception: 'Suvokimo tipas',
        onSupport: 'Ar reikalinga vietoje palaikymo paslauga?',
        batteryNo: 'Akumuliatoriaus numeris',
        normalStartDate: 'Garantijos pradžios data',
        qmotorNo: 'Priekinio variklio numeris',
        hmotorNo: 'Galutinio variklio numeris',
        fault_cause_type: 'Gedimo priežasties tipas',
        measure_name: 'Priemonės pavadinimas',
        part_name: 'Detalės pavadinimas',
        close_order_notification: 'Užsakymo uždarymas reikalauja atsakyti siūlymo autoriui',
        TIS_Case_Data: 'TIS bylos duomenys',
        case_File: 'Bylos archyvas',
        responsibility_Data: 'Atsakomybės duomenys',
        longterm_Measures: 'Ilgalaikės priemonės',
        tisCaseNo: 'TIS bylos numeris',
        vehGlobalFwVer: 'Viso automobilio programinės įrangos versija',
        vehGlobalFwPn: 'Viso automobilio programinės įrangos dalies numeris',
        archivesNo: 'Archyvo numeris',
        archivesTitle: 'Archyvo pavadinimas',
        archivesSource: 'Archyvo šaltinis',
        proposer: 'Pasiūlymo autorius',
        proposedTime: 'Pasiūlymo data',
        archivesManagementPersonnel: 'Archyvo tvarkytojas',
        functionalMode: 'Funkcinis modulis',
        supplier: 'Tiekėjas',
        accessoriesInvolved: 'Ar susiję su priedais?',
        functionalDomain: 'Funkcinė sritis',
        invalidPartId: 'Netinkama detalė',
        archivesType: 'Archyvo tipas',
        archivesGrade: 'Archyvo lygis',
        problemDescription: 'Problemų aprašymas',
        analysisProgress: 'Analizės eiga',
        qaRemark: 'Kokybės užtikrinimo pastabos',
        tacRemark: 'TAC pastabos',
        responsibleDepartment: 'Atsakingas skyrius',
        coordinator: 'Koordinatorius',
        principal: 'Pagrindinis atsakingasis',
        containmentAction: 'Apribojimo priemonės',
        issueStatus: 'Problemų būsena',
        softwareProblems: 'Programinės įrangos problemos',
        vehGlobalFwVer_j: 'Bazinė versija',
        vehGlobalFwPn_j: 'Bazinės detalės numeris',
        ewo: 'EWO numeris',
        rootCause: 'Šakninė priežastis',
        marketBehavior: 'Rinkos elgsena',
        shortTermMeasures: 'Trumpalaikės priemonės',
        shortTermBreakpointDescription: 'Trumpalaikių priemonių pertraukimo aprašymas',
        measuresResult: 'Priemonių patvirtinimo rezultatas',
        measuresConfirmation: 'Priemonių patvirtinimo paaiškinimas',
        longTermMeasures: 'Ilgalaikės priemonės',
        longTermMeasuresBreak: 'Numatomas ilgalaikių priemonių pertraukimo aprašymas',
        implementation: 'Ar įgyvendinta?',
        longMeasuresTime: 'Faktinė ilgalaikių priemonių pertraukimo data',
        vinBreak: 'Ilgalaikių priemonių pertraukimo VIN',
        breakpointImplementationPhase: 'Pertraukimo įgyvendinimo etapas',
        archive_Information: 'Archyvo informacija',
        reason_incomplete_closure: 'Uždarymo be užbaigimo priežastis',
        entry_Date: 'Įvažiavimo data',
        departure_date: 'Išvažiavimo data',
        work_order_number: 'Darbo užsakymo numeris',
        questionnaire_usage: 'Klausimyno paskirtis',
        classification_of_technical_enquiries: 'Techninių užklausų klasifikacija',
        change_of_document_owner: 'Dokumento savininko keitimas',
        oldowner: 'Ankstesnis savininkas',
        newowner: 'Naujas savininkas',
        original: 'Originalas',
        translation: 'Vertimas',
        dealer_address: 'Prekybos atstovo adresas',
        sel_up_engineers: 'Galite pasirinkti iki 12 inžinierių!',
        sel_up_weeks: 'Galite pasirinkti iki 12 savaičių!',
        veh_infor_inquiry: 'Transporto priemonės informacijos užklausa',
        create_organization: 'Sukurti organizaciją',
        ref_code: 'Gauti naują patvirtinimo kodą',
        fault_complaint_Desp: 'Gedimo aprašymas / Kliento skundų aprašymas',
        broken_down_vehicle: 'Ar transporto priemonė sugedo?',
        reporting_organization: 'Pranešanti organizacija',
        reporter: 'Pranešėjas',
        oneclick_convert: 'Konvertuoti vienu paspaudimu',
        assembly: 'Mazinas',
        show_original: 'Rodyti originalą',
        sync_datong: 'Sinchronizuoti su Datong',
        system_category_iii: 'Sistemos kategorija III',
        maxus_Records: 'MAXUS pokalbių įrašai',
    },
    // 罗马尼亚
    roRO: {
        vin: 'VIN',
        inquiry_no: 'Număr caz',
        case_theme: 'Subiect caz',
        department_name: 'Nume departament',
        department_type: 'Tip departament',
        document_status: 'Stare document',
        inquiry_date: 'Data solicitării',
        organization_name: 'Nume organizație',
        name: 'Nume propunător',
        sap_code: 'Cod SAP',
        failed_part: 'Componentă defectă',
        case_type: 'Tip caz',
        vehicle_status: 'Stare reparație',
        case_owner: 'Persoană responsabilă',
        country: 'Țară',
        fault_cause: 'Cauză defecțiune',
        symptoms: 'Simptome defecțiune',
        is_the_document_qualified: 'Documentul este calificat?',
        is_the_document_replied_in_a_timely_manner: 'Documentul a fost răspuns la timp?',
        filter: 'Filtru',
        system_classification_I: 'Clasificare sistem I',
        system_classification_II: 'Clasificare sistem II',
        full_query: 'Interogare completă',
        fuzzy_query: 'Interogare aproximativă',
        whether_belongs_new_car_market: 'Este lansare mașină nouă?',
        caseStatus: 'Stare caz',
        correct: 'Da',
        deny: 'Nu',
        not_closed: 'Neînchis',
        no_reply: 'Fără răspuns',
        replied: 'Răspuns',
        closed: 'Închis',
        drafts: 'Ciornă',
        create_time: 'Data creării',
        create_user: 'Utilizator creator',
        parent_of_document: 'Document părinte',
        document_owner: 'Proprietar document',
        case_subject: 'Subiect caz',
        receipt_info: 'Informații primire',
        superior_of_case: 'Caz superior',
        inquiry_time: 'Timp interogare',
        status: 'Stare',
        overseas_company: 'Nume companie străină',
        general_agent_name: 'Nume agent general',
        dealer_code: 'Cod dealer',
        dealer_name: 'Nume dealer',
        name_of_subsidiary: 'Nume filială',
        contacts: 'Contacte',
        contact_information: 'Informații de contact',
        training_certification: 'Certificare instruire',
        driving_mileage: 'Kilometraj',
        plate_number: 'Număr înmatriculare',
        material_no: 'Număr material',
        material_desc: 'Descriere material',
        offline_date: 'Dată scoatere din producție',
        model_platform: 'Platformă model',
        engine_number: 'Număr motor',
        transmission_type: 'Tip transmisie',
        assembly_no: 'Număr asamblare',
        fault_info_desc: 'Descriere informații defect',
        fault_handle_process: 'Procesul de tratare a defecțiunii',
        solution: 'Soluție',
        remark: 'Observație',
        caseRemark: 'Observație caz',
        document_information: 'Informații document',
        basic_information_of_service_center: 'Informații de bază centrul de service',
        basic_vehicle_information: 'Informații de bază vehicul',
        problem_description: 'Descrierea problemei',
        common_links: 'Linkuri frecvente',
        claim_information: 'Informații solicitare garanție',
        diagnostic_report_record: 'Înregistrare raport diagnostic',
        vehicle_history: 'Documente interogare istoric vehicul',
        programming_history: 'Istoric programare',
        vehicle_sales_logistics_information: 'Informații vânzare și logistică vehicul',
        new_vehicle_information: 'Informații noi vehicul',
        attachment_upload: 'Încărcare atașamente',
        diagnostic_report: 'Raport diagnostic',
        bulk_download: 'Descărcare în masă',
        document_View: 'Vizualizare document',
        inquiry_content: 'Conținut interogare',
        inquiry_entry: 'Introducere interogare',
        subordinate_record: 'Înregistrare întrebări și răspunsuri nivel inferior',
        superior_record: 'Înregistrare întrebări și răspunsuri nivel superior',
        send_content: 'Conținut trimis',
        send_time: 'Timp trimitere',
        sent_username: 'Utilizator expeditor',
        receive_name: 'Trimis către',
        dept_name: 'Nivel',
        enclosure: 'Atașament',
        wind_case: 'Închidere caz',
        close_order: 'Închidere comandă',
        case_reporting: 'Raportare caz',
        pdf_preview: 'Previzualizare PDF',
        SIS_maintenance: 'Mențiune accidente majore',
        Please_fill_in_the_inquiry_content: 'Vă rugăm completați conținutul interogării',
        sending_an_email: 'Trimitere email',
        copy: 'Copiază',
        repeat: 'VIN duplicat',
        inconsistent: 'Platformă model vehicul incompatibilă',
        sendTo: 'Trimite către',
        reply: 'Introduceți conținutul pentru întrebare/răspuns',
        please_check_the_exported_document: 'Vă rugăm să bifați documentul exportat',
        please_upload_diagnostic_report: 'Vă rugăm să încărcați raportul de diagnostic',
        please_enter_the_vin: 'Vă rugăm să introduceți VIN-ul',
        placeholderDTC: 'Exemplu: P080800_P087D00_------',
        placeholderFaultInfoDesc:
            '1. Verificați problema semnalată de client (doar pentru a vă asigura că problema a apărut)',
        placeholderFaultHandleProcess:
            '2. Identificați simptomele asociate (găsiți și înregistrați toate simptomele care ar putea fi legate de problemă)\n3. Analizați simptomele (observați cu atenție simptomele asociate pentru a identifica cauzele comune)\n4. Confirmați problema (restrângeți concluziile pentru a vă asigura că rezolvați problema corectă)',
        placeholderSolution:
            '5. Rezolvați problema (efectuați reparația)\n6. Verificați funcționarea vehiculului (asigurați-vă că reparația a rezolvat problema)',
        placeholderRemark: 'Ex.: Caseta de direcție - 201806, Amortizor față stânga - 2010101',
        placeholderContact: 'Introduceți numele operatorului',
        close_time: 'Data închiderii',
        one_touch: 'Regenerare document',
        confirm_generating_new_case: 'Sigur doriți să generați un nou document?',
        closing_statement: 'Motiv închidere',
        number_of_cases: 'Număr de documente',
        number_of_vehicles: 'Număr de vehicule',
        pleaseEnterContent: 'Vă rugăm să introduceți conținutul',
        case_age: 'Vechime caz',
        last_response_time: 'Ultima oră de răspuns',
        time_since_last_response: 'Timp de la ultimul răspuns',
        warranty_start_date: 'Data începerii garanției',
        submit_reason: 'Motivul trimiterii',
        synchronize_PQCP: 'Sincronizează PQCP',
        FPR_export: 'Export FPR',
        level_selection: 'Selectare nivel',
        category_selection: 'Selectare categorie',
        brand_selection: 'Selectare marcă',
        code: 'Cod',
        description: 'Descriere',
        major_complaints: 'Plângeri majore',
        difficult_miscellaneous_diseases: 'Defecțiuni complexe și rare',
        emerging_issues: 'Probleme noi apărute',
        breakpoint_failure: 'Eșec punct de întrerupere',
        general_complaints: 'Reclamație generală',
        other: 'Altele',
        roewe: 'Roewe',
        mg: 'MG',
        serious: 'Grav',
        secondary: 'Secundar',
        generally: 'General',
        complete: 'Finalizat',
        please_select_level: 'Selectați nivelul',
        please_select_category: 'Selectați categoria',
        please_select_brand: 'Selectați marca',
        placeholder_auto: 'Completat automat',
        translate: 'Traduce',
        isTranslate: 'Se traduce sau nu?',
        day: 'zi',
        one_click_order: 'Închide comanda cu un singur clic',
        greater_than: 'Mai mare decât',
        less_than: 'Mai mic decât',
        between: 'Între',
        document_label: 'Etichetă document',
        receipts_first_modification_time: 'Data primei modificări a documentului',
        Selection_of_Document_Owner: 'Selectarea responsabilului documentului',
        responsiblePerson: 'Persoana responsabilă:',
        functional_Domain: 'Domeniu funcțional',
        Category: 'Categorie',
        property: 'Proprietate',
        reRepair: 'Reparație repetată',
        pullInNum: 'Număr de vizite în service',
        perception: 'Perceptibil',
        onSupport: 'Necesită suport pe loc?',
        batteryNo: 'Număr baterie',
        normalStartDate: 'Data începerii garanției',
        qmotorNo: 'Număr motor față',
        hmotorNo: 'Număr motor spate',
        fault_cause_type: 'Tip cauză defect',
        measure_name: 'Nume măsură',
        part_name: 'Nume piesă',
        close_order_notification: 'Închiderea comenzii necesită răspuns către proponent',
        TIS_Case_Data: 'Date caz TIS',
        case_File: 'Dosar caz',
        responsibility_Data: 'Date privind repartizarea responsabilității',
        longterm_Measures: 'Măsuri pe termen lung',
        tisCaseNo: 'Număr caz TIS',
        vehGlobalFwVer: 'Versiune software vehicul complet',
        vehGlobalFwPn: 'Număr piesă software vehicul complet',
        archivesNo: 'Număr arhivă',
        archivesTitle: 'Titlu arhivă',
        archivesSource: 'Sursă arhivă',
        proposer: 'Propunător',
        proposedTime: 'Data propunerii',
        archivesManagementPersonnel: 'Personal administrare arhivă',
        functionalMode: 'Modul funcțional',
        supplier: 'Furnizor',
        accessoriesInvolved: 'Implică accesorii?',
        functionalDomain: 'Domeniu funcțional',
        invalidPartId: 'Piesă defectă',
        archivesType: 'Tip arhivă',
        archivesGrade: 'Grad arhivă',
        problemDescription: 'Descriere problemă',
        analysisProgress: 'Progres analiză',
        qaRemark: 'Observație QA',
        tacRemark: 'Observație TAC',
        responsibleDepartment: 'Departament responsabil',
        coordinator: 'Coordonator',
        principal: 'Responsabil principal',
        containmentAction: 'Măsuri de conținere',
        issueStatus: 'Stare problemă',
        softwareProblems: 'Probleme software',
        vehGlobalFwVer_j: 'Versiune de referință',
        vehGlobalFwPn_j: 'Număr piesă de referință',
        ewo: 'Număr EWO',
        rootCause: 'Cauză fundamentală',
        marketBehavior: 'Comportament pe piață',
        shortTermMeasures: 'Măsuri pe termen scurt',
        shortTermBreakpointDescription: 'Descriere punct de întrerupere măsuri scurte',
        measuresResult: 'Rezultat aprobare măsuri',
        measuresConfirmation: 'Confirmare măsuri',
        longTermMeasures: 'Măsuri pe termen lung',
        longTermMeasuresBreak: 'Descriere estimată punct de întrerupere măsuri lungi',
        implementation: 'Este implementat?',
        longMeasuresTime: 'Dată reală punct de întrerupere măsuri lungi',
        vinBreak: 'VIN punct de întrerupere măsuri lungi',
        breakpointImplementationPhase: 'Fază implementare punct de întrerupere',
        archive_Information: 'Informații arhivă',
        reason_incomplete_closure: 'Motiv închidere fără finalizare',
        entry_Date: 'Data intrării',
        departure_date: 'Data ieșirii',
        work_order_number: 'Număr comandă de lucru',
        questionnaire_usage: 'Scop chestionar',
        classification_of_technical_enquiries: 'Clasificare întrebări tehnice',
        change_of_document_owner: 'Schimbare deținător document',
        oldowner: 'Vechiul deținător',
        newowner: 'Noul deținător',
        original: 'Original',
        translation: 'Traducere',
        dealer_address: 'Adresa dealerului',
        sel_up_engineers: 'Puteți selecta până la 12 ingineri!',
        sel_up_weeks: 'Puteți selecta până la 12 săptămâni!',
        veh_infor_inquiry: 'Interogare informații vehicul',
        create_organization: 'Creare organizație',
        ref_code: 'Obțineți codul de verificare reîmprospătat',
        fault_complaint_Desp: 'Descrierea defecțiunii / Descrierea plângerii clientului',
        broken_down_vehicle: 'Este vehiculul defect?',
        reporting_organization: 'Organizația raportoare',
        reporter: 'Raportor',
        oneclick_convert: 'Conversie într-un singur clic',
        assembly: 'Subansamblu',
        show_original: 'Afișare text original',
        sync_datong: 'Sincronizare cu Datong',
        system_category_iii: 'Categorie sistem III',
        maxus_Records: 'Înregistrări de conversații MAXUS',
    },
    // 挪威博克马尔
    nbNO: {
        vin: 'VIN',
        inquiry_no: 'Saksnummer',
        case_theme: 'Sakstema',
        department_name: 'Avdelingsnavn',
        department_type: 'Avdelingstype',
        document_status: 'Dokumentstatus',
        inquiry_date: 'Forespørselsdato',
        organization_name: 'Organisasjonsnavn',
        name: 'Navn på foreslår',
        sap_code: 'SAP-kode',
        failed_part: 'Defekt del',
        case_type: 'Sakstype',
        vehicle_status: 'Reparasjonsstatus',
        case_owner: 'Ansvarlig',
        country: 'Land',
        fault_cause: 'Feilårsak',
        symptoms: 'Feilsymptomer',
        is_the_document_qualified: 'Er dokumentet kvalifisert?',
        is_the_document_replied_in_a_timely_manner: 'Er dokumentet besvart i tide?',
        filter: 'Filter',
        system_classification_I: 'Systemklassifisering I',
        system_classification_II: 'Systemklassifisering II',
        full_query: 'Full spørring',
        fuzzy_query: 'Usikker spørring',
        whether_belongs_new_car_market: 'Gjelder lansering av ny bil?',
        caseStatus: 'Saksstatus',
        correct: 'Ja',
        deny: 'Nei',
        not_closed: 'Ikke lukket',
        no_reply: 'Ingen svar',
        replied: 'Besvart',
        closed: 'Lukket',
        drafts: 'Utkast',
        create_time: 'Opprettelsestidspunkt',
        create_user: 'Oppretter',
        parent_of_document: 'Overordnet dokument',
        document_owner: 'Dokumenteier',
        case_subject: 'Saksemne',
        receipt_info: 'Mottaksinformasjon',
        superior_of_case: 'Overordnet sak',
        inquiry_time: 'Forespørslens tidspunkt',
        status: 'Status',
        overseas_company: 'Utenlandsk selskapsnavn',
        general_agent_name: 'Hovedagentens navn',
        dealer_code: 'Forhandlerkode',
        dealer_name: 'Forhandlernavn',
        name_of_subsidiary: 'Datterselskapets navn',
        contacts: 'Kontakter',
        contact_information: 'Kontaktinformasjon',
        training_certification: 'Opplæringssertifikat',
        driving_mileage: 'Kjørelengde',
        plate_number: 'Skilt',
        material_no: 'Materiale-nummer',
        material_desc: 'Materialebeskrivelse',
        offline_date: 'Produksjonsstoppdato',
        model_platform: 'Modellplattform',
        engine_number: 'Motornummer',
        transmission_type: 'Girkassetype',
        assembly_no: 'Monteringsnummer',
        fault_info_desc: 'Feilinformasjonsbeskrivelse',
        fault_handle_process: 'Feilhåndteringsprosess',
        solution: 'Løsning',
        remark: 'Merknad',
        caseRemark: 'Saksmarkering',
        document_information: 'Dokumentinformasjon',
        basic_information_of_service_center: 'Grunnleggende informasjon om servicekontor',
        basic_vehicle_information: 'Grunnleggende kjøretøyinformasjon',
        problem_description: 'Problem beskrivelse',
        common_links: 'Vanlige lenker',
        claim_information: 'Reklamasjonsinformasjon',
        diagnostic_report_record: 'Diagnoserapportlogg',
        vehicle_history: 'Kjøretøyhistorikk forespørselsdokumenter',
        programming_history: 'Programmeringshistorikk',
        vehicle_sales_logistics_information: 'Salgs- og logistikkinformasjon for kjøretøy',
        new_vehicle_information: 'Ny kjøretøyinformasjon',
        attachment_upload: 'Opplasting av vedlegg',
        diagnostic_report: 'Diagnoserapport',
        bulk_download: 'Masse nedlasting',
        document_View: 'Dokumentvisning',
        inquiry_content: 'Forespørselsinnhold',
        inquiry_entry: 'Inntasting av forespørsel',
        subordinate_record: 'Underordnet spørsmål-og-svar-logg',
        superior_record: 'Overordnet spørsmål-og-svar-logg',
        send_content: 'Sendt innhold',
        send_time: 'Sendingstidspunkt',
        sent_username: 'Avsender',
        receive_name: 'Sendt til',
        dept_name: 'Nivå',
        enclosure: 'Vedlegg',
        wind_case: 'Avslutt sak',
        close_order: 'Lukk ordre',
        case_reporting: 'Saksrapportering',
        pdf_preview: 'PDF-forhåndsvisning',
        SIS_maintenance: 'Vedlikehold ved alvorlige ulykker',
        Please_fill_in_the_inquiry_content: 'Fyll ut forespørselsinnholdet',
        sending_an_email: 'Sender e-post',
        copy: 'Kopier',
        repeat: 'VIN-duplikat',
        inconsistent: 'Uoverensstemmelse i kjøretøyplattform',
        sendTo: 'Send til',
        reply: 'Skriv inn innhold for spørring/svar',
        please_check_the_exported_document: 'Vennligst merk av for eksportert dokument',
        please_upload_diagnostic_report: 'Vennligst last opp diagnose-rapporten',
        please_enter_the_vin: 'Vennligst skriv inn VIN',
        placeholderDTC: 'Eksempel: P080800_P087D00_------',
        placeholderFaultInfoDesc:
            '1. Bekreft problemet kunden har meldt (kun for å sikre at problemet oppsto)',
        placeholderFaultHandleProcess:
            '2. Identifiser relaterte symptomer (finn og noter alle symptomer som kan være knyttet til problemet)\n3. Analyser symptomene (observer nøye relaterte symptomer for å finne vanlige årsaker)\n4. Bekreft problemet (begrens resultatene dine for å sikre at du løser riktig problem)',
        placeholderSolution:
            '5. Fiks problemet (utfør reparasjon)\n6. Verifiser kjøretøyets funksjon (sjekk at reparasjonen har løst problemet)',
        placeholderRemark: 'F.eks.: Styremekanisme - 201806, FL-støtdemper - 2010101',
        placeholderContact: 'Skriv inn operatørnavn',
        close_time: 'Avslutningstidspunkt',
        one_touch: 'Gjenopprett dokument',
        confirm_generating_new_case: 'Er du sikker på at du vil opprette et nytt dokument?',
        closing_statement: 'Avslutningskommentar',
        number_of_cases: 'Antall dokumenter',
        number_of_vehicles: 'Antall kjøretøy',
        pleaseEnterContent: 'Vennligst skriv inn innhold',
        case_age: 'Saksalder',
        last_response_time: 'Tidspunkt for siste svar',
        time_since_last_response: 'Tid siden siste svar',
        warranty_start_date: 'Startdato for garanti',
        submit_reason: 'Årsak til innsending',
        synchronize_PQCP: 'Synkroniser PQCP',
        FPR_export: 'FPR-eksport',
        level_selection: 'Nivåvalg',
        category_selection: 'Kategorivalg',
        brand_selection: 'Merkevalg',
        code: 'Kode',
        description: 'Beskrivelse',
        major_complaints: 'Store klager',
        difficult_miscellaneous_diseases: 'Kompliserte og sjeldne feil',
        emerging_issues: 'Nye problemer',
        breakpoint_failure: 'Feil ved stoppunkt',
        general_complaints: 'Generell klage',
        other: 'Annet',
        roewe: 'Roewe',
        mg: 'MG',
        serious: 'Alvorlig',
        secondary: 'Sekundær',
        generally: 'Generelt',
        complete: 'Fullført',
        please_select_level: 'Velg nivå',
        please_select_category: 'Velg kategori',
        please_select_brand: 'Velg merke',
        placeholder_auto: 'Fylles ut automatisk',
        translate: 'Oversett',
        isTranslate: 'Skal det oversettes?',
        day: 'dag',
        one_click_order: 'Lukk sak med ett klikk',
        greater_than: 'Større enn',
        less_than: 'Mindre enn',
        between: 'Mellom',
        document_label: 'Dokumentetikett',
        receipts_first_modification_time: 'Første endringstidspunkt for dokumentet',
        Selection_of_Document_Owner: 'Valg av dokumentansvarlig',
        responsiblePerson: 'Ansvarlig person:',
        functional_Domain: 'Funksjonelt domene',
        Category: 'Kategori',
        property: 'Egenskap',
        reRepair: 'Gjentatt reparasjon',
        pullInNum: 'Antall verkstedbesøk',
        perception: 'Oppfattelsesrelatert',
        onSupport: 'Krever støtte på stedet?',
        batteryNo: 'Batterinummer',
        normalStartDate: 'Garantistartdato',
        qmotorNo: 'Nummer på fremre motor',
        hmotorNo: 'Nummer på bakre motor',
        fault_cause_type: 'Type feilårsak',
        measure_name: 'Tiltaksnavn',
        part_name: 'Delens navn',
        close_order_notification: 'Lukking av sak krever svar til foreslått part',
        TIS_Case_Data: 'TIS-saksdata',
        case_File: 'Saksmappe',
        responsibility_Data: 'Ansvarsdata',
        longterm_Measures: 'Langtidsforanstaltninger',
        tisCaseNo: 'TIS-saksnummer',
        vehGlobalFwVer: 'Programvareversjon for hele kjøretøyet',
        vehGlobalFwPn: 'Programvaredelningsnummer for hele kjøretøyet',
        archivesNo: 'Arkivnummer',
        archivesTitle: 'Arkivtittel',
        archivesSource: 'Arkivkilde',
        proposer: 'Foreslått av',
        proposedTime: 'Foreslått dato',
        archivesManagementPersonnel: 'Arkivansvarlig',
        functionalMode: 'Funksjonell modul',
        supplier: 'Leverandør',
        accessoriesInvolved: 'Involverer tilbehør?',
        functionalDomain: 'Funksjonelt domene',
        invalidPartId: 'Ugyldig del',
        archivesType: 'Arkivtype',
        archivesGrade: 'Arkivgrad',
        problemDescription: 'Problembeskrivelse',
        analysisProgress: 'Analysestatus',
        qaRemark: 'QA-kommentar',
        tacRemark: 'TAC-kommentar',
        responsibleDepartment: 'Ansvarlig avdeling',
        coordinator: 'Koordinator',
        principal: 'Hovedansvarlig',
        containmentAction: 'Innholdsforanstaltninger',
        issueStatus: 'Problemstatus',
        softwareProblems: 'Programvareproblemer',
        vehGlobalFwVer_j: 'Grunnlinjeversjon',
        vehGlobalFwPn_j: 'Grunnlinjedelningsnummer',
        ewo: 'EWO-nummer',
        rootCause: 'Rotårsak',
        marketBehavior: 'Markedsoppførsel',
        shortTermMeasures: 'Korttidsforanstaltninger',
        shortTermBreakpointDescription: 'Beskrivelse av korttidsforanstaltningers knekkpunkt',
        measuresResult: 'Resultat av godkjenning av tiltak',
        measuresConfirmation: 'Bekreftelse av tiltak',
        longTermMeasures: 'Langtidsforanstaltninger',
        longTermMeasuresBreak: 'Forventet beskrivelse av knekkpunkt for langtidsforanstaltninger',
        implementation: 'Er det iverksatt?',
        longMeasuresTime: 'Faktisk knekkpunktdato for langtidsforanstaltninger',
        vinBreak: 'VIN for langtidsforanstaltningers knekkpunkt',
        breakpointImplementationPhase: 'Fase for iverksettelse av knekkpunkt',
        archive_Information: 'Arkivinformasjon',
        reason_incomplete_closure: 'Årsak til lukking uten fullføring',
        entry_Date: 'Innkjøringsdato',
        departure_date: 'Utkjøringsdato',
        work_order_number: 'Arbeidsordrenummer',
        questionnaire_usage: 'Formål med spørreskjema',
        classification_of_technical_enquiries: 'Klassifisering av tekniske henvendelser',
        change_of_document_owner: 'Endre dokumenteier',
        oldowner: 'Tidligere eier',
        newowner: 'Ny eier',
        original: 'Original',
        translation: 'Oversettelse',
        dealer_address: 'Forhandleradresse',
        sel_up_engineers: 'Du kan velge opptil 12 ingeniører!',
        sel_up_weeks: 'Du kan velge opptil 12 uker!',
        veh_infor_inquiry: 'Spørring om kjøretøyinformasjon',
        create_organization: 'Opprett organisasjon',
        ref_code: 'Hent ny bekreftelseskode',
        fault_complaint_Desp: 'Feilbeskrivelse / Kundeplager',
        broken_down_vehicle: 'Er kjøretøyet stående fast?',
        reporting_organization: 'Rapporterende organisasjon',
        reporter: 'Rapportør',
        oneclick_convert: 'Konverter med ett klikk',
        assembly: 'Montert enhet',
        show_original: 'Vis original',
        sync_datong: 'Synkroniser med Datong',
        system_category_iii: 'Systemkategori III',
        maxus_Records: 'MAXUS samtalelogger',
    },
    // 葡萄牙语巴西
    ptBX: {
        vin: 'VIN',
        inquiry_no: 'Número do caso',
        case_theme: 'Tema do caso',
        department_name: 'Nome do departamento',
        department_type: 'Tipo de departamento',
        document_status: 'Status do documento',
        inquiry_date: 'Data da consulta',
        organization_name: 'Nome da organização',
        name: 'Nome do proponente',
        sap_code: 'Código SAP',
        failed_part: 'Peça com falha',
        case_type: 'Tipo de caso',
        vehicle_status: 'Status do reparo',
        case_owner: 'Responsável',
        country: 'País',
        fault_cause: 'Causa da falha',
        symptoms: 'Sintomas da falha',
        is_the_document_qualified: 'O documento é qualificado?',
        is_the_document_replied_in_a_timely_manner: 'O documento foi respondido em tempo hábil?',
        filter: 'Filtro',
        system_classification_I: 'Classificação do sistema I',
        system_classification_II: 'Classificação do sistema II',
        full_query: 'Consulta completa',
        fuzzy_query: 'Consulta difusa',
        whether_belongs_new_car_market: 'É lançamento de novo veículo?',
        caseStatus: 'Status do caso',
        correct: 'Sim',
        deny: 'Não',
        not_closed: 'Não encerrado',
        no_reply: 'Sem resposta',
        replied: 'Respondido',
        closed: 'Encerrado',
        drafts: 'Rascunhos',
        create_time: 'Data de criação',
        create_user: 'Criador',
        parent_of_document: 'Documento superior',
        document_owner: 'Responsável pelo documento',
        case_subject: 'Assunto do caso',
        receipt_info: 'Informações do recibo',
        superior_of_case: 'Caso superior',
        inquiry_time: 'Horário da consulta',
        status: 'Status',
        overseas_company: 'Nome da empresa no exterior',
        general_agent_name: 'Nome do agente geral',
        dealer_code: 'Código do concessionário',
        dealer_name: 'Nome do concessionário',
        name_of_subsidiary: 'Nome da subsidiária',
        contacts: 'Contatos',
        contact_information: 'Informações de contato',
        training_certification: 'Certificação de treinamento',
        driving_mileage: 'Quilometragem',
        plate_number: 'Placa',
        material_no: 'Número do material',
        material_desc: 'Descrição do material',
        offline_date: 'Data de saída da linha',
        model_platform: 'Plataforma do modelo',
        engine_number: 'Número do motor',
        transmission_type: 'Tipo de transmissão',
        assembly_no: 'Número de montagem',
        fault_info_desc: 'Descrição das informações da falha',
        fault_handle_process: 'Processo de tratamento de falha',
        solution: 'Solução',
        remark: 'Observação',
        caseRemark: 'Observação do caso',
        document_information: 'Informações do documento',
        basic_information_of_service_center: 'Informações básicas do centro de serviço',
        basic_vehicle_information: 'Informações básicas do veículo',
        problem_description: 'Descrição do problema',
        common_links: 'Links comuns',
        claim_information: 'Informações de garantia',
        diagnostic_report_record: 'Registro de relatório de diagnóstico',
        vehicle_history: 'Documentos de consulta do histórico do veículo',
        programming_history: 'Histórico de programação',
        vehicle_sales_logistics_information: 'Informações de venda e logística do veículo',
        new_vehicle_information: 'Novas informações do veículo',
        attachment_upload: 'Envio de anexos',
        diagnostic_report: 'Relatório de diagnóstico',
        bulk_download: 'Download em lote',
        document_View: 'Visualização de documento',
        inquiry_content: 'Conteúdo da consulta',
        inquiry_entry: 'Entrada de consulta',
        subordinate_record: 'Registro de perguntas e respostas do nível inferior',
        superior_record: 'Registro de perguntas e respostas do nível superior',
        send_content: 'Conteúdo enviado',
        send_time: 'Horário de envio',
        sent_username: 'Remetente',
        receive_name: 'Enviado para',
        dept_name: 'Nível',
        enclosure: 'Anexo',
        wind_case: 'Encerrar caso',
        close_order: 'Fechar ordem',
        case_reporting: 'Relatório do caso',
        pdf_preview: 'Visualização de PDF',
        SIS_maintenance: 'Manutenção de acidentes graves',
        Please_fill_in_the_inquiry_content: 'Preencha o conteúdo da consulta',
        sending_an_email: 'Enviar e-mail',
        copy: 'Copiar',
        repeat: 'VIN duplicado',
        inconsistent: 'Plataforma do modelo do veículo inconsistente',
        sendTo: 'Enviar para',
        reply: 'Digite o conteúdo para perguntar/responder',
        please_check_the_exported_document: 'Marque o documento exportado',
        please_upload_diagnostic_report: 'Envie o relatório de diagnóstico',
        please_enter_the_vin: 'Insira o VIN',
        placeholderDTC: 'Exemplo: P080800_P087D00_------',
        placeholderFaultInfoDesc:
            '1. Verifique o problema relatado pelo cliente (apenas para garantir que o problema ocorreu)',
        placeholderFaultHandleProcess:
            '2. Identifique os sintomas relacionados (encontre e registre todos os sintomas que possam estar relacionados ao problema)\n3. Analise os sintomas (observe cuidadosamente os sintomas relacionados para identificar causas comuns)\n4. Confirme o problema (reduza suas conclusões para garantir que está resolvendo o problema correto)',
        placeholderSolution:
            '5. Corrija o problema (realize o reparo)\n6. Verifique o funcionamento do veículo (confira se o reparo resolveu o problema)',
        placeholderRemark:
            'Ex.: Caixa de direção - 201806, Amortecedor dianteiro esquerdo - 2010101',
        placeholderContact: 'Digite o nome do operador',
        close_time: 'Data de encerramento',
        one_touch: 'Recriar documento',
        confirm_generating_new_case: 'Tem certeza de que deseja gerar um novo documento?',
        closing_statement: 'Justificativa de encerramento',
        number_of_cases: 'Quantidade de documentos',
        number_of_vehicles: 'Quantidade de veículos',
        pleaseEnterContent: 'Digite o conteúdo',
        case_age: 'Idade do caso',
        last_response_time: 'Último horário de resposta',
        time_since_last_response: 'Tempo desde a última resposta',
        warranty_start_date: 'Data de início da garantia',
        submit_reason: 'Motivo do envio',
        synchronize_PQCP: 'Sincronizar PQCP',
        FPR_export: 'Exportação FPR',
        level_selection: 'Seleção de nível',
        category_selection: 'Seleção de categoria',
        brand_selection: 'Seleção de marca',
        code: 'Código',
        description: 'Descrição',
        major_complaints: 'Reclamações graves',
        difficult_miscellaneous_diseases: 'Problemas complexos e raros',
        emerging_issues: 'Problemas recentes',
        breakpoint_failure: 'Falha no ponto de interrupção',
        general_complaints: 'Reclamação geral',
        other: 'Outro',
        roewe: 'Roewe',
        mg: 'MG',
        serious: 'Grave',
        secondary: 'Secundário',
        generally: 'Geral',
        complete: 'Concluído',
        please_select_level: 'Selecione o nível',
        please_select_category: 'Selecione a categoria',
        please_select_brand: 'Selecione a marca',
        placeholder_auto: 'Preenchido automaticamente',
        translate: 'Traduzir',
        isTranslate: 'Traduzir ou não',
        day: 'dia',
        one_click_order: 'Fechar ordem com um clique',
        greater_than: 'Maior que',
        less_than: 'Menor que',
        between: 'Entre',
        document_label: 'Etiqueta do documento',
        receipts_first_modification_time: 'Primeira modificação do documento',
        Selection_of_Document_Owner: 'Seleção do responsável pelo documento',
        responsiblePerson: 'Responsável:',
        functional_Domain: 'Domínio funcional',
        Category: 'Categoria',
        property: 'Propriedade',
        reRepair: 'Reparo repetido',
        pullInNum: 'Número de visitas à oficina',
        perception: 'Relacionado à percepção',
        onSupport: 'Requer suporte no local?',
        batteryNo: 'Número da bateria',
        normalStartDate: 'Data de início da garantia',
        qmotorNo: 'Número do motor dianteiro',
        hmotorNo: 'Número do motor traseiro',
        fault_cause_type: 'Tipo de causa da falha',
        measure_name: 'Nome da medida',
        part_name: 'Nome da peça',
        close_order_notification: 'O fechamento da ordem requer resposta ao proponente',
        TIS_Case_Data: 'Dados do caso TIS',
        case_File: 'Arquivo do caso',
        responsibility_Data: 'Dados de atribuição de responsabilidade',
        longterm_Measures: 'Medidas de longo prazo',
        tisCaseNo: 'Número do caso TIS',
        vehGlobalFwVer: 'Versão do software do veículo completo',
        vehGlobalFwPn: 'Número da peça de software do veículo completo',
        archivesNo: 'Número do arquivo',
        archivesTitle: 'Título do arquivo',
        archivesSource: 'Fonte do arquivo',
        proposer: 'Proponente',
        proposedTime: 'Data da proposta',
        archivesManagementPersonnel: 'Pessoal gestor do arquivo',
        functionalMode: 'Módulo funcional',
        supplier: 'Fornecedor',
        accessoriesInvolved: 'Envolve acessórios?',
        functionalDomain: 'Domínio funcional',
        invalidPartId: 'Peça defeituosa',
        archivesType: 'Tipo de arquivo',
        archivesGrade: 'Nível do arquivo',
        problemDescription: 'Descrição do problema',
        analysisProgress: 'Progresso da análise',
        qaRemark: 'Observação QA',
        tacRemark: 'Observação TAC',
        responsibleDepartment: 'Departamento responsável',
        coordinator: 'Coordenador',
        principal: 'Responsável principal',
        containmentAction: 'Ações de contenção',
        issueStatus: 'Status do problema',
        softwareProblems: 'Problemas de software',
        vehGlobalFwVer_j: 'Versão de linha de base',
        vehGlobalFwPn_j: 'Número da peça de linha de base',
        ewo: 'Número EWO',
        rootCause: 'Causa raiz',
        marketBehavior: 'Comportamento no mercado',
        shortTermMeasures: 'Medidas de curto prazo',
        shortTermBreakpointDescription: 'Descrição do ponto de corte das medidas de curto prazo',
        measuresResult: 'Resultado da aprovação das medidas',
        measuresConfirmation: 'Confirmação das medidas',
        longTermMeasures: 'Medidas de longo prazo',
        longTermMeasuresBreak: 'Descrição estimada do ponto de corte das medidas de longo prazo',
        implementation: 'Foi implementado?',
        longMeasuresTime: 'Data real do ponto de corte das medidas de longo prazo',
        vinBreak: 'VIN do ponto de corte das medidas de longo prazo',
        breakpointImplementationPhase: 'Fase de implementação do ponto de corte',
        archive_Information: 'Informações do arquivo',
        reason_incomplete_closure: 'Motivo do fechamento sem conclusão',
        entry_Date: 'Data de entrada',
        departure_date: 'Data de saída',
        work_order_number: 'Número da ordem de serviço',
        questionnaire_usage: 'Finalidade do questionário',
        classification_of_technical_enquiries: 'Classificação das consultas técnicas',
        change_of_document_owner: 'Alteração do proprietário do documento',
        oldowner: 'Proprietário Antigo',
        newowner: 'Novo Proprietário',
        original: 'Original',
        translation: 'Tradução',
        dealer_address: 'Endereço do revendedor',
        sel_up_engineers: 'Selecione até 12 engenheiros!',
        sel_up_weeks: 'Selecione até 12 semanas!',
        veh_infor_inquiry: 'Consulta de informações do veículo',
        create_organization: 'Criar organização',
        ref_code: 'Obter código de verificação atualizado',
        fault_complaint_Desp: 'Descrição da falha / Descrição da reclamação do cliente',
        broken_down_vehicle: 'O veículo está quebrado?',
        reporting_organization: 'Organização reportante',
        reporter: 'Reportante',
        oneclick_convert: 'Conversão com um clique',
        assembly: 'Conjunto',
        show_original: 'Exibir original',
        sync_datong: 'Sincronizar com Datong',
        system_category_iii: 'Categoria do sistema III',
        maxus_Records: 'Registros de conversas MAXUS',
    },
    // 瑞典语
    svSE: {
        vin: 'VIN',
        inquiry_no: 'Ärendenummer',
        case_theme: 'Ämne för ärendet',
        department_name: 'Avdelningsnamn',
        department_type: 'Avdelningstyp',
        document_status: 'Dokumentstatus',
        inquiry_date: 'Förfrågningsdatum',
        organization_name: 'Organisationsnamn',
        name: 'Namn på föreslående part',
        sap_code: 'SAP-kod',
        failed_part: 'Defekt komponent',
        case_type: 'Ärendetyp',
        vehicle_status: 'Reparationsstatus',
        case_owner: 'Ansvarig',
        country: 'Land',
        fault_cause: 'Orsak till felet',
        symptoms: 'Felsymtom',
        is_the_document_qualified: 'Är dokumentet godkänt?',
        is_the_document_replied_in_a_timely_manner: 'Har dokumentet besvarats i tid?',
        filter: 'Filter',
        system_classification_I: 'Systemklassificering I',
        system_classification_II: 'Systemklassificering II',
        full_query: 'Fullständig sökning',
        fuzzy_query: 'Otydlig sökning',
        whether_belongs_new_car_market: 'Gäller lansering av ny bil?',
        caseStatus: 'Ärendestatus',
        correct: 'Ja',
        deny: 'Nej',
        not_closed: 'Inte avslutat',
        no_reply: 'Inget svar',
        replied: 'Besvarad',
        closed: 'Stängd',
        drafts: 'Utkast',
        create_time: 'Skapandetid',
        create_user: 'Skapare',
        parent_of_document: 'Överordnat dokument',
        document_owner: 'Dokumentägare',
        case_subject: 'Ämne för ärendet',
        receipt_info: 'Mottagningsinformation',
        superior_of_case: 'Överordnat ärende',
        inquiry_time: 'Förfråganstid',
        status: 'Status',
        overseas_company: 'Utländskt företagsnamn',
        general_agent_name: 'Generalagentens namn',
        dealer_code: 'Återförsäljarkod',
        dealer_name: 'Återförsäljarnamn',
        name_of_subsidiary: 'Dotterbolagsnamn',
        contacts: 'Kontakter',
        contact_information: 'Kontaktuppgifter',
        training_certification: 'Utbildningscertifikat',
        driving_mileage: 'Körsträcka',
        plate_number: 'Registreringsnummer',
        material_no: 'Materialnummer',
        material_desc: 'Materialbeskrivning',
        offline_date: 'Produktionsstoppdatum',
        model_platform: 'Modellplattform',
        engine_number: 'Motornummer',
        transmission_type: 'Växellådets typ',
        assembly_no: 'Monteringsnummer',
        fault_info_desc: 'Felbeskrivning',
        fault_handle_process: 'Feldhanteringsprocess',
        solution: 'Lösning',
        remark: 'Anmärkning',
        caseRemark: 'Ärendekommentar',
        document_information: 'Dokumentinformation',
        basic_information_of_service_center: 'Grundläggande information om servicecenter',
        basic_vehicle_information: 'Grundläggande fordoninformation',
        problem_description: 'Problembeskrivning',
        common_links: 'Vanliga länkar',
        claim_information: 'Garantianspråksinformation',
        diagnostic_report_record: 'Diagnosrapportlogg',
        vehicle_history: 'Fordonshistorik förfrågningsdokument',
        programming_history: 'Programmeringshistorik',
        vehicle_sales_logistics_information: 'Fordonets försäljnings- och logistikinformation',
        new_vehicle_information: 'Ny fordoninformation',
        attachment_upload: 'Uppladdning av bilagor',
        diagnostic_report: 'Diagnosrapport',
        bulk_download: 'Massnedladdning',
        document_View: 'Dokumentvisning',
        inquiry_content: 'Förfrågningsinnehåll',
        inquiry_entry: 'Inmatning av förfrågan',
        subordinate_record: 'Underordnad fråge- och svarslogg',
        superior_record: 'Överordnad fråge- och svarslogg',
        send_content: 'Skickat innehåll',
        send_time: 'Skicktid',
        sent_username: 'Avsändare',
        receive_name: 'Skickat till',
        dept_name: 'Nivå',
        enclosure: 'Bilaga',
        wind_case: 'Stäng ärende',
        close_order: 'Stäng order',
        case_reporting: 'Ärenderapportering',
        pdf_preview: 'PDF-förhandsgranskning',
        SIS_maintenance: 'Underhåll vid allvarliga olyckor',
        Please_fill_in_the_inquiry_content: 'Fyll i förfrågningsinnehållet',
        sending_an_email: 'Skickar e-post',
        copy: 'Kopiera',
        repeat: 'Dubblett VIN',
        inconsistent: 'Fordonsmodellens plattform är inkonsekvent',
        sendTo: 'Skicka till',
        reply: 'Ange innehåll för förfrågan/svar',
        please_check_the_exported_document: 'Markera det exporterade dokumentet',
        please_upload_diagnostic_report: 'Ladda upp diagnostikrapporten',
        please_enter_the_vin: 'Ange VIN',
        placeholderDTC: 'Exempel: P080800_P087D00_------',
        placeholderFaultInfoDesc:
            '1. Bekräfta kundens rapporterade problem (endast för att säkerställa att problemet uppstått)',
        placeholderFaultHandleProcess:
            '2. Identifiera relaterade symtom (hitta och dokumentera alla symtom som kan vara kopplade till problemet)\n3. Analysera symtomen (observera noggrant relaterade symtom för att hitta vanliga orsaker)\n4. Bekräfta problemet (begränsa dina resultat för att säkerställa att du löser rätt problem)',
        placeholderSolution:
            '5. Åtgärda problemet (genomför reparation)\n6. Verifiera fordonets funktion (kontrollera att din reparation löst problemet)',
        placeholderRemark: 'T.ex.: Styrutrustning - 201806, Vänster framstötdämpare - 2010101',
        placeholderContact: 'Ange operatörens namn',
        close_time: 'Stängningstid',
        one_touch: 'Återskapa dokument',
        confirm_generating_new_case: 'Är du säker på att du vill skapa ett nytt dokument?',
        closing_statement: 'Stängningskommentar',
        number_of_cases: 'Antal dokument',
        number_of_vehicles: 'Antal fordon',
        pleaseEnterContent: 'Ange innehåll',
        case_age: 'Ärendets ålder',
        last_response_time: 'Senaste svarstid',
        time_since_last_response: 'Tid sedan senaste svar',
        warranty_start_date: 'Garantistartdatum',
        submit_reason: 'Anledning till insändning',
        synchronize_PQCP: 'Synkronisera PQCP',
        FPR_export: 'FPR-export',
        level_selection: 'Nivåval',
        category_selection: 'Kategorival',
        brand_selection: 'Märkesval',
        code: 'Kod',
        description: 'Beskrivning',
        major_complaints: 'Allvarliga klagomål',
        difficult_miscellaneous_diseases: 'Komplexa och sällsynta fel',
        emerging_issues: 'Nya problem',
        breakpoint_failure: 'Fel vid brytpunkt',
        general_complaints: 'Allmän klagomål',
        other: 'Annat',
        roewe: 'Roewe',
        mg: 'MG',
        serious: 'Allvarlig',
        secondary: 'Sekundär',
        generally: 'Allmänt',
        complete: 'Slutförd',
        please_select_level: 'Välj nivå',
        please_select_category: 'Välj kategori',
        please_select_brand: 'Välj märke',
        placeholder_auto: 'Fylls i automatiskt',
        translate: 'Översätt',
        isTranslate: 'Ska översättas?',
        day: 'dag',
        one_click_order: 'Stäng ärende med ett klick',
        greater_than: 'Större än',
        less_than: 'Mindre än',
        between: 'Mellan',
        document_label: 'Dokumentetikett',
        receipts_first_modification_time: 'Dokumentets första ändringstidpunkt',
        Selection_of_Document_Owner: 'Val av dokumentansvarig',
        responsiblePerson: 'Ansvarig person:',
        functional_Domain: 'Funktionell domän',
        Category: 'Kategori',
        property: 'Egenskap',
        reRepair: 'Upprepad reparation',
        pullInNum: 'Antal besök på verkstad',
        perception: 'Perceptionsrelaterat',
        onSupport: 'Kräver platsstöd?',
        batteryNo: 'Batterinummer',
        normalStartDate: 'Garantistartdatum',
        qmotorNo: 'Frammotor nummer',
        hmotorNo: 'Bakmotor nummer',
        fault_cause_type: 'Typ av felsorsak',
        measure_name: 'Åtgärdsnamn',
        part_name: 'Delnamn',
        close_order_notification: 'Stängning av ärende kräver svar till förslagsställaren',
        TIS_Case_Data: 'TIS-fallsdata',
        case_File: 'Fallarkiv',
        responsibility_Data: 'Ansvarsdata',
        longterm_Measures: 'Långsiktiga åtgärder',
        tisCaseNo: 'TIS-ärendenummer',
        vehGlobalFwVer: 'Mjukvaruversion för hela fordonet',
        vehGlobalFwPn: 'Mjukvarudelnummer för hela fordonet',
        archivesNo: 'Arkivnummer',
        archivesTitle: 'Arkivtitel',
        archivesSource: 'Arkivkälla',
        proposer: 'Förslagsställare',
        proposedTime: 'Förslagsdatum',
        archivesManagementPersonnel: 'Arkivansvarig personal',
        functionalMode: 'Funktionell modul',
        supplier: 'Leverantör',
        accessoriesInvolved: 'Inkluderar tillbehör?',
        functionalDomain: 'Funktionell domän',
        invalidPartId: 'Felaktig komponent',
        archivesType: 'Arkivtyp',
        archivesGrade: 'Arkivnivå',
        problemDescription: 'Problembeskrivning',
        analysisProgress: 'Analysens framsteg',
        qaRemark: 'QA-anmärkning',
        tacRemark: 'TAC-anmärkning',
        responsibleDepartment: 'Ansvarig avdelning',
        coordinator: 'Koordinator',
        principal: 'Huvudansvarig',
        containmentAction: 'Innehållande åtgärder',
        issueStatus: 'Problemstatus',
        softwareProblems: 'Mjukvaruproblem',
        vehGlobalFwVer_j: 'Baslinjeversion',
        vehGlobalFwPn_j: 'Baslinjedelnummer',
        ewo: 'EWO-nummer',
        rootCause: 'Rotorsak',
        marketBehavior: 'Marknadsbeteende',
        shortTermMeasures: 'Kortsiktiga åtgärder',
        shortTermBreakpointDescription: 'Beskrivning av brytpunkt för kortsiktiga åtgärder',
        measuresResult: 'Resultat av godkännande av åtgärder',
        measuresConfirmation: 'Bekräftelse av åtgärder',
        longTermMeasures: 'Långsiktiga åtgärder',
        longTermMeasuresBreak: 'Uppskattad brytpunktsbeskrivning för långsiktiga åtgärder',
        implementation: 'Har det implementerats?',
        longMeasuresTime: 'Faktiskt brytpunktsdatum för långsiktiga åtgärder',
        vinBreak: 'VIN för långsiktiga åtgärders brytpunkt',
        breakpointImplementationPhase: 'Implementeringsfas för brytpunkt',
        archive_Information: 'Arkivinformation',
        reason_incomplete_closure: 'Orsak till stängning utan fullbordande',
        entry_Date: 'Inkörningsdatum',
        departure_date: 'Utkörningsdatum',
        work_order_number: 'Arbetsordernummer',
        questionnaire_usage: 'Syfte med frågeformulär',
        classification_of_technical_enquiries: 'Klassificering av tekniska förfrågningar',
        change_of_document_owner: 'Ändra dokumentägare',
        oldowner: 'Tidigare ägare',
        newowner: 'Ny ägare',
        original: 'Original',
        translation: 'Översättning',
        dealer_address: 'Återförsäljaradress',
        sel_up_engineers: 'Du kan välja upp till 12 ingenjörer!',
        sel_up_weeks: 'Du kan välja upp till 12 veckor!',
        veh_infor_inquiry: 'Förfrågan om fordoninformation',
        create_organization: 'Skapa organisation',
        ref_code: 'Hämta ny verifieringskod',
        fault_complaint_Desp: 'Felbeskrivning / Kundklagomål',
        broken_down_vehicle: 'Är fordonet ur funktion?',
        reporting_organization: 'Rapporterande organisation',
        reporter: 'Rapportör',
        oneclick_convert: 'Konvertera med ett klick',
        assembly: 'Montering',
        show_original: 'Visa original',
        sync_datong: 'Synkronisera med Datong',
        system_category_iii: 'Systemkategori III',
        maxus_Records: 'MAXUS samtalshistorik',
    },
    // 斯洛伐克
    skSK: {
        vin: 'VIN',
        inquiry_no: 'Číslo prípadu',
        case_theme: 'Téma prípadu',
        department_name: 'Názov oddelenia',
        department_type: 'Typ oddelenia',
        document_status: 'Stav dokumentu',
        inquiry_date: 'Dátum dopytu',
        organization_name: 'Názov organizácie',
        name: 'Názov navrhovateľa',
        sap_code: 'SAP kód',
        failed_part: 'Chybná súčiastka',
        case_type: 'Typ prípadu',
        vehicle_status: 'Stav opravy',
        case_owner: 'Zodpovedná osoba',
        country: 'Krajina',
        fault_cause: 'Príčina poruchy',
        symptoms: 'Príznaky poruchy',
        is_the_document_qualified: 'Je dokument kvalifikovaný?',
        is_the_document_replied_in_a_timely_manner: 'Bol dokument včas zodpovedaný?',
        filter: 'Filter',
        system_classification_I: 'Systémová klasifikácia I',
        system_classification_II: 'Systémová klasifikácia II',
        full_query: 'Kompletné vyhľadávanie',
        fuzzy_query: 'Nejasné vyhľadávanie',
        whether_belongs_new_car_market: 'Patrí k uvedeniu nového modelu?',
        caseStatus: 'Stav prípadu',
        correct: 'Áno',
        deny: 'Nie',
        not_closed: 'Neuzavreté',
        no_reply: 'Bez odpovede',
        replied: 'Besvarad',
        closed: 'Stängd',
        drafts: 'Utkast',
        create_time: 'Skapandetid',
        create_user: 'Skapare',
        parent_of_document: 'Överordnat dokument',
        document_owner: 'Dokumentägare',
        case_subject: 'Ämne för ärendet',
        receipt_info: 'Mottagningsinformation',
        superior_of_case: 'Överordnat ärende',
        inquiry_time: 'Förfråganstid',
        status: 'Status',
        overseas_company: 'Utländskt företagsnamn',
        general_agent_name: 'Generalagentens namn',
        dealer_code: 'Återförsäljarkod',
        dealer_name: 'Återförsäljarnamn',
        name_of_subsidiary: 'Dotterbolagsnamn',
        contacts: 'Kontakter',
        contact_information: 'Kontaktuppgifter',
        training_certification: 'Utbildningscertifikat',
        driving_mileage: 'Körsträcka',
        plate_number: 'Registreringsnummer',
        material_no: 'Materialnummer',
        material_desc: 'Materialbeskrivning',
        offline_date: 'Produktionsstoppdatum',
        model_platform: 'Modellplattform',
        engine_number: 'Motornummer',
        transmission_type: 'Växellådets typ',
        assembly_no: 'Monteringsnummer',
        fault_info_desc: 'Felbeskrivning',
        fault_handle_process: 'Proces riešenia poruchy',
        solution: 'Riešenie',
        remark: 'Poznámka',
        caseRemark: 'Poznámka k prípadu',
        document_information: 'Informácie o dokumente',
        basic_information_of_service_center: 'Základné informácie o servise',
        basic_vehicle_information: 'Základné informácie o vozidle',
        problem_description: 'Popis problému',
        common_links: 'Bežné odkazy',
        claim_information: 'Informácie o nároku',
        diagnostic_report_record: 'Záznam diagnostického správy',
        vehicle_history: 'Dokumenty dotazovania histórie vozidla',
        programming_history: 'História programovania',
        vehicle_sales_logistics_information: 'Informácie o predaji a logistike vozidla',
        new_vehicle_information: 'Nové informácie o vozidle',
        attachment_upload: 'Nahranie príloh',
        diagnostic_report: 'Diagnostická správa',
        bulk_download: 'Hromadné sťahovanie',
        document_View: 'Zobrazenie dokumentu',
        inquiry_content: 'Obsah dopytu',
        inquiry_entry: 'Záznam dopytu',
        subordinate_record: 'Záznam otázok a odpovedí podriadených',
        superior_record: 'Záznam otázok a odpovedí nadriadených',
        send_content: 'Odoslaný obsah',
        send_time: 'Čas odoslania',
        sent_username: 'Odosielateľ',
        receive_name: 'Odoslané pre',
        dept_name: 'Úroveň',
        enclosure: 'Príloha',
        wind_case: 'Ukončiť prípad',
        close_order: 'Zatvoriť objednávku',
        case_reporting: 'Nahlásenie prípadu',
        pdf_preview: 'Náhľad PDF',
        SIS_maintenance: 'Údržba vážnych nehôd',
        Please_fill_in_the_inquiry_content: 'Vyplňte obsah dopytu',
        sending_an_email: 'Odoslanie e-mailu',
        copy: 'Kopírovať',
        repeat: 'Duplicitné VIN',
        inconsistent: 'Nekonzistentná platforma modelu vozidla',
        sendTo: 'Odoslať na',
        reply: 'Zadajte obsah pre otázku/odpoveď',
        please_check_the_exported_document: 'Prosím, označte exportovaný dokument',
        please_upload_diagnostic_report: 'Nahrajte diagnostickú správu',
        please_enter_the_vin: 'Zadajte VIN',
        placeholderDTC: 'Príklad: P080800_P087D00_------',
        placeholderFaultInfoDesc:
            '1. Overte problém nahlásený zákazníkom (iba pre istotu, že problém skutočne nastal)',
        placeholderFaultHandleProcess:
            '2. Identifikujte súvisiace príznaky (nájdite a zaznamenajte všetky príznaky, ktoré môžu súvisieť s problémom)\n3. Analyzujte príznaky (pozorne sledujte súvisiace príznaky a hľadajte bežné príčiny)\n4. Potvrďte problém (zúžte svoje zistenia, aby ste si boli istí, že riešite správny problém)',
        placeholderSolution:
            '5. Opravte problém (vykonajte opravu)\n6. Overte prevádzku vozidla (skontrolujte, či vaša oprava problém vyriešila)',
        placeholderRemark: 'Napr.: Riadenie - 201806, Predný ľavý tlmič - 2010101',
        placeholderContact: 'Zadajte meno operátora',
        close_time: 'Čas ukončenia',
        one_touch: 'Obnoviť dokument',
        confirm_generating_new_case: 'Naozaj chcete vytvoriť nový dokument?',
        closing_statement: 'Poznámka k ukončeniu',
        number_of_cases: 'Počet dokumentov',
        number_of_vehicles: 'Počet vozidiel',
        pleaseEnterContent: 'Zadajte obsah',
        case_age: 'Vek prípadu',
        last_response_time: 'Čas poslednej odpovede',
        time_since_last_response: 'Čas od poslednej odpovede',
        warranty_start_date: 'Dátum začiatku záruky',
        submit_reason: 'Dôvod odoslania',
        synchronize_PQCP: 'Synchronizovať PQCP',
        FPR_export: 'Export FPR',
        level_selection: 'Výber úrovne',
        category_selection: 'Výber kategórie',
        brand_selection: 'Výber značky',
        code: 'Kód',
        description: 'Popis',
        major_complaints: 'Vážne sťažnosti',
        difficult_miscellaneous_diseases: 'Zložité a zriedkavé poruchy',
        emerging_issues: 'Novovzniknuté problémy',
        breakpoint_failure: 'Zlyhanie bodu prerušenia',
        general_complaints: 'Všeobecná sťažnosť',
        other: 'Iné',
        roewe: 'Roewe',
        mg: 'MG',
        serious: 'Závažné',
        secondary: 'Sekundárne',
        generally: 'Všeobecne',
        complete: 'Dokončené',
        please_select_level: 'Vyberte úroveň',
        please_select_category: 'Vyberte kategóriu',
        please_select_brand: 'Vyberte značku',
        placeholder_auto: 'Automaticky vyplnené',
        translate: 'Preložiť',
        isTranslate: 'Preložiť alebo nie?',
        day: 'deň',
        one_click_order: 'Zatvoriť objednávku jedným kliknutím',
        greater_than: 'Väčšie ako',
        less_than: 'Menšie ako',
        between: 'Medzi',
        document_label: 'Štítok dokumentu',
        receipts_first_modification_time: 'Čas prvej úpravy dokumentu',
        Selection_of_Document_Owner: 'Výber zodpovednej osoby za dokument',
        responsiblePerson: 'Zodpovedná osoba:',
        functional_Domain: 'Funkčná oblasť',
        Category: 'Kategória',
        property: 'Vlastnosť',
        reRepair: 'Opakovaná oprava',
        pullInNum: 'Počet návštev servisu',
        perception: 'Percepčné',
        onSupport: 'Vyžaduje miestnu podporu?',
        batteryNo: 'Číslo batérie',
        normalStartDate: 'Dátum začiatku záruky',
        qmotorNo: 'Číslo predného motora',
        hmotorNo: 'Číslo zadného motora',
        fault_cause_type: 'Typ príčiny poruchy',
        measure_name: 'Názov opatrenia',
        part_name: 'Názov súčiastky',
        close_order_notification: 'Zatvorenie objednávky vyžaduje odpoveď navrhovateľovi',
        TIS_Case_Data: 'Údaje prípadu TIS',
        case_File: 'Archív prípadu',
        responsibility_Data: 'Ansvarsdata',
        longterm_Measures: 'Långsiktiga åtgärder',
        tisCaseNo: 'TIS-ärendenummer',
        vehGlobalFwVer: 'Mjukvaruversion för hela fordonet',
        vehGlobalFwPn: 'Mjukvarudelnummer för hela fordonet',
        archivesNo: 'Arkivnummer',
        archivesTitle: 'Arkivtitel',
        archivesSource: 'Arkivkälla',
        proposer: 'Förslagsställare',
        proposedTime: 'Förslagsdatum',
        archivesManagementPersonnel: 'Arkivansvarig personal',
        functionalMode: 'Funktionell modul',
        supplier: 'Leverantör',
        accessoriesInvolved: 'Inkluderar tillbehör?',
        functionalDomain: 'Funktionell domän',
        invalidPartId: 'Felaktig komponent',
        archivesType: 'Arkivtyp',
        archivesGrade: 'Arkivnivå',
        problemDescription: 'Problembeskrivning',
        analysisProgress: 'Analysens framsteg',
        qaRemark: 'QA-anmärkning',
        tacRemark: 'TAC-anmärkning',
        responsibleDepartment: 'Ansvarig avdelning',
        coordinator: 'Koordinator',
        principal: 'Huvudansvarig',
        containmentAction: 'Innehållande åtgärder',
        issueStatus: 'Problemstatus',
        softwareProblems: 'Mjukvaruproblem',
        vehGlobalFwVer_j: 'Baslinjeversion',
        vehGlobalFwPn_j: 'Baslinjedelnummer',
        ewo: 'EWO-nummer',
        rootCause: 'Rotorsak',
        marketBehavior: 'Marknadsbeteende',
        shortTermMeasures: 'Kortsiktiga åtgärder',
        shortTermBreakpointDescription: 'Beskrivning av brytpunkt för kortsiktiga åtgärder',
        measuresResult: 'Resultat av godkännande av åtgärder',
        measuresConfirmation: 'Bekräftelse av åtgärder',
        longTermMeasures: 'Långsiktiga åtgärder',
        longTermMeasuresBreak: 'Uppskattad brytpunktsbeskrivning för långsiktiga åtgärder',
        implementation: 'Har det implementerats?',
        longMeasuresTime: 'Faktiskt brytpunktsdatum för långsiktiga åtgärder',
        vinBreak: 'VIN för långsiktiga åtgärders brytpunkt',
        breakpointImplementationPhase: 'Implementeringsfas för brytpunkt',
        archive_Information: 'Arkivinformation',
        reason_incomplete_closure: 'Orsak till stängning utan fullbordande',
        entry_Date: 'Inkörningsdatum',
        departure_date: 'Utkörningsdatum',
        work_order_number: 'Arbetsordernummer',
        questionnaire_usage: 'Syfte med frågeformulär',
        classification_of_technical_enquiries: 'Klassificering av tekniska förfrågningar',
        change_of_document_owner: 'Zmena vlastníka dokumentu',
        oldowner: 'Pôvodný vlastník',
        newowner: 'Nový vlastník',
        original: 'Originál',
        translation: 'Preklad',
        dealer_address: 'Adresa predajcu',
        sel_up_engineers: 'Môžete vybrať maximálne 12 inžinierov!',
        sel_up_weeks: 'Môžete vybrať maximálne 12 týždňov!',
        veh_infor_inquiry: 'Dopyt informácií o vozidle',
        create_organization: 'Vytvoriť organizáciu',
        ref_code: 'Získať nový overovací kód',
        fault_complaint_Desp: 'Popis poruchy / Popis sťažnosti zákazníka',
        broken_down_vehicle: 'Je vozidlo porazené?',
        reporting_organization: 'Nahlásenie organizácie',
        reporter: 'Nahlásiteľ',
        oneclick_convert: 'Prevod jedným kliknutím',
        assembly: 'Súčiastka',
        show_original: 'Zobraziť originál',
        sync_datong: 'Synchronizovať s Datong',
        system_category_iii: 'Systémová kategória III',
        maxus_Records: 'Záznamy konverzácií MAXUS',
    },
    // 斯洛文尼亚
    slSI: {
        vin: 'VIN',
        inquiry_no: 'Številka primera',
        case_theme: 'Tema primera',
        department_name: 'Ime oddelka',
        department_type: 'Tip oddelka',
        document_status: 'Status dokumenta',
        inquiry_date: 'Datum poizvedbe',
        organization_name: 'Ime organizacije',
        name: 'Ime predlagatelja',
        sap_code: 'SAP koda',
        failed_part: 'Okvarjen del',
        case_type: 'Vrsta primera',
        vehicle_status: 'Status popravila',
        case_owner: 'Odgovorna oseba',
        country: 'Država',
        fault_cause: 'Vzrok okvare',
        symptoms: 'Simptomi okvare',
        is_the_document_qualified: 'Ali je dokument ustrezno izpolnjen?',
        is_the_document_replied_in_a_timely_manner: 'Ali je bil dokument pravočasno odgovorjen?',
        filter: 'Filter',
        system_classification_I: 'Sistemska klasifikacija I',
        system_classification_II: 'Sistemska klasifikacija II',
        full_query: 'Polno poizvedovanje',
        fuzzy_query: 'Približno poizvedovanje',
        whether_belongs_new_car_market: 'Ali gre za uvedbo novega vozila?',
        caseStatus: 'Status primera',
        correct: 'Da',
        deny: 'Ne',
        not_closed: 'Ni zaključeno',
        no_reply: 'Brez odgovora',
        replied: 'Odgovorjeno',
        closed: 'Zaključano',
        drafts: 'Osnutki',
        create_time: 'Čas ustvarjanja',
        create_user: 'Ustvarilec',
        parent_of_document: 'Nadrejeni dokument',
        document_owner: 'Lastnik dokumenta',
        case_subject: 'Predmet primera',
        receipt_info: 'Informacije o prejemu',
        superior_of_case: 'Nadrejeni primer',
        inquiry_time: 'Čas poizvedbe',
        status: 'Stanje',
        overseas_company: 'Ime tuje družbe',
        general_agent_name: 'Ime glavnega agenta',
        dealer_code: 'Koda prodajalca',
        dealer_name: 'Ime prodajalca',
        name_of_subsidiary: 'Ime hčerinske družbe',
        contacts: 'Stiki',
        contact_information: 'Kontaktni podatki',
        training_certification: 'Certifikat o usposobljanju',
        driving_mileage: 'Prevoženi kilometri',
        plate_number: 'Registrska številka',
        material_no: 'Številka materiala',
        material_desc: 'Opis materiala',
        offline_date: 'Datum umika iz proizvodnje',
        model_platform: 'Platforma modela',
        engine_number: 'Številka motorja',
        transmission_type: 'Tip menjalnika',
        assembly_no: 'Montažna številka',
        fault_info_desc: 'Opis informacij o okvari',
        fault_handle_process: 'Postopek obravnave okvare',
        solution: 'Rešitev',
        remark: 'Opomba',
        caseRemark: 'Opomba primera',
        document_information: 'Informacije o dokumentu',
        basic_information_of_service_center: 'Osnovne informacije o servisnem centru',
        basic_vehicle_information: 'Osnovne informacije o vozilu',
        problem_description: 'Opis težave',
        common_links: 'Pogoste povezave',
        claim_information: 'Informacije o zahtevku',
        diagnostic_report_record: 'Zapis diagnostičnega poročila',
        vehicle_history: 'Dokumenti poizvedbe zgodovine vozila',
        programming_history: 'Zgodovina programiranja',
        vehicle_sales_logistics_information: 'Informacije o prodaji in logistiki vozila',
        new_vehicle_information: 'Nova informacija o vozilu',
        attachment_upload: 'Naložitev prilog',
        diagnostic_report: 'Diagnostično poročilo',
        bulk_download: 'Skupno prenašanje',
        document_View: 'Prikaz dokumenta',
        inquiry_content: 'Vsebina poizvedbe',
        inquiry_entry: 'Vnos poizvedbe',
        subordinate_record: 'Zapis vprašanj in odgovorov podrejenih',
        superior_record: 'Zapis vprašanj in odgovorov nadrejenih',
        send_content: 'Poslana vsebina',
        send_time: 'Čas pošiljanja',
        sent_username: 'Pošiljatelj',
        receive_name: 'Poslano za',
        dept_name: 'Raven',
        enclosure: 'Priponka',
        wind_case: 'Zaključek primera',
        close_order: 'Zaprtje naročila',
        case_reporting: 'Poročanje primera',
        pdf_preview: 'Predogled PDF',
        SIS_maintenance: 'Vzdrževanje ob resnih nesrečah',
        Please_fill_in_the_inquiry_content: 'Izpolnite vsebino poizvedbe',
        sending_an_email: 'Pošiljanje e-pošte',
        copy: 'Kopiraj',
        repeat: 'Podvojen VIN',
        inconsistent: 'Neujemanje platforme modela vozila',
        sendTo: 'Pošlji za',
        reply: 'Vnesite vsebino za poizvedbo/odgovor',
        please_check_the_exported_document: 'Označite izvoženi dokument',
        please_upload_diagnostic_report: 'Naložite diagnostično poročilo',
        please_enter_the_vin: 'Vnesite VIN',
        placeholderDTC: 'Primer: P080800_P087D00_------',
        placeholderFaultInfoDesc:
            '1. Preverite problem, ki ga je navedel stranka (samo za zagotovitev, da je problem dejansko obstajal)',
        placeholderFaultHandleProcess:
            '2. Določite povezane simptome (poiščite in zabeležite vse simptome, ki bi lahko bili povezani s težavo)\n3. Analizirajte simptome (natančno opazujte povezane simptome in poiščite pogoste vzroke)\n4. Potrdite težavo (zožite svoje ugotovitve, da zagotovite, da rešujete pravo težavo)',
        placeholderSolution:
            '5. Odpravite težavo (izvedite popravilo)\n6. Preverite delovanje vozila (preverite, ali je vaše popravilo odpravilo težavo)',
        placeholderRemark: 'Npr.: Krmilni mehanizem - 201806, Sprednji levi amortizer - 2010101',
        placeholderContact: 'Vnesite ime operaterja',
        close_time: 'Čas zaključka',
        one_touch: 'Ponovno ustvari dokument',
        confirm_generating_new_case: 'Ali ste prepričani, da želite ustvariti nov dokument?',
        closing_statement: 'Opomba ob zaključku',
        number_of_cases: 'Število dokumentov',
        number_of_vehicles: 'Število vozil',
        pleaseEnterContent: 'Vnesite vsebino',
        case_age: 'Starost primera',
        last_response_time: 'Čas zadnjega odgovora',
        time_since_last_response: 'Čas od zadnjega odgovora',
        warranty_start_date: 'Datum začetka garancije',
        submit_reason: 'Razlog za oddajo',
        synchronize_PQCP: 'Sinhroniziraj PQCP',
        FPR_export: 'Izvoz FPR',
        level_selection: 'Izbira ravni',
        category_selection: 'Izbira kategorije',
        brand_selection: 'Izbira blagovne znamke',
        code: 'Koda',
        description: 'Opis',
        major_complaints: 'Pomembne pritožbe',
        difficult_miscellaneous_diseases: 'Zapletene in redke okvare',
        emerging_issues: 'Novonastale težave',
        breakpoint_failure: 'Okvara prelomne točke',
        general_complaints: 'Všeobecná sťažnosť',
        other: 'Iné',
        roewe: 'Roewe',
        mg: 'MG',
        serious: 'Závažné',
        secondary: 'Sekundárne',
        generally: 'Všeobecne',
        complete: 'Dokončené',
        please_select_level: 'Vyberte úroveň',
        please_select_category: 'Vyberte kategóriu',
        please_select_brand: 'Vyberte značku',
        placeholder_auto: 'Automaticky vyplnené',
        translate: 'Preložiť',
        isTranslate: 'Preložiť alebo nie?',
        day: 'deň',
        one_click_order: 'Zatvoriť objednávku jedným kliknutím',
        greater_than: 'Väčšie ako',
        less_than: 'Menšie ako',
        between: 'Medzi',
        document_label: 'Štítok dokumentu',
        receipts_first_modification_time: 'Čas prvej úpravy dokumentu',
        Selection_of_Document_Owner: 'Výber zodpovednej osoby za dokument',
        responsiblePerson: 'Zodpovedná osoba:',
        functional_Domain: 'Funkčná oblasť',
        Category: 'Kategória',
        property: 'Vlastnosť',
        reRepair: 'Opakovaná oprava',
        pullInNum: 'Počet návštev servisu',
        perception: 'Percepčné',
        onSupport: 'Vyžaduje miestnu podporu?',
        batteryNo: 'Číslo batérie',
        normalStartDate: 'Dátum začiatku záruky',
        qmotorNo: 'Číslo predného motora',
        hmotorNo: 'Číslo zadného motora',
        fault_cause_type: 'Typ príčiny poruchy',
        measure_name: 'Názov opatrenia',
        part_name: 'Názov súčiastky',
        close_order_notification: 'Zatvorenie objednávky vyžaduje odpoveď navrhovateľovi',
        TIS_Case_Data: 'Údaje prípadu TIS',
        case_File: 'Archív prípadu',
        responsibility_Data: 'Podatki o razporeditvi odgovornosti',
        longterm_Measures: 'Dolgoročni ukrepi',
        tisCaseNo: 'Številka primera TIS',
        vehGlobalFwVer: 'Različica programske opreme celotnega vozila',
        vehGlobalFwPn: 'Številka programske komponente celotnega vozila',
        archivesNo: 'Številka arhiva',
        archivesTitle: 'Naslov arhiva',
        archivesSource: 'Vir arhiva',
        proposer: 'Predlagatelj',
        proposedTime: 'Datum predloga',
        archivesManagementPersonnel: 'Osebje za upravljanje arhiva',
        functionalMode: 'Funkcijski modul',
        supplier: 'Dobavitelj',
        accessoriesInvolved: 'Ali vključuje dodatno opremo?',
        functionalDomain: 'Funkcijska domena',
        invalidPartId: 'Neveljavni del',
        archivesType: 'Vrsta arhiva',
        archivesGrade: 'Raven arhiva',
        problemDescription: 'Opis težave',
        analysisProgress: 'Napredek analize',
        qaRemark: 'Opomba QA',
        tacRemark: 'Opomba TAC',
        responsibleDepartment: 'Odgovorni oddelek',
        coordinator: 'Koordinator',
        principal: 'Glavni odgovorni',
        containmentAction: 'Ukrepi za omejitev',
        issueStatus: 'Status težave',
        softwareProblems: 'Težave s programsko opremo',
        vehGlobalFwVer_j: 'Osnovna različica',
        vehGlobalFwPn_j: 'Osnovna številka dela',
        ewo: 'Številka EWO',
        rootCause: 'Korenski vzrok',
        marketBehavior: 'Obnašanje na trgu',
        shortTermMeasures: 'Kratkoročni ukrepi',
        shortTermBreakpointDescription: 'Opis preloma kratkoročnih ukrepov',
        measuresResult: 'Rezultat odobritve ukrepov',
        measuresConfirmation: 'Potrditev ukrepov',
        longTermMeasures: 'Dolgoročni ukrepi',
        longTermMeasuresBreak: 'Predviden opis preloma dolgoročnih ukrepov',
        implementation: 'Ali je izvedeno?',
        longMeasuresTime: 'Dejanski datum preloma dolgoročnih ukrepov',
        vinBreak: 'VIN preloma dolgoročnih ukrepov',
        breakpointImplementationPhase: 'Faza izvedbe preloma',
        archive_Information: 'Informacije o arhivu',
        reason_incomplete_closure: 'Razlog za zaprtje brez dokončanja',
        entry_Date: 'Datum vstopa',
        departure_date: 'Datum izstopa',
        work_order_number: 'Številka delovnega naloga',
        questionnaire_usage: 'Namen vprašalnika',
        classification_of_technical_enquiries: 'Klasifikacija tehničnih poizvedb',
        change_of_document_owner: 'Sprememba lastnika dokumenta',
        oldowner: 'Prejšnji lastnik',
        newowner: 'Novi lastnik',
        original: 'Izvirnik',
        translation: 'Prevod',
        dealer_address: 'Naslov prodajalca',
        sel_up_engineers: 'Izberete lahko do 12 inženirjev!',
        sel_up_weeks: 'Izberete lahko do 12 tednov!',
        veh_infor_inquiry: 'Poizvedba podatkov o vozilu',
        create_organization: 'Ustvari organizacijo',
        ref_code: 'Pridobi osveženo kodo za preverjanje',
        fault_complaint_Desp: 'Opis okvare / Opis strankine pritožbe',
        broken_down_vehicle: 'Ali je vozilo pokvarjeno?',
        reporting_organization: 'Poročevalna organizacija',
        reporter: 'Poročevalec',
        oneclick_convert: 'Pretvorba z enim klikom',
        assembly: 'Sestavni del',
        show_original: 'Prikaži izvirnik',
        sync_datong: 'Sinhroniziraj z Datong',
        system_category_iii: 'Sistemska kategorija III',
        maxus_Records: 'MAXUS zapisi pogovorov',
    },
    // 泰语
    thTH: {
        vin: 'VIN',
        inquiry_no: 'หมายเลขเคส',
        case_theme: 'หัวข้อเคส',
        department_name: 'ชื่อแผนก',
        department_type: 'ประเภทแผนก',
        document_status: 'สถานะเอกสาร',
        inquiry_date: 'วันที่สอบถาม',
        organization_name: 'ชื่อองค์กร',
        name: 'ชื่อผู้เสนอ',
        sap_code: 'รหัส SAP',
        failed_part: 'ชิ้นส่วนที่ล้มเหลว',
        case_type: 'ประเภทเคส',
        vehicle_status: 'สถานะการซ่อม',
        case_owner: 'ผู้รับผิดชอบ',
        country: 'ประเทศ',
        fault_cause: 'สาเหตุของความขัดข้อง',
        symptoms: 'อาการขัดข้อง',
        is_the_document_qualified: 'เอกสารได้มาตรฐานหรือไม่',
        is_the_document_replied_in_a_timely_manner: 'มีการตอบกลับเอกสารทันเวลาหรือไม่',
        filter: 'ตัวกรอง',
        system_classification_I: 'การจัดหมวดหมู่ระบบ I',
        system_classification_II: 'การจัดหมวดหมู่ระบบ II',
        full_query: 'ค้นหาแบบเต็ม',
        fuzzy_query: 'ค้นหาแบบคลุมเครือ',
        whether_belongs_new_car_market: 'เกี่ยวข้องกับการเปิดตัวรถใหม่หรือไม่',
        caseStatus: 'สถานะเคส',
        correct: 'ใช่',
        deny: 'ไม่',
        not_closed: 'ยังไม่ปิดเคส',
        no_reply: 'ยังไม่ตอบกลับ',
        replied: 'ตอบกลับแล้ว',
        closed: 'ปิดเคสแล้ว',
        drafts: 'ร่าง',
        create_time: 'เวลาสร้าง',
        create_user: 'ผู้สร้าง',
        parent_of_document: 'เอกสารต้นสังกัด',
        document_owner: 'เจ้าของเอกสาร',
        case_subject: 'หัวข้อเคส',
        receipt_info: 'ข้อมูลใบเสร็จ',
        superior_of_case: 'เคสต้นสังกัด',
        inquiry_time: 'เวลาสอบถาม',
        status: 'สถานะ',
        overseas_company: 'ชื่อบริษัทต่างประเทศ',
        general_agent_name: 'ชื่อตัวแทนทั่วไป',
        dealer_code: 'รหัสผู้จำหน่าย',
        dealer_name: 'ชื่อผู้จำหน่าย',
        name_of_subsidiary: 'ชื่อบริษัทลูก',
        contacts: 'ผู้ติดต่อ',
        contact_information: 'ข้อมูลการติดต่อ',
        training_certification: 'ใบรับรองการอบรม',
        driving_mileage: 'ระยะทางที่ขับ',
        plate_number: 'หมายเลขทะเบียน',
        material_no: 'หมายเลขวัสดุ',
        material_desc: 'คำอธิบายวัสดุ',
        offline_date: 'วันที่ออกจากสายการผลิต',
        model_platform: 'แพลตฟอร์มรุ่นรถ',
        engine_number: 'หมายเลขเครื่องยนต์',
        transmission_type: 'ประเภทเกียร์',
        assembly_no: 'หมายเลขประกอบ',
        fault_info_desc: 'คำอธิบายข้อมูลความขัดข้อง',
        fault_handle_process: 'ขั้นตอนการจัดการความผิดพลาด',
        solution: 'วิธีแก้ไข',
        remark: 'หมายเหตุ',
        caseRemark: 'หมายเหตุกรณี',
        document_information: 'ข้อมูลเอกสาร',
        basic_information_of_service_center: 'ข้อมูลพื้นฐานศูนย์บริการ',
        basic_vehicle_information: 'ข้อมูลพื้นฐานของรถ',
        problem_description: 'คำอธิบายปัญหา',
        common_links: 'ลิงก์ที่ใช้บ่อย',
        claim_information: 'ข้อมูลการเคลม',
        diagnostic_report_record: 'บันทึกผลรายงานการวินิจฉัย',
        vehicle_history: 'เอกสารสอบถามประวัติรถ',
        programming_history: 'ประวัติการโปรแกรม',
        vehicle_sales_logistics_information: 'ข้อมูลการขายและโลจิสติกส์ของรถ',
        new_vehicle_information: 'ข้อมูลรถใหม่',
        attachment_upload: 'อัปโหลดไฟล์แนบ',
        diagnostic_report: 'รายงานการวินิจฉัย',
        bulk_download: 'ดาวน์โหลดแบบกลุ่ม',
        document_View: 'ดูเอกสาร',
        inquiry_content: 'เนื้อหาการสอบถาม',
        inquiry_entry: 'รายการสอบถาม',
        subordinate_record: 'บันทึกคำถาม-คำตอบจากระดับล่าง',
        superior_record: 'บันทึกคำถาม-คำตอบจากระดับบน',
        send_content: 'เนื้อหาที่ส่ง',
        send_time: 'เวลาที่ส่ง',
        sent_username: 'ผู้ส่ง',
        receive_name: 'ส่งถึง',
        dept_name: 'ระดับ',
        enclosure: 'ไฟล์แนบ',
        wind_case: 'ปิดเคส',
        close_order: 'ปิดใบสั่งงาน',
        case_reporting: 'รายงานเคส',
        pdf_preview: 'แสดงตัวอย่าง PDF',
        SIS_maintenance: 'การบำรุงรักษากรณีอุบัติเหตุร้ายแรง',
        Please_fill_in_the_inquiry_content: 'กรุณากรอกเนื้อหาการสอบถาม',
        sending_an_email: 'ส่งอีเมล',
        copy: 'คัดลอก',
        repeat: 'VIN ซ้ำ',
        inconsistent: 'แพลตฟอร์มรุ่นรถไม่ตรงกัน',
        sendTo: 'ส่งถึง',
        reply: 'กรอกข้อความเพื่อสอบถาม/ตอบกลับ',
        please_check_the_exported_document: 'กรุณาเลือกเอกสารที่ส่งออก',
        please_upload_diagnostic_report: 'กรุณาอัปโหลดรายงานการวินิจฉัย',
        please_enter_the_vin: 'กรุณาใส่หมายเลข VIN',
        placeholderDTC: 'ตัวอย่าง: P080800_P087D00_------',
        placeholderFaultInfoDesc:
            '1. ยืนยันปัญหาที่ลูกค้าแจ้ง (เพียงเพื่อให้แน่ใจว่าเกิดปัญหาจริง)',
        placeholderFaultHandleProcess:
            '2. ระบุอาการที่เกี่ยวข้อง (ค้นหาและบันทึกอาการทั้งหมดที่อาจเกี่ยวข้องกับปัญหา)\n3. วิเคราะห์อาการ (สังเกตอาการที่เกี่ยวข้องอย่างละเอียด เพื่อหาสาเหตุทั่วไป)\n4. ยืนยันปัญหา (จำกัดขอบเขตผลลัพธ์ของคุณให้แคบลง เพื่อให้แน่ใจว่าคุณกำลังแก้ไขปัญหาที่ถูกต้อง)',
        placeholderSolution:
            '5. แก้ไขปัญหา (ดำเนินการซ่อมแซม)\n6. ตรวจสอบการทำงานของรถ (ตรวจสอบให้แน่ใจว่าการซ่อมแซมของคุณได้แก้ไขปัญหาแล้ว)',
        placeholderRemark: 'เช่น พวงมาลัย - 201806, โช้คอัพหน้าซ้าย - 2010101',
        placeholderContact: 'กรุณาใส่ชื่อผู้ปฏิบัติงาน',
        close_time: 'เวลาปิดเคส',
        one_touch: 'สร้างเอกสารใหม่',
        confirm_generating_new_case: 'ยืนยันการสร้างเอกสารใหม่หรือไม่?',
        closing_statement: 'คำอธิบายการปิดเคส',
        number_of_cases: 'จำนวนเอกสาร',
        number_of_vehicles: 'จำนวนรถยนต์',
        pleaseEnterContent: 'กรุณาใส่ข้อความ',
        case_age: 'อายุเคส',
        last_response_time: 'เวลาตอบกลับล่าสุด',
        time_since_last_response: 'ระยะเวลาตั้งแต่การตอบกลับครั้งล่าสุด',
        warranty_start_date: 'วันที่เริ่มรับประกัน',
        submit_reason: 'เหตุผลในการส่ง',
        synchronize_PQCP: 'ซิงค์ข้อมูล PQCP',
        FPR_export: 'ส่งออก FPR',
        level_selection: 'เลือกระดับ',
        category_selection: 'เลือกหมวดหมู่',
        brand_selection: 'เลือกแบรนด์',
        code: 'รหัส',
        description: 'คำอธิบาย',
        major_complaints: 'ข้อร้องเรียนสำคัญ',
        difficult_miscellaneous_diseases: 'ปัญหายากและซับซ้อน',
        emerging_issues: 'ปัญหาใหม่ที่เกิดขึ้น',
        breakpoint_failure: 'จุดหยุดทำงานล้มเหลว',
        general_complaints: 'ข้อร้องเรียนทั่วไป',
        other: 'อื่นๆ',
        roewe: 'โรอีเว่',
        mg: 'เอ็มจี',
        serious: 'รุนแรง',
        secondary: 'รอง',
        generally: 'ทั่วไป',
        complete: 'เสร็จสิ้น',
        please_select_level: 'กรุณาเลือกระดับ',
        please_select_category: 'กรุณาเลือกหมวดหมู่',
        please_select_brand: 'กรุณาเลือกยี่ห้อ',
        placeholder_auto: 'กรอกโดยอัตโนมัติ',
        translate: 'แปลภาษา',
        isTranslate: 'ต้องการแปลหรือไม่',
        day: 'วัน',
        one_click_order: 'ปิดงานด้วยคลิกเดียว',
        greater_than: 'มากกว่า',
        less_than: 'น้อยกว่า',
        between: 'ระหว่าง',
        document_label: 'ป้ายกำกับเอกสาร',
        receipts_first_modification_time: 'เวลาแก้ไขเอกสารครั้งแรก',
        Selection_of_Document_Owner: 'เลือกผู้รับผิดชอบเอกสาร',
        responsiblePerson: 'ผู้รับผิดชอบ:',
        functional_Domain: 'โดเมนเชิงฟังก์ชัน',
        Category: 'หมวดหมู่',
        property: 'คุณสมบัติ',
        reRepair: 'ซ่อมซ้ำ',
        pullInNum: 'จำนวนครั้งที่เข้าศูนย์',
        perception: 'ประเภทที่รับรู้ได้',
        onSupport: 'ต้องการสนับสนุนหน้างานหรือไม่',
        batteryNo: 'หมายเลขแบตเตอรี่',
        normalStartDate: 'วันที่รับประกัน',
        qmotorNo: 'หมายเลขมอเตอร์หน้า',
        hmotorNo: 'หมายเลขมอเตอร์หลัง',
        fault_cause_type: 'ประเภทสาเหตุขัดข้อง',
        measure_name: 'ชื่อมาตรการ',
        part_name: 'ชื่อชิ้นส่วน',
        close_order_notification: 'การปิดงานต้องตอบกลับผู้เสนอ',
        TIS_Case_Data: 'ข้อมูลกรณี TIS',
        case_File: 'แฟ้มกรณี',
        responsibility_Data: 'ข้อมูลการแบ่งความรับผิดชอบ',
        longterm_Measures: 'มาตรการระยะยาว',
        tisCaseNo: 'หมายเลขกรณี TIS',
        vehGlobalFwVer: 'เวอร์ชันซอฟต์แวร์ของรถยนต์ทั้งคัน',
        vehGlobalFwPn: 'หมายเลขชิ้นส่วนซอฟต์แวร์ของรถยนต์ทั้งคัน',
        archivesNo: 'หมายเลขแฟ้ม',
        archivesTitle: 'ชื่อเรื่องแฟ้ม',
        archivesSource: 'แหล่งที่มาของแฟ้ม',
        proposer: 'ผู้เสนอ',
        proposedTime: 'วันที่เสนอ',
        archivesManagementPersonnel: 'เจ้าหน้าที่จัดการแฟ้ม',
        functionalMode: 'โมดูลฟังก์ชัน',
        supplier: 'ผู้จัดจำหน่าย',
        accessoriesInvolved: 'เกี่ยวข้องกับอุปกรณ์เสริมหรือไม่',
        functionalDomain: 'โดเมนเชิงฟังก์ชัน',
        invalidPartId: 'ชิ้นส่วนที่เสียหาย',
        archivesType: 'ประเภทแฟ้ม',
        archivesGrade: 'ระดับแฟ้ม',
        problemDescription: 'คำอธิบายปัญหา',
        analysisProgress: 'ความคืบหน้าในการวิเคราะห์',
        qaRemark: 'หมายเหตุจาก QA',
        tacRemark: 'หมายเหตุจาก TAC',
        responsibleDepartment: 'แผนกที่รับผิดชอบ',
        coordinator: 'ผู้ประสานงาน',
        principal: 'ผู้รับผิดชอบหลัก',
        containmentAction: 'มาตรการควบคุม',
        issueStatus: 'สถานะปัญหา',
        softwareProblems: 'ปัญหาซอฟต์แวร์',
        vehGlobalFwVer_j: 'เวอร์ชันฐานอ้างอิง',
        vehGlobalFwPn_j: 'หมายเลขชิ้นส่วนฐานอ้างอิง',
        ewo: 'หมายเลข EWO',
        rootCause: 'สาเหตุหลัก',
        marketBehavior: 'พฤติกรรมในตลาด',
        shortTermMeasures: 'มาตรการระยะสั้น',
        shortTermBreakpointDescription: 'คำอธิบายจุดหยุดมาตรการระยะสั้น',
        measuresResult: 'ผลการอนุมัติมาตรการ',
        measuresConfirmation: 'คำยืนยันมาตรการ',
        longTermMeasures: 'มาตรการระยะยาว',
        longTermMeasuresBreak: 'คำอธิบายประมาณการจุดหยุดมาตรการระยะยาว',
        implementation: 'ดำเนินการแล้วหรือไม่',
        longMeasuresTime: 'วันที่จุดหยุดจริงของมาตรการระยะยาว',
        vinBreak: 'VIN จุดหยุดมาตรการระยะยาว',
        breakpointImplementationPhase: 'ระยะการดำเนินการจุดหยุด',
        archive_Information: 'ข้อมูลแฟ้ม',
        reason_incomplete_closure: 'เหตุผลการปิดโดยไม่เสร็จสมบูรณ์',
        entry_Date: 'วันที่เข้าศูนย์',
        departure_date: 'วันที่ออกจากศูนย์',
        work_order_number: 'หมายเลขใบงาน',
        questionnaire_usage: 'วัตถุประสงค์แบบสอบถาม',
        classification_of_technical_enquiries: 'การจัดหมวดหมู่คำถามทางเทคนิค',
        change_of_document_owner: 'เปลี่ยนเจ้าของเอกสาร',
        oldowner: 'เจ้าของเดิม',
        newowner: 'เจ้าของใหม่',
        original: 'ต้นฉบับ',
        translation: 'คำแปล',
        dealer_address: 'ที่อยู่ผู้จัดจำหน่าย',
        sel_up_engineers: 'เลือกได้สูงสุด 12 วิศวกร!',
        sel_up_weeks: 'เลือกได้สูงสุด 12 สัปดาห์!',
        veh_infor_inquiry: 'สอบถามข้อมูลรถ',
        create_organization: 'สร้างองค์กร',
        ref_code: 'รับรหัสยืนยันใหม่',
        fault_complaint_Desp: 'คำอธิบายความผิดพลาด/คำร้องเรียนของลูกค้า',
        broken_down_vehicle: 'รถเสียกลางทางหรือไม่',
        reporting_organization: 'องค์กรที่รายงาน',
        reporter: 'ผู้รายงาน',
        oneclick_convert: 'แปลงด้วยคลิกเดียว',
        assembly: 'ชุดประกอบ',
        show_original: 'แสดงต้นฉบับ',
        sync_datong: 'ซิงค์กับ Datong',
        system_category_iii: 'หมวดหมู่ระบบ III',
        maxus_Records: 'บันทึกการสนทนา MAXUS',
    },
    // 乌克兰语
    ukUA: {
        vin: 'VIN',
        inquiry_no: 'Номер випадку',
        case_theme: 'Тема випадку',
        department_name: 'Назва відділу',
        department_type: 'Тип відділу',
        document_status: 'Статус документа',
        inquiry_date: 'Дата запиту',
        organization_name: 'Назва організації',
        name: 'Назва пропонента',
        sap_code: 'Код SAP',
        failed_part: 'Несправна деталь',
        case_type: 'Тип випадку',
        vehicle_status: 'Стан ремонту',
        case_owner: 'Відповідальна особа',
        country: 'Країна',
        fault_cause: 'Причина несправності',
        symptoms: 'Симптоми несправності',
        is_the_document_qualified: 'Чи є документ кваліфікованим?',
        is_the_document_replied_in_a_timely_manner: 'Чи надано відповідь на документ учасно?',
        filter: 'Фільтр',
        system_classification_I: 'Системна класифікація I',
        system_classification_II: 'Системна класифікація II',
        full_query: 'Повний запит',
        fuzzy_query: 'Нечіткий запит',
        whether_belongs_new_car_market: 'Чи стосується запуску нового автомобіля?',
        caseStatus: 'Статус випадку',
        correct: 'Так',
        deny: 'Ні',
        not_closed: 'Не закрито',
        no_reply: 'Без відповіді',
        replied: 'ตอบกลับแล้ว',
        closed: 'ปิดเคสแล้ว',
        drafts: 'ร่าง',
        create_time: 'เวลาสร้าง',
        create_user: 'ผู้สร้าง',
        parent_of_document: 'เอกสารต้นสังกัด',
        document_owner: 'เจ้าของเอกสาร',
        case_subject: 'หัวข้อเคส',
        receipt_info: 'ข้อมูลใบเสร็จ',
        superior_of_case: 'เคสต้นสังกัด',
        inquiry_time: 'เวลาสอบถาม',
        status: 'สถานะ',
        overseas_company: 'ชื่อบริษัทต่างประเทศ',
        general_agent_name: 'ชื่อตัวแทนทั่วไป',
        dealer_code: 'รหัสผู้จำหน่าย',
        dealer_name: 'ชื่อผู้จำหน่าย',
        name_of_subsidiary: 'ชื่อบริษัทลูก',
        contacts: 'ผู้ติดต่อ',
        contact_information: 'ข้อมูลการติดต่อ',
        training_certification: 'ใบรับรองการอบรม',
        driving_mileage: 'ระยะทางที่ขับ',
        plate_number: 'หมายเลขทะเบียน',
        material_no: 'หมายเลขวัสดุ',
        material_desc: 'คำอธิบายวัสดุ',
        offline_date: 'วันที่ออกจากสายการผลิต',
        model_platform: 'แพลตฟอร์มรุ่นรถ',
        engine_number: 'หมายเลขเครื่องยนต์',
        transmission_type: 'ประเภทเกียร์',
        assembly_no: 'หมายเลขประกอบ',
        fault_info_desc: 'คำอธิบายข้อมูลความขัดข้อง',
        fault_handle_process: 'ขั้นตอนการจัดการความผิดพลาด',
        solution: 'วิธีแก้ไข',
        remark: 'หมายเหตุ',
        caseRemark: 'หมายเหตุกรณี',
        document_information: 'ข้อมูลเอกสาร',
        basic_information_of_service_center: 'ข้อมูลพื้นฐานศูนย์บริการ',
        basic_vehicle_information: 'ข้อมูลพื้นฐานของรถ',
        problem_description: 'คำอธิบายปัญหา',
        common_links: 'ลิงก์ที่ใช้บ่อย',
        claim_information: 'ข้อมูลการเคลม',
        diagnostic_report_record: 'บันทึกผลรายงานการวินิจฉัย',
        vehicle_history: 'เอกสารสอบถามประวัติรถ',
        programming_history: 'ประวัติการโปรแกรม',
        vehicle_sales_logistics_information: 'ข้อมูลการขายและโลจิสติกส์ของรถ',
        new_vehicle_information: 'ข้อมูลรถใหม่',
        attachment_upload: 'อัปโหลดไฟล์แนบ',
        diagnostic_report: 'รายงานการวินิจฉัย',
        bulk_download: 'ดาวน์โหลดแบบกลุ่ม',
        document_View: 'ดูเอกสาร',
        inquiry_content: 'เนื้อหาการสอบถาม',
        inquiry_entry: 'Введення запиту',
        subordinate_record: 'Запис питань і відповідей підлеглих',
        superior_record: 'Запис питань і відповідей керівництва',
        send_content: 'Надісланий вміст',
        send_time: 'Час надсилання',
        sent_username: 'Надіслав',
        receive_name: 'Надіслано до',
        dept_name: 'Рівень',
        enclosure: 'Вкладення',
        wind_case: 'Закрити справу',
        close_order: 'Закрити замовлення',
        case_reporting: 'Подання звіту про справу',
        pdf_preview: 'Попередній перегляд PDF',
        SIS_maintenance: 'Обслуговування серйозних аварій',
        Please_fill_in_the_inquiry_content: 'Будь ласка, заповніть вміст запиту',
        sending_an_email: 'Надсилання електронного листа',
        copy: 'Копіювати',
        repeat: 'VIN повторюється',
        inconsistent: 'Невідповідність платформи моделі автомобіля',
        sendTo: 'Надіслати до',
        reply: 'Введіть текст для запиту/відповіді',
        please_check_the_exported_document: 'Будь ласка, позначте експортований документ',
        please_upload_diagnostic_report: 'Будь ласка, завантажте діагностичний звіт',
        please_enter_the_vin: 'Будь ласка, введіть VIN',
        placeholderDTC: 'Приклад: P080800_P087D00_------',
        placeholderFaultInfoDesc:
            '1. Перевірте проблему, повідомлену клієнтом (лише для підтвердження наявності проблеми)',
        placeholderFaultHandleProcess:
            '2. Визначте пов’язані симптоми (знайдіть і зафіксуйте всі симптоми, які можуть бути пов’язані з проблемою)\n3. Проаналізуйте симптоми (уважно спостерігайте пов’язані симптоми, щоб виявити типові причини)\n4. Підтвердьте проблему (звузьте коло можливих причин, щоб переконатися, що ви вирішуєте правильну проблему)',
        placeholderSolution:
            '5. Усуньте проблему (проведіть ремонт)\n6. Перевірте роботу автомобіля (переконайтеся, що ваш ремонт усунув проблему)',
        placeholderRemark:
            'Наприклад: Рульова рейка - 201806, Амортизатор переднього лівого колеса - 2010101',
        placeholderContact: 'Введіть ім’я оператора',
        close_time: 'Час закриття',
        one_touch: 'Перестворити документ',
        confirm_generating_new_case: 'Ви впевнені, що хочете створити новий документ?',
        closing_statement: 'Коментар до закриття',
        number_of_cases: 'Кількість документів',
        number_of_vehicles: 'Кількість транспортних засобів',
        pleaseEnterContent: 'Будь ласка, введіть текст',
        case_age: 'Вік справи',
        last_response_time: 'Час останньої відповіді',
        time_since_last_response: 'Час з моменту останньої відповіді',
        warranty_start_date: 'Дата початку гарантії',
        submit_reason: 'Причина подання',
        synchronize_PQCP: 'Синхронізувати PQCP',
        FPR_export: 'Експорт FPR',
        level_selection: 'Вибір рівня',
        category_selection: 'Вибір категорії',
        brand_selection: 'Вибір бренду',
        code: 'Код',
        description: 'Опис',
        major_complaints: 'Серйозні скарги',
        difficult_miscellaneous_diseases: 'Складні та рідкісні несправності',
        emerging_issues: 'Нові проблеми',
        breakpoint_failure: 'Збій контрольної точки',
        general_complaints: 'Загальна скарга',
        other: 'Інше',
        roewe: 'Roewe',
        mg: 'MG',
        serious: 'Серйозно',
        secondary: 'Вторинний',
        generally: 'Загалом',
        complete: 'Завершено',
        please_select_level: 'Будь ласка, оберіть рівень',
        please_select_category: 'Будь ласка, оберіть категорію',
        please_select_brand: 'Будь ласка, оберіть бренд',
        placeholder_auto: 'Автоматично заповнюється',
        translate: 'Перекласти',
        isTranslate: 'Чи перекладати?',
        day: 'день',
        one_click_order: 'Закрити замовлення одним кліком',
        greater_than: 'Більше ніж',
        less_than: 'Менше ніж',
        between: 'Між',
        document_label: 'Мітка документа',
        receipts_first_modification_time: 'Час першого редагування документа',
        Selection_of_Document_Owner: 'Вибір відповідальної особи за документ',
        responsiblePerson: 'Відповідальна особа:',
        functional_Domain: 'Функціональна область',
        Category: 'Категорія',
        property: 'Властивість',
        reRepair: 'Повторний ремонт',
        pullInNum: 'Кількість відвідувань СТО',
        perception: 'Пов’язане зі сприйняттям',
        onSupport: 'Потребує підтримки на місці?',
        batteryNo: 'Номер акумулятора',
        normalStartDate: 'Дата початку гарантії',
        qmotorNo: 'Номер переднього мотора',
        hmotorNo: 'Номер заднього мотора',
        fault_cause_type: 'Тип причини несправності',
        measure_name: 'Назва заходу',
        part_name: 'Назва деталі',
        close_order_notification:
            'Для закриття замовлення потрібна відповідь ініціатору пропозиції',
        TIS_Case_Data: 'Дані випадку TIS',
        case_File: 'Архів випадку',
        responsibility_Data: 'Дані про розподіл відповідальності',
        longterm_Measures: 'Довгострокові заходи',
        tisCaseNo: 'Номер випадку TIS',
        vehGlobalFwVer: 'Версія програмного забезпечення всього транспортного засобу',
        vehGlobalFwPn: 'Номер програмної деталі всього транспортного засобу',
        archivesNo: 'Номер архіву',
        archivesTitle: 'Назва архіву',
        archivesSource: 'Джерело архіву',
        proposer: 'Автор пропозиції',
        proposedTime: 'Дата подання пропозиції',
        archivesManagementPersonnel: 'Персонал з управління архівами',
        functionalMode: 'Функціональний модуль',
        supplier: 'Постачальник',
        accessoriesInvolved: 'Чи стосується аксесуарів?',
        functionalDomain: 'Функціональна область',
        invalidPartId: 'Несправна деталь',
        archivesType: 'Тип архіву',
        archivesGrade: 'Рівень архіву',
        problemDescription: 'Опис проблеми',
        analysisProgress: 'Хід аналізу',
        qaRemark: 'Примітка QA',
        tacRemark: 'Примітка TAC',
        responsibleDepartment: 'Відповідальний відділ',
        coordinator: 'Координатор',
        principal: 'Головний відповідальний',
        containmentAction: 'Заходи з обмеження',
        issueStatus: 'Статус проблеми',
        softwareProblems: 'Проблеми з програмним забезпеченням',
        vehGlobalFwVer_j: 'Базова версія',
        vehGlobalFwPn_j: 'Базовий номер деталі',
        ewo: 'Номер EWO',
        rootCause: 'Коренева причина',
        marketBehavior: 'Поведінка на ринку',
        shortTermMeasures: 'Короткострокові заходи',
        shortTermBreakpointDescription: 'Опис точки розриву короткострокових заходів',
        measuresResult: 'Результат затвердження заходів',
        measuresConfirmation: 'Підтвердження заходів',
        longTermMeasures: 'Довгострокові заходи',
        longTermMeasuresBreak: 'Очікуваний опис точки розриву довгострокових заходів',
        implementation: 'Чи реалізовано?',
        longMeasuresTime: 'Фактична дата точки розриву довгострокових заходів',
        vinBreak: 'VIN точки розриву довгострокових заходів',
        breakpointImplementationPhase: 'Етап реалізації точки розриву',
        archive_Information: 'Інформація про архів',
        reason_incomplete_closure: 'Причина закриття без завершення',
        entry_Date: 'Дата в’їзду',
        departure_date: 'Дата виїзду',
        work_order_number: 'Номер робочого замовлення',
        questionnaire_usage: 'Призначення опитувальника',
        classification_of_technical_enquiries: 'Класифікація технічних запитів',
        change_of_document_owner: 'Зміна власника документа',
        oldowner: 'Попередній власник',
        newowner: 'Новий власник',
        original: 'Оригінал',
        translation: 'Переклад',
        dealer_address: 'Адреса дилера',
        sel_up_engineers: 'Можна обрати до 12 інженерів!',
        sel_up_weeks: 'Можна обрати до 12 тижнів!',
        veh_infor_inquiry: 'Запит інформації про транспортний засіб',
        create_organization: 'Створити організацію',
        ref_code: 'Отримати новий код підтвердження',
        fault_complaint_Desp: 'Опис несправності / Опис скарги клієнта',
        broken_down_vehicle: 'Чи є транспортний засіб несправним?',
        reporting_organization: 'Організація, що повідомляє',
        reporter: 'Повідомник',
        oneclick_convert: 'Конвертувати в один клік',
        assembly: 'Вузол',
        show_original: 'Показати оригінал',
        sync_datong: 'Синхронізувати з Datong',
        system_category_iii: 'Категорія системи III',
        maxus_Records: 'Записи розмов MAXUS',
    },
    // 希腊语
    elGR: {
        vin: 'VIN',
        inquiry_no: 'Αριθμός περίπτωσης',
        case_theme: 'Θέμα περίπτωσης',
        department_name: 'Όνομα τμήματος',
        department_type: 'Τύπος τμήματος',
        document_status: 'Κατάσταση εγγράφου',
        inquiry_date: 'Ημερομηνία ερώτησης',
        organization_name: 'Όνομα οργανισμού',
        name: 'Όνομα προτείνοντος',
        sap_code: 'Κωδικός SAP',
        failed_part: 'Ελαττωματικό εξάρτημα',
        case_type: 'Τύπος περίπτωσης',
        vehicle_status: 'Κατάσταση επισκευής',
        case_owner: 'Υπεύθυνος',
        country: 'Χώρα',
        fault_cause: 'Αιτία βλάβης',
        symptoms: 'Συμπτώματα βλάβης',
        is_the_document_qualified: 'Είναι το έγγραφο επικυρωμένο;',
        is_the_document_replied_in_a_timely_manner: 'Έχει απαντηθεί το έγγραφο εγκαίρως;',
        filter: 'Φίλτρο',
        system_classification_I: 'Συστηματική ταξινόμηση I',
        system_classification_II: 'Συστηματική ταξινόμηση II',
        full_query: 'Πλήρης αναζήτηση',
        fuzzy_query: 'Ασαφής αναζήτηση',
        whether_belongs_new_car_market: 'Αναφέρεται σε νέα κυκλοφορία αυτοκινήτου;',
        caseStatus: 'Κατάσταση περίπτωσης',
        correct: 'Ναι',
        deny: 'Όχι',
        not_closed: 'Δεν έχει κλείσει',
        no_reply: 'Χωρίς απάντηση',
        replied: 'Відповіли',
        closed: 'Закрито',
        drafts: 'Чернетки',
        create_time: 'Час створення',
        create_user: 'Автор',
        parent_of_document: 'Батьківський документ',
        document_owner: 'Власник документа',
        case_subject: 'Тема випадку',
        receipt_info: 'Інформація про отримання',
        superior_of_case: 'Вищий рівень випадку',
        inquiry_time: 'Час запиту',
        status: 'Статус',
        overseas_company: 'Назва закордонної компанії',
        general_agent_name: 'Ім\'я генерального агента',
        dealer_code: 'Код дилера',
        dealer_name: 'Ім\'я дилера',
        name_of_subsidiary: 'Назва дочірньої компанії',
        contacts: 'Контакти',
        contact_information: 'Контактна інформація',
        training_certification: 'Сертифікат навчання',
        driving_mileage: 'Пробіг',
        plate_number: 'Номерний знак',
        material_no: 'Номер матеріалу',
        material_desc: 'Опис матеріалу',
        offline_date: 'Дата зняття з виробництва',
        model_platform: 'Платформа моделі',
        engine_number: 'Номер двигуна',
        transmission_type: 'Тип трансмісії',
        assembly_no: 'Номер збірки',
        fault_info_desc: 'Опис інформації про несправність',
        fault_handle_process: 'Διαδικασία χειρισμού βλάβης',
        solution: 'Λύση',
        remark: 'Σχόλιο',
        caseRemark: 'Σχόλιο περίπτωσης',
        document_information: 'Πληροφορίες εγγράφου',
        basic_information_of_service_center: 'Βασικές πληροφορίες κέντρου σέρβις',
        basic_vehicle_information: 'Βασικές πληροφορίες οχήματος',
        problem_description: 'Περιγραφή προβλήματος',
        common_links: 'Συνηθισμένοι σύνδεσμοι',
        claim_information: 'Πληροφορίες διεκδίκησης',
        diagnostic_report_record: 'Αρχείο διαγνωστικής έκθεσης',
        vehicle_history: 'Έγγραφα ερωτήματος ιστορικού οχήματος',
        programming_history: 'Ιστορικό προγραμματισμού',
        vehicle_sales_logistics_information: 'Πληροφορίες πώλησης και λογιστικής οχήματος',
        new_vehicle_information: 'Νέες πληροφορίες οχήματος',
        attachment_upload: 'Μεταφόρτωση συνημμένων',
        diagnostic_report: 'Διαγνωστική έκθεση',
        bulk_download: 'Μαζική λήψη',
        document_View: 'Προβολή εγγράφου',
        inquiry_content: 'Περιεχόμενο ερωτήματος',
        inquiry_entry: 'Καταχώριση ερωτήματος',
        subordinate_record: 'Εγγραφή ερωτήσεων και απαντήσεων υφισταμένων',
        superior_record: 'Εγγραφή ερωτήσεων και απαντήσεων ανωτέρων',
        send_content: 'Απεσταλμένο περιεχόμενο',
        send_time: 'Ώρα αποστολής',
        sent_username: 'Αποστολέας',
        receive_name: 'Απεστάλη σε',
        dept_name: 'Επίπεδο',
        enclosure: 'Συνημμένο',
        wind_case: 'Κλείσιμο υπόθεσης',
        close_order: 'Κλείσιμο παραγγελίας',
        case_reporting: 'Αναφορά υπόθεσης',
        pdf_preview: 'Προεπισκόπηση PDF',
        SIS_maintenance: 'Συντήρηση σοβαρών ατυχημάτων',
        Please_fill_in_the_inquiry_content: 'Συμπληρώστε το περιεχόμενο του ερωτήματος',
        sending_an_email: 'Αποστολή email',
        copy: 'Αντιγραφή',
        repeat: 'Επαναλαμβανόμενο VIN',
        inconsistent: 'Ασυνέπεια πλατφόρμας μοντέλου οχήματος',
        sendTo: 'Αποστολή σε',
        reply: 'Εισαγάγετε περιεχόμενο για ερώτηση/απάντηση',
        please_check_the_exported_document: 'Παρακαλούμε επιλέξτε το εξαγόμενο έγγραφο',
        please_upload_diagnostic_report: 'Παρακαλούμε ανεβάστε τη διαγνωστική αναφορά',
        please_enter_the_vin: 'Παρακαλούμε εισαγάγετε τον αριθμό VIN',
        placeholderDTC: 'Παράδειγμα: P080800_P087D00_------',
        placeholderFaultInfoDesc:
            '1. Επαληθεύστε το πρόβλημα που ανέφερε ο πελάτης (μόνο για να βεβαιωθείτε ότι το πρόβλημα πράγματι υπήρξε)',
        placeholderFaultHandleProcess:
            '2. Προσδιορίστε τα σχετικά συμπτώματα (βρείτε και καταγράψτε όλα τα συμπτώματα που μπορεί να σχετίζονται με το πρόβλημα)\n3. Αναλύστε τα συμπτώματα (παρατηρήστε προσεκτικά τα σχετικά συμπτώματα για να εντοπίσετε κοινές αιτίες)\n4. Επιβεβαιώστε το πρόβλημα (περιορίστε τα αποτελέσματά σας για να βεβαιωθείτε ότι λύνετε το σωστό πρόβλημα)',
        placeholderSolution:
            '5. Διορθώστε το πρόβλημα (πραγματοποιήστε την επισκευή)\n6. Επαληθεύστε τη λειτουργία του οχήματος (ελέγξτε ότι η επισκευή σας έχει επιλύσει το πρόβλημα)',
        placeholderRemark: 'Π.χ.: Τιμόνι - 201806, Αμορτισέρ μπροστινό αριστερό - 2010101',
        placeholderContact: 'Εισαγάγετε το όνομα του χειριστή',
        close_time: 'Ώρα κλεισίματος',
        one_touch: 'Επαναδημιουργία εγγράφου',
        confirm_generating_new_case: 'Είστε βέβαιοι ότι θέλετε να δημιουργήσετε νέο έγγραφο;',
        closing_statement: 'Σχόλιο κλεισίματος',
        number_of_cases: 'Αριθμός εγγράφων',
        number_of_vehicles: 'Αριθμός οχημάτων',
        pleaseEnterContent: 'Παρακαλούμε εισαγάγετε περιεχόμενο',
        case_age: 'Ηλικία υπόθεσης',
        last_response_time: 'Ώρα τελευταίας απάντησης',
        time_since_last_response: 'Χρόνος από την τελευταία απάντηση',
        warranty_start_date: 'Ημερομηνία έναρξης εγγύησης',
        submit_reason: 'Αιτιολογία υποβολής',
        synchronize_PQCP: 'Συγχρονισμός PQCP',
        FPR_export: 'Εξαγωγή FPR',
        level_selection: 'Επιλογή επιπέδου',
        category_selection: 'Επιλογή κατηγορίας',
        brand_selection: 'Επιλογή μάρκας',
        code: 'Κωδικός',
        description: 'Περιγραφή',
        major_complaints: 'Σοβαρές παράπονα',
        difficult_miscellaneous_diseases: 'Περίπλοκα και σπάνια προβλήματα',
        emerging_issues: 'Νέα προβλήματα',
        breakpoint_failure: 'Αποτυχία σημείου διακοπής',
        general_complaints: 'Γενική καταγγελία',
        other: 'Άλλο',
        roewe: 'Roewe',
        mg: 'MG',
        serious: 'Σοβαρό',
        secondary: 'Δευτερεύον',
        generally: 'Γενικά',
        complete: 'Ολοκληρωμένο',
        please_select_level: 'Επιλέξτε επίπεδο',
        please_select_category: 'Επιλέξτε κατηγορία',
        please_select_brand: 'Επιλέξτε μάρκα',
        placeholder_auto: 'Συμπληρώνεται αυτόματα',
        translate: 'Μετάφραση',
        isTranslate: 'Να μεταφραστεί ή όχι;',
        day: 'ημέρα',
        one_click_order: 'Κλείσιμο παραγγελίας με ένα κλικ',
        greater_than: 'Μεγαλύτερο από',
        less_than: 'Μικρότερο από',
        between: 'Μεταξύ',
        document_label: 'Ετικέτα εγγράφου',
        receipts_first_modification_time: 'Ώρα πρώτης τροποποίησης εγγράφου',
        Selection_of_Document_Owner: 'Επιλογή υπεύθυνου εγγράφου',
        responsiblePerson: 'Υπεύθυνος:',
        functional_Domain: 'Λειτουργικός τομέας',
        Category: 'Κατηγορία',
        property: 'Ιδιότητα',
        reRepair: 'Επαναλαμβανόμενη επισκευή',
        pullInNum: 'Αριθμός επισκέψεων στο συνεργείο',
        perception: 'Αντιληπτικό',
        onSupport: 'Απαιτείται υποστήριξη επιτόπου;',
        batteryNo: 'Αριθμός μπαταρίας',
        normalStartDate: 'Ημερομηνία έναρξης εγγύησης',
        qmotorNo: 'Αριθμός μπροστινού κινητήρα',
        hmotorNo: 'Αριθμός πίσω κινητήρα',
        fault_cause_type: 'Τύπος αιτίας βλάβης',
        measure_name: 'Όνομα μέτρου',
        part_name: 'Όνομα εξαρτήματος',
        close_order_notification: 'Το κλείσιμο της παραγγελίας απαιτεί απάντηση στον προτείνοντα',
        TIS_Case_Data: 'Δεδομένα περίπτωσης TIS',
        case_File: 'Αρχείο περίπτωσης',
        responsibility_Data: 'Δεδομένα κατανομής ευθύνης',
        longterm_Measures: 'Μέτρα μακράς διάρκειας',
        tisCaseNo: 'Αριθμός περίπτωσης TIS',
        vehGlobalFwVer: 'Έκδοση λογισμικού ολόκληρου του οχήματος',
        vehGlobalFwPn: 'Αριθμός ανταλλακτικού λογισμικού ολόκληρου του οχήματος',
        archivesNo: 'Αριθμός αρχείου',
        archivesTitle: 'Τίτλος αρχείου',
        archivesSource: 'Πηγή αρχείου',
        proposer: 'Προτείνων',
        proposedTime: 'Ημερομηνία υποβολής',
        archivesManagementPersonnel: 'Προσωπικό διαχείρισης αρχείων',
        functionalMode: 'Λειτουργική μονάδα',
        supplier: 'Προμηθευτής',
        accessoriesInvolved: 'Εμπλέκονται αξεσουάρ;',
        functionalDomain: 'Λειτουργικός τομέας',
        invalidPartId: 'Μη έγκυρο εξάρτημα',
        archivesType: 'Τύπος αρχείου',
        archivesGrade: 'Βαθμίδα αρχείου',
        problemDescription: 'Περιγραφή προβλήματος',
        analysisProgress: 'Πρόοδος ανάλυσης',
        qaRemark: 'Σχόλιο QA',
        tacRemark: 'Σχόλιο TAC',
        responsibleDepartment: 'Υπεύθυνο τμήμα',
        coordinator: 'Συντονιστής',
        principal: 'Κύριος υπεύθυνος',
        containmentAction: 'Μέτρα περιορισμού',
        issueStatus: 'Κατάσταση προβλήματος',
        softwareProblems: 'Προβλήματα λογισμικού',
        vehGlobalFwVer_j: 'Βασική έκδοση',
        vehGlobalFwPn_j: 'Βασικός αριθμός εξαρτήματος',
        ewo: 'Αριθμός EWO',
        rootCause: 'Θεμελιώδης αιτία',
        marketBehavior: 'Συμπεριφορά αγοράς',
        shortTermMeasures: 'Μέτρα βραχυπρόθεσμα',
        shortTermBreakpointDescription: 'Περιγραφή σημείου διακοπής βραχυπρόθεσμων μέτρων',
        measuresResult: 'Αποτέλεσμα έγκρισης μέτρων',
        measuresConfirmation: 'Επιβεβαίωση μέτρων',
        longTermMeasures: 'Μέτρα μακράς διάρκειας',
        longTermMeasuresBreak: 'Εκτιμώμενη περιγραφή σημείου διακοπής μέτρων μακράς διάρκειας',
        implementation: 'Έχει εφαρμοστεί;',
        longMeasuresTime: 'Πραγματική ημερομηνία σημείου διακοπής μέτρων μακράς διάρκειας',
        vinBreak: 'VIN σημείου διακοπής μέτρων μακράς διάρκειας',
        breakpointImplementationPhase: 'Φάση εφαρμογής σημείου διακοπής',
        archive_Information: 'Πληροφορίες αρχείου',
        reason_incomplete_closure: 'Αιτία κλεισίματος χωρίς ολοκλήρωση',
        entry_Date: 'Ημερομηνία εισόδου',
        departure_date: 'Ημερομηνία εξόδου',
        work_order_number: 'Αριθμός εντολής εργασίας',
        questionnaire_usage: 'Σκοπός ερωτηματολογίου',
        classification_of_technical_enquiries: 'Ταξινόμηση τεχνικών ερωτημάτων',
        change_of_document_owner: 'Αλλαγή ιδιοκτήτη εγγράφου',
        oldowner: 'Παλιός Ιδιοκτήτης',
        newowner: 'Νέος Ιδιοκτήτης',
        original: 'Πρωτότυπο',
        translation: 'Μετάφραση',
        dealer_address: 'Διεύθυνση αντιπροσώπου',
        sel_up_engineers: 'Μπορείτε να επιλέξετε έως 12 μηχανικούς!',
        sel_up_weeks: 'Μπορείτε να επιλέξετε έως 12 εβδομάδες!',
        veh_infor_inquiry: 'Ερώτημα πληροφοριών οχήματος',
        create_organization: 'Δημιουργία οργανισμού',
        ref_code: 'Λήψη νέου κωδικού επαλήθευσης',
        fault_complaint_Desp: 'Περιγραφή βλάβης / Περιγραφή παράπονου πελάτη',
        broken_down_vehicle: 'Το όχημα έχει βλάβη;',
        reporting_organization: 'Αναφέρουσα οργάνωση',
        reporter: 'Αναφέρων',
        oneclick_convert: 'Μετατροπή με ένα κλικ',
        assembly: 'Συναρμολογημένο σύνολο',
        show_original: 'Εμφάνιση πρωτοτύπου',
        sync_datong: 'Συγχρονισμός με Datong',
        system_category_iii: 'Κατηγορία συστήματος III',
        maxus_Records: 'Αρχεία συνομιλιών MAXUS',
    },
    // 爱沙尼亚
    etEE: {
        vin: 'VIN',
        inquiry_no: 'Juhtumi number',
        case_theme: 'Juhtumi teema',
        department_name: 'Osakonna nimi',
        department_type: 'Osakonna tüüp',
        document_status: 'Dokumendi olek',
        inquiry_date: 'Päringu kuupäev',
        organization_name: 'Organisatsiooni nimi',
        name: 'Ettepaneku esitaja nimi',
        sap_code: 'SAP kood',
        failed_part: 'Rikkinud detail',
        case_type: 'Juhtumi tüüp',
        vehicle_status: 'Remondi staatus',
        case_owner: 'Vastutaja',
        country: 'Riik',
        fault_cause: 'Vea põhjus',
        symptoms: 'Vea sümptomid',
        is_the_document_qualified: 'Kas dokument on kvalifitseeritud?',
        is_the_document_replied_in_a_timely_manner: 'Kas dokumendile vastati õigeaegselt?',
        filter: 'Filter',
        system_classification_I: 'Süsteemi klassifikatsioon I',
        system_classification_II: 'Süsteemi klassifikatsioon II',
        full_query: 'Täielik päring',
        fuzzy_query: 'Uduine päring',
        whether_belongs_new_car_market: 'Kas kuulub uue auto turuletoomisele?',
        caseStatus: 'Juhtumi olek',
        correct: 'Jah',
        deny: 'Ei',
        not_closed: 'Mitte suletud',
        no_reply: 'Vastus puudub',
        replied: 'Vastatud',
        closed: 'Suletud',
        drafts: 'Mustandid',
        create_time: 'Loomise aeg',
        create_user: 'Looja',
        parent_of_document: 'Ülem-dokument',
        document_owner: 'Dokumendi omanik',
        case_subject: 'Juhtumi teema',
        receipt_info: 'Vastuvõtu info',
        superior_of_case: 'Ülem-juhtum',
        inquiry_time: 'Päringu aeg',
        status: 'Olek',
        overseas_company: 'Välisettevõtte nimi',
        general_agent_name: 'Peaagenti nimi',
        dealer_code: 'Edasimüüja kood',
        dealer_name: 'Edasimüüja nimi',
        name_of_subsidiary: 'Tütarettevõtte nimi',
        contacts: 'Kontaktid',
        contact_information: 'Kontaktandmed',
        training_certification: 'Koolitussertifikaat',
        driving_mileage: 'Sõidetud kilomeetrid',
        plate_number: 'Numbrimärk',
        material_no: 'Materjali number',
        material_desc: 'Materjali kirjeldus',
        offline_date: 'Tootmiselt väljastamise kuupäev',
        model_platform: 'Mudeli platvorm',
        engine_number: 'Mootori number',
        transmission_type: 'Käigukasti tüüp',
        assembly_no: 'Koostenummer',
        fault_info_desc: 'Vigadeave kirjeldus',
        fault_handle_process: 'Vea käsitlemise protsess',
        solution: 'Lahendus',
        remark: 'Märkus',
        caseRemark: 'Juhtumi märkus',
        document_information: 'Dokumendi teave',
        basic_information_of_service_center: 'Teeninduskeskuse põhiteave',
        basic_vehicle_information: 'Sõiduki põhiteave',
        problem_description: 'Probleemi kirjeldus',
        common_links: 'Levinud lingid',
        claim_information: 'Garantiinõude teave',
        diagnostic_report_record: 'Diagnostikaraporti kirje',
        vehicle_history: 'Sõiduki ajaloo päringudokumendid',
        programming_history: 'Programmeerimise ajalugu',
        vehicle_sales_logistics_information: 'Sõiduki müügi ja logistika teave',
        new_vehicle_information: 'Uus sõidukiteave',
        attachment_upload: 'Manuste üleslaadimine',
        diagnostic_report: 'Diagnostikaraport',
        bulk_download: 'Hulgilaadimine',
        document_View: 'Dokumendi vaade',
        inquiry_content: 'Päringu sisu',
        inquiry_entry: 'Päringu sisestus',
        subordinate_record: 'Alluvate küsimuste ja vastuste logi',
        superior_record: 'Ülemiste küsimuste ja vastuste logi',
        send_content: 'Saadetud sisu',
        send_time: 'Saatmise aeg',
        sent_username: 'Saatja',
        receive_name: 'Saadetud adressaadile',
        dept_name: 'Tase',
        enclosure: 'Manus',
        wind_case: 'Juhtumi sulgemine',
        close_order: 'Tellimuse sulgemine',
        case_reporting: 'Juhtumi teatamine',
        pdf_preview: 'PDF-i eelvaade',
        SIS_maintenance: 'Tõsiste õnnetuste hooldus',
        Please_fill_in_the_inquiry_content: 'Palun täitke päringu sisu',
        sending_an_email: 'Meili saatmine',
        copy: 'Kopeeri',
        repeat: 'VIN kordub',
        inconsistent: 'Sõiduki mudeli platvorm pole ühtlane',
        sendTo: 'Saada adressaadile',
        reply: 'Sisestage sisu päringuks/vastuseks',
        please_check_the_exported_document: 'Palun märkige eksportitud dokument',
        please_upload_diagnostic_report: 'Palun laadige üles diagnostikaraport',
        please_enter_the_vin: 'Palun sisestage VIN',
        placeholderDTC: 'Näide: P080800_P087D00_------',
        placeholderFaultInfoDesc:
            '1. Kinnitage kliendi teatatud probleem (ainult selleks, et veenduda, et probleem esines)',
        placeholderFaultHandleProcess:
            '2. Tuvastage seotud sümptomid (leidke ja salvestage kõik sümptomid, mis võivad olla probleemiga seotud)\n3. Analüüsige sümptomeid (vaadake hoolikalt seotud sümptomeid, et tuvastada levinud põhjused)\n4. Kinnitage probleem (piirake oma tulemusi, et veenduda, et lahendate õiget probleemi)',
        placeholderSolution:
            '5. Parandage probleem (teostage remont)\n6. Kontrollige sõiduki tööd (veenduge, et teie remont on probleemi lahendanud)',
        placeholderRemark:
            'Näiteks: Juhtimismehhanism - 201806, Esimene vasak amortisaator - 2010101',
        placeholderContact: 'Sisestage operaatori nimi',
        close_time: 'Sulgemisaeg',
        one_touch: 'Dokumendi taasloomine',
        confirm_generating_new_case: 'Kas soovite kindlasti luua uue dokumendi?',
        closing_statement: 'Sulgemise selgitus',
        number_of_cases: 'Dokumentide arv',
        number_of_vehicles: 'Sõidukite arv',
        pleaseEnterContent: 'Palun sisestage sisu',
        case_age: 'Juhtumi vanus',
        last_response_time: 'Viimase vastuse aeg',
        time_since_last_response: 'Aeg viimasest vastusest',
        warranty_start_date: 'Garantii alguskuupäev',
        submit_reason: 'Esitamise põhjus',
        synchronize_PQCP: 'Sünkrooni PQCP',
        FPR_export: 'FPR eksport',
        level_selection: 'Taseme valik',
        category_selection: 'Kategooria valik',
        brand_selection: 'Brändi valik',
        code: 'Kood',
        description: 'Kirjeldus',
        major_complaints: 'Olulised kaebused',
        difficult_miscellaneous_diseases: 'Keerukad ja haruldased rikkejuhtumid',
        emerging_issues: 'Uued probleemid',
        breakpoint_failure: 'Katkestuspunkti tõrge',
        general_complaints: 'Üldine kaebus',
        other: 'Muu',
        roewe: 'Roewe',
        mg: 'MG',
        serious: 'Tõsine',
        secondary: 'Teisene',
        generally: 'Üldiselt',
        complete: 'Lõpetatud',
        please_select_level: 'Palun valige tase',
        please_select_category: 'Palun valige kategooria',
        please_select_brand: 'Palun valige bränd',
        placeholder_auto: 'Täidetakse automaatselt',
        translate: 'Tõlkida',
        isTranslate: 'Kas tõlkida?',
        day: 'päev',
        one_click_order: 'Sule tellimus ühe klõpsuga',
        greater_than: 'Suurem kui',
        less_than: 'Väiksem kui',
        between: 'Vahel',
        document_label: 'Dokumendi silt',
        receipts_first_modification_time: 'Dokumendi esimese muutmise aeg',
        Selection_of_Document_Owner: 'Dokumendi vastutaja valik',
        responsiblePerson: 'Vastutaja:',
        functional_Domain: 'Funktsionaalne domeen',
        Category: 'Kategooria',
        property: 'Omadus',
        reRepair: 'Korduv remont',
        pullInNum: 'Teeninduskordade arv',
        perception: 'Tajumisega seotud',
        onSupport: 'Kas nõuab kohapealist toetust?',
        batteryNo: 'Akunumber',
        normalStartDate: 'Garantiiaeg alguskuupäev',
        qmotorNo: 'Esiosa mootori number',
        hmotorNo: 'Tagumise mootori number',
        fault_cause_type: 'Vea põhjuse tüüp',
        measure_name: 'Meetme nimi',
        part_name: 'Osa nimi',
        close_order_notification: 'Tellimuse sulgemine nõuab vastust ettepaneku esitajale',
        TIS_Case_Data: 'TIS juhtumi andmed',
        case_File: 'Juhtumi arhiiv',
        responsibility_Data: 'Vastutuse andmed',
        longterm_Measures: 'Pikaajalised meetmed',
        tisCaseNo: 'TIS-juhtumi number',
        vehGlobalFwVer: 'Sõiduki täieliku tarkvara versioon',
        vehGlobalFwPn: 'Sõiduki täieliku tarkvara osa number',
        archivesNo: 'Arhiivi number',
        archivesTitle: 'Arhiivi pealkiri',
        archivesSource: 'Arhiivi allikas',
        proposer: 'Ettepaneku esitaja',
        proposedTime: 'Ettepaneku esitamise kuupäev',
        archivesManagementPersonnel: 'Arhiivi haldur',
        functionalMode: 'Funktsionaalne moodul',
        supplier: 'Tarnija',
        accessoriesInvolved: 'Kas puudutab lisavarustust?',
        functionalDomain: 'Funktsionaalne domeen',
        invalidPartId: 'Vigane osa',
        archivesType: 'Arhiivi tüüp',
        archivesGrade: 'Arhiivi tase',
        problemDescription: 'Probleemi kirjeldus',
        analysisProgress: 'Analüüsi edenemine',
        qaRemark: 'QA märkus',
        tacRemark: 'TAC märkus',
        responsibleDepartment: 'Vastutav osakond',
        coordinator: 'Koordinaator',
        principal: 'Peamine vastutaja',
        containmentAction: 'Piirangu meetmed',
        issueStatus: 'Probleemi staatus',
        softwareProblems: 'Tarkvaraprobleemid',
        vehGlobalFwVer_j: 'Baasversioon',
        vehGlobalFwPn_j: 'Baasosa number',
        ewo: 'EWO number',
        rootCause: 'Põhjus',
        marketBehavior: 'Turukäitumine',
        shortTermMeasures: 'Lühiajalised meetmed',
        shortTermBreakpointDescription: 'Lühiajaliste meetmete katkepunkti kirjeldus',
        measuresResult: 'Meetmete heakskiidu tulemus',
        measuresConfirmation: 'Meetmete kinnituse selgitus',
        longTermMeasures: 'Pikaajalised meetmed',
        longTermMeasuresBreak: 'Pikaajaliste meetmete hinnanguline katkepunkti kirjeldus',
        implementation: 'Kas rakendatud?',
        longMeasuresTime: 'Pikaajaliste meetmete tegelik katkepunkti kuupäev',
        vinBreak: 'Pikaajaliste meetmete katkepunkti VIN',
        breakpointImplementationPhase: 'Katkepunkti rakendamise etapp',
        archive_Information: 'Arhiivi teave',
        reason_incomplete_closure: 'Põhjus mittelõpetatud sulgemiseks',
        entry_Date: 'Teenindusse sisenemise kuupäev',
        departure_date: 'Teenindusest lahkumise kuupäev',
        work_order_number: 'Töökorralduse number',
        questionnaire_usage: 'Küsimustiku eesmärk',
        classification_of_technical_enquiries: 'Tehniliste päringute klassifikatsioon',
        change_of_document_owner: 'Dokumendi omaniku muutmine',
        oldowner: 'Vana omanik',
        newowner: 'Uus omanik',
        original: 'Originaal',
        translation: 'Tõlge',
        dealer_address: 'Edasimüüja aadress',
        sel_up_engineers: 'Saate valida kuni 12 inseneri!',
        sel_up_weeks: 'Saate valida kuni 12 nädalat!',
        veh_infor_inquiry: 'Sõidukiandmete päring',
        create_organization: 'Loo organisatsioon',
        ref_code: 'Hangi värskendatud kinnituskood',
        fault_complaint_Desp: 'Vea kirjeldus / Kliendi kaebuse kirjeldus',
        broken_down_vehicle: 'Kas sõiduk on rikki jäänud?',
        reporting_organization: 'Teavitav organisatsioon',
        reporter: 'Teavitaja',
        oneclick_convert: 'Teisenda ühe klõpsuga',
        assembly: 'Koost',
        show_original: 'Kuva originaal',
        sync_datong: 'Sünkrooni Datongiga',
        system_category_iii: 'Süsteemi kategooria III',
        maxus_Records: 'MAXUS vestluskirjed',
    },
    // 哈萨克
    kkKZ: {
        vin: 'VIN',
        inquiry_no: 'Сұрақ қағазының нөмірі',
        case_theme: 'Жағдайдың тақырыбы',
        department_name: 'Бөлім атауы',
        department_type: 'Бөлім түрі',
        document_status: 'Құжат күйі',
        inquiry_date: 'Сұрақ берілген күні',
        organization_name: 'Ұйым атауы',
        name: 'Ұсыныс жасаушының атауы',
        sap_code: 'SAP коды',
        failed_part: 'Сәтсіз болған бөлшек',
        case_type: 'Жағдай түрі',
        vehicle_status: 'Жөндеу күйі',
        case_owner: 'Жауапты тұлға',
        country: 'Ел',
        fault_cause: 'Ақау себебі',
        symptoms: 'Ақау белгілері',
        is_the_document_qualified: 'Құжат сапалы ма?',
        is_the_document_replied_in_a_timely_manner: 'Құжатқа уақытында жауап берілді ме?',
        filter: 'Сүзгі',
        system_classification_I: 'Жүйелік классификация I',
        system_classification_II: 'Жүйелік классификация II',
        full_query: 'Толық сұраныс',
        fuzzy_query: 'Жуық сұраныс',
        whether_belongs_new_car_market: 'Жаңа автокөліктің шығарылуына жатады ма?',
        caseStatus: 'Жағдай күйі',
        correct: 'Иә',
        deny: 'Жоқ',
        not_closed: 'Жабылмаған',
        no_reply: 'Жауап берілмеді',
        replied: 'Жауап берілді',
        closed: 'Жабылды',
        drafts: 'Қораптағы құжаттар',
        create_time: 'Құру уақыты',
        create_user: 'Құрушы',
        parent_of_document: 'Жоғары деңгейлі құжат',
        document_owner: 'Құжат иесі',
        case_subject: 'Жағдай тақырыбы',
        receipt_info: 'Қабылдау ақпараты',
        superior_of_case: 'Жоғары деңгейлі жағдай',
        inquiry_time: 'Сұрақ берілген уақыт',
        status: 'Күйі',
        overseas_company: 'Шетелдегі компанияның атауы',
        general_agent_name: 'Жалпы агент атауы',
        dealer_code: 'Дилер коды',
        dealer_name: 'Дилер атауы',
        name_of_subsidiary: 'Қызметкер компанияның атауы',
        contacts: 'Байланыс тұлғалары',
        contact_information: 'Байланыс ақпараты',
        training_certification: 'Оқыту сертификаты',
        driving_mileage: 'Жүрген жолы',
        plate_number: 'Номер таңбасы',
        material_no: 'Материал нөмірі',
        material_desc: 'Материал сипаттамасы',
        offline_date: 'Өндіруден шығарылған күні',
        model_platform: 'Модель платформасы',
        engine_number: 'Қозғалтқыш нөмірі',
        transmission_type: 'Беріліс қорабы түрі',
        assembly_no: 'Жинақтау нөмірі',
        fault_info_desc: 'Ақаулық ақпаратының сипаттамасы',
        fault_handle_process: 'Ақаулықты өңдеу процесі',
        solution: 'Шешім',
        remark: 'Ескерту',
        caseRemark: 'Жағдайға ескерту',
        document_information: 'Құжат ақпараты',
        basic_information_of_service_center: 'Қызмет көрсету орталығының негізгі ақпараты',
        basic_vehicle_information: 'Көліктің негізгі ақпараты',
        problem_description: 'Мәселені сипаттау',
        common_links: 'Жиі қолданылатын сілтемелер',
        claim_information: 'Талап ақпараты',
        diagnostic_report_record: 'Диагностикалық есеп жазбасы',
        vehicle_history: 'Көлік тарихын сұрау құжаттары',
        programming_history: 'Бағдарламалау тарихы',
        vehicle_sales_logistics_information: 'Көлік сатуы мен логистика ақпараты',
        new_vehicle_information: 'Жаңа көлік ақпараты',
        attachment_upload: 'Салынымдарды жүктеу',
        diagnostic_report: 'Диагностикалық есеп',
        bulk_download: 'Топтап жүктеп алу',
        document_View: 'Құжатты қарау',
        inquiry_content: 'Сұрау мазмұны',
        inquiry_entry: 'Сұрақты енгізу',
        subordinate_record: 'Төменгі деңгейдегі сұрақ-жауап жазбалары',
        superior_record: 'Жоғары деңгейдегі сұрақ-жауап жазбалары',
        send_content: 'Жіберілген мазмұн',
        send_time: 'Жіберу уақыты',
        sent_username: 'Жіберуші',
        receive_name: 'Қабылдаушы',
        dept_name: 'Деңгей',
        enclosure: 'Қосымша',
        wind_case: 'Істі жабу',
        close_order: 'Тапсырысты жабу',
        case_reporting: 'Оқиға туралы хабарлау',
        pdf_preview: 'PDF алдын ала қарау',
        SIS_maintenance: 'Ауыр аварияларды қызмет көрсету',
        Please_fill_in_the_inquiry_content: 'Сұрау мазмұнын толтырыңыз',
        sending_an_email: 'Электрондық поштаны жіберу',
        copy: 'Көшіру',
        repeat: 'VIN қайталануы',
        inconsistent: 'Көлік моделінің платформасы сәйкес емес',
        sendTo: 'Жіберу',
        reply: 'Sisestage sisu päringuks/vastuseks',
        please_check_the_exported_document: 'Palun märkige eksportitud dokument',
        please_upload_diagnostic_report: 'Palun laadige üles diagnostikaraport',
        please_enter_the_vin: 'Palun sisestage VIN',
        placeholderDTC: 'Näide: P080800_P087D00_------',
        placeholderFaultInfoDesc:
            '1. Kinnitage kliendi teatatud probleem (ainult selleks, et veenduda, et probleem esines)',
        placeholderFaultHandleProcess:
            '2. Tuvastage seotud sümptomid (leidke ja salvestage kõik sümptomid, mis võivad olla probleemiga seotud)\n3. Analüüsige sümptomeid (vaadake hoolikalt seotud sümptomeid, et tuvastada levinud põhjused)\n4. Kinnitage probleem (piirake oma tulemusi, et veenduda, et lahendate õiget probleemi)',
        placeholderSolution:
            '5. Parandage probleem (teostage remont)\n6. Kontrollige sõiduki tööd (veenduge, et teie remont on probleemi lahendanud)',
        placeholderRemark:
            'Näiteks: Juhtimismehhanism - 201806, Esimene vasak amortisaator - 2010101',
        placeholderContact: 'Sisestage operaatori nimi',
        close_time: 'Sulgemisaeg',
        one_touch: 'Dokumendi taasloomine',
        confirm_generating_new_case: 'Kas soovite kindlasti luua uue dokumendi?',
        closing_statement: 'Sulgemise selgitus',
        number_of_cases: 'Dokumentide arv',
        number_of_vehicles: 'Sõidukite arv',
        pleaseEnterContent: 'Palun sisestage sisu',
        case_age: 'Juhtumi vanus',
        last_response_time: 'Viimase vastuse aeg',
        time_since_last_response: 'Aeg viimasest vastusest',
        warranty_start_date: 'Garantii alguskuupäev',
        submit_reason: 'Esitamise põhjus',
        synchronize_PQCP: 'Sünkrooni PQCP',
        FPR_export: 'FPR eksport',
        level_selection: 'Taseme valik',
        category_selection: 'Kategooria valik',
        brand_selection: 'Brändi valik',
        code: 'Kood',
        description: 'Kirjeldus',
        major_complaints: 'Olulised kaebused',
        difficult_miscellaneous_diseases: 'Keerukad ja haruldased rikkejuhtumid',
        emerging_issues: 'Uued probleemid',
        breakpoint_failure: 'Katkestuspunkti tõrge',
        general_complaints: 'Жалпы шағым',
        other: 'Басқа',
        roewe: 'Roewe',
        mg: 'MG',
        serious: 'Ауыр',
        secondary: 'Қосымша',
        generally: 'Жалпы',
        complete: 'Аяқталды',
        please_select_level: 'Деңгейді таңдаңыз',
        please_select_category: 'Санатты таңдаңыз',
        please_select_brand: 'Брендті таңдаңыз',
        placeholder_auto: 'Автоматты түрде толтырылады',
        translate: 'Аудару',
        isTranslate: 'Аударылсын ба?',
        day: 'күн',
        one_click_order: 'Бір шертумен тапсырысты жабу',
        greater_than: 'Одан үлкен',
        less_than: 'Одан кіші',
        between: 'Арасында',
        document_label: 'Құжат белгісі',
        receipts_first_modification_time: 'Құжаттың алғашқы өзгертілу уақыты',
        Selection_of_Document_Owner: 'Құжат жауапкерін таңдау',
        responsiblePerson: 'Жауапты тұлға:',
        functional_Domain: 'Функционалды аймақ',
        Category: 'Санат',
        property: 'Қасиет',
        reRepair: 'Қайталанатын жөндеу',
        pullInNum: 'СТО-ға келу саны',
        perception: 'Қабылдауға байланысты',
        onSupport: 'Орында қолдау керек пе?',
        batteryNo: 'Аккумулятор нөмірі',
        normalStartDate: 'Кепілдік мерзімінің басталу күні',
        qmotorNo: 'Алдыңғы мотор нөмірі',
        hmotorNo: 'Артқы мотор нөмірі',
        fault_cause_type: 'Ақау себебінің түрі',
        measure_name: 'Шара атауы',
        part_name: 'Бөлшек атауы',
        close_order_notification: 'Тапсырысты жабу ұсыныс жасаушыға жауап беруді қажет етеді',
        TIS_Case_Data: 'TIS жағдайының деректері',
        case_File: 'Жағдай файлы',
        responsibility_Data: 'Жауапкершілік мәліметтері',
        longterm_Measures: 'Ұзақ мерзімді шаралар',
        tisCaseNo: 'TIS жағдай нөмірі',
        vehGlobalFwVer: 'Бүкіл көліктің бағдарламалық қамтамасыз ету нұсқасы',
        vehGlobalFwPn: 'Бүкіл көліктің бағдарламалық бөлшегінің нөмірі',
        archivesNo: 'Архив нөмірі',
        archivesTitle: 'Архив атауы',
        archivesSource: 'Архив көзі',
        proposer: 'Ұсынушы',
        proposedTime: 'Ұсынылған күні',
        archivesManagementPersonnel: 'Архив басқарушысы',
        functionalMode: 'Функционалды модуль',
        supplier: 'Жеткізуші',
        accessoriesInvolved: 'Қосалқы бөлшектер қамтылған ба?',
        functionalDomain: 'Функционалды аймақ',
        invalidPartId: 'Жарамсыз бөлшек',
        archivesType: 'Архив түрі',
        archivesGrade: 'Архив деңгейі',
        problemDescription: 'Мәселенің сипаттамасы',
        analysisProgress: 'Талдау барысы',
        qaRemark: 'Сапа кепілдемесі (QA) ескертпесі',
        tacRemark: 'Техникалық қолдау орталығы (TAC) ескертпесі',
        responsibleDepartment: 'Жауапты бөлім',
        coordinator: 'Үйлестіруші',
        principal: 'Басты жауапты',
        containmentAction: 'Шектеу шаралары',
        issueStatus: 'Мәселе күйі',
        softwareProblems: 'Бағдарламалық қамтамасыз ету мәселелері',
        vehGlobalFwVer_j: 'Негізгі нұсқа нөмірі',
        vehGlobalFwPn_j: 'Негізгі бөлшек нөмірі',
        ewo: 'EWO нөмірі',
        rootCause: 'Түбірлі себеп',
        marketBehavior: 'Нарықтағы мінез-құлық',
        shortTermMeasures: 'Қысқа мерзімді шаралар',
        shortTermBreakpointDescription: 'Қысқа мерзімді шаралардың тоқтау нүктесінің сипаттамасы',
        measuresResult: 'Шараларды бекіту нәтижесі',
        measuresConfirmation: 'Шараларды растау туралы түсіндірме',
        longTermMeasures: 'Ұзақ мерзімді шаралар',
        longTermMeasuresBreak: 'Ұзақ мерзімді шаралардың тоқтау нүктесінің бағаланған сипаттамасы',
        implementation: 'Іске асырылды ма?',
        longMeasuresTime: 'Ұзақ мерзімді шаралардың нақты тоқтау күні',
        vinBreak: 'Ұзақ мерзімді шаралардың тоқтау нүктесінің VIN коды',
        breakpointImplementationPhase: 'Тоқтау нүктесін іске асыру кезеңі',
        archive_Information: 'Архив ақпараты',
        reason_incomplete_closure: 'Аяқталмаған жабу себебі',
        entry_Date: 'Келу күні',
        departure_date: 'Кету күні',
        work_order_number: 'Жұмыс тапсырысының нөмірі',
        questionnaire_usage: 'Сауалнаманың мақсаты',
        classification_of_technical_enquiries: 'Техникалық сұрақтардың жіктелуі',
        change_of_document_owner: 'Құжат иесін ауыстыру',
        oldowner: 'Ескі иесі',
        newowner: 'Жаңа иесі',
        original: 'Бастапқы нұсқа',
        translation: 'Аударма',
        dealer_address: 'Дилердің мекенжайы',
        sel_up_engineers: 'Сіз 12 инженерге дейін таңдай аласыз!',
        sel_up_weeks: 'Сіз 12 аптаға дейін таңдай аласыз!',
        veh_infor_inquiry: 'Көлік туралы ақпаратты сұрау',
        create_organization: 'Ұйымды құру',
        ref_code: 'Жаңартылған растау кодын алу',
        fault_complaint_Desp: 'Ақаулық сипаттамасы / Тұтынушының шағымы',
        broken_down_vehicle: 'Көлік тоқтаған ба?',
        reporting_organization: 'Есеп беретін ұйым',
        reporter: 'Есеп беруші',
        oneclick_convert: 'Бір шертумен түрлендіру',
        assembly: 'Түйін',
        show_original: 'Бастапқы нұсқаны көрсету',
        sync_datong: 'Datong-пен синхрондау',
        system_category_iii: 'Жүйе санаты III',
        maxus_Records: 'MAXUS әңгімелесу жазбалары',
    },
    // 希伯来语
    heIL: {
        vin: 'VIN',
        inquiry_no: 'מספר תיק מקרה',
        case_theme: 'נושא המקרה',
        department_name: 'שם המחלקה',
        department_type: 'סוג המחלקה',
        document_status: 'סטטוס המסמך',
        inquiry_date: 'תאריך הפנייה',
        organization_name: 'שם הארגון',
        name: 'שם הגורם המציע',
        sap_code: 'קוד SAP',
        failed_part: 'רכיב כשל',
        case_type: 'סוג המקרה',
        vehicle_status: 'סטטוס תיקון',
        case_owner: 'אחראי',
        country: 'מדינה',
        fault_cause: 'סיבת התקלה',
        symptoms: 'תסמיני תקלה',
        is_the_document_qualified: 'האם המסמך עומד בדרישות?',
        is_the_document_replied_in_a_timely_manner: 'האם נענה למסמך בזמן?',
        filter: 'מסנן',
        system_classification_I: 'סיווג מערכת I',
        system_classification_II: 'סיווג מערכת II',
        full_query: 'שאילתה מלאה',
        fuzzy_query: 'שאילתה מטושטשת',
        whether_belongs_new_car_market: 'האם קשור לשיקול רכב חדש בשוק?',
        caseStatus: 'סטטוס המקרה',
        correct: 'כן',
        deny: 'לא',
        not_closed: 'לא סגור',
        no_reply: 'ללא מענה',
        replied: 'Жауап берілді',
        closed: 'Жабылды',
        drafts: 'Қораптағы құжаттар',
        create_time: 'Құру уақыты',
        create_user: 'Құрушы',
        parent_of_document: 'Жоғары деңгейлі құжат',
        document_owner: 'Құжат иесі',
        case_subject: 'Жағдай тақырыбы',
        receipt_info: 'Қабылдау ақпараты',
        superior_of_case: 'Жоғары деңгейлі жағдай',
        inquiry_time: 'Сұрақ берілген уақыт',
        status: 'Күйі',
        overseas_company: 'Шетелдегі компанияның атауы',
        general_agent_name: 'Жалпы агент атауы',
        dealer_code: 'Дилер коды',
        dealer_name: 'Дилер атауы',
        name_of_subsidiary: 'Қызметкер компанияның атауы',
        contacts: 'Байланыс тұлғалары',
        contact_information: 'Байланыс ақпараты',
        training_certification: 'Оқыту сертификаты',
        driving_mileage: 'Жүрген жолы',
        plate_number: 'Номер таңбасы',
        material_no: 'Материал нөмірі',
        material_desc: 'Материал сипаттамасы',
        offline_date: 'Өндіруден шығарылған күні',
        model_platform: 'Модель платформасы',
        engine_number: 'Қозғалтқыш нөмірі',
        transmission_type: 'Беріліс қорабы түрі',
        assembly_no: 'Жинақтау нөмірі',
        fault_info_desc: 'Ақаулық ақпаратының сипаттамасы',
        fault_handle_process: 'תהליך טיפול בתקלה',
        solution: 'פתרון',
        remark: 'הערה',
        caseRemark: 'הערת מקרה',
        document_information: 'מידע על המסמך',
        basic_information_of_service_center: 'מידע בסיסי על מרכז השירות',
        basic_vehicle_information: 'מידע בסיסי על הרכב',
        problem_description: 'תיאור הבעיה',
        common_links: 'קישורים נפוצים',
        claim_information: 'מידע על תביעה',
        diagnostic_report_record: 'רשומה של דוח אבחון',
        vehicle_history: 'מסמכי שאילתות היסטוריית רכב',
        programming_history: 'היסטוריית תכנות',
        vehicle_sales_logistics_information: 'מידע על מכירת הרכב ולוגיסטיקה',
        new_vehicle_information: 'מידע חדש על רכב',
        attachment_upload: 'העלאת קבצים מצורפים',
        diagnostic_report: 'דוח אבחון',
        bulk_download: 'הורדה קבוצתית',
        document_View: 'תצוגת מסמך',
        inquiry_content: 'תוכן השאילתה',
        inquiry_entry: 'הזנת שאילתה',
        subordinate_record: 'רשומת שאלות ותשובות של רמה נמוכה',
        superior_record: 'רשומת שאלות ותשובות של רמה גבוהה',
        send_content: 'תוכן שנשלח',
        send_time: 'שעת שליחה',
        sent_username: 'שולח',
        receive_name: 'נשלח אל',
        dept_name: 'רמה',
        enclosure: 'קובץ מצורף',
        wind_case: 'סגירת מקרה',
        close_order: 'סגירת הזמנה',
        case_reporting: 'דיווח על מקרה',
        pdf_preview: 'תצוגה מקדימה של PDF',
        SIS_maintenance: 'תחזוקת תאונות חמורות',
        Please_fill_in_the_inquiry_content: 'נא למלא את תוכן השאילתה',
        sending_an_email: 'שליחת דוא"ל',
        copy: 'העתק',
        repeat: 'VIN כפול',
        inconsistent: 'פלטפורמת הדגם אינה עקיבה',
        sendTo: 'שלח ל',
        reply: 'הזן תוכן לשאילתה/תשובה',
        please_check_the_exported_document: 'אנא סמן את המסמכים המיוצאים',
        please_upload_diagnostic_report: 'אנא העלה דוח אבחון',
        please_enter_the_vin: 'אנא הזן מספר VIN',
        placeholderDTC: 'דוגמה: P080800_P087D00_------',
        placeholderFaultInfoDesc:
            '1. אמת את הבעיה שדווחה על ידי הלקוח (רק כדי לוודא שהבעיה אכן התרחשה)',
        placeholderFaultHandleProcess:
            '2. זיהוי תסמינים קשורים (מצא ורשום את כל התסמינים שעשויים להיות קשורים לבעיה)\n3. ניתוח תסמינים (צפה בזהירות בתסמינים הקשורים כדי לאתר סיבות נפוצות)\n4. אימות הבעיה (צמצם את המסקנות שלך כדי לוודא שאתה פותר את הבעיה הנכונה)',
        placeholderSolution:
            '5. תיקון הבעיה (בצע תיקון)\n6. אימות פעולת הרכב (בדוק שהתיקון שביצעת פתר את הבעיה)',
        placeholderRemark: 'לדוגמה: מנגנון היגוי - 201806, בולם זעזועים קדמי שמאל - 2010101',
        placeholderContact: 'הזן שם מפעיל',
        close_time: 'מועד סגירה',
        one_touch: 'בניית מסמך מחדש',
        confirm_generating_new_case: 'האם אתה בטוח שברצונך ליצור מסמך חדש?',
        closing_statement: 'הסבר סגירה',
        number_of_cases: 'מספר מסמכים',
        number_of_vehicles: 'מספר רכבים',
        pleaseEnterContent: 'אנא הזן תוכן',
        case_age: 'גיל המקרה',
        last_response_time: 'מועד תגובה אחרונה',
        time_since_last_response: 'זמן מאז התגובה האחרונה',
        warranty_start_date: 'תאריך תחילת האחריות',
        submit_reason: 'סיבת הגשה',
        synchronize_PQCP: 'סנכרון PQCP',
        FPR_export: 'ייצוא FPR',
        level_selection: 'בחירת רמה',
        category_selection: 'בחירת קטגוריה',
        brand_selection: 'בחירת מותג',
        code: 'קוד',
        description: 'תיאור',
        major_complaints: 'תלונות חמורות',
        difficult_miscellaneous_diseases: 'תקלות מורכבות ונדירות',
        emerging_issues: 'בעיות חדשות',
        breakpoint_failure: 'כשל בנקודת עצירה',
        general_complaints: 'תלונה כללית',
        other: 'אחר',
        roewe: 'רואווי',
        mg: 'MG',
        serious: 'חמור',
        secondary: 'משני',
        generally: 'באופן כללי',
        complete: 'הושלם',
        please_select_level: 'בחר רמה',
        please_select_category: 'בחר קטגוריה',
        please_select_brand: 'בחר מותג',
        placeholder_auto: 'נמלא אוטומטית',
        translate: 'תרגום',
        isTranslate: 'להמיר או לא?',
        day: 'יום',
        one_click_order: 'סגירת הזמנה בקליק אחד',
        greater_than: 'גדול מ-',
        less_than: 'קטן מ-',
        between: 'בין',
        document_label: 'תווית מסמך',
        receipts_first_modification_time: 'מועד השינוי הראשון למסמך',
        Selection_of_Document_Owner: 'בחירת אחראי על המסמך',
        responsiblePerson: 'אחראי:',
        functional_Domain: 'תחום פונקציונלי',
        Category: 'קטגוריה',
        property: 'מאפיין',
        reRepair: 'תיקון חוזר',
        pullInNum: 'מספר ביקורים בתחנת שירות',
        perception: 'קשור לתפיסה',
        onSupport: 'האם נדרש תמיכה现场?',
        batteryNo: 'מספר סוללה',
        normalStartDate: 'תאריך תחילת האחריות',
        qmotorNo: 'מספר מנוע קדמי',
        hmotorNo: 'מספר מנוע אחורי',
        fault_cause_type: 'סוג סיבת התקלה',
        measure_name: 'שם האמצעי',
        part_name: 'שם החלק',
        close_order_notification: 'סגירת ההזמנה דורשת מענה למגיש ההצעה',
        TIS_Case_Data: 'נתוני מקרה TIS',
        case_File: 'תיק המקרה',
        responsibility_Data: 'נתוני חלוקת אחריות',
        longterm_Measures: 'אמצעי פעולה ארוכי טווח',
        tisCaseNo: 'מספר מקרה TIS',
        vehGlobalFwVer: 'גרסת תוכנת הרכב המלא',
        vehGlobalFwPn: 'מספר חלק תוכנת הרכב המלא',
        archivesNo: 'מספר הארכיון',
        archivesTitle: 'כותרת הארכיון',
        archivesSource: 'מקור הארכיון',
        proposer: 'מציע',
        proposedTime: 'תאריך ההצעה',
        archivesManagementPersonnel: 'איש צוות ניהול הארכיון',
        functionalMode: 'מודול פונקציונלי',
        supplier: 'ספק',
        accessoriesInvolved: 'האם מעורבים אביזרים?',
        functionalDomain: 'תחום פונקציונלי',
        invalidPartId: 'רכיב כשל',
        archivesType: 'סוג הארכיון',
        archivesGrade: 'דרגת הארכיון',
        problemDescription: 'תיאור הבעיה',
        analysisProgress: 'התקדמות ניתוח',
        qaRemark: 'הערת בקרת איכות (QA)',
        tacRemark: 'הערת מרכז תמיכה טכנית (TAC)',
        responsibleDepartment: 'המחלקה האחראית',
        coordinator: 'מתאם',
        principal: 'אחראי ראשי',
        containmentAction: 'פעולות הכלה',
        issueStatus: 'סטטוס הבעיה',
        softwareProblems: 'בעיות תוכנה',
        vehGlobalFwVer_j: 'גרסת קו הבסיס',
        vehGlobalFwPn_j: 'מספר חלק קו הבסיס',
        ewo: 'מספר EWO',
        rootCause: 'סיבת השורש',
        marketBehavior: 'התנהגות שוק',
        shortTermMeasures: 'אמצעי פעולה קצרי טווח',
        shortTermBreakpointDescription: 'תיאור נקודת הפסקה של אמצעי קצר',
        measuresResult: 'תוצאות אישור אמצעי הפעולה',
        measuresConfirmation: 'אישור אמצעי הפעולה',
        longTermMeasures: 'אמצעי פעולה ארוכי טווח',
        longTermMeasuresBreak: 'תיאור משוער של נקודת הפסקה לאמצעי ארוך',
        implementation: 'האם יושם?',
        longMeasuresTime: 'תאריך ביצוע בפועל של נקודת הפסקה לאמצעי ארוך',
        vinBreak: 'VIN של נקודת הפסקה לאמצעי ארוך',
        breakpointImplementationPhase: 'שלב יישום נקודת הפסקה',
        archive_Information: 'פרטי הארכיון',
        reason_incomplete_closure: 'סיבת סגירה ללא השלמה',
        entry_Date: 'תאריך כניסה',
        departure_date: 'תאריך יציאה',
        work_order_number: 'מספר פקודת עבודה',
        questionnaire_usage: 'מטרת השאלון',
        classification_of_technical_enquiries: 'סיווג שאילתות טכניות',
        change_of_document_owner: 'שינוי בעל המסמך',
        oldowner: 'בעלים קודם',
        newowner: 'בעלים חדש',
        original: 'מקור',
        translation: 'תרגום',
        dealer_address: 'כתובת הסוכנות',
        sel_up_engineers: 'ניתן לבחור עד 12 מהנדסים!',
        sel_up_weeks: 'ניתן לבחור עד 12 שבועות!',
        veh_infor_inquiry: 'שאילתת מידע על רכב',
        create_organization: 'יצירת ארגון',
        ref_code: 'קבל קוד אימות מעודכן',
        fault_complaint_Desp: 'תיאור תקלה / תיאור תלונה של הלקוח',
        broken_down_vehicle: 'האם הרכב תקוע?',
        reporting_organization: 'ארגון מדווח',
        reporter: 'מדווח',
        oneclick_convert: 'המרה בקליק אחד',
        assembly: 'אוסף',
        show_original: 'הצג מקור',
        sync_datong: 'סנכרון עם דאטונג',
        system_category_iii: 'קטגוריית מערכת III',
        maxus_Records: 'רשומות שיחות מקסוס',
    },
};
